/*! ===========================================================================
 *  AV Milestone Event  —  site-wide auto celebration + "catch N" mini-game.
 *  ---------------------------------------------------------------------------
 *  • Trigger is AUTOMATIC from the live product count (rendered by Liquid into
 *    #av-ms-root[data-count]); active while count is in [milestone, milestone+buffer).
 *  • Works for EVERY milestone (100..10000); tier/points come from data-milestones.
 *  • Catch GOAL tokens -> reveal the universal promo code (copyable). Progress is
 *    persisted per-milestone in localStorage, so it survives navigation.
 *  • Hybrid: ambient tokens drift while browsing + an arcade "challenge round".
 *  • Accessibility: keyboard-operable; prefers-reduced-motion -> static a11y
 *    variant (still mandatory catching, no motion).
 *  Testing overrides (query params):
 *    ?av_milestone=1000  force a milestone active (preview before you hit it)
 *    ?av_ms_mode=lite|rich  force the accessible / rich variant
 *    ?av_ms_reset=1  clear this browser's saved progress
 *  =========================================================================== */
(function () {
  "use strict";
  var root = document.getElementById("av-ms-root");
  if (!root || root.__avMs) return; root.__avMs = 1;

  /* ------------------------------ config -------------------------------- */
  var COUNT  = parseInt(root.dataset.count  || "0", 10) || 0;
  var BUFFER = parseInt(root.dataset.buffer || "90", 10) || 90;
  var RATE   = parseFloat(root.dataset.rate || "0") || 0;   // templates/day — only to estimate DAYS left
  var GOAL   = parseInt(root.dataset.goal   || "10", 10) || 10;
  var CODE   = (root.dataset.code  || "MILESTONE").trim();
  var LABEL  = (root.dataset.label || "").trim();       // optional, e.g. "15% OFF"
  var MILES  = []; try { MILES = JSON.parse(root.dataset.milestones || "[]"); } catch (e) { MILES = []; }
  /* 🎯 CANNON MINI-GAME (see the "===== CANNON =====" section further down).
     data-game-at is the milestone number the cannon replaces the medal game
     at — 0 (the default) means never. The two src attributes exist because
     JavaScript cannot construct Shopify's hashed asset URLs; only Liquid can,
     so the snippet hands them over. They are NOT keys inside data-milestones:
     that JSON is parsed in one go above, and one malformed literal in it sets
     MILES = [] and silently kills the celebration AND the teaser for every
     milestone. */
  var GAME_AT   = parseInt(root.dataset.gameAt || "0", 10) || 0;
  var PHYS_SRC  = root.dataset.physSrc  || "";
  var PARTS_SRC = root.dataset.partsSrc || "";
  var GAME_ON   = false;                 // decided in the go-block, below
  /* GAME_ON says the cannon OWNS this milestone: no medal bar content, no
     medal popover, no medal round that could grant the code. It is not
     read-only — cannonDowngrade() clears it if the physics bundle never
     arrives, and every surface re-renders from it.
     WON_BY_CANNON says the visitor ACTUALLY DESTROYED SIX TEMPLATES. Only
     the win branch of cannonShatter() writes it, and only reveal() reads
     it. Keeping the two apart is what stops the reward panel describing a
     game the visitor never played. */
  var WON_BY_CANNON = false;
  /* 🥚 CANNON_EGG says THE ROUND THAT IS OPEN RIGHT NOW CAME FROM THE
     EASTER-EGG BADGE. It is a property of the ROUND, not of the page load:
     cannonArena() writes it from the `egg` parameter that cannonEggLaunch()
     started and cannonPick/cannonOpenLevel/cannonPlay carried, and
     cannonEnd() clears it when the round is torn down.
     ⚠ IT USED TO BE A PAGE-LOAD LATCH, set by the badge and cleared by
     nothing, and that cost a real shopper a real reward: press the cyan badge
     on the knowledge-hub page during the celebration and win() — which reads
     this — could never pay again on that page load, from any door, including
     the celebration bar. An egg round still cannot pay; a genuine milestone
     round opened after one now can.
     It is declared HERE, beside the other mode flags, because setUnlocked()
     and win() below both have to read it and both are defined above the
     cannon section. See THE BARRIERS at the foot of
     theme/src/cannon-section.js. */
  var CANNON_EGG = false;

  var qs = null; try { qs = new URLSearchParams(location.search); } catch (e) { qs = { get: function(){return null;} }; }
  var forceN    = qs.get("av_milestone");
  var forceMode = qs.get("av_ms_mode");
  // Keep the preview trigger alive across page navigation while testing on a draft
  // (session-only; never set for real visitors, who have no such URL param). Use
  // ?av_milestone=off to stop previewing.
  try {
    if (forceN === "off") { sessionStorage.removeItem("av_ms_preview"); forceN = null; }
    else if (forceN) { sessionStorage.setItem("av_ms_preview", forceN); }
    else { forceN = sessionStorage.getItem("av_ms_preview"); }
    if (forceMode) sessionStorage.setItem("av_ms_mode_p", forceMode);
    else if (forceMode === null) forceMode = sessionStorage.getItem("av_ms_mode_p");
  } catch (e) {}
  if (qs.get("av_ms_reset")) { try { Object.keys(localStorage).forEach(function (k) { if (k.indexOf("av_ms_") === 0) localStorage.removeItem(k); }); } catch (e) {} }

  /* --------------------------- pick milestone --------------------------- */
  // Two states: a CELEBRATION (game) while count is in [milestone, milestone+buffer),
  // or a pre-milestone TEASER while we're within LEAD templates of the next milestone
  // ("only X to go — a surprise awaits"). Teaser auto-hands-off to the game on hit.
  // Teaser lead-in is PROPORTIONAL: the setting (default 30) is the anchor at the
  // 1,000 milestone; every milestone gets lead = round(n * anchor / 1000). So bigger
  // milestones (with bigger gaps) get a proportionally longer teaser window.
  var ANCHOR = parseInt(root.dataset.lead || "30", 10) || 30;
  function leadFor(m) { return Math.max(3, Math.round(m.n * ANCHOR / 1000)); }
  function pickAuto() {
    var m = null;
    for (var i = 0; i < MILES.length; i++) { if (COUNT >= MILES[i].n) m = MILES[i]; }
    if (!m) return null;
    if (COUNT - m.n >= BUFFER) return null;           // celebration window has passed
    return m;
  }
  function pickUpcoming() { for (var i = 0; i < MILES.length; i++) { if (MILES[i].n > COUNT) return MILES[i]; } return null; }
  function byN(n) { return MILES.filter(function (m) { return m.n == n; })[0] || { n: n, tier: "silver", pts: 0 }; }
  var forceTease = qs.get("av_ms_teaser");
  var milestone = null, mode = null, isPreview = false, remaining = 0;
  if (forceN) {
    milestone = byN(parseInt(forceN, 10) || 1000); mode = "celebration"; isPreview = true;
  } else if (forceTease) {
    milestone = byN(parseInt(forceTease, 10) || 1000);
    remaining = milestone.n - COUNT; var _l = leadFor(milestone); if (remaining < 1 || remaining > _l) remaining = Math.max(1, Math.round(_l * 0.4));
    mode = "teaser"; isPreview = true;
  } else {
    milestone = pickAuto();
    if (milestone) { mode = "celebration"; }
    else {
      var up = pickUpcoming();
      if (up) { remaining = up.n - COUNT; if (remaining >= 1 && remaining <= leadFor(up)) { milestone = up; mode = "teaser"; } }
    }
  }
  // 🕹 ARCADE — the easter egg. Without this the engine stops right below whenever no
  // celebration and no teaser is running, so the game would be unreachable for most of
  // the year. If the page carries an opt-in launcher ([data-av-ms-arcade="1000"] — the
  // "easter egg" badge on the reward table) we boot a THIRD mode instead: the full game
  // ON DEMAND ONLY. No ambient medals, no HUD, no site-wide event light, its own
  // localStorage namespace, and NEVER the promo code (see NS / setUnlocked / win).
  // ?av_ms_arcade=1 forces it over a live celebration (test lever), =off disables it.
  var ARCADE = false, arcadeBusy = false;
  var arcForce = qs.get("av_ms_arcade");
  if (arcForce !== "off" && (!milestone || !mode || arcForce === "1")) {
    var arcadeHost = document.querySelector("[data-av-ms-arcade],[data-av-ms-cannon]");
    if (arcadeHost) {
      var arcAttr = arcadeHost.hasAttribute("data-av-ms-arcade")
                  ? "data-av-ms-arcade" : "data-av-ms-cannon";
      var arcN = parseInt(arcadeHost.getAttribute(arcAttr) || "", 10);
      if (!arcN) { var arcUp = pickUpcoming(); arcN = arcUp ? arcUp.n : 1000; }
      milestone = byN(arcN); mode = "arcade"; ARCADE = true;
    }
  }
  if (!milestone || !mode) return;                     // nothing to show right now
  var GENUINE = false;                                 // 🔒 see setUnlocked()/win()
  try {
    var liveMs = pickAuto();
    GENUINE = !!(liveMs && liveMs.n === milestone.n);
  } catch (e) { GENUINE = false; }
  var TIER = milestone.tier || "silver";
  var MEDALS = {
    bronze:   "https://cdn.shopify.com/s/files/1/0884/4771/3613/files/autovectors.com_ppf_template_bronze_medal.png?v=1773657769",
    silver:   "https://cdn.shopify.com/s/files/1/0884/4771/3613/files/autovectors.com_ppf_template_Silver_medal.png?v=1773657769",
    gold:     "https://cdn.shopify.com/s/files/1/0884/4771/3613/files/autovectors.com_ppf_template_Gold_medal.png?v=1773657769",
    platinum: "https://cdn.shopify.com/s/files/1/0884/4771/3613/files/autovectors.com_ppf_template_Platinum_medal.png?v=1773657769"
  };
  var MEDAL_SRC = MEDALS[TIER] || MEDALS.silver;
  var NEXT_TIER = { bronze: "silver", silver: "gold", gold: "platinum", platinum: "platinum" }[TIER] || "gold";
  var NEXT_MEDAL_SRC = MEDALS[NEXT_TIER] || MEDAL_SRC;
  // Dedicated BOSS artwork per tier — the final boss matches the milestone's OWN tier
  // (1000/1500 = silver boss, 2000+ = gold, 7000+ = platinum).
  var BOSS_SRC = {
    bronze:   "https://cdn.shopify.com/s/files/1/0884/4771/3613/files/bronze_boss.png?v=1784309670",
    silver:   "https://cdn.shopify.com/s/files/1/0884/4771/3613/files/SILVER_BOSS.png?v=1784309669",
    gold:     "https://cdn.shopify.com/s/files/1/0884/4771/3613/files/gold_boss.png?v=1784310081",
    platinum: "https://cdn.shopify.com/s/files/1/0884/4771/3613/files/platinum_boss.png?v=1784310178"
  };
  var TIER_LADDER = ["bronze", "silver", "gold", "platinum"];
  function activeTier() {                                        // fun levels climb the tier ladder: L5+ = +1, L10+ = +2
    if (!funMode) return TIER;
    var i = TIER_LADDER.indexOf(TIER); if (i < 0) i = 1;
    return TIER_LADDER[Math.min(3, i + (funLevel >= 8 ? 2 : funLevel >= 5 ? 1 : 0))];
  }
  try { var _wb = new Image(); _wb.src = BOSS_SRC[TIER]; } catch (e) {}   // warm the boss art

  /* ------------------------------ state --------------------------------- */
  // Arcade rounds live in their OWN namespace so a practice game can never write into
  // (or unlock) a real milestone bucket. ?av_ms_reset=1 still clears both.
  var NS  = ARCADE ? "av_ms_arc_" : "av_ms_";
  var KEY = NS + "v1_" + milestone.n;
  var caughtMem = 0, unlockMem = false;
  function getCaught() { try { return parseInt(localStorage.getItem(KEY + "_caught") || "0", 10) || 0; } catch (e) { return caughtMem; } }
  function setCaught(v) { caughtMem = v; try { localStorage.setItem(KEY + "_caught", v); } catch (e) {} }
  function isUnlocked() { if (unlockMem) return true; try { return localStorage.getItem(KEY + "_unlocked") === "1"; } catch (e) { return false; } }
  function setUnlocked() { if (ARCADE || CANNON_EGG || !GENUINE) return; unlockMem = true; try { localStorage.setItem(KEY + "_unlocked", "1"); } catch (e) {} }   // 🕹 the arcade never grants the code

  /* --------------------------- capabilities ----------------------------- */
  function mm(q) { return window.matchMedia && matchMedia(q).matches; }
  var reduce = mm("(prefers-reduced-motion: reduce)");
  var coarse = mm("(hover:none),(pointer:coarse)");
  // Default is ALWAYS the rich animated game (the medals are lightweight DOM, not the
  // heavy WebGL that the site's "Lite" mode turns off) — so Lite mode does NOT force
  // low-motion. Only genuine prefers-reduced-motion (or the manual toggle / ?av_ms_mode=lite) does.
  var a11y   = forceMode === "lite" || (forceMode !== "rich" && reduce);

  /* ------------------------------ helpers ------------------------------- */
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function tier(e) { e.classList.add("av-ms"); e.setAttribute("data-tier", TIER); return e; }
  function rnd(a, b) { return a + (b - a) * Math.random(); }
  function pseudo() { return Math.random(); }
  function medalGlyph() { return TIER === "gold" || TIER === "platinum" ? "✦" : "★"; }
  var TIER_NAME = { bronze: "Bronze", silver: "Silver", gold: "Gold", platinum: "Platinum" }[TIER] || "Silver";
  // Per-tier INTENSITY dial — one place that scales every celebration effect so the
  // journey escalates Bronze (subtle) -> Platinum (finale). Each effect keeps its own hard cap.
  var TIER_FX = {
    bronze:   { rank: "Street", shards: 6,  confetti: 120, rays: 3, aura: false },
    silver:   { rank: "Sport",  shards: 7,  confetti: 160, rays: 4, aura: false },
    gold:     { rank: "Track",  shards: 9,  confetti: 200, rays: 5, aura: false },
    platinum: { rank: "Apex",   shards: 11, confetti: 250, rays: 6, aura: true }
  };
  var FX = TIER_FX[TIER] || TIER_FX.silver;

  // Opt-in procedural sound (OFF by default, no files; unlocked only via the toggle = a user gesture)
  // Always-on procedural sound (no files, no toggle). Browsers block audio until a user
  // gesture — the game needs clicks anyway, so we unlock the context on the first interaction.
  var Sound = (function () {
    var ctx = null;
    function ac() { if (ctx) return ctx; try { ctx = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { ctx = null; } return ctx; }
    function play(c, freq, dur, type, vol, when, pan) {
      var t = c.currentTime + (when || 0), o = c.createOscillator(), g = c.createGain();
      o.type = type || "sine"; o.frequency.setValueAtTime(freq, t);
      g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(vol || 0.14, t + 0.008); g.gain.exponentialRampToValueAtTime(0.0001, t + (dur || 0.12));
      o.connect(g);
      if (pan && c.createStereoPanner) {                          // sounds live WHERE the medal is
        var p = c.createStereoPanner(); p.pan.setValueAtTime(Math.max(-0.7, Math.min(0.7, pan)), t);
        g.connect(p); p.connect(c.destination);
      } else g.connect(c.destination);
      o.start(t); o.stop(t + (dur || 0.12) + 0.03);
    }
    function tone(freq, dur, type, vol, when, pan) {
      var c = ac(); if (!c) return;
      if (c.state === "suspended") { try { c.resume().then(function () { play(c, freq, dur, type, vol, when, pan); }, function () {}); } catch (e) {} return; }
      play(c, freq, dur, type, vol, when, pan);
    }
    // Tier-keyed scales: catch blips are QUANTIZED to the round's key, so the round
    // sounds composed instead of random. Fun-tier upgrades change the key too.
    var SCALES = {
      bronze:   [349.2, 392, 440, 493.9, 523.3, 587.3, 659.3, 698.5, 784, 880],
      silver:   [392, 440, 493.9, 523.3, 587.3, 659.3, 698.5, 784, 880, 987.8],
      gold:     [370, 415.3, 440, 493.9, 554.4, 587.3, 659.3, 740, 830.6, 880],
      platinum: [370, 415.3, 493.9, 554.4, 622.3, 659.3, 740, 830.6, 932.3, 987.8]
    };
    function quantize(f) {
      var sc = SCALES[activeTier()] || SCALES.silver, best = sc[0];
      for (var qi = 1; qi < sc.length; qi++) if (Math.abs(sc[qi] - f) < Math.abs(best - f)) best = sc[qi];
      return best;
    }
    // Near-subliminal 2-4 voice tonal BED per round; dawn stages open extra voices.
    var bed = { on: false, nodes: [] }, BEDGAIN = 0.026;
    var BED = {
      bronze:   [73.4, 110, 146.8, 220],
      silver:   [110, 164.8, 220, 261.6],
      gold:     [82.4, 123.5, 164.8, 246.9],
      platinum: [123.5, 185, 246.9, 311.1]
    };
    function bedStart(quiet, stage) {
      var c = ac(); if (!c || c.state === "suspended" || bed.on) return bed.on;
      bed.on = true;
      var fs = BED[activeTier()] || BED.silver;
      for (var i = 0; i < fs.length; i++) {
        var o = c.createOscillator(), o2 = c.createOscillator(), g = c.createGain();
        o.type = i === 1 ? "triangle" : "sine"; o2.type = "sine";
        o.frequency.value = fs[i]; o2.frequency.value = fs[i] * 1.004;   // slow natural beating
        g.gain.value = 0.0001;
        o.connect(g); o2.connect(g); g.connect(c.destination);
        o.start(); o2.start();
        bed.nodes.push({ o: o, o2: o2, g: g });
      }
      bedLevel(stage || 0, quiet);
      return true;
    }
    function bedLevel(stage, quiet) {
      if (!bed.on) return;
      var q = quiet ? 0.55 : 1;
      bed.nodes.forEach(function (n, i) {
        var vol = i <= Math.min(1 + stage, 3) ? BEDGAIN * q * (i < 2 ? 1 : 0.7) : 0.0001;
        try { n.g.gain.setTargetAtTime(Math.max(0.0001, vol), n.g.context.currentTime, 1.2); } catch (e) {}
      });
    }
    function bedStop() {
      bed.nodes.forEach(function (n) { try {
        n.g.gain.setTargetAtTime(0.0001, n.g.context.currentTime, 0.35);
        n.o.stop(n.g.context.currentTime + 1.6); n.o2.stop(n.g.context.currentTime + 1.6);
      } catch (e) {} });
      bed.nodes = []; bed.on = false;
    }
    function unlock() {
      var c = ac(); if (c && c.state === "suspended") { try { c.resume(); } catch (e) {} }
      window.removeEventListener("pointerdown", unlock, true); window.removeEventListener("keydown", unlock, true);
    }
    return {
      arm: function () { window.addEventListener("pointerdown", unlock, true); window.addEventListener("keydown", unlock, true); },
      hit: function (worth, prog, pan) {
        var base = 380 + Math.min(1, prog || 0) * 340;            // pitch ladder: each catch rings a little higher
        if (perfNow() < feverUntil) base *= 1.5;                  // 🔥 FEVER: jump up a fifth
        base = quantize(base);                                    // snapped to the tier's key -> it sounds composed
        tone(worth > 1 ? quantize(base * 1.25) : base, 0.1, "triangle", 0.13, 0, pan);
        if (worth > 1) tone(quantize(base * 1.5), 0.09, "triangle", 0.1, 0.05, pan);
      },
      bed: { start: bedStart, level: bedLevel, stop: bedStop },
      combo: function (n) { tone(400 + Math.min(n, 10) * 55, 0.08, "square", 0.09); },
      fx: function (name) {
        if (name === "crack") tone(210, 0.09, "square", 0.11);
        else if (name === "freeze") { tone(880, 0.12, "sine", 0.12); tone(660, 0.14, "sine", 0.11, 0.09); tone(440, 0.2, "sine", 0.1, 0.19); }
        else if (name === "magnet") { tone(330, 0.1, "sawtooth", 0.07); tone(495, 0.12, "sawtooth", 0.07, 0.09); }
        else if (name === "time") { tone(700, 0.08, "triangle", 0.12); tone(1050, 0.1, "triangle", 0.12, 0.07); }
        else if (name === "frenzy") { [440, 554, 659, 880].forEach(function (f, i) { tone(f, 0.07, "square", 0.09, i * 0.05); }); }
        else if (name === "chrome") { [1046.5, 1174.7, 1318.5, 1568, 1760].forEach(function (f, i) { tone(f, 0.06, "triangle", 0.1, i * 0.045); }); }
        else if (name === "feverout") { tone(660, 0.22, "sine", 0.1); tone(494, 0.34, "sine", 0.09, 0.14); }
        else if (name === "goldflip") { [523.3, 659.3, 784].forEach(function (f, i) { tone(f, 0.14, "triangle", 0.12, i * 0.07); }); }
        else if (name === "typeline") { for (var ti = 0; ti < 18; ti++) tone(1300 + (ti % 4) * 90, 0.012, "square", 0.028, ti * 0.1); }
        else if (name === "bosshit") { tone(160, 0.16, "square", 0.15); tone(320, 0.1, "square", 0.1, 0.06); tone(520, 0.08, "square", 0.08, 0.13); }
        else if (name === "trap") { tone(150, 0.18, "sawtooth", 0.12); tone(105, 0.24, "sawtooth", 0.1, 0.1); }
        else if (name === "beat") { tone(80, 0.12, "sine", 0.2); }
        else if (name === "go") { [523.3, 659.3, 880].forEach(function (f, i) { tone(f, 0.11, "triangle", 0.13, i * 0.055); }); }
        else if (name === "cutsnap") { tone(quantize(900 + Math.random() * 200), 0.045, "square", 0.07); }
        else if (name === "cutdone") {                           // the blade runs the path, then the liner lifts
          for (var ci2 = 0; ci2 < 8; ci2++) tone(1500 + (ci2 % 3) * 160, 0.016, "square", 0.05, ci2 * 0.035);
          tone(520, 0.1, "triangle", 0.11, 0.3); tone(760, 0.22, "sine", 0.07, 0.36);
        }
        else if (name === "bossin") {                            // ⚠ rising alarm, then the boss lands
          for (var ri = 0; ri < 9; ri++) tone(130 + ri * 62, 0.11, "sawtooth", 0.045, ri * 0.1);
          tone(880, 0.05, "square", 0.09, 0.95);
          tone(72, 0.55, "sawtooth", 0.17, 0.97); tone(48, 0.8, "sawtooth", 0.13, 1.08);
        }
        else if (name === "bossdie") {
          tone(200, 0.3, "sawtooth", 0.15); tone(140, 0.4, "sawtooth", 0.12, 0.18); tone(90, 0.55, "sawtooth", 0.12, 0.38);
          [900, 700, 1100, 800].forEach(function (f, i) { tone(f, 0.03, "square", 0.06, 0.1 + i * 0.16); });
        }
        else if (name === "squeak") { tone(620, 0.07, "triangle", 0.1); tone(360, 0.07, "triangle", 0.09, 0.05); tone(170, 0.09, "triangle", 0.08, 0.1); }
        else if (name === "storm") { tone(1500, 0.04, "triangle", 0.07); tone(1250, 0.05, "triangle", 0.06, 0.04); tone(70, 0.9, "sawtooth", 0.08, 0.06); tone(52, 1.2, "sawtooth", 0.06, 0.16); }   // crack, then rolling thunder
        else if (name === "thunder") { tone(1600, 0.03, "square", 0.08); tone(64, 0.7, "sawtooth", 0.08, 0.04); tone(46, 1.0, "sawtooth", 0.06, 0.14); }
        else if (name === "plink") { tone(quantize(480 + Math.random() * 420), 0.1, "sine", 0.055); }
        else if (name.indexOf("zap") === 0) {                    // ⚡ chain link N — climbs the tier scale
          var zi = parseInt(name.slice(3), 10) || 0;
          tone(quantize(420 * Math.pow(1.14, zi)), 0.07, "square", 0.085);
          tone(quantize(840 * Math.pow(1.14, zi)), 0.05, "triangle", 0.05, 0.02);
        }
        else if (name === "ding") { tone(quantize(700 + Math.random() * 300), 0.08, "triangle", 0.09); }
        else if (name === "plotter") {
          tone(90, 1.5, "sawtooth", 0.04);                                        // servo hum
          for (var pi = 0; pi < 15; pi++) tone(1500 + (pi % 3) * 180, 0.018, "square", 0.05, 0.06 + pi * 0.09);   // blade ticks
          tone(520, 0.1, "triangle", 0.1, 1.5);                                   // blade lift
          tone(700, 0.25, "sine", 0.06, 1.55); tone(1000, 0.2, "sine", 0.05, 1.68);   // liner peel
        }
        else if (name === "check") { tone(587, 0.1, "triangle", 0.12); tone(784, 0.12, "triangle", 0.12, 0.08); }
      },
      win: function () { [523, 659, 784, 1046, 1318].forEach(function (f, i) { tone(f, 0.2, "triangle", 0.14, i * 0.1); }); }
    };
  })();

  /* =====================================================================
     HUD  (always present while the game is running or after unlock)
     ===================================================================== */
  var hud, hudRingI, hudVal, pop;
  function buildHUD() {
    hud = tier(el("div", "av-ms-hud"));
    hud.setAttribute("role", "button"); hud.setAttribute("tabindex", "0");
    // 🎯 The bar is SHARED — it is the way back to the code once it is won,
    // whichever game won it — so it is built either way. Its CONTENT is not
    // shared: a medal image on a cannon milestone advertises a game that
    // cannot be played, and that image is what the visitor clicks.
    hud.setAttribute("aria-label", milestone.n + " templates milestone reward " +
                                   (GAME_ON ? "cannon game" : "game"));
    hud.innerHTML =
      '<span class="av-ms-hud__medal">' + (GAME_ON ? cannonMarkSVG() : '<img src="' + MEDAL_SRC + '" alt="" aria-hidden="true">') + '</span>' +
      '<span class="av-ms-hud__txt"><span class="av-ms-hud__k">' + (isPreview ? "Preview • " : "") + 'Milestone</span>' +
      '<span class="av-ms-hud__v">' + fmt(milestone.n) + ' reached</span></span>' +
      '<span class="av-ms-hud__ring"><i></i></span>';
    document.body.appendChild(hud);
    hudRingI = hud.querySelector(".av-ms-hud__ring i");
    hudVal   = hud.querySelector(".av-ms-hud__v");
    // no ✕ button: the bar must always stay reachable (discount code, game entry)
    hud.addEventListener("click", function () { togglePop(); });
    hud.addEventListener("keydown", function (ev) { if (ev.key === "Enter" || ev.key === " ") { ev.preventDefault(); togglePop(); } });
    updateHUD();
  }
  function updateHUD() {
    if (!hud) return;
    var c = getCaught(), done = isUnlocked();
    var pct = Math.min(100, Math.round((c / GOAL) * 100));
    hud.querySelector(".av-ms-hud__ring").style.setProperty("--p", done ? 100 : pct);
    // 🎯 getCaught() is a MEDAL counter. A cannon round never calls
    // setCaught(), so this ring would sit at "0/40" for the whole
    // celebration and read as a broken game.
    hudRingI.textContent = done ? "✓" : (GAME_ON ? "▶" : (c + "/" + GOAL));
    hud.classList.toggle("is-final", !done && c >= GOAL - 3);      // heartbeat while the final medal is out
    if (!done && c >= GOAL - 3) bossHint();                        // reliable finale-hint trigger
    if (done) { hud.classList.add("is-done"); hud.classList.remove("is-final"); if (hudVal) hudVal.textContent = "Code ready"; }
    if (pop) refreshPop();
  }

  /* ----------------------------- popover -------------------------------- */
  function buildPop() {
    pop = tier(el("div", "av-ms-pop")); pop.hidden = true; document.body.appendChild(pop); refreshPop();
  }
  function refreshPop() {
    if (!pop) return;
    var c = getCaught(), done = isUnlocked(), pct = Math.min(100, Math.round((c / GOAL) * 100));
    if (done) {
      pop.innerHTML =
        '<button class="av-ms-pop__x" type="button" aria-label="Close">✕</button>' +
        '<h4>' + fmt(milestone.n) + ' templates published 🎉</h4>' +
        '<p>You reached the AutoVectors <b>' + fmt(milestone.n) + '-template</b> milestone and unlocked the reward' + (LABEL ? ' — <b>' + esc(LABEL) + '</b>' : '') + '. Copy the code and use it at checkout.</p>' +
        '<div class="av-ms-code"><input readonly value="' + esc(CODE) + '" aria-label="Promo code"><button type="button" data-copy>Copy</button></div>' +
        '<div class="av-ms-pop-timer"></div>' +                  // ⌛ how long the won code stays valid
        '<a class="av-ms-btn" href="/discount/' + encodeURIComponent(CODE) + '?redirect=/pages/template-library">Shop with code</a>' +
        // 🎯 DECISION: the "Play for fun" medal round does NOT survive a
        // cannon milestone. It could not grant the code (funMode routes every
        // catch to funGain), so it was never a security problem — it was a
        // truth problem: it offers "Level N · boss ×1.4" to somebody who has
        // never seen a medal, a boss or a level. The affordance is kept and
        // pointed at the game they actually played.
        (GAME_ON
          ? '<button class="av-ms-btn av-ms-btn--ghost" type="button" data-cannon-again style="margin-top:8px">↻ Fire the cannon again</button>'
          : '<button class="av-ms-btn av-ms-btn--ghost" type="button" data-fun style="margin-top:8px">🎮 Play for fun — Level ' + funLevel + ' (' + funSecs() + 's · boss ×' + funBoost().toFixed(1) + ')</button>');
      pop.querySelector(".av-ms-pop-timer").appendChild(makeCountdown("av-ms-count--pop"));
      wireCopy(pop);
      /* 🚨 THE OWNER'S OWN FINDING. This button used to call cannonOpen(),
         which resolves cannonDefaultLevel() — and once the code is won that
         is cannonMax(), so clearing level 1 and pressing "↻ Fire the cannon
         again" dropped him into LEVEL 2 with no warning and no choice:
         "iskarto imeta i antra leveli be perspejimo ir pasirinkimo".
         "Again" now means THE RANGE: cannonRange() opens the picker, where
         every unlocked level is named and scored and the one he just cleared
         is one press away. cannonRange() starts the bundle download itself,
         which matters here more than anywhere — on an already-unlocked page
         cannonBoot() never ran. */
      var cbtn = pop.querySelector("[data-cannon-again]");
      if (cbtn) cbtn.addEventListener("click", function () { pop.hidden = true; cannonRange(); });
      var fbtn = pop.querySelector("[data-fun]");
      if (fbtn) fbtn.addEventListener("click", function () { funMode = true; funCaught = 0; pop.hidden = true; startArena(); });
    } else if (GAME_ON) {
      // 🎯 THE FIX. Not a CSS hide, not a disabled button: [data-round] and
      // [data-a11y] are never created, so there is nothing to click, nothing
      // for a keyboard to reach and nothing for an extension to un-hide.
      pop.innerHTML = cannonPopHTML();
      pop.querySelector(".av-ms-pop-timer").appendChild(makeCountdown("av-ms-count--pop"));
      pop.querySelector("[data-cannon]").addEventListener("click", function () {
        pop.hidden = true; cannonOpen();
      });
      /* ☰ THE RANGE FROM THE BAR ITSELF. cannonPopHTML() renders this only
         when cannonMax() > 1 — a player with something to replay — so the
         null guard is the condition, not a defensive habit. Without it the
         ladder's "unlocked forever" was only true from inside a round: press
         Quit during the celebration and the cleared levels were unreachable
         until you re-entered the milestone round. */
      var prb = pop.querySelector("[data-cn-poprange]");
      if (prb) prb.addEventListener("click", function () { pop.hidden = true; cannonRange(); });
    } else {
      pop.innerHTML =
        '<button class="av-ms-pop__x" type="button" aria-label="Close">✕</button>' +
        '<h4>We just hit ' + fmt(milestone.n) + ' templates! 🎉</h4>' +
        '<p>AutoVectors just published its <b>' + fmt(milestone.n) + 'th</b> pre-cut PPF template — a new library milestone. To celebrate, beat the <b>Challenge Round</b>: catch <b>' + GOAL + '</b> glowing ' + TIER_NAME + ' medals against the clock to unlock your discount code' + (LABEL ? ' — <b>' + esc(LABEL) + '</b>' : '') + '.</p>' +
        '<div class="av-ms-bar"><i style="width:' + pct + '%"></i></div>' +
        '<div class="av-ms-pop-timer"></div>' +
        '<button class="av-ms-btn" type="button" data-round>▶ Start challenge round</button>' +
        '<div class="av-ms-mini">' + c + ' / ' + GOAL + ' caught · <button type="button" data-a11y>' + (a11y ? "rich mode" : "keyboard / low-motion mode") + '</button></div>';
      pop.querySelector(".av-ms-pop-timer").appendChild(makeCountdown("av-ms-count--pop"));
      pop.querySelector("[data-round]").addEventListener("click", function () {
        funMode = false; pop.hidden = true; primerThen(startArena);
      });
      pop.querySelector("[data-a11y]").addEventListener("click", function () { a11y = !a11y; rebuild(); togglePop(true); });
    }
    // On desktop you close this by clicking the HUD medal again; on a phone the panel
    // covers it, so there was no visible way out at all.
    var px = pop.querySelector(".av-ms-pop__x");
    if (px) px.addEventListener("click", function (ev) { ev.stopPropagation(); pop.hidden = true; });
  }
  // tap/click outside the panel closes it — the expected gesture on touch
  document.addEventListener("pointerdown", function (ev) {
    if (!pop || pop.hidden || arena) return;
    if (ev.target && ev.target.closest && (ev.target.closest(".av-ms-pop") || ev.target.closest(".av-ms-hud"))) return;
    pop.hidden = true;
  }, true);
  function togglePop(forceOpen) {
    if (!pop) return;
    pop.hidden = forceOpen === true ? false : !pop.hidden;
    if (!pop.hidden) refreshPop();
  }

  /* =====================================================================
     RICH ambient medals + shared MOTION engine (rAF drift + GENTLE dodge).
     Medals ease along a baseline drift and softly steer AWAY from the cursor
     only when it's close — and the dodge FADES to zero at point-blank range,
     so they stop fleeing right when you're on them. A forgiving click radius
     means a near-click counts. Same engine drives the arcade medals
     (bounded/bouncing, mode:"arena"). Sizes are randomized (~40%..100%).
     ===================================================================== */
  var overlay, spawnTimer, active = 0, MAXTOK = coarse ? 2 : 3, BASE = 76;
  var freezeUntil = 0, forceRare = false;                       // "?" wildcard effects + comeback bonus
  // 🧲 The magnet works by POSITION so it also works on touch: desktop follows the
  // cursor, mobile stays anchored at the tap point and vacuums coins in range.
  var magnet = { x: 0, y: 0, until: 0, follow: false, ate: 0 }, magnetFx = null;
  /* -- quick-win juice: impact frames, haptics, fever, chain spark ---------- */
  var hitStopUntil = 0, feverUntil = 0, lastBuzz = 0, lastSpark = 0;
  function hitStop(ms) { hitStopUntil = Math.max(hitStopUntil, perfNow() + ms); }   // arcade "impact frames"
  function buzz(p) { try { if (coarse && navigator.vibrate) { var n = perfNow(); if (n - lastBuzz < 90) return; lastBuzz = n; navigator.vibrate(p); } } catch (e) {} }
  function arenaShake() {
    if (reduce || !arena) return;
    var pf = arena.querySelector(".av-ms-arena"); if (!pf) return;
    pf.classList.remove("is-shake"); void pf.offsetWidth; pf.classList.add("is-shake");
  }
  function startFever() {
    feverUntil = perfNow() + 5000;
    if (arena) { var pf = arena.querySelector(".av-ms-arena"); if (pf) pf.classList.add("is-fever"); }
    Sound.fx("frenzy"); buzz([15, 30, 15, 30, 15]);
    toast("🔥 <b>FEVER!</b> Everything +1 — don’t miss!", 2400);
    setTimeout(function () { if (perfNow() >= feverUntil) endFever(false); }, 5060);
  }
  function endFever(broken, x, y) {
    feverUntil = 0;
    if (arena) {
      var pf = arena.querySelector(".av-ms-arena");
      if (pf) { pf.classList.remove("is-fever");
        if (broken && !reduce) { pf.classList.add("is-feverout"); setTimeout(function () { pf.classList.remove("is-feverout"); }, 960); } }
    }
    if (broken) {                                                // a warm goodbye, not a punishment
      Sound.fx("feverout");
      toast("🔥 <b>beautiful run.</b>", 1600);
      if (x != null && !reduce) { burst.spawn(x, y, 5); showWarm(x, y, "✨ beautiful run."); }
    }
  }
  function showWarm(x, y, txt) {
    var p = tier(el("div", "av-ms-plus av-ms-plus--warm", txt));
    p.style.cssText += ";position:fixed;left:" + (x - 44) + "px;top:" + (y - 12) + "px;";
    document.body.appendChild(p); setTimeout(function () { p.remove(); }, 900);
  }
  function specRipple(x, y) {                                    // the game's ONLY rainbow — CHROME exclusive
    if (reduce) return;
    for (var i = 0; i < 2; i++) (function (k) { setTimeout(function () {
      var g = tier(el("div", "av-ms-specring" + (k ? " is-b" : "")));
      g.style.left = (x + (k ? 4 : 0)) + "px"; g.style.top = (y - (k ? 4 : 0)) + "px";
      document.body.appendChild(g); setTimeout(function () { g.remove(); }, 680);
    }, k * 60); })(i);
  }
  function chainSpark(src, x, y) {                               // aimed tracer shot at the NEAREST plain medal (+1, no chaining)
    if (reduce || perfNow() < magnet.until || perfNow() - lastSpark < 300) return;
    var RANGE = coarse ? 200 : 240;                              // long directional snipe on both platforms
    var best = null, bd = 1e9;
    for (var i = 0; i < mobs.length; i++) {
      var o = mobs[i];
      if (o === src || o.removed || o.el.__caught || o.bossFight || o.trapTok || o.special || o.chromeTok || (o.hp && o.hp > 1)) continue;
      var dx = (o.x + o._hw) - x, dy = (o.y + o._hh) - y, d = dx * dx + dy * dy;
      if (d < RANGE * RANGE && d < bd) { bd = d; best = o; }
    }
    if (!best) return;
    lastSpark = perfNow();
    var tx = best.x + best._hw, ty = best.y + best._hh;
    var dist = Math.sqrt(bd), dur = Math.max(90, Math.min(260, Math.round(dist * 1.1)));   // flight time reads at any range
    var ang = Math.round(Math.atan2(ty - y, tx - x) * 180 / Math.PI);
    var s = tier(el("div", "av-ms-spark"));
    s.style.transitionDuration = dur + "ms";
    s.style.transform = "translate(" + x + "px," + y + "px) rotate(" + ang + "deg)";
    document.body.appendChild(s);
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      s.style.transform = "translate(" + tx + "px," + ty + "px) rotate(" + ang + "deg)";
    }); });
    (function (o2) { setTimeout(function () {
      s.remove();
      if (o2.removed || o2.el.__caught) return;
      o2.el.__caught = 1; o2.frozen = true; o2.el.classList.add("is-caught");
      setTimeout(function () { removeMob(o2); }, 330);
      gainCatch(1, o2.x + o2._hw, o2.y + o2._hh);
    }, dur + 20); })(best);
  }
  function showCrit(x, y) {
    var p = tier(el("div", "av-ms-plus av-ms-plus--crit", "CRITICAL!"));
    p.style.cssText += ";position:fixed;left:" + (x - 34) + "px;top:" + (y - 14) + "px;";
    document.body.appendChild(p); setTimeout(function () { p.remove(); }, 780);
    arenaShake();
  }
  var bossDying = false, KILLCAM = 1500, ENTRANCE = 1900;        // trophy-shot hold · boss arrival cinematic
  /* ================== ✂️ CUT THE PATTERN ==================================
     The boss's armour is a pre-cut template. You don't click it off — you DRAG
     through its anchor nodes to trace the cut line, exactly like the vector paths
     the store sells. One unbroken stroke = CLEAN CUT = two layers at once.
     ====================================================================== */
  /* ============ ✒️ PEN: draw vector curves that CAGE the boss ==============
     Two weapons, two phases. The pen draws smooth bezier walls the boss bounces
     off; when it stops making progress inside them the script calls it TRAPPED and
     holds it still — which is your window to switch to the knife and cut.
     ====================================================================== */
  var weapon = "pen", lines = [], ink = 1, linesSvg = null, drawing = null, weaponBar = null, bossO = null;
  // any press landing on arena CHROME is a UI click, never a stroke and never a catch
  var CHROME_SEL = ".av-ms-weapons,.av-ms-arena__foot,.av-ms-guide,.av-ms-arena__hud,.av-ms-arena__title";
  var trapHist = [], trapBounce = 0, trapUntil = 0, trapped = false;
  function cancelDraw() {                                        // a press that lands a catch must not also leave a stroke
    if (!drawing) return;
    if (drawing.el && drawing.el.parentNode) drawing.el.remove();
    drawing = null;
  }
  function penActive() { return !!weaponBar && weapon === "pen" && !bossDying && !guidePause; }
  function smoothPath(p) {                                       // quadratic-midpoint smoothing = the curvy vector look
    if (p.length < 2) return "";
    var d = "M " + p[0].x.toFixed(1) + " " + p[0].y.toFixed(1);
    for (var i = 1; i < p.length - 1; i++) {
      d += " Q " + p[i].x.toFixed(1) + " " + p[i].y.toFixed(1) + " " +
           ((p[i].x + p[i + 1].x) / 2).toFixed(1) + " " + ((p[i].y + p[i + 1].y) / 2).toFixed(1);
    }
    return d + " L " + p[p.length - 1].x.toFixed(1) + " " + p[p.length - 1].y.toFixed(1);
  }
  function svgEl(t) { return document.createElementNS("http://www.w3.org/2000/svg", t); }
  // A guide card is a READING moment: the round freezes while it's up, you close it
  // with ✕ (or let it run out), and a big GO! tells you play has resumed.
  var guidePause = false, guideEl = null, guideT = 0, guideTick = 0;
  function closeGuide(silent) {
    clearTimeout(guideT); clearInterval(guideTick);
    if (!guideEl) return;
    var g = guideEl; guideEl = null; guidePause = false;
    g.classList.remove("is-in");
    setTimeout(function () { if (g.parentNode) g.remove(); }, 420);
    if (!silent) goSplash();
  }
  function goSplash() {
    var host = (arena && arena.querySelector(".av-ms-arena")) || overlay;
    if (!host || reduce) return;
    var s = tier(el("div", "av-ms-go", "GO!"));
    host.appendChild(s); Sound.fx("go"); buzz([14, 40, 14]);
    setTimeout(function () { if (s.parentNode) s.remove(); }, 950);
  }
  function guideCard(host, title, steps, ms) {
    if (!host) return;
    closeGuide(true);                                            // one card at a time, no GO between them
    [].forEach.call(document.querySelectorAll(".av-ms-guide"), function (o) { o.remove(); });
    var dur = ms || 9000, left = Math.ceil(dur / 1000);
    var g = tier(el("div", "av-ms-guide"));
    g.innerHTML = '<button class="av-ms-guide__x" type="button" aria-label="Skip and start now">✕</button>' +
      '<b>' + title + '</b>' +
      // the step text MUST sit in its own wrapper: the row is a flex container, and a bare
      // <em>/<b> inside it would become a separate flex ITEM and break the sentence apart
      steps.map(function (s, i) { return '<p><i>' + (i + 1) + '</i><span>' + s + '</span></p>'; }).join("") +
      '<u>⏸ Paused — starts in <em data-gsec>' + left + '</em>s · tap ✕ to go now</u>' +
      '<s class="av-ms-guide__bar" style="animation-duration:' + dur + 'ms"></s>';
    host.appendChild(g);
    guideEl = g; guidePause = true;                              // ⏸ the round clock stops while you read
    var x = g.querySelector(".av-ms-guide__x");
    x.addEventListener("pointerdown", function (ev) { ev.preventDefault(); ev.stopPropagation(); closeGuide(); }, true);
    x.addEventListener("click", function (ev) { ev.stopPropagation(); closeGuide(); }, true);   // keyboard / fallback
    requestAnimationFrame(function () { requestAnimationFrame(function () { g.classList.add("is-in"); }); });
    guideTick = setInterval(function () {                        // a visible countdown: the card is plainly temporary
      var n = g.querySelector("[data-gsec]");
      if (--left <= 0) { clearInterval(guideTick); left = 0; }
      if (n) n.textContent = left;
    }, 1000);
    guideT = setTimeout(closeGuide, dur);
  }
  var tutForce = false;                                          // level 1 replays every tutorial, seen or not
  function seenOnce(key) {
    try { if (localStorage.getItem(key)) return tutForce ? false : true; localStorage.setItem(key, "1"); } catch (e) {}
    return false;
  }
  // ✒️ the PEN is available from the very first second of every round — walls trap
  // ordinary medals too (and fade after ~3s). The ✂️ knife only joins at the boss.
  function weaponsInit(host) {
    weapon = "pen"; lines = []; ink = 1; drawing = null;
    bossO = null; trapped = false; trapHist = []; trapBounce = 0; trapUntil = 0;
    if (!host || reduce) return;
    linesSvg = svgEl("svg"); linesSvg.setAttribute("class", "av-ms-lines"); host.appendChild(linesSvg);
    weaponBar = tier(el("div", "av-ms-weapons"));
    weaponBar.innerHTML = '<button type="button" data-w="pen" class="is-on"><b>✒️</b><span>DRAW</span><i></i></button>';
    host.appendChild(weaponBar);
    weaponBar.addEventListener("pointerdown", function (ev) {
      var b = ev.target.closest("[data-w]"); if (!b) return;
      ev.stopPropagation(); setWeapon(b.getAttribute("data-w"));
    }, true);
    if (!seenOnce("av_ms_tut_pen")) guideCard(host, "✒️ YOUR TOOL: VECTOR LINES", [
      "Hold and <em>drag</em> anywhere to draw a curve.",
      "Curves are <em>walls</em> — medals bounce off them, so you can corral them.",
      "They fade after a few seconds. Ink refills by itself."
    ], 16000);
  }
  function weaponsEnd() {
    bossO = null; trapped = false; weapon = "pen";
    if (linesSvg) { linesSvg.remove(); linesSvg = null; }
    if (weaponBar) { weaponBar.remove(); weaponBar = null; }
    lines = []; drawing = null;
  }
  function bossPhaseStart(o) {                                   // the boss brings the SECOND weapon
    bossO = o; trapHist = []; trapBounce = 0; trapped = false; trapUntil = 0;
    lines.slice().forEach(killLine);                             // clean slate: pre-boss webs do not carry over
    for (var su = 0; su < mobs.length; su++) if (mobs[su].stuck) unstick(mobs[su]);
    var host = (arena && arena.querySelector(".av-ms-arena")) || overlay;
    if (!host || reduce || !weaponBar || !o.hpShield) return;    // no armour -> no blade, and no "tap CUT" hint
    var kb = el("button", "", '<b>✂️</b><span>CUT</span><i></i>');
    kb.type = "button"; kb.setAttribute("data-w", "knife"); kb.classList.add("is-new");
    weaponBar.appendChild(kb);
    setTimeout(function () { kb.classList.remove("is-new"); }, 2200);
    Sound.fx("goldflip");
    toast("✂️ <b>NEW WEAPON: CUT</b>", 2600);
    if (!seenOnce("av_ms_tut_boss")) guideCard(host, "🎯 BOSS TUTORIAL — PIN IT, THEN CUT IT", [
      "✒️ <em>DRAW</em> curves around the boss to <b>box it in</b> — it bounces off your walls.",
      "When it can’t move it goes <b>TRAPPED</b> and the ✂️ button starts flashing.",
      "Tap ✂️ <em>CUT</em>, then drag through the nodes to peel its armour and finish it."
    ], 22000);
    else guideCard(host, "🎯 HOW TO BEAT IT", [
      "✒️ Box it in with curves until it’s <b>TRAPPED</b>.",
      "✂️ Then switch to CUT and drag through the nodes."
    ], 13000);
  }
  function bossPhaseEnd() {
    bossO = null; trapped = false;
    var kb = weaponBar && weaponBar.querySelector('[data-w="knife"]');
    if (kb) kb.remove();
    lines.slice().forEach(killLine);                             // the cage dies with the boss
    setWeapon("pen");
  }
  function setWeapon(w) {
    if (!weaponBar) return;
    if (w === "knife" && !weaponBar.querySelector('[data-w="knife"]')) return;   // no knife before the boss
    if (weapon === w) return;
    weapon = w;
    [].forEach.call(weaponBar.querySelectorAll("[data-w]"), function (b) {
      b.classList.toggle("is-on", b.getAttribute("data-w") === w);
      if (b.getAttribute("data-w") === "knife" && w === "knife") b.classList.remove("is-urge");
    });
    Sound.fx("check");
    if (drawing) finishStroke();                                 // never leave a half-drawn wall behind
    if (w === "knife") { if (bossO && bossO.hpShield) startCut(bossO); }
    else cutClear();                                             // ✂️ is completely off while drawing
  }
  function addLine(pts) {
    if (pts.length < 2 || !linesSvg) return;
    var p = svgEl("path");
    p.setAttribute("class", "av-ms-line");
    p.setAttribute("d", smoothPath(pts));
    linesSvg.appendChild(p);
    var anchors = [];
    for (var i = 0; i < pts.length; i += Math.max(1, Math.round(pts.length / 4))) {
      var r = svgEl("rect");
      r.setAttribute("class", "av-ms-lineanchor");
      r.setAttribute("x", (pts[i].x - 4).toFixed(1)); r.setAttribute("y", (pts[i].y - 4).toFixed(1));
      r.setAttribute("width", 8); r.setAttribute("height", 8);
      linesSvg.appendChild(r); anchors.push(r);
    }
    // before the boss walls are temporary (~3s) so the field can't be scribbled shut;
    // once the boss is out they stay up until it dies.
    var ln = { pts: pts, el: p, anchors: anchors, born: perfNow(), life: bossO ? 1e9 : 6000 };
    lines.push(ln);
    while (lines.length > (bossO ? 6 : 4)) killLine(lines[0]);   // keep the field readable and the math cheap
    Sound.fx("cutdone");
  }
  function killLine(ln) {
    var k = lines.indexOf(ln); if (k > -1) lines.splice(k, 1);
    for (var u = 0; u < mobs.length; u++) if (mobs[u].stuck === ln) unstick(mobs[u]);
    if (ln.el) { ln.el.classList.add("is-gone"); (function (e) { setTimeout(function () { if (e.parentNode) e.remove(); }, 400); })(ln.el); }
    ln.anchors.forEach(function (a) { setTimeout(function () { if (a.parentNode) a.remove(); }, 400); });
  }
  function linesTick(now) {                                      // walls age out on their own
    for (var i = lines.length - 1; i >= 0; i--) if (now - lines[i].born > lines[i].life) killLine(lines[i]);
  }
  // 🕸 STICKY WEB — before the boss, a drawn curve CATCHES medals instead of batting
  // them away. Bouncing looked good but was useless: a deflected medal is no easier to
  // collect. Sticking turns the pen into a net — draw a web, then walk it and cash in.
  // The boss and its twins are exempt: their curves are a CAGE, and that fight is built
  // on bouncing them into a corner.
  function stickMob(o, ln, px, py, nx, ny, R) {
    if (o.stuck) return;
    o.stuck = ln;
    o.sbv = Math.max(0.6, Math.sqrt((o.bvx || 0) * (o.bvx || 0) + (o.bvy || 0) * (o.bvy || 0)) || 1.2);
    o.vx = 0; o.vy = 0; o.bvx = 0; o.bvy = 0;
    o.x = px + nx * R - o._hw; o.y = py + ny * R - o._hh;         // snap it onto the strand
    o.el.classList.add("is-stuck");
    if (now2 - (o.lastPing || 0) > 90) { o.lastPing = now2; Sound.fx("cutsnap"); }
  }
  function unstick(o) {
    if (!o.stuck) return;
    o.stuck = 0;
    o.el.classList.remove("is-stuck");
    // NEVER release with a zero baseline — motionStep eases velocity toward it, so the
    // medal would silently coast to a dead stop (the same trap doTrap once fell into).
    var a = Math.random() * 6.283, sp = o.sbv || 1.2;
    o.bvx = Math.cos(a) * sp; o.bvy = Math.sin(a) * sp;
    o.vx = o.bvx * 1.6; o.vy = o.bvy * 1.6;
  }
  var now2 = 0;                                                   // lineBounce shares its clock with stickMob

  function lineBounce(o, now, isBoss) {                          // EVERYTHING in the arena hits the drawn walls
    if (!lines.length) { o.bounceRun = 0; return; }
    // A PINNED boss is positionally immovable — motionStep zeroes its velocity every frame,
    // so de-penetrating it here can only teleport it (and the cut template anchored to it).
    // Safe: every exit from `trapped` (breakFree / releaseBoss / bossPhaseEnd) kills the
    // walls in the same call, so it can never un-pin while still inside one.
    if (isBoss && (trapped || bossDying)) { o.bounceRun = 0; return; }
    now2 = now;
    if (o.stuck) return;                                        // already caught in the web
    var cx = o.x + o._hw, cy = o.y + o._hh, R = o._hw * 0.92, hit = false;
    var REST = isBoss ? 0.62 : 0.88;                             // restitution < 1: a wedged boss must bleed energy
    var ax = 0, ay = 0;                                          // corrections ACCUMULATE and land once, below
    for (var i = lines.length - 1; i >= 0; i--) {
      var ln = lines[i];
      if (!ln.el.parentNode) continue;
      // A polyline is ONE surface, so resolve only its CLOSEST point. Pushing per
      // overlapping segment counted the same contact ~7 times (a wall is sampled every
      // 12px, the boss radius is ~42px) and injected ~100px of position per frame — that
      // is the thrashing when a line is drawn through a boss that is already boxed in.
      var bd2 = R * R, bpx = 0, bpy = 0, bsx = 0, bsy = 0, found = false;
      for (var j = 0; j < ln.pts.length - 1; j++) {
        var a = ln.pts[j], b = ln.pts[j + 1];
        var sx = b.x - a.x, sy = b.y - a.y, L2 = sx * sx + sy * sy || 1;
        var t = Math.max(0, Math.min(1, ((cx - a.x) * sx + (cy - a.y) * sy) / L2));
        var px = a.x + sx * t, py = a.y + sy * t, dx = cx - px, dy = cy - py, d2 = dx * dx + dy * dy;
        if (d2 >= bd2) continue;                                 // rejects "no overlap" AND "not the deepest"
        bd2 = d2; bpx = px; bpy = py; bsx = sx; bsy = sy; found = true;
      }
      if (!found) continue;
      var d = Math.sqrt(bd2), nx, ny;
      if (d > 0.5) { nx = (cx - bpx) / d; ny = (cy - bpy) / d; }
      else {                                                     // drawn dead through the centre: sub-pixel
        var sl = Math.sqrt(bsx * bsx + bsy * bsy) || 1;          // geometry is pure noise, so take the segment's
        nx = -bsy / sl; ny = bsx / sl;                           // own perpendicular and eject the way it came
        if (nx * o.vx + ny * o.vy > 0) { nx = -nx; ny = -ny; }
      }
      // pre-boss: ordinary medals are CAUGHT by the strand rather than deflected
      if (!bossO && !o.bossFight && !o.el.classList.contains("is-decoy") && !o.el.classList.contains("is-key")) {
        stickMob(o, ln, bpx, bpy, nx, ny, R);
        ln.el.classList.remove("is-ping"); void ln.el.getBBox; ln.el.classList.add("is-ping");
        return;
      }
      var dot = o.vx * nx + o.vy * ny;
      if (dot < 0) {                                             // ONE reflection per WALL, not per segment
        o.vx = (o.vx - 2 * dot * nx) * REST;                     // (7 reflections meant REST^7 = 0.035, which
        o.vy = (o.vy - 2 * dot * ny) * REST;                     //  annihilated velocity and made every damper
        o.bvx = o.vx * 0.5; o.bvy = o.vy * 0.5;                  //  downstream a no-op)
      }
      ax += nx * (R - d); ay += ny * (R - d);                    // separate walls ARE separate surfaces: a corner
      if (!hit) { hit = true; if (isBoss) trapBounce++;          // must push out of both, so these do sum
        ln.el.classList.remove("is-ping"); void ln.el.getBBox; ln.el.classList.add("is-ping");
        if (now - (o.lastPing || 0) > 120) { o.lastPing = now; Sound.fx("cutsnap"); if (!reduce) burst.spawn(bpx, bpy, 2); } }
    }
    // Applied ONCE, and deliberately UNCAPPED: a capped push could leave a body still
    // inside the wall, and next frame it would be resolved to the far side — i.e. walls
    // would become permeable, which is worse than the jitter this fixes.
    o.x += ax; o.y += ay;
    if (!isBoss) return;
    o.bounceRun = hit ? (o.bounceRun || 0) + 1 : 0;
    if (o.bounceRun > 5) { o.vx *= 0.55; o.vy *= 0.55; o.bvx *= 0.55; o.bvy *= 0.55; }   // stop the jackhammer
    if (o.bounceRun > 14 && !trapped && !bossDying) doTrap(o);   // pinned in a niche IS a cage - reward it
  }
  function trapTick(o, now) {                                    // "is it stuck?" — small travel box + real wall hits
    if (trapped || !bossO || bossDying) return;
    trapHist.push({ t: now, x: o.x + o._hw, y: o.y + o._hh });
    while (trapHist.length && now - trapHist[0].t > 1500) trapHist.shift();
    if (trapHist.length < 12 || trapBounce < 3) return;
    var mnx = 1e9, mxx = -1e9, mny = 1e9, mxy = -1e9;
    trapHist.forEach(function (h) { mnx = Math.min(mnx, h.x); mxx = Math.max(mxx, h.x); mny = Math.min(mny, h.y); mxy = Math.max(mxy, h.y); });
    if (mxx - mnx < 190 && mxy - mny < 190) doTrap(o);
  }
  function doTrap(o) {
    trapped = true; trapUntil = perfNow() + 6000; trapBounce = 0; trapHist = [];
    o.vx *= 0.05; o.vy *= 0.05; o.bvx = 0; o.bvy = 0;
    o.el.classList.add("is-trapped");
    lines.forEach(function (ln) { ln.el.classList.add("is-locked"); ln.life = 12000; ln.born = perfNow(); });
    Sound.fx("bosshit"); hitStop(140); arenaShake(); buzz([25, 50, 25]);
    var hasBlade = !!(weaponBar && weaponBar.querySelector('[data-w="knife"]'));
    toast(hasBlade ? "🕸 <b>TRAPPED!</b> Now tap ✂️ CUT" : "🕸 <b>TRAPPED!</b> Hit it now!", 3200);
    // the player picks the weapon — we only make the right button impossible to miss
    if (weaponBar && weapon !== "knife") {
      var kb = weaponBar.querySelector('[data-w="knife"]');
      if (kb) kb.classList.add("is-urge");                       // stays lit until they arm it or it breaks free
    }
  }
  function breakFree(o) {
    releaseBoss(o);                                              // same restore as a phase change — it must MOVE after
    Sound.fx("bossdie"); arenaShake(); buzz([30, 60]);
    toast("💥 <b>It broke free!</b> ✒️ Cage it again", 2600);
    if (weaponBar) {
      var kb2 = weaponBar.querySelector('[data-w="knife"]'); if (kb2) kb2.classList.remove("is-urge");
      var pb = weaponBar.querySelector('[data-w="pen"]');
      if (pb) { pb.classList.add("is-urge"); setTimeout(function () { pb.classList.remove("is-urge"); }, 5000); }
    }
    if (!o.removed) enrage(o);                                   // releaseBoss already set the velocity + baseline
  }
  var cut = null;
  function cutClear() {
    if (blade) { blade.remove(); blade = null; }
    if (!cut) return;
    clearTimeout(cut.graceT);
    if (cut.wrap && cut.wrap.parentNode) cut.wrap.remove();
    cut = null;
  }
  function startCut(o) {
    if (weapon !== "knife") return;                              // the blade only exists while CUT is the armed weapon
    if (!o || o.removed || o.el.__caught || !o.hpShield || reduce) return;
    cutClear();
    var host = (arena && arena.querySelector(".av-ms-arena")) || overlay;
    if (!host) return;
    var n = funMode ? (funLevel >= 10 ? 5 : funLevel >= 5 ? 4 : 3) : 3;
    var W = Math.round(Math.min(300, FLD.w * 0.6)), PAD = 34, H = 132;
    var wrap = tier(el("div", "av-ms-cutwrap"));
    wrap.style.width = (W + PAD * 2) + "px"; wrap.style.height = H + "px";
    wrap.style.marginLeft = -((W + PAD * 2) / 2) + "px"; wrap.style.marginTop = -(H / 2) + "px";
    var pts = [], i;
    for (i = 0; i < n; i++) {
      var t = i / (n - 1);
      pts.push({ x: PAD + W * t, y: H / 2 + (i % 2 ? 1 : -1) * rnd(16, 38) });
    }
    var poly = pts.map(function (p) { return p.x.toFixed(0) + " " + p.y.toFixed(0); }).join(", ");
    wrap.innerHTML =
      '<svg class="av-ms-cutsvg" viewBox="0 0 ' + (W + PAD * 2) + ' ' + H + '">' +
        '<polyline class="guide" points="' + poly + '" />' +
        '<polyline class="drag" points="" />' +
        '<polyline class="live" points="" />' +
      '</svg>';
    pts.forEach(function (p, k) {
      var nd = el("span", "av-ms-cutnode");
      nd.style.left = p.x + "px"; nd.style.top = p.y + "px";
      nd.setAttribute("data-i", k);
      if (k === 0) nd.classList.add("is-next");
      wrap.appendChild(nd);
      p.el = nd;
    });
    host.appendChild(wrap);
    cut = { o: o, wrap: wrap, pts: pts, hit: 0, stroke: false, broke: false,
            hw: (W + PAD * 2) / 2, hh: H / 2,                     // cached: cutFollow runs every frame
            live: wrap.querySelector(".live"), drag: wrap.querySelector(".drag"), graceT: 0 };
    cutFollow();
    toast("✂️ <b>CUT THE PATTERN</b> — hold and drag through the nodes", 2800);
  }
  // Forgiving, distance-based hit test on the NEXT node only — elementFromPoint on a
  // 15px square made cutting feel like guesswork.
  function cutTry(x, y) {
    if (!cut || cut.done || !cut.stroke) return;
    var p = cut.pts[cut.hit]; if (!p) return;
    var r = p.el.getBoundingClientRect(), dx = x - (r.left + r.width / 2), dy = y - (r.top + r.height / 2);
    var R = coarse ? 46 : 36;
    if (dx * dx + dy * dy <= R * R) cutNodeHit(p.el);
    else if (dx * dx + dy * dy <= (R * 2) * (R * 2)) p.el.classList.add("is-near");
    else p.el.classList.remove("is-near");
  }
  function cutDrag(x, y) {                                       // rubber band from the last node to the cursor = "I am cutting"
    if (!cut || cut.done || !cut.drag) return;
    if (!cut.stroke || !cut.hit) { cut.drag.setAttribute("points", ""); return; }
    var wr = cut.wrap.getBoundingClientRect(), sc = (cut.wrap.offsetWidth || 1) / (wr.width || 1);
    var last = cut.pts[cut.hit - 1];
    cut.drag.setAttribute("points", last.x.toFixed(0) + " " + last.y.toFixed(0) + ", " +
      ((x - wr.left) * sc).toFixed(0) + " " + ((y - wr.top) * sc).toFixed(0));
  }
  function bladeAt(x, y, on) {                                   // a visible blade so you always see where you cut
    if (reduce) return;
    if (!on) { if (blade) { blade.remove(); blade = null; } return; }
    if (!blade) { blade = tier(el("div", "av-ms-blade")); document.body.appendChild(blade); }
    blade.style.transform = "translate(" + x + "px," + y + "px)";
    blade.classList.toggle("is-cutting", !!(cut && cut.stroke));
  }
  var blade = null;
  function cutFollow() {                                         // the template rides on the boss
    if (!cut || !cut.o || cut.o.removed) return;
    var tx = cut.o.x + cut.o._hw, ty = cut.o.y + cut.o._hh;
    // CLAMP into the arena: cornered bosses used to carry half the template (and its
    // first nodes) off-screen, where you could neither see nor reach the cut. The wrap
    // is centred on this point by negative margins, so clamping the centre by its own
    // half-size keeps every node visible. Uses innerWidth/Height - reading layout here
    // would force a reflow every frame.
    var m = 8;
    tx = Math.max(FLD.x0 + cut.hw + m, Math.min(FLD.x1 - cut.hw - m, tx));
    ty = Math.max(cut.hh + m, Math.min(innerHeight - cut.hh - m, ty));
    cut.wrap.style.transform = "translate(" + tx.toFixed(1) + "px," + ty.toFixed(1) + "px)";
  }
  function cutNodeHit(nd) {
    if (!cut || cut.done || weapon !== "knife" || guidePause) return;
    var k = parseInt(nd.getAttribute("data-i"), 10);
    if (k !== cut.hit) return;                                   // must follow the path in order
    var p = cut.pts[k];
    p.el.classList.remove("is-next", "is-near"); p.el.classList.add("is-hit");
    cut.hit++;
    cut.live.setAttribute("points", cut.pts.slice(0, cut.hit).map(function (q) { return q.x.toFixed(0) + " " + q.y.toFixed(0); }).join(", "));
    Sound.fx("cutsnap"); buzz(8);
    if (!reduce) { var r = p.el.getBoundingClientRect(); burst.spawn(r.left + r.width / 2, r.top + r.height / 2, 3); }
    if (cut.hit < cut.pts.length) cut.pts[cut.hit].el.classList.add("is-next");
    else cutFinish();
  }
  function cutFinish() {
    if (!cut || cut.done || weapon !== "knife" || guidePause) return;
    cut.done = true;
    var o = cut.o, clean = !cut.broke, w = cut.wrap;
    w.classList.add("is-done"); if (clean) w.classList.add("is-clean");
    Sound.fx("cutdone"); hitStop(clean ? 140 : 100); arenaShake(); buzz(clean ? [20, 40, 20, 40, 30] : [20, 50]);
    var rr = w.getBoundingClientRect();
    if (!reduce) { burst.spawn(rr.left + rr.width / 2, rr.top + rr.height / 2, clean ? 16 : 10); impactRing(rr.left + rr.width / 2, rr.top + rr.height / 2); }
    var layers = clean ? 2 : 1;
    o.hpShield = Math.max(0, o.hpShield - layers);
    bossRibbon(o);
    if (clean) { Sound.fx("goldflip"); toast("✂️ <b>CLEAN CUT!</b> Two layers peeled", 2400); }
    else toast(o.hpShield ? "✂️ <b>Cut made</b> — " + o.hpShield + " layer" + (o.hpShield > 1 ? "s" : "") + " left" : "✂️ <b>Template stripped!</b> Now hurt it", 2200);
    setTimeout(function () {
      cutClear();
      if (o.removed || o.el.__caught) return;
      if (o.hpShield) { bossNextPhase(o); return; }               // cage spent -> it breaks loose again
      endCutPhase(o);                                            // armour gone -> PHASE 2
    }, 620);
  }
  function phaseBanner(title, sub) {                             // a beat that says "that phase is over"
    var host = arena && arena.querySelector(".av-ms-arena");
    if (!host || reduce) return;
    var b = tier(el("div", "av-ms-phase", "<b>" + title + "</b><span>" + sub + "</span>"));
    host.appendChild(b);
    Sound.fx("bossin"); hitStop(120); arenaShake(); buzz([20, 55, 20]);
    setTimeout(function () { b.classList.add("is-out"); }, 1450);
    setTimeout(function () { if (b.parentNode) b.remove(); }, 2050);
  }
  // A peeled layer ends a PHASE: the cage is spent, so the walls shatter with it and the
  // boss breaks loose to be trapped somewhere new. Without this it stayed pinned in the
  // same walls and every remaining layer was cut for free in the same spot.
  function releaseBoss(o) {                                      // a phase ends -> the cage is spent, it runs loose
    trapped = false; trapUntil = 0; trapBounce = 0; trapHist = [];
    if (o) o.el.classList.remove("is-trapped");
    lines.slice().forEach(killLine);
    if (!o || o.removed) return;
    // doTrap zeroes the BASELINE drift (bvx/bvy) and motionStep eases velocity toward it,
    // so restoring only vx/vy left the boss coasting to a dead stop a second later — which
    // is why the next phase started with it standing still. enrage() could not rescue it
    // either: it MULTIPLIES the baseline, and 0 x 1.28 is still 0.
    var ang = Math.random() * 6.283, sp = Math.max(1.4, (o.maxSp || 4) * 0.45);
    o.bvx = Math.cos(ang) * sp; o.bvy = Math.sin(ang) * sp;      // a real baseline again…
    o.vx = o.bvx * 2.6; o.vy = o.bvy * 2.6;                      // …plus a visible kick out of the cage
    o.bounceRun = 0;
  }
  function bossNextPhase(o) {
    var left = o.hpShield, total = o.armour0 || left, done = total - left;
    setWeapon("pen");                                            // the blade is useless while it runs loose
    releaseBoss(o);
    if (!o.removed) enrage(o);
    phaseBanner("⚔ PHASE " + done + " CLEARED",                  // `done` = layers peeled so far, and a CLEAN cut peels 2
      left + " layer" + (left > 1 ? "s" : "") + " left — it broke loose, cage it again");
    if (weaponBar) {
      var kb = weaponBar.querySelector('[data-w="knife"]'); if (kb) kb.classList.remove("is-urge");
      var pb = weaponBar.querySelector('[data-w="pen"]');
      if (pb) { pb.classList.add("is-urge"); setTimeout(function () { pb.classList.remove("is-urge"); }, 4200); }
    }
  }
  // PHASE 2: no armour left, so the blade has no job. Retire it, re-arm the pen
  // automatically, and the fight becomes "spot the real one among the twins and hit it".
  function endCutPhase(o) {
    cutClear();
    setWeapon("pen");
    var kb = weaponBar && weaponBar.querySelector('[data-w="knife"]');
    if (kb) { kb.classList.add("is-spent"); setTimeout(function () { if (kb.parentNode) kb.remove(); }, 420); }
    releaseBoss(o);                                              // the cage falls too — a pinned boss would give
    enrage(o);                                                   // the twins away instantly, killing the disguise
    phaseBanner("🛡 ARMOUR STRIPPED", "Final phase — spot the real one and hit it");
    toast("🛡 <b>Armour stripped!</b> ✒️ Lines only now — find the REAL one and hit it", 3600);
    var host = (arena && arena.querySelector(".av-ms-arena")) || overlay;
    if (host && !seenOnce("av_ms_tut_phase2")) guideCard(host, "🎭 PHASE 2 — SPOT THE REAL ONE", [
      "Its <em>twins</em> look identical — only a hit tells them apart.",
      "✒️ Your curves still work: wall them in, then <em>hit</em> the real boss.",
      "A twin just pops with a “Decoy!” — no harm, keep hunting."
    ], 18000);
  }
  function cutBreak() {                                          // stroke lifted mid-path -> short grace, then reset
    if (!cut || cut.done || !cut.hit) return;
    cut.broke = true;
    cut.graceT = setTimeout(function () {
      if (!cut || cut.done || weapon !== "knife" || guidePause) return;
      cut.pts.forEach(function (p, k) { p.el.classList.remove("is-hit", "is-next"); if (!k) p.el.classList.add("is-next"); });
      cut.hit = 0; cut.live.setAttribute("points", "");
      cut.wrap.classList.remove("is-broke");
      Sound.fx("crack"); toast("✂️ Cut lost — start again", 1500);
    }, 1300);
    cut.wrap.classList.add("is-broke");
  }
  /* ---- pen strokes: draw -> becomes a wall on release ---- */
  window.addEventListener("pointerdown", function (ev) {
    if (!penActive() || ink < 0.06) { if (penActive()) outOfInk(); return; }
    if (ev.target && ev.target.closest && ev.target.closest(CHROME_SEL)) return;   // never swallow a UI button
    ev.preventDefault();                                         // stop text-selection / native drag stealing the gesture
    drawing = { pts: [{ x: ev.clientX, y: ev.clientY }], el: svgEl("path"), id: ev.pointerId };
    drawing.el.setAttribute("class", "av-ms-line is-draft");
    if (linesSvg) {
      linesSvg.appendChild(drawing.el);
      // capture the pointer so a FAST drag can never outrun the element under it
      try { if (linesSvg.parentNode && linesSvg.parentNode.setPointerCapture) linesSvg.parentNode.setPointerCapture(ev.pointerId); } catch (e) {}
    }
  }, true);
  window.addEventListener("pointermove", function (ev) {
    if (!drawing || !penActive()) return;
    var last = drawing.pts[drawing.pts.length - 1];
    var dx = ev.clientX - last.x, dy = ev.clientY - last.y, d2 = dx * dx + dy * dy;
    if (d2 < 144) return;                                        // sample every ~12px: smooth but cheap
    var d = Math.sqrt(d2);
    if (d > 90 && ev.getCoalescedEvents) {                       // a fast flick can skip pixels — fill the gap in
      var co = ev.getCoalescedEvents();
      for (var ci = 0; ci < co.length; ci++) {
        var lp = drawing.pts[drawing.pts.length - 1], cdx = co[ci].clientX - lp.x, cdy = co[ci].clientY - lp.y;
        if (cdx * cdx + cdy * cdy >= 144) drawing.pts.push({ x: co[ci].clientX, y: co[ci].clientY });
      }
    }
    ink -= d / 5200;                                             // roomier ink so a full cage never runs dry mid-stroke
    drawing.pts.push({ x: ev.clientX, y: ev.clientY });
    drawing.el.setAttribute("d", smoothPath(drawing.pts));
    paintInk();
    if (ink <= 0) { ink = 0; finishStroke(); outOfInk(); }
  }, { passive: true });
  function outOfInk() {
    if (!weaponBar) return;
    var b = weaponBar.querySelector('[data-w="pen"]');
    if (!b || b.classList.contains("is-dry")) return;
    b.classList.add("is-dry"); Sound.fx("trap");
    toast("✒️ <b>Out of ink</b> — it refills, keep it short", 1800);
    setTimeout(function () { b.classList.remove("is-dry"); }, 1400);
  }
  function finishStroke() {
    if (!drawing) return;
    var pts = drawing.pts;
    if (drawing.el.parentNode) drawing.el.remove();
    drawing = null;
    if (pts.length >= 2) addLine(pts);
  }
  window.addEventListener("pointerup", function () { if (drawing) finishStroke(); }, { passive: true });
  window.addEventListener("pointercancel", function () { if (drawing) finishStroke(); }, { passive: true });
  function paintInk() {
    if (!weaponBar) return;
    var b = weaponBar.querySelector('[data-w="pen"] i');
    if (b) b.style.transform = "scaleY(" + Math.max(0, Math.min(1, ink)).toFixed(3) + ")";
  }
  window.addEventListener("pointerdown", function (ev) {
    if (!cut || cut.done || weapon !== "knife" || guidePause) return;
    if (ev.target && ev.target.closest && ev.target.closest(CHROME_SEL)) return;
    cut.stroke = true; clearTimeout(cut.graceT); cut.wrap.classList.add("is-live"); cut.wrap.classList.remove("is-broke");
    cutTry(ev.clientX, ev.clientY); cutDrag(ev.clientX, ev.clientY); bladeAt(ev.clientX, ev.clientY, true);
  }, true);
  window.addEventListener("pointermove", function (ev) {
    if (!cut || cut.done || weapon !== "knife" || guidePause) return;
    bladeAt(ev.clientX, ev.clientY, true);
    if (!cut.stroke) return;
    cutTry(ev.clientX, ev.clientY);
    cutDrag(ev.clientX, ev.clientY);
  }, { passive: true });
  window.addEventListener("pointerup", function () {
    if (!cut || cut.done || weapon !== "knife" || guidePause) return;
    cut.stroke = false; cut.wrap.classList.remove("is-live"); cutDrag(0, 0); bladeAt(0, 0, false);
    if (cut.hit && cut.hit < cut.pts.length) cutBreak();
  }, { passive: true });
  function bossDeath(o, worth, cx, cy) {                         // FINAL BLOW: the boss goes out with a show
    if (o.el.__caught || bossDying) return;
    o.el.__caught = 1; o.frozen = true; bossDying = true;
    cutClear(); bossPhaseEnd();                                  // ✂️ put the tools away
    o.el.classList.add("is-dying");
    Sound.fx("bossdie"); buzz([30, 60, 30, 60, 80]);
    hitStop(220); arenaShake(); slowmo = 0.35;
    // KILL CAM: dim the arena and glide the boss to centre stage so its artwork is
    // actually readable — the old version popped in place and was over too fast.
    var host = (arena && arena.querySelector(".av-ms-arena")) || document.body;
    var cam = null;
    if (!reduce) {
      cam = tier(el("div", "av-ms-killcam")); cam.innerHTML = "<i></i>";
      host.appendChild(cam);
      requestAnimationFrame(function () { requestAnimationFrame(function () { cam.classList.add("is-on"); }); });
      var x0 = o.x, y0 = o.y, tx = FLD.x0 + FLD.w / 2 - o._hw, ty = innerHeight * 0.42 - o._hh, t0c = perfNow();
      var glide = setInterval(function () {
        var k = Math.min(1, (perfNow() - t0c) / 520);
        var e = 1 - Math.pow(1 - k, 3);
        o.x = x0 + (tx - x0) * e; o.y = y0 + (ty - y0) * e;
        if (k >= 1) clearInterval(glide);
      }, 16);
      setTimeout(function () { clearInterval(glide); }, 900);
    }
    var decs = [];                                               // the decoys die with their master
    for (var di = 0; di < mobs.length; di++) if (mobs[di] !== o && !mobs[di].removed && mobs[di].el.classList.contains("is-decoy")) decs.push(mobs[di]);
    decs.forEach(function (d2, k) { setTimeout(function () {
      if (d2.removed || d2.el.__caught) return;
      d2.el.__caught = 1; d2.frozen = true; d2.el.classList.add("is-caught");
      if (!reduce) burst.spawn(d2.x + d2._hw, d2.y + d2._hh, 4);
      setTimeout(function () { removeMob(d2); }, 300);
    }, 140 + k * 150); });
    (function (m) { setTimeout(function () {                     // TROPHY SHOT: the enlarged boss gets STAMPED
      if (!document.body.contains(m.el)) return;
      m.el.appendChild(el("span", "av-ms-token__defeated", "DEFEATED"));
      Sound.fx("bosshit"); buzz(40); arenaShake();
    }, reduce ? 240 : 620); })(o);
    var N = reduce ? 0 : 5;                                      // crackling mini-explosions across the boss
    for (var bi = 0; bi < N; bi++) (function (k) {
      setTimeout(function () {
        if (!document.body.contains(o.el)) return;
        var r = o.el.getBoundingClientRect();
        burst.spawn(r.left + r.width * (0.2 + Math.random() * 0.6), r.top + r.height * (0.2 + Math.random() * 0.6), 6);
        Sound.combo(k + 4); arenaShake();
      }, KILLCAM + k * 170);
    })(bi);
    setTimeout(function () {                                     // THE BIG ONE -> then the win flows as usual
      var r = o.el.getBoundingClientRect(), fx2 = r.left + r.width / 2, fy2 = r.top + r.height / 2;
      slowmo = 1; bossDying = false;
      if (cam) { cam.classList.remove("is-on"); setTimeout(function () { cam.remove(); }, 500); }
      if (!reduce) {
        burst.spawn(fx2, fy2, 24); impactRing(fx2, fy2); bloom();
        setTimeout(function () { impactRing(fx2, fy2); burst.spawn(fx2, fy2, 10); }, 130);   // double pulse reads on phones
        var sw = tier(el("div", "av-ms-shock")); document.body.appendChild(sw); setTimeout(function () { sw.remove(); }, 900);
      }
      o.el.classList.add("is-caught");
      setTimeout(function () { removeMob(o); }, 330);
      hitStop(160); arenaShake(); Sound.fx("bosshit");
      gainCatch(worth, fx2, fy2, true);                          // the killing blow banks the reserved points
    }, KILLCAM + N * 170 + 220);
  }
  var mobs = [], motionRaf = 0, lastMotionAt = 0, pointerX = -99999, pointerY = -99999;
  // ---- PLAY FIELD BAND -------------------------------------------------
  // On a wide desktop the arena used to span the whole monitor: medals crossed
  // enormous distances and the browser composited a huge surface every frame.
  // The field is now a CENTRED BAND ~20% narrower (never below 1100px, never
  // above 1900px) with the sides letterboxed. Coordinates stay in viewport
  // space on purpose — the band only moves the BOUNDS, so nothing shifts.
  // Touch keeps the full width: phone screens have no spare room to give away.
  var FLD = { x0: 0, x1: 0, w: 0 };
  function fieldSize() {
    var w = coarse ? innerWidth
                   : Math.min(innerWidth, Math.max(1100, Math.round(innerWidth * 0.8)), 1900);
    FLD.w = w; FLD.x0 = Math.round((innerWidth - w) / 2); FLD.x1 = FLD.x0 + w;
    if (arena) {
      var pf = arena.querySelector(".av-ms-arena");
      if (pf) pf.style.setProperty("--ms-bar", FLD.x0 + "px");
    }
  }
  fieldSize();
  addEventListener("resize", fieldSize);


  window.addEventListener("pointerdown", forgivingCatch, true);   // near-miss catch on EVERY device (touch too), before page handlers
  if (!coarse) {
    var trackPtr = function (e) { pointerX = e.clientX; pointerY = e.clientY; };
    window.addEventListener("pointermove", trackPtr, { passive: true });
    window.addEventListener("pointerdown", trackPtr, { passive: true });
    window.addEventListener("blur", function () { pointerX = pointerY = -99999; });
  }
  function buildOverlay() { overlay = el("div", "av-ms-overlay"); overlay.setAttribute("aria-hidden", "false"); document.body.appendChild(overlay); }
  function scheduleSpawn() {
    clearTimeout(spawnTimer);
    spawnTimer = setTimeout(function () { spawnAmbient(); scheduleSpawn(); }, rnd(1800, 3800));
  }
  function makeToken(rare, scale, boss, kind) {
    var b = tier(el("button", "av-ms-token")); b.type = "button";
    if (rare) b.classList.add("is-rare");
    if (boss) b.classList.add("is-boss");
    if (kind) b.classList.add("is-" + kind);                     // is-wild / is-chrome / is-time
    var h = Math.round(BASE * (scale || 1)), w = Math.round(h * 0.87);
    b.style.width = w + "px"; b.style.height = h + "px";
    var im = document.createElement("img");
    var tk = activeTier();
    b.setAttribute("data-tier", tk);                             // fun L5+ upgrades the whole look to gold/platinum
    im.className = "av-ms-token__img"; im.src = boss ? (BOSS_SRC[tk] || MEDAL_SRC) : (MEDALS[tk] || MEDAL_SRC); im.alt = ""; im.setAttribute("aria-hidden", "true");
    im.style.animationDelay = (-Math.random() * 4).toFixed(2) + "s";
    b.appendChild(im);
    if (boss) b.appendChild(el("span", "av-ms-token__ribbon", "FINAL"));
    if (kind === "wild") b.appendChild(el("span", "av-ms-token__q", "?"));
    if (kind === "time") b.appendChild(el("span", "av-ms-token__q", "+5s"));
    if (kind === "mag") b.appendChild(el("span", "av-ms-token__q", "🧲"));
    b.setAttribute("aria-label", boss ? "Catch the final medal" : kind === "wild" ? "Catch the mystery medal" : ("Catch a " + TIER_NAME + " milestone medal"));
    b._hw = w / 2; b._hh = h / 2;
    return b;
  }
  function addMob(o) {
    mobs.push(o);
    // WATCHDOG: also revive if the engine went quiet while motionRaf still holds a
    // stale id (the historical "all medals frozen forever" death mode).
    if (!motionRaf || perfNow() - lastMotionAt > 600) { try { cancelAnimationFrame(motionRaf); } catch (e) {} motionRaf = requestAnimationFrame(motionStep); }
  }
  function removeMob(o) { if (o.removed) return; o.removed = true; o.dead = true; if (o.el.parentNode) o.el.remove(); if (o.onGone) o.onGone(); }
  function catchMob(o, cx, cy) {
    if (o.el.__caught || o.removed) return;
    o.frozen = false;                                            // release the press-freeze (boss/heavy keep moving after a non-final hit)
    if (o.bossFight) {                                           // BOSS FIGHT: multi-hit, enrages between hits
      if (o.dashUntil && perfNow() < o.dashUntil) return;        // phasing mid-dash — untouchable
      if (o.hpShield) {                                          // ✂️ armoured: clicks bounce off — you must CUT the template
        if (reduce) {                                            // low-motion fallback keeps the old click-to-strip
          o.hpShield--; bossRibbon(o); Sound.fx("crack");
          toast(o.hpShield ? "🛡 <b>ARMOUR " + o.hpShield + " left</b>" : "🛡 <b>ARMOUR BROKEN!</b>", 1600);
          return;
        }
        Sound.fx("crack"); hitStop(70); buzz(18);
        if (!reduce) burst.spawn(cx, cy, 3);
        o.el.classList.remove("is-tease"); void o.el.offsetWidth; o.el.classList.add("is-tease");
        toast(weapon === "knife" ? "🛡 <b>Armoured!</b> Drag through the nodes to cut"
                                 : "🛡 <b>Armoured!</b> ✒️ Cage it, then pick ✂️ CUT", 1900);
        if (weapon === "knife" && !cut) startCut(o);              // never auto-arm the blade from a click
        return;
      }
      var crit = o.critUntil && perfNow() < o.critUntil, dmg = crit ? 2 : 1;   // weak-point window after the dash
      if (crit) { showCrit(cx, cy); hitStop(140); buzz([20, 40, 20, 40, 30]); }
      if (o.hp > dmg) { o.hp -= dmg; gainCatch(dmg, cx, cy, true); enrage(o); return; }   // only boss damage may pass GOAL-3
      bossDeath(o, o.hp, cx, cy);                                // FINAL BLOW: dramatic death, then banks remaining hits
      return;
    }
    if (!o.bossFight && o.hp && o.hp > 1) {                      // HEAVY medal: first hit only CRACKS it
      o.hp--; o.el.classList.add("is-cracked"); Sound.fx("crack"); buzz([10, 30, 10]);
      if (!reduce) burst.spawn(cx, cy, 4);
      o.vx += rnd(-1.6, 1.6); o.vy += rnd(-1.2, 1.2);            // knock it loose
      return;
    }
    o.el.__caught = 1; o.frozen = true;
    var r = o.el.getBoundingClientRect(); o.el.classList.add("is-caught");
    setTimeout(function () { removeMob(o); }, 330);
    if (o.special) { o.special(r.left + r.width / 2, r.top + r.height / 2); return; }   // "?" / ⏱ medals
    if (o.combo) { var now = perfNow(); combo = now - lastCatch < 900 ? combo + 1 : 1; lastCatch = now; if (combo > maxCombo) maxCombo = combo; if (combo >= 2) flashCombo(cx, cy); if (combo >= 8 && now > feverUntil) startFever(); }
    var w = o.worth || 1;
    if (perfNow() < feverUntil) w += 1;                          // 🔥 FEVER: everything +1
    if (o.chromeTok) { Sound.fx("chrome"); specRipple(cx, cy); hitStop(90); buzz([10, 30, 10, 30, 20]); }
    else if (w > 1) { hitStop(50); buzz([10, 40, 10]); }
    else buzz(8);
    gainCatch(w, r.left + r.width / 2, r.top + r.height / 2);
    chainSpark(o, r.left + r.width / 2, r.top + r.height / 2);
  }
  function bindCatch(o, worth) {
    o.worth = worth;
    o.el.addEventListener("click", function (ev) {
      ev.preventDefault();
      if (guidePause) return;                                    // ⏸ a tutorial card is up: the round has not started
      catchMob(o, ev.clientX, ev.clientY);
    });   // safety net for touch/keyboard — catchMob is idempotent (__caught guard)
  }
  function forgivingCatch(ev) {                        // a click NEAR a medal is enough (no pixel-perfect aim)
    if (guidePause) return;                                      // ⏸ nothing is catchable while the guide is up
    if (playHalted() || !mobs.length) return;
    if (ev.target && ev.target.classList && ev.target.classList.contains("av-ms-cutnode")) return;   // ✂️ the cut owns its own touches
    if (weapon === "knife" && cut) return;                       // ✂️ a cut stroke is never a catch
    if (ev.target && ev.target.closest && ev.target.closest(CHROME_SEL)) return;
    var best = null, bd = 1e9, near = null, nd = 1e9;
    for (var i = 0; i < mobs.length; i++) {
      var o = mobs[i]; if (o.removed || o.el.__caught) continue;
      var dx = (o.x + o._hw) - ev.clientX, dy = (o.y + o._hh) - ev.clientY, d = Math.sqrt(dx * dx + dy * dy);
      if (d < o._hw + 34 && d < bd) { bd = d; best = o; }
      if (d < nd) { nd = d; near = o; }
    }
    // PHASE 1 only: while the REAL boss still wears armour the blade owns it, so a pen
    // stroke across it never lands a hit. Once stripped (PHASE 2) hitting is the point.
    // Decoys are deliberately NOT protected — popping fakes is how you filter down to the
    // real one, and it must work in every phase (they spawn on armour hits too).
    if (best && best === bossO && bossO.hpShield && weapon === "pen") return;
    if (best) {                                                  // press-squash: 55ms anticipation, then the pop
      cancelDraw();                                              // this press is a catch, not a stroke
      best.frozen = true;                                        // stop dead ON press — no darting away mid-squash
      best.el.classList.add("is-press");
      (function (b, bx, by) { setTimeout(function () { b.el.classList.remove("is-press"); catchMob(b, bx, by); }, 55); })(best, ev.clientX, ev.clientY);
      return;
    }
    if (perfNow() < feverUntil) endFever(true, ev.clientX, ev.clientY);   // whiffed during FEVER -> a warm goodbye
    [].forEach.call(document.querySelectorAll(".av-ms-ember"), function (e2) { e2.remove(); });   // whiff snuffs the embers
    if (near && nd < 150 && perfNow() > (near.teaseCd || 0)) {   // near-miss: the medal wobbles, teasing you
      near.teaseCd = perfNow() + 1000;
      near.el.classList.add("is-tease");
      (function (m) { setTimeout(function () { if (!m.removed) m.el.classList.remove("is-tease"); }, 480); })(near);
    }
  }
  function motionStep(now) {
    lastMotionAt = now;                                          // heartbeat for the addMob watchdog
    if (lines.length) {                                          // ✒️ walls stop EVERYTHING in the arena
      linesTick(now);
      for (var dq = 0; dq < mobs.length; dq++) {
        var dm = mobs[dq];
        if (dm.removed || dm.el.__caught || dm.mode !== "arena") continue;
        lineBounce(dm, now, dm === bossO);
      }
    }
    if (ink < 1 && weaponBar) { ink = Math.min(1, ink + 0.0022); paintInk(); }
    if (now < tow.until) towTick(now);                          // 🧲 drag boss + twins toward the beam
    if (bossO && !bossO.removed && !bossDying) {                 // 🕸 cage detection + escape
      if (trapped) {
        bossO.vx = 0; bossO.vy = 0; bossO.bvx = 0; bossO.bvy = 0;   // PINNED: the template must not slide under the cursor
        if (now > trapUntil) breakFree(bossO);
      } else {
        // cutting is the precision beat, so take the shiver off the nodes — but only
        // gently: freezing it here would make the cage pointless. A real wedge is handled
        // by the restitution + auto-trap in lineBounce, which PINS it properly.
        if (cut && cut.o === bossO) { bossO.vx *= 0.93; bossO.vy *= 0.93; bossO.bvx *= 0.93; bossO.bvy *= 0.93; }
        trapTick(bossO, now);
      }
    }
    if (cut) cutFollow();                                        // ✂️ the cut template rides along with the boss
    if (waveEl) {                                                // 🪞 drive the bath surface (visual + physics share one number)
      var wh = curWaveH();
      waveY = wh > 2 ? innerHeight - wh : 0;
      waveEl.style.transform = "translateY(" + (innerHeight - wh).toFixed(1) + "px)";
    }
    if (now < magnet.until) {                                    // vortex follows the cursor (desktop) or stays anchored
      if (magnet.follow && pointerX > -9000) { magnet.x = pointerX; magnet.y = pointerY; }
      if (magnetFx) magnetFx.style.transform = "translate(" + magnet.x + "px," + magnet.y + "px)";
    } else if (magnetFx) { magnetFx.remove(); magnetFx = null; }
    try {                                                        // ARMOR: an exception here must never kill the rAF chain
    for (var i = mobs.length - 1; i >= 0; i--) {
      var o = mobs[i];
      if (!o) continue;                                          // array may shift if a catch ends the round mid-frame
      if (o.removed) { mobs.splice(i, 1); continue; }
      if (o.stuck) { o.born += 16; }                             // 🕸 held by the web: no drift, no wind, no magnet
      else if (!o.frozen && !o.dead) {
        if (guidePause || now < freezeUntil || now < hitStopUntil) { o.born += 16; }   // ⏸ guide / ❄ FREEZE / impact-frame
        else {
        if (o.zig) o.bvy = Math.sin((now - o.born) / 320 + (o.seed || 0)) * 1.15;               // zigzag persona
        if (o.sway) o.bvx = Math.sin((now - o.born) / 300 + (o.seed || 0)) * 0.9;               // rain drops sway while falling
        if (windX && !o.bossFight && (o.mode === "arena" || o.rainTok)) {                        // 🌬 CROSSWIND: everything leans downwind (rain included)
          o.vx += windX * 0.14;                                                                  // strong enough to beat the baseline easing
          o.bvx += (windX * 1.8 - o.bvx) * 0.006;                                                // and it slowly bends their drift too
        }
        if (o.dart && now > (o.nextDart || 0)) { o.vx += rnd(-3.5, 3.5); o.vy += rnd(-2.5, 2.5); o.nextDart = now + rnd(1100, 2800); }   // sprinter darts
        o.vx += (o.bvx - o.vx) * 0.04; o.vy += (o.bvy - o.vy) * 0.04;          // ease toward baseline drift
        var cx = o.x + o._hw, cy = o.y + o._hh;
        if (now < magnet.until && !o.trapTok && !o.bossFight) {                // 🧲 MAGNET pulls by position (touch too)
          var mdx = cx - magnet.x, mdy = cy - magnet.y, md = Math.sqrt(mdx * mdx + mdy * mdy) || 1;
          if (md < 500) {
            if (md > 34) { var pf = 0.5 + 0.7 * (1 - md / 500); o.vx -= (mdx / md) * pf; o.vy -= (mdy / md) * pf; }
            else magnetEat(o);                                                 // reached the core -> swallowed
          }
        } else if (!coarse && pointerX > -9000) {
          var dx = cx - pointerX, dy = cy - pointerY, d2 = dx * dx + dy * dy, R = o.rad;
          if (d2 < R * R && d2 > o.dead0 * o.dead0) {                          // GENTLE dodge, fades to 0 at point-blank
            if (o.shyTok && d2 < R * R * 0.45 && now > (o.blinkCd || 0)) { shyBlink(o); }
            else {
              var d = Math.sqrt(d2), f = (1 - d / R) * (1 - o.dead0 / d);
              o.vx += (dx / d) * f * o.push; o.vy += (dy / d) * f * o.push;
            }
          }
        }
        if (waveY && !o.bossFight) {                                            // 🪞 BUOYANCY: the rising bath lifts EVERYTHING out of it (rain drops included)
          var bot = o.y + o._hh * 2;
          if (bot > waveY) {
            var depth = bot - waveY;
            o.vy -= Math.min(2.2, depth * 0.05);                                // pushed up, harder the deeper it is
            o.vy *= 0.86; o.vx *= 0.97;                                          // liquid drag -> they settle and bob
            o.bvy = Math.min(o.bvy, 0);
            o.y -= Math.min(9, depth * 0.09);                                    // direct lift too, so speed caps can't trap them under
            o.buoy = 1;
          }
        }
        var cap = (o.dashUntil && now < o.dashUntil) ? o.maxSp * 3 : o.maxSp;   // boss escape-dash overshoots the cap
        if (now < magnet.until && !o.trapTok && !o.bossFight) cap = Math.max(cap, o.maxSp * 2);   // sucked in FAST
        if (o.rainTok && !o.splashed && o.y > innerHeight - 80) {               // 💧 SPLASH: drops land in sparks + a musical plink
          o.splashed = 1;
          if (!reduce) burst.spawn(o.x + o._hw, innerHeight - 50, 2);
          Sound.fx("plink");
        }
        var sp = Math.sqrt(o.vx * o.vx + o.vy * o.vy); if (sp > cap) { o.vx *= cap / sp; o.vy *= cap / sp; }
        o.x += o.vx * slowmo; o.y += o.vy * slowmo;
        if (o.mode === "arena") {
          var bounced = false;
          if (o.x < o.minX) { o.x = o.minX; o.vx = Math.abs(o.vx); o.bvx = Math.abs(o.bvx); bounced = true; }
          else if (o.x > o.maxX) { o.x = o.maxX; o.vx = -Math.abs(o.vx); o.bvx = -Math.abs(o.bvx); bounced = true; }
          if (o.y < o.minY) { o.y = o.minY; o.vy = Math.abs(o.vy); o.bvy = Math.abs(o.bvy); bounced = true; }
          else if (o.y > o.maxY) { o.y = o.maxY; o.vy = -Math.abs(o.vy); o.bvy = -Math.abs(o.bvy); bounced = true; }
          if (bounced && now < pinballUntil && pinballHits < 10 && !o.bossFight && !o.trapTok && !o.special) {
            pinballHits++;                                       // 💥 every wall hit scores while the bumpers are live
            bounceScore(o.x + o._hw, o.y + o._hh, pinballHits);
          }
          if (now - o.born > o.ttl) o.dead = true;
        } else if (o.bossFight) {                                              // the BOSS never leaves the screen — bounce
          var bw = o._hw * 2, bh = o._hh * 2;
          if (o.x < FLD.x0 + 8) { o.x = FLD.x0 + 8; o.vx = Math.abs(o.vx); o.bvx = Math.abs(o.bvx); }
          else if (o.x > FLD.x1 - bw - 8) { o.x = FLD.x1 - bw - 8; o.vx = -Math.abs(o.vx); o.bvx = -Math.abs(o.bvx); }
          if (o.y < 64) { o.y = 64; o.vy = Math.abs(o.vy); o.bvy = Math.abs(o.bvy); }
          else if (o.y > innerHeight - bh - 8) { o.y = innerHeight - bh - 8; o.vy = -Math.abs(o.vy); o.bvy = -Math.abs(o.bvy); }
          if (now - o.born > o.ttl) o.dead = true;
        } else if (o.x < FLD.x0 - 170 || o.x > FLD.x1 + 170 || o.y < -170 || o.y > innerHeight + 170 || now - o.born > o.ttl) { o.dead = true; }
        }
      }
      o.el.style.transform = "translate(" + o.x.toFixed(1) + "px," + o.y.toFixed(1) + "px)";
      if (o.dead) { removeMob(o); mobs.splice(i, 1); }
    }
    } catch (e) {}                                               // swallow — the re-arm below MUST always run
    motionRaf = mobs.length ? requestAnimationFrame(motionStep) : 0;
  }
  function bossOnScreen() { return !!(overlay && overlay.querySelector(".av-ms-token.is-boss:not(.is-decoy)")); }
  function clearField(mode) { for (var i = mobs.length - 1; i >= 0; i--) { if (mobs[i].mode === mode && !mobs[i].el.classList.contains("is-boss")) removeMob(mobs[i]); } }
  var bossHintShown = false;
  function toast(html, ms) {                                     // one small top pill at a time (latest wins)
    var old = document.querySelector(".av-ms-bosshint"); if (old) old.remove();
    var h = tier(el("div", "av-ms-bosshint", html));
    document.body.appendChild(h);
    requestAnimationFrame(function () { requestAnimationFrame(function () { h.classList.add("is-in"); }); });
    setTimeout(function () { h.classList.remove("is-in"); setTimeout(function () { h.remove(); }, 500); }, ms || 3000);
  }
  function bossHint() {                                          // heads-up a beat BEFORE the arrival cinematic
    if (bossHintShown) return; bossHintShown = true;
    toast('⚠ <b>INCOMING…</b>', 1800);
  }
  function shyBlink(o) {                                         // SHY medal: vanishes in a puff, reappears elsewhere
    o.blinkCd = perfNow() + 2600;
    if (!reduce) burst.spawn(o.x + o._hw, o.y + o._hh, 4);
    o.el.classList.add("is-blink");
    setTimeout(function () {
      if (o.removed) return;
      o.x = rnd(FLD.x0 + 70, Math.max(FLD.x0 + 140, FLD.x1 - 160)); o.y = rnd(90, Math.max(160, innerHeight * 0.72));
      if (o.mode === "arena") { o.x = Math.min(Math.max(o.x, o.minX), o.maxX); o.y = Math.min(Math.max(o.y, o.minY), o.maxY); }
      o.vx = o.bvx; o.vy = o.bvy;
      o.el.classList.remove("is-blink");
    }, 230);
  }
  function startMagnet(x, y, comboRain) {
    magnet.x = x; magnet.y = y; magnet.until = perfNow() + 4500; magnet.follow = !coarse; magnet.ate = 0;
    Sound.fx("magnet");
    toast(comboRain ? "🌀 <b>MAGNET COMBO</b> — it feasts on the rain!" : "🧲 <b>MAGNET</b> — they come to you!", 2800);
    if (!magnetFx) { magnetFx = tier(el("div", "av-ms-magnetfx")); document.body.appendChild(magnetFx); }
    magnetFx.style.transform = "translate(" + x + "px," + y + "px)";
    setTimeout(function () { if (magnetFx && perfNow() >= magnet.until) { magnetFx.remove(); magnetFx = null; } }, 4900);
  }
  function magnetEat(o) {                                        // the vortex swallows coins that reach its core
    if (o.el.__caught || o.removed || o.special || o.bossFight || o.trapTok || (o.hp && o.hp > 1)) return;
    if (o.rainTok && magnet.ate >= 5) {                          // rain scoring is CAPPED: extra drops are eaten for show
      o.el.__caught = 1; o.frozen = true; o.el.classList.add("is-caught");
      setTimeout(function () { removeMob(o); }, 260);
      if (!reduce) burst.spawn(o.x + o._hw, o.y + o._hh, 3);
      Sound.combo(magnet.ate); return;
    }
    if (o.rainTok) magnet.ate++;
    // DEFERRED: this is called from inside motionStep's mob loop — a direct catch can
    // finish the round (closeArena splices mobs) and crash the iteration, killing the
    // motion engine for good. A 0ms hop runs it safely between frames.
    setTimeout(function () { catchMob(o, o.x + o._hw, o.y + o._hh); }, 0);
  }
  var lastFxAt = 0;
  function catchFx(x, y, worth) {                                // perf: full flourish, throttled under rapid-fire (magnet feasts)
    if (reduce) return;
    var n2 = perfNow(), full = n2 - lastFxAt > 140; lastFxAt = n2;
    burst.spawn(x, y, full ? FX.shards + (worth > 1 ? 4 : 0) : 3);
    if (full) { impactRing(x, y); eventPulse(); }
  }
  function bounceScore(x, y, n) {                                // called FROM motionStep -> defer (a score can end the round)
    setTimeout(function () {
      if (isUnlocked() && !funMode) return;
      Sound.fx("ding");
      if (!reduce) { burst.spawn(x, y, 3); impactRing(x, y); }
      gainCatch(1, x, y);
      if (n >= 10) toast("💥 <b>TILT!</b> 10 bumper hits", 1800);
    }, 0);
  }
  function showPenalty(x, y, txt) {
    var p = tier(el("div", "av-ms-plus av-ms-plus--bad", txt));
    p.style.cssText += ";position:fixed;left:" + (x - 12) + "px;top:" + (y - 10) + "px;";
    document.body.appendChild(p); setTimeout(function () { p.remove(); }, 720);
  }
  function wildEffect(x, y) {                                    // "?" medal: random surprise
    var r = Math.random();
    if (r < 0.3) { gainCatch(3, x, y); toast("✨ Mystery medal — <b>+3</b>!", 2200); }
    else if (r < 0.55) {
      freezeUntil = perfNow() + 3000;
      document.documentElement.classList.add("av-ms-freeze");
      setTimeout(function () { document.documentElement.classList.remove("av-ms-freeze"); }, 3000);
      Sound.fx("freeze"); toast("❄ <b>FREEZE</b> — they can’t run!", 2600); gainCatch(1, x, y);
    } else if (r < 0.8) { startMagnet(x, y); gainCatch(1, x, y); }
    else { toast("☔ <b>MEDAL RAIN!</b>", 2400); gainCatch(1, x, y); rain(); }   // rain() plays its own storm
  }
  /* ===================== ⚡💥🪞 COMBO SET PIECES =========================
     Same shape as RAIN+MAGNET: an EVENT dresses the arena, a KEY coin pops in,
     and catching the key fuses two systems into a screen-wide payoff.
     Each has a DIFFERENT motion signature: chain (spreads), pulse (pushes),
     dip (upgrades) — so none of them feels like the magnet vortex (pulls).
     ===================================================================== */
  function keyCoin(host, glyph, cls, onCatch, label) {          // the catchable that triggers a payoff
    if (!host || !document.body.contains(host)) return;
    var b = makeToken(false, 1.05, false, "mag");               // bigger than a normal medal — it's the prize
    b.classList.remove("is-mag"); b.classList.add(cls, "is-key");
    var q = b.querySelector(".av-ms-token__q"); if (q) q.textContent = glyph;
    if (label) b.appendChild(el("span", "av-ms-token__cap", label));   // says what it DOES, right on the coin
    if (label) toast("👉 <b>Catch the " + label.toLowerCase() + "!</b>", 2600);   // instruction lands WITH the object
    var pad = 70, w = b._hw * 2, h = b._hh * 2;
    var minX = FLD.x0 + pad, maxX = Math.max(minX + 40, FLD.x1 - pad - w), minY = pad + 54, maxY = Math.max(minY + 40, innerHeight * 0.62);
    var x0 = rnd(minX, maxX), y0 = rnd(minY, maxY);
    var o = { el: b, x: x0, y: y0, vx: 0, vy: 0, bvx: rnd(-0.4, 0.4), bvy: rnd(-0.3, 0.3), _hw: b._hw, _hh: b._hh,
      rad: 90, dead0: 30, push: 0.12, maxSp: 2, mode: arena ? "arena" : "ambient",
      minX: minX, maxX: maxX, minY: minY, maxY: Math.max(minY + 40, innerHeight - pad - h), ttl: 7000, born: perfNow(), combo: !!arena, onGone: function () {} };
    o.special = function (x, y) { onCatch(x, y); gainCatch(1, x, y); };
    host.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
    if (!reduce) impactRing(x0 + b._hw, y0 + b._hh);
    Sound.fx("check");
    bindCatch(o, 1); addMob(o);
  }
  function boltBetween(x1, y1, x2, y2) {                        // a jagged arc from A to B (rotated strip + zigzag svg)
    if (reduce) return;
    var dx = x2 - x1, dy = y2 - y1, len = Math.sqrt(dx * dx + dy * dy) || 1;
    var ang = Math.atan2(dy, dx) * 180 / Math.PI;
    var s = "", px = 0;
    while (px < 92) { px += rnd(10, 18); s += px.toFixed(0) + " " + rnd(2, 18).toFixed(0) + ", "; }
    var pts = "0 10, " + s + "100 10";
    var d = tier(el("div", "av-ms-arc"));
    d.style.cssText += ";left:" + x1 + "px;top:" + y1 + "px;width:" + len + "px;transform:rotate(" + ang + "deg);";
    d.innerHTML = '<svg viewBox="0 0 100 20" preserveAspectRatio="none">' +
      '<polyline class="g1" points="' + pts + '" /><polyline class="core" points="' + pts + '" /></svg>';   // layered strokes, no filter
    document.body.appendChild(d);
    setTimeout(function () { d.remove(); }, 300);
  }
  function spTesla(host) {                                      // ⚡ CHAIN: charge the field, then a cascade arcs medal->medal
    toast("⚡ <b>TESLA COIL</b> — catch it to chain!", 2400);
    Sound.fx("storm");
    mobs.forEach(function (o) { if (!o.removed && !o.el.__caught && o.mode === "arena" && !o.bossFight && !o.special) o.el.classList.add("is-charged"); });
    for (var ci = 0; ci < (coarse ? 5 : 7); ci++) (function (k) {   // ENERGIZE the field so the chain has fuel
      setTimeout(function () {
        if (playHalted() || !document.body.contains(host)) return;
        var b = makeToken(false, rnd(0.45, 0.62)); b.classList.add("is-lite", "is-charged");
        var pad = 64, w = b._hw * 2, h = b._hh * 2;
        var minX = FLD.x0 + pad, maxX = Math.max(minX + 40, FLD.x1 - pad - w), minY = pad + 54, maxY = Math.max(minY + 40, innerHeight - pad - h);
        var x0 = rnd(minX, maxX), y0 = rnd(minY, maxY), ang = Math.random() * 6.283;
        var o = { el: b, x: x0, y: y0, vx: Math.cos(ang) * 0.7, vy: Math.sin(ang) * 0.7, bvx: Math.cos(ang) * 0.7, bvy: Math.sin(ang) * 0.7,
          _hw: b._hw, _hh: b._hh, rad: 70, dead0: 26, push: 0.18, maxSp: 2.2, mode: "arena",
          minX: minX, maxX: maxX, minY: minY, maxY: maxY, ttl: 9000, born: perfNow(), combo: true, onGone: function () {} };
        host.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
        Sound.fx("zap" + Math.min(7, k));
        bindCatch(o, 1); addMob(o);
      }, 140 + k * 130);
    })(ci);
    setTimeout(function () { keyCoin(host, "⚡", "is-tesla", function (x, y) {   // key arrives once the field is charged
      // (labelled below so the player knows instantly what this coin does)
      Sound.fx("frenzy"); hitStop(120); arenaShake();
      var px = x, py = y, links = 0;
      (function hop() {
        if (links >= 8 || playHalted() || !arena) return;
        var best = null, bd = 1e9;
        for (var i = 0; i < mobs.length; i++) {
          var o = mobs[i];
          if (o.removed || o.el.__caught || o.bossFight || o.trapTok || o.special || (o.hp && o.hp > 1)) continue;
          var ddx = (o.x + o._hw) - px, ddy = (o.y + o._hh) - py, d2 = ddx * ddx + ddy * ddy;
          if (d2 < bd) { bd = d2; best = o; }
        }
        if (!best) return;
        var tx = best.x + best._hw, ty = best.y + best._hh;
        boltBetween(px, py, tx, ty);
        best.el.__caught = 1; best.frozen = true; best.el.classList.add("is-caught");
        (function (m) { setTimeout(function () { removeMob(m); }, 300); })(best);
        Sound.fx("zap" + Math.min(7, links));
        if (!reduce) burst.spawn(tx, ty, 4);
        gainCatch(1, tx, ty);
        px = tx; py = ty; links++;
        setTimeout(hop, 115);
      })();
    }, "TESLA COIL"); }, 1000);
  }
  /* ===================================================================
     BOSS DROPS — small, fast pickups that only exist during the boss fight.
     Before this the finale branch cleared the field to just the boss, so there
     was nothing to do but draw and cut. Each drop is worth 0 points: `special`
     fires INSTEAD of scoring, so none of them can touch the GOAL-3 reserve.
     They deliberately do NOT copy keyCoin's trailing gainCatch(1) — during the
     boss fight `caught` is already GOAL-3, so that would print a "+1" that
     banks nothing. Phase split keeps the signature mechanics intact:
       armour up   -> ❄ STOP  (hold it still so the cut nodes stop sliding)
       armour gone -> 💣 BREACH (damage — refuses while armour remains, so the
                      vector cut can never be skipped)
       always      -> 🧲 TOW (drags the boss AND every twin identically — an
                      effect that moved only the real one would end phase 2)
                      ✒️ INK (buy more walls)
     =================================================================== */
  var tow = { x: 0, y: 0, until: 0, follow: false };
  function bossBody(o) { return o.bossFight || o.el.classList.contains("is-decoy"); }
  function towTick(now) {
    if (now >= tow.until) return;
    if (tow.follow && pointerX > -9000) { tow.x = pointerX; tow.y = pointerY; }
    for (var i = 0; i < mobs.length; i++) {
      var o = mobs[i];
      if (o.removed || o.el.__caught || o.mode !== "arena" || !bossBody(o)) continue;
      if (trapped && o === bossO) continue;                      // never yank a caged boss out of its cage
      if (bossDying || (o.dashUntil && now < o.dashUntil)) continue;
      var dx = tow.x - (o.x + o._hw), dy = tow.y - (o.y + o._hh), d = Math.sqrt(dx * dx + dy * dy) || 1;
      if (d < 30) { o.vx *= 0.8; o.vy *= 0.8; continue; }         // parked: stop pulling so it can't orbit
      var f = Math.max(0.9, (o.push || 0.4) * 1.7);               // must out-pull a deep-level boss's own dodge
      o.vx += (dx / d) * f; o.vy += (dy / d) * f;                 // velocity ONLY — the baseline stays its own
    }
  }
  function dropEffect(kind, x, y) {
    var host = arena && arena.querySelector(".av-ms-arena");
    if (kind === "tow") {
      tow.x = x; tow.y = y; tow.until = perfNow() + 3400; tow.follow = !coarse;
      Sound.fx("magnet"); buzz(20);
      toast(coarse ? "🧲 <b>TOW BEAM</b> — everything is dragged to that spot"
                   : "🧲 <b>TOW BEAM</b> — steer it with your cursor!", 2600);
      if (!reduce) impactRing(x, y);
    } else if (kind === "stop") {
      freezeUntil = Math.max(freezeUntil, perfNow() + 1600);
      document.documentElement.classList.add("av-ms-freeze");
      setTimeout(function () {                                    // re-check: two stops must not un-freeze early
        if (perfNow() >= freezeUntil) document.documentElement.classList.remove("av-ms-freeze");
      }, 1650);
      Sound.fx("trap"); hitStop(90); buzz([18, 40]);
      toast("❄ <b>DEAD STOP</b> — everything frozen, cut now!", 2400);
      if (!reduce) impactRing(x, y);
    } else if (kind === "ink") {
      ink = 1; paintInk();
      var pb = weaponBar && weaponBar.querySelector('[data-w="pen"]');
      if (pb) { pb.classList.remove("is-dry"); pb.classList.add("is-urge");
                setTimeout(function () { pb.classList.remove("is-urge"); }, 2600); }
      Sound.fx("check"); toast("✒️ <b>INK REFILLED</b> — draw freely", 2200);
    } else if (kind === "time") {
      var add = 4000 + Math.min(4000, Math.max(0, funLevel - 6) * 350);
      if (addTime) addTime(add);
      Sound.fx("time"); buzz([14, 30]);
      toast("⏱ <b>+" + (add / 1000).toFixed(1) + " seconds</b>", 2200);
      if (!reduce) { burst.spawn(x, y, 7); impactRing(x, y); }
    } else if (kind === "breach") {
      if (!bossO || bossO.removed || bossDying || bossO.hpShield) return;
      var dmg = Math.max(1, Math.round((bossO.hp0 || bossO.hp) * 0.33));
      if (dmg >= bossO.hp) dmg = bossO.hp - 1;                    // the killing blow stays the player's
      if (dmg < 1) { toast("💣 <b>BREACH</b> — it's on its last hit, finish it yourself!", 2600); return; }
      bossO.hp -= dmg;
      bombBlast(host, bossO.x + bossO._hw, bossO.y + bossO._hh);
      gainCatch(dmg, bossO.x + bossO._hw, bossO.y + bossO._hh, true);   // boss-reserved: the only path past GOAL-3
      enrage(bossO);
      toast("💣 <b>BREACH!</b> −" + dmg + " HP · " + bossO.hp + " left", 2600);
    }
  }
  var DROPS = {
    tow:    { g: "🧲", cls: "is-tow",    cap: "TOW" },
    stop:   { g: "❄",  cls: "is-stop",   cap: "STOP" },
    ink:    { g: "✒️", cls: "is-inkdrop", cap: "INK" },
    time:   { g: "⏱", cls: "is-timedrop", cap: "+TIME" },
    breach: { g: "💣", cls: "is-breach", cap: "BOMB" }
  };
  function bossDrop(host) {
    if (!host || !bossO || bossO.removed || bossDying || reduce) return;
    // TOW is the staple, but a caged boss is already where you want it and towTick
    // refuses to drag it out — so it would be a dud pickup. Skip it while trapped.
    var pool = trapped ? [] : ["tow", "tow"];
    if (bossO.hpShield) pool.push("stop", "stop");                // phase 1: hold it still to cut
    else pool.push("breach", "breach");                           // phase 2: damage, cut already done
    if (ink < 0.75 && weaponBar) pool.push("ink");                // never spawn a dud refill
    // ⏱ the finale clears the field, so once the boss lands the clock ONLY goes down —
    // the PUMP needs catches and the boss is the only thing left to catch. Weight time
    // drops up with the level, where the armour stack is what eats the clock.
    if (addTime) { var tw = Math.min(4, 1 + Math.floor(Math.max(0, funLevel - 6) / 4));
                   for (var ti = 0; ti < tw; ti++) pool.push("time"); }
    var kind = pool[Math.floor(Math.random() * pool.length)], D = DROPS[kind];
    var b = makeToken(false, coarse ? 0.7 : 0.62, false, "mag");
    b.classList.remove("is-mag"); b.classList.add("av-ms-drop", D.cls, "is-key");
    var q = b.querySelector(".av-ms-token__q"); if (q) q.textContent = D.g;
    b.appendChild(el("span", "av-ms-token__cap", D.cap));
    var pad = 74, w = b._hw * 2, h = b._hh * 2;
    var minX = FLD.x0 + pad, maxX = Math.max(minX + 40, FLD.x1 - pad - w);
    var minY = pad + 54, maxY = Math.max(minY + 40, innerHeight - pad - h);
    var x0 = rnd(minX, maxX), y0 = rnd(minY, maxY), ang = Math.random() * 6.283, spd = rnd(4.6, 6.2);
    var o = { el: b, x: x0, y: y0, vx: Math.cos(ang) * spd, vy: Math.sin(ang) * spd,
      bvx: Math.cos(ang) * spd, bvy: Math.sin(ang) * spd, _hw: b._hw, _hh: b._hh,
      rad: 74, dead0: 26, push: 0.42, maxSp: 7.6, mode: "arena",   // FAST — worth chasing, easy to miss
      minX: minX, maxX: maxX, minY: minY, maxY: maxY, ttl: 5200, born: perfNow(), combo: false,
      onGone: function () {} };
    o.special = function (cx, cy) { dropEffect(kind, cx, cy); };
    host.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
    if (!reduce) impactRing(x0 + b._hw, y0 + b._hh);
    Sound.fx("ding");
    bindCatch(o, 0); addMob(o);
  }
  function bombBlast(host, x, y) {                              // 💥 the detonation itself — transform/opacity only
    if (reduce) return;
    burst.spawn(x, y, 26); impactRing(x, y); bloom();
    if (!host) return;
    var b = tier(el("div", "av-ms-blast", "<i></i><i></i><u></u>"));
    b.style.left = x + "px"; b.style.top = y + "px";
    host.appendChild(b);
    setTimeout(function () { if (b.parentNode) b.remove(); }, 1100);
  }
  function spPinball(host) {                                    // 💥 PULSE: bumpers light up, then everything gets FLUNG
    toast("💥 <b>BUMPERS LIVE</b> — pop the pulse!", 2400);
    Sound.fx("magnet");
    var bump = tier(el("div", "av-ms-bumpers")); bump.innerHTML = "<i></i>";
    host.appendChild(bump); setTimeout(function () { bump.remove(); }, 9000);
    for (var bi2 = 0; bi2 < (coarse ? 5 : 7); bi2++) (function (k) {   // rack the BALLS so the pulse has something to fling
      setTimeout(function () {
        if (playHalted() || !document.body.contains(host)) return;
        var b = makeToken(false, rnd(0.45, 0.62)); b.classList.add("is-lite");
        var pad = 64, w = b._hw * 2, h = b._hh * 2;
        var minX = FLD.x0 + pad, maxX = Math.max(minX + 40, FLD.x1 - pad - w), minY = pad + 54, maxY = Math.max(minY + 40, innerHeight - pad - h);
        var x0 = rnd(minX, maxX), y0 = rnd(minY, maxY), ang = Math.random() * 6.283;
        var o = { el: b, x: x0, y: y0, vx: Math.cos(ang) * 1.1, vy: Math.sin(ang) * 1.1, bvx: Math.cos(ang) * 1.1, bvy: Math.sin(ang) * 1.1,
          _hw: b._hw, _hh: b._hh, rad: 70, dead0: 26, push: 0.2, maxSp: 3, mode: "arena",
          minX: minX, maxX: maxX, minY: minY, maxY: maxY, ttl: 10000, born: perfNow(), combo: true, onGone: function () {} };
        host.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
        Sound.fx("ding");
        bindCatch(o, 1); addMob(o);
      }, 140 + k * 120);
    })(bi2);
    setTimeout(function () { keyCoin(host, "💥", "is-pulse", function (x, y) {
      pinballUntil = perfNow() + 4200; pinballHits = 0;
      bump.classList.add("is-live");
      Sound.fx("bossdie"); hitStop(160); arenaShake(); buzz([30, 60, 30, 60, 40]);
      bombBlast(host, x, y);
      var defused = 0;                                          // 🛡 the blast DEFUSES every red fake on the field
      for (var di = 0; di < mobs.length; di++) {
        var t2 = mobs[di];
        if (t2.removed || t2.el.__caught || !t2.trapTok) continue;
        t2.el.__caught = 1; t2.frozen = true;                   // marked first so MINEFIELD's onGone can't double-pay
        t2.el.classList.add("is-defused");
        (function (m) { setTimeout(function () { removeMob(m); }, 320); })(t2);
        if (!reduce) burst.spawn(t2.x + t2._hw, t2.y + t2._hh, 4);
        defused++;
        if (defused <= 6 && addTime) addTime(500);              // each cleared fake buys back half a second
      }
      // 💣 CHAIN DETONATION — the real payoff: HALF the scoring medals on the field go up
      // and they PAY. Nearest to the blast first, so it reads as an outward chain reaction.
      var scor = [];
      for (var si = 0; si < mobs.length; si++) {
        var m = mobs[si];
        if (m.removed || m.el.__caught || m.bossFight || m.mode !== "arena") continue;
        if (m.trapTok || m.el.classList.contains("is-decoy")) continue;   // fakes were just defused above
        m._bd = Math.pow((m.x + m._hw) - x, 2) + Math.pow((m.y + m._hh) - y, 2);
        scor.push(m);
      }
      scor.sort(function (p, q) { return p._bd - q._bd; });
      var take = Math.floor(scor.length / 2), blown = 0;
      for (var bk = 0; bk < take; bk++) (function (m, k) {
        blown++;
        setTimeout(function () {                                // staggered: a chain, not one flat pop
          if (m.removed || m.el.__caught) return;
          var mx = m.x + m._hw, my = m.y + m._hh;
          if (!reduce) { burst.spawn(mx, my, 7); impactRing(mx, my); }
          Sound.hit(1, k / Math.max(1, take), (mx / innerWidth - 0.5) * 1.4);
          catchMob(m, mx, my);                                  // deferred by design — catching can end the round
        }, 90 + k * 70);
      })(scor[bk], bk);
      toast("💥 <b>PULSE!</b> " + (blown ? blown + " medal" + (blown > 1 ? "s" : "") + " detonated · " : "") +
            (defused ? "🛡 " + defused + " fake" + (defused > 1 ? "s" : "") + " cleared +" + (Math.min(defused, 6) * 0.5).toFixed(1) + "s · " : "") +
            "wall hits score", 3200);
      if (defused) Sound.fx("check");
      for (var i = 0; i < mobs.length; i++) {                   // and the SURVIVORS get flung outward
        var o = mobs[i];
        if (o.removed || o.el.__caught || o.bossFight || o.mode !== "arena") continue;
        var ddx = (o.x + o._hw) - x, ddy = (o.y + o._hh) - y, dd = Math.sqrt(ddx * ddx + ddy * ddy) || 1;
        o.vx = (ddx / dd) * 13; o.vy = (ddy / dd) * 13;
        o.bvx = (ddx / dd) * 3.2; o.bvy = (ddy / dd) * 3.2;
        o.maxSp = Math.max(o.maxSp, 9);
      }
      setTimeout(function () { bump.classList.remove("is-live"); }, 4300);
    }, "PULSE"); }, 1000);
  }
  function spChrome(host) {                                     // 🪞 DIP: a chrome wave rises and PLATES every medal
    toast("🪞 <b>CHROME BATH</b> — grab the dipper!", 2400);
    Sound.fx("chrome");
    var wave = tier(el("div", "av-ms-chromewave")); wave.innerHTML = "<i></i>";
    host.appendChild(wave);
    waveEl = wave; wvFrom = 0; wvTo = 0; wvT0 = perfNow(); wvDur = 1;
    setWave(innerHeight * 0.14, 1100);                           // the bath starts filling
    setTimeout(function () { if (waveEl === wave) { waveEl = null; waveY = 0; } wave.remove(); }, 12000);
    setTimeout(function () { keyCoin(host, "🪣", "is-dip", function (x, y) {
      chromeDipUntil = perfNow() + 4500;
      setWave(innerHeight * 0.58, 900);                          // SURGE: the bath swells and lifts everything above it
      setTimeout(function () { setWave(0, 1400); }, 4700);       // then it drains away
      Sound.fx("chrome"); hitStop(110); arenaShake(); buzz([12, 30, 12, 30, 20]);
      toast("🪞 <b>CHROME DIP!</b> Everything floats — and it’s chrome", 2800);
      for (var i = 0; i < mobs.length; i++) {                   // plate what's already on the field
        var o = mobs[i];
        if (o.removed || o.el.__caught || o.bossFight || o.trapTok || o.special) continue;
        o.chromeTok = 1; o.worth = 3;
        o.el.classList.remove("is-lite"); o.el.classList.add("is-chrome");
        if (!reduce) specRipple(o.x + o._hw, o.y + o._hh);
      }
    }, "DIPPER"); }, 1000);
  }
  function setPiece(host) {                                     // rotate so consecutive rounds differ
    var pool = [spTesla, spPinball, spChrome];
    (pool[(funMode ? funLevel : Math.floor(Math.random() * 3)) % 3])(host);
  }
  function lightning(host, side) {                              // ⚡ a full-arena flash + a jagged bolt (opacity/transform only)
    if (reduce || !host) return;
    var fl = tier(el("div", "av-ms-flash")); host.appendChild(fl);
    setTimeout(function () { fl.remove(); }, 620);
    var xPct = side ? rnd(58, 82) : rnd(18, 42);                 // alternate sides so it feels alive
    var bolt = el("div", "av-ms-bolt");
    var seg = "", x = xPct, y = 0, step = coarse ? 18 : 12;      // fewer segments on phones = fewer path points to raster
    while (y < 86) { x += rnd(-8, 8); y += rnd(step - 2, step + 3); seg += x.toFixed(1) + " " + y.toFixed(0) + ", "; }
    var pts = xPct + " 0, " + seg + (x + rnd(-4, 4)).toFixed(1) + " 100";
    // glow is LAYERED STROKES, never filter:drop-shadow — a full-screen blurred SVG
    // stalls mobile GPUs for whole frames (that was the freeze during lightning).
    bolt.innerHTML = '<svg viewBox="0 0 100 100" preserveAspectRatio="none">' +
      '<polyline class="g2" points="' + pts + '" /><polyline class="g1" points="' + pts + '" /><polyline class="core" points="' + pts + '" /></svg>';
    host.appendChild(bolt);
    setTimeout(function () { bolt.remove(); }, 500);
  }
  function rain() {                                              // heavy shower + a 🧲 COMBO coin pops in somewhere random
    var host = arena ? arena.querySelector(".av-ms-arena") : overlay;
    if (!host) return;
    Sound.fx("storm");                                           // low thunder + first droplets
    if (!reduce) {                                               // a cool storm-light washes over the arena
      var st2 = tier(el("div", "av-ms-stormtint"));
      host.appendChild(st2); setTimeout(function () { st2.remove(); }, 4200);
      lightning(host, 0);                                        // ⚡ flash on the thunder...
      setTimeout(function () { if (document.body.contains(host)) { lightning(host, 1); Sound.fx("thunder"); } }, 1900);   // ...and a second strike mid-shower
    }
    var RN = coarse ? 7 : 10;
    for (var i = 0; i < RN; i++) (function (i) {
      setTimeout(function () {
        if (playHalted() || !document.body.contains(host)) return;
        var b = makeToken(false, rnd(0.34, 0.5)); b.classList.add("is-lite");
        var x0 = rnd(FLD.x0 + 50, Math.max(FLD.x0 + 140, FLD.x1 - 120)), y0 = -70;
        var o = { el: b, x: x0, y: y0, vx: rnd(-0.4, 0.4), vy: rnd(2.1, 3), bvx: rnd(-0.3, 0.3), bvy: rnd(2.1, 3), _hw: b._hw, _hh: b._hh,
          rad: 60, dead0: 22, push: 0.1, maxSp: 4.2, mode: "ambient", ttl: 9000, born: perfNow(), combo: !!arena, rainTok: 1, onGone: function () {} };
        o.sway = 1; o.seed = Math.random() * 6.28;               // drops SWAY as they fall
        host.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
        bindCatch(o, 1); addMob(o);
      }, i * 220);
    })(i);
    setTimeout(function () {                                     // catch the 🧲 coin -> the vortex feasts on the rain
      if (playHalted() || !document.body.contains(host)) return;
      var b = makeToken(false, 0.85, false, "mag");
      var pad = 70, w = b._hw * 2, h = b._hh * 2;
      var minX = FLD.x0 + pad, maxX = Math.max(minX + 40, FLD.x1 - pad - w), minY = pad + 48, maxY = Math.max(minY + 40, innerHeight * 0.65);
      var x0 = rnd(minX, maxX), y0 = rnd(minY, maxY);
      var o = { el: b, x: x0, y: y0, vx: 0, vy: 0, bvx: rnd(-0.4, 0.4), bvy: rnd(-0.3, 0.3), _hw: b._hw, _hh: b._hh,
        rad: 90, dead0: 30, push: 0.12, maxSp: 2, mode: arena ? "arena" : "ambient",
        minX: minX, maxX: maxX, minY: minY, maxY: Math.max(minY + 40, innerHeight - pad - h), ttl: 6500, born: perfNow(), combo: !!arena, onGone: function () {} };
      o.special = function (x, y) { startMagnet(x, y, true); gainCatch(1, x, y); };
      host.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
      if (!reduce) impactRing(x0 + b._hw, y0 + b._hh);           // the "pop" announcing it
      Sound.fx("check");
      bindCatch(o, 1); addMob(o);
    }, 900);
  }
  function armBoss(o, b) {                                       // BOSS FIGHT: hp = hits left to the goal
    o.bossFight = 1; o.hp = Math.max(1, GOAL - (funMode ? funCaught : getCaught()));
    o.hp0 = o.hp;                                                // 💣 BREACH sizes its 33% off the STARTING pool
    // ARMOUR scales with the level (shield hits cost time but give NO progress, so the
    // GOAL math stays exact) — this is what makes deep-level bosses an actual fight.
    // Real round gets exactly ONE layer so every player meets the vector cut once;
    // fun levels stack more. Armour is stripped by CUTTING, never by clicking.
    var sh = funMode ? Math.max(1, Math.min(5, Math.ceil((funLevel - 1) / 2.4))) : 1;   // L1-2:1 L4:2 L6:3 L9:4 L11+:5
    if (wallTier) { sh += wallTier >= 4 ? 2 : 1; o.wallFeint = wallTier >= 3; }   // 🧱 walls stack on top
    o.hpShield = Math.min(7, sh);
    o.armour0 = o.hpShield;
    b.appendChild(el("span", "av-ms-token__rim"));               // rim light silhouettes the boss (warms per hit)
    b.setAttribute("data-rim", "0");
    bossRibbon(o, b);
  }
  function bossRibbon(o, b) {
    var rib = (b || o.el).querySelector(".av-ms-token__ribbon");
    if (!rib) return;
    rib.textContent = (o.hpShield ? "🛡" + o.hpShield + " " : "") + Array(o.hp + 1).join("◆");
    rib.classList.toggle("is-armoured", !!o.hpShield);
  }
  function enrage(o) {                                           // each hit: faster, angrier, dashes away, spawns decoys
    o.maxSp *= 1.35; o.push *= 1.35; o.rad += 15; o.bvx *= 1.28; o.bvy *= 1.28;
    o.el.classList.add("is-enraged");
    bossRibbon(o);
    Sound.fx("bosshit"); hitStop(120); arenaShake(); buzz([20, 50, 20]);
    o.el.setAttribute("data-rim", o.hp === 2 ? "1" : "2");       // rim warms: base -> ember -> furnace
    o.critUntil = perfNow() + 970;                               // dash (450ms) + weak-point CRITICAL window (~520ms)
    (function (m) {
      setTimeout(function () { if (!m.removed && !m.el.__caught) m.el.classList.add("is-crit"); }, 455);
      setTimeout(function () { if (!m.removed) m.el.classList.remove("is-crit"); }, 975);
    })(o);
    toast(o.hp === 2 ? "⚔️ Boss hit — <b>2 more!</b>" : "🔥 Boss ENRAGED — <b>1 more hit!</b>", 2000);
    if (!reduce) {
      o.dashUntil = perfNow() + 450;
      o.el.classList.add("is-dashing");
      (function (m) { setTimeout(function () { if (!m.removed) m.el.classList.remove("is-dashing"); }, 470); })(o);
      if (pointerX > -9000) { var dx = (o.x + o._hw) - pointerX, dy = (o.y + o._hh) - pointerY, dd = Math.sqrt(dx * dx + dy * dy) || 1; o.vx = (dx / dd) * 9; o.vy = (dy / dd) * 9; }
      burst.spawn(o.x + o._hw, o.y + o._hh, 8);
      if (o.wallFeint && Math.random() < 0.55) {                 // 🧱 PHANTOM FEINT: a second surprise dash mid-window
        (function (m) { setTimeout(function () {
          if (m.removed || m.el.__caught) return;
          m.dashUntil = perfNow() + 380; m.el.classList.add("is-dashing");
          setTimeout(function () { if (!m.removed) m.el.classList.remove("is-dashing"); }, 390);
          if (pointerX > -9000) { var fdx = (m.x + m._hw) - pointerX, fdy = (m.y + m._hh) - pointerY, fdd = Math.sqrt(fdx * fdx + fdy * fdy) || 1; m.vx = (fdx / fdd) * 8; m.vy = (fdy / fdd) * 8; }
        }, 640); })(o);
      }
    }
    [].forEach.call(document.querySelectorAll(".av-ms-token.is-decoy"), function (d) {   // older decoys warm up too
      d.classList.add("is-enraged");
      d.setAttribute("data-rim", o.el.getAttribute("data-rim") || "0");
      var dr2 = d.querySelector(".av-ms-token__ribbon"), sr2 = o.el.querySelector(".av-ms-token__ribbon");
      if (dr2 && sr2) { dr2.textContent = sr2.textContent; dr2.className = sr2.className; }
    });
    spawnDecoys(o, o.hp === 2 ? 1 : 2);
  }
  function spawnDecoys(src, n) {                                 // boss "splits" into look-alike decoys (worth 0)
    var host = src.mode === "arena" && arena ? arena.querySelector(".av-ms-arena") : overlay;
    if (!host) return;
    for (var i = 0; i < n; i++) {
      var b = makeToken(false, 1.4, true);                       // SAME size as the boss — no size tell
      b.classList.add("is-decoy");
      // perfect disguise: mirror the boss's rim state, enrage glow and ribbon pips
      if (src.el.classList.contains("is-enraged")) b.classList.add("is-enraged");
      b.setAttribute("data-rim", src.el.getAttribute("data-rim") || "0");
      b.appendChild(el("span", "av-ms-token__rim"));
      var srib = src.el.querySelector(".av-ms-token__ribbon"), drib = b.querySelector(".av-ms-token__ribbon");
      if (srib && drib) { drib.textContent = srib.textContent; drib.className = srib.className; }
      var ang = Math.random() * 6.283, spd = rnd(1.6, 2.6);
      var o = { el: b, x: src.x, y: src.y, vx: Math.cos(ang) * 7, vy: Math.sin(ang) * 7, bvx: Math.cos(ang) * spd, bvy: Math.sin(ang) * spd,
        _hw: b._hw, _hh: b._hh, rad: src.rad, dead0: 34, push: src.push, maxSp: src.maxSp, mode: src.mode, ttl: 9000, born: perfNow(), onGone: function () {} };   // inherits the ENRAGED boss's dodge — behavior doesn't tell either
      o.dashUntil = perfNow() + 400;                             // burst out of the boss uncatchably fast
      if (src.mode === "arena") { o.minX = src.minX; o.maxX = src.maxX; o.minY = src.minY; o.maxY = src.maxY; }
      // popping a twin is the core of PHASE 2 — say plainly that it was fake and how many
      // are left, so "click them away until one survives" reads as the intended plan.
      // `this` (not a closured `o`) — every decoy in this loop shares one `var o`.
      o.special = function (x, y) {
        this.el.classList.add("is-fake");
        var left = document.querySelectorAll(".av-ms-token.is-decoy:not(.is-caught)").length;
        toast(left ? "😜 <b>Fake!</b> " + left + " twin" + (left > 1 ? "s" : "") + " still out there"
                   : "😜 <b>Last fake gone</b> — the one still standing is the REAL boss", 1900);
        Sound.fx("crack"); buzz(18);
        if (!reduce) { burst.spawn(x, y, 6); showWarm(x, y, "😜 fake"); }
      };
      host.appendChild(b); b.style.transform = "translate(" + o.x + "px," + o.y + "px)";
      bindCatch(o, 0); addMob(o);
    }
  }
  function inviteCatch(x, y) {                                   // ambient medal clicked -> nudge into the round
    if (!reduce) { burst.spawn(x, y, 6); impactRing(x, y); }
    Sound.fx("check");
    toast("⏱ These only count in the <b>Challenge Round</b> — tap ▶ to start it", 3200);
    togglePop(true);
  }
  function spawnAmbient() {
    // AMBIENT medals are a LURE only: they drift for the celebration feel, but PROGRESS
    // counts ONLY inside the timed Challenge Round (anti-cheat — no timerless farming).
    // Clicking one pops it and invites the visitor to start the round. BOSS = arena only.
    if (isUnlocked() || getCaught() >= GOAL || active >= MAXTOK || !overlay) return;
    var vw = innerWidth, vh = innerHeight;
    var rare = Math.random() < 0.14, persona = null;
    if (!rare) { var pp = Math.random(); persona = pp < 0.22 ? "zig" : pp < 0.34 ? "dart" : pp < 0.44 ? "shy" : null; }
    var scale = rare ? rnd(0.82, 1.05) : persona === "dart" ? rnd(0.38, 0.52) : rnd(0.42, 1.0);
    var b = makeToken(rare, scale); active++;
    if (persona) b.classList.add("is-" + persona);
    var fromLeft = Math.random() < 0.5;
    var y0 = rnd(vh * 0.16, vh * 0.72), x0 = fromLeft ? -130 : vw + 130;
    var spd = persona === "dart" ? rnd(1.2, 1.9) : rnd(0.6, 1.4);
    var bvx = (fromLeft ? 1 : -1) * spd, bvy = rnd(-0.3, 0.3);
    var o = { el: b, x: x0, y: y0, vx: bvx, vy: bvy, bvx: bvx, bvy: bvy, _hw: b._hw, _hh: b._hh,
      rad: 100, dead0: 34, push: 0.28, maxSp: persona === "dart" ? 5 : 2.9, mode: "ambient", ttl: 44000, born: perfNow(), onGone: function () { active--; } };
    if (persona === "zig") { o.zig = 1; o.seed = Math.random() * 6.28; }
    else if (persona === "dart") { o.dart = 1; o.nextDart = perfNow() + 800; }
    else if (persona === "shy") o.shyTok = 1;
    o.special = inviteCatch;
    overlay.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
    bindCatch(o, 0); addMob(o);
  }
  function gainCatch(worth, x, y, fromBoss) {
    if (ARCADE || funMode) { funGain(worth, x, y, fromBoss); return; }   // fun replay / arcade: separate counter, nothing persisted
    if (isUnlocked()) return;
    var prev = getCaught();
    // The last 3 points belong to the BOSS. Without this cap a magnet/chain/pinball
    // burst could jump 34 -> 40 and end the round with no boss fight at all.
    var c = Math.min(fromBoss ? GOAL : GOAL - 3, prev + worth); setCaught(c);
    if (prev === 0 && c > 0) { try { if (!localStorage.getItem(KEY + "_t0")) localStorage.setItem(KEY + "_t0", "" + Date.now()); } catch (e) {} }   // hunt timer starts on the 1st catch
    if (x != null) { showPlus(x, y, worth); Sound.hit(worth, c / GOAL, (x / innerWidth - 0.5) * 1.4); catchFx(x, y, worth); }
    updateHUD();
    if (c >= GOAL) { win(); return; }
    if (prev < 10 && c >= 10 && c < 20) { toast("💪 <b>" + c + "/" + GOAL + "</b> — keep going!", 2400); Sound.fx("check"); }
    else if (prev < 20 && c >= 20 && c < 30) { toast("🔥 <b>Halfway!</b> " + c + "/" + GOAL, 2400); Sound.fx("check"); }
    else if (prev < 30 && c >= 30 && c < GOAL - 3) { toast("⚡ <b>" + c + "/" + GOAL + "</b> — almost there!", 2400); Sound.fx("check"); }
  }
  function showPlus(x, y, worth) {
    var p = tier(el("div", "av-ms-plus", "+" + worth));
    p.style.cssText += ";position:fixed;left:" + (x - 8) + "px;top:" + (y - 10) + "px;";
    document.body.appendChild(p); setTimeout(function () { p.remove(); }, 720);
  }
  function impactRing(x, y) {
    var r = tier(el("div", "av-ms-ring"));
    r.style.cssText += ";left:" + x + "px;top:" + y + "px;";
    document.body.appendChild(r); setTimeout(function () { r.remove(); }, 300);
  }
  // lightweight persistent burst canvas: tier-colored shards + a white spark on each catch
  var burst = (function () {
    var cv, g, W, H, dpr = Math.min(window.devicePixelRatio || 1, 2), P = [], raf = 0, last = 0;
    var COLS = { bronze: ["#e8a15a", "#b76e2c"], silver: ["#e9f2ff", "#9fb3c8"], gold: ["#ffd875", "#e0a422"], platinum: ["#eaf4ff", "#a9c6e0"] };
    function size() { if (!cv) return; W = cv.width = innerWidth * dpr; H = cv.height = innerHeight * dpr; cv.style.width = innerWidth + "px"; cv.style.height = innerHeight + "px"; }
    function ensure() { if (cv) return; cv = el("canvas", "av-ms-burst"); cv.setAttribute("aria-hidden", "true"); document.body.appendChild(cv); g = cv.getContext("2d"); size(); addEventListener("resize", size, { passive: true }); }
    function spawn(x, y, n) {
      ensure(); var pal = (COLS[TIER] || COLS.silver).concat(["#ffffff"]); x *= dpr; y *= dpr;
      var count = Math.min(n || 6, 24);                          // big blasts (boss death) get the full spread
      for (var i = 0; i < count; i++) {
        if (P.length > 90) break;
        var a = Math.random() * 6.283, sp = (2 + Math.random() * 5) * dpr;
        P.push({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 2 * dpr, s: (2 + Math.random() * 3) * dpr, rot: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.4, life: 0, ttl: 300 + Math.random() * 260, c: pal[(Math.random() * pal.length) | 0] });
      }
      P.push({ x: x, y: y, s: (5 + Math.random() * 3) * dpr, life: 0, ttl: 200, spark: true });
      if (!raf) { last = 0; raf = requestAnimationFrame(frame); }
    }
    function frame(t) {
      if (!last) last = t; var dt = Math.min(40, t - last); last = t; g.clearRect(0, 0, W, H);
      for (var i = P.length - 1; i >= 0; i--) {
        var p = P[i]; p.life += dt; if (p.life >= p.ttl) { P.splice(i, 1); continue; }
        var k = 1 - p.life / p.ttl; g.save(); g.translate(p.x, p.y);
        if (p.spark) { g.globalAlpha = k * k; g.fillStyle = "#ffffff"; g.beginPath(); g.arc(0, 0, p.s * (0.4 + k), 0, 6.283); g.fill(); }
        else { p.vy += 0.05 * dpr * dt / 16; p.x += p.vx * dt / 16; p.y += p.vy * dt / 16; p.rot += p.vr; p.vx *= 0.99; g.globalAlpha = k; g.rotate(p.rot); g.fillStyle = p.c; g.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 0.7); }
        g.restore();
      }
      raf = P.length ? requestAnimationFrame(frame) : 0;
    }
    return { spawn: spawn };
  })();

  /* =====================================================================
     ARCADE challenge round  (fast tokens, 30s, combo; catches count toward goal)
     ===================================================================== */
  var arena, arenaRaf, arenaEnd, arenaSpawn, combo = 0, lastCatch = 0, maxCombo = 0;
  // FUN MODE: replay the round after winning, purely for fun — each level is 10s
  // shorter and the boss 0.5x faster. No code/progress at stake.
  var funMode = false, funCaught = 0, funLevel = 2;
  try { funLevel = Math.max(2, parseInt(localStorage.getItem("av_ms_funlvl") || "2", 10) || 2); } catch (e) {}
  var funMax = funLevel;                                       // 🕹 highest level ever reached = the arcade picker ceiling
  var funRunStart = 0, funRunLog = [], ghostTracking = false, ghost = null;   // 👻 race your fastest clean round
  try { ghost = JSON.parse(localStorage.getItem("av_ms_ghost") || "null"); } catch (e) {}
  // 🃏 MUTATOR deck (L3+, seeded by level so L22 ≠ L23), 🧱 WALL bosses (every 5th),
  // 🌬 crosswind vector, 🕊 mercy after 2 fails on the same level.
  var muts = [], windX = 0, addTime = null, wallTier = 0, funFails = {};
  // ⚡💥🪞 SET PIECES — the rain+magnet pattern: EVENT -> KEY coin -> two systems fuse.
  var pinballUntil = 0, pinballHits = 0, chromeDipUntil = 0;
  // 🪞 the chrome bath is a real LIQUID: one JS-driven level drives BOTH the visual
  // and the buoyancy, so medals visibly get lifted out of it and bob on the surface.
  var waveEl = null, waveY = 0, wvFrom = 0, wvTo = 0, wvT0 = 0, wvDur = 1;
  function curWaveH() {
    if (!waveEl) return 0;
    var k = Math.max(0, Math.min(1, (perfNow() - wvT0) / wvDur));
    k = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;   // ease in-out
    return wvFrom + (wvTo - wvFrom) * k;
  }
  function setWave(toH, dur) { wvFrom = curWaveH(); wvTo = toH; wvT0 = perfNow(); wvDur = dur || 800; }
  var MUTS = {
    "CROSSWIND":   { icon: "»",  rule: "side-wind pushes every medal" },
    "MINEFIELD":   { icon: "⛔", rule: "fakes swarm — untouched fakes pay +0.5s" },
    "CHROME RUSH": { icon: "✨", rule: "chrome odds ×5 — feast!" }
  };
  function pickMuts(lvl) {
    var names = ["CROSSWIND", "MINEFIELD", "CHROME RUSH"];
    var out = [names[lvl % 3]];
    if (lvl >= 12) out.push(names[(lvl + 1) % 3]);               // L12+: DOUBLE MUTATION
    return out;
  }
  var WALLNAMES = ["", "OVERCLOCK", "TWIN SIGNAL", "PHANTOM FEINT", "IRONCLAD", "TWIN STORM"];
  // COMPRESSED ARC: something new every level to ~L16, then UNCAPPED asymptotic
  // curves — every level is measurably meaner forever, but never impossible.
  function funSecs() { return Math.max(20, Math.round(52 - (funLevel - 2) * 2.5)); }        // melts to 20s; PUMP feeds it back
  function playHalted() { return isUnlocked() && !funMode; }     // "unlocked" stops the real game but NOT fun replays
  function funBoost() { return +(4.0 - 2.8 * Math.pow(0.9, funLevel - 2)).toFixed(2); }     // boss → asymptote 4.0
  function funSpeed() { return +(2.6 - 1.6 * Math.pow(0.92, funLevel - 2)).toFixed(2); }    // medals → asymptote 2.6
  function funGain(worth, x, y, fromBoss) {
    funCaught = Math.min(fromBoss ? GOAL : GOAL - 3, funCaught + worth);   // last 3 are the boss's alone
    if (addTime) addTime(600 * worth);                           // ⏱ PUMP THE CLOCK: every catch feeds the timer
    if (ghostTracking) for (var gi = 0; gi < worth && funRunLog.length < GOAL; gi++) funRunLog.push(Math.round(perfNow() - funRunStart));
    if (x != null) { showPlus(x, y, worth); Sound.hit(worth, funCaught / GOAL, (x / innerWidth - 0.5) * 1.4); catchFx(x, y, worth); }
    if (funCaught >= GOAL) {
      var cleared = funLevel, ghostMsg = "";
      if (ghostTracking && funRunLog.length) {                   // 👻 fastest clean round becomes the ghost
        var gdur = funRunLog[funRunLog.length - 1];
        var fair = cleared >= (ghost && ghost.lvl || 0);        // an easy replay cannot erase a hard-level record
        var beat = !!(ghost && ghost.dur && fair && gdur < ghost.dur);
        if (!ghost || !ghost.dur || (fair && gdur < ghost.dur)) {
          ghost = { t: funRunLog.slice(), dur: gdur, lvl: cleared };
          try { localStorage.setItem("av_ms_ghost", JSON.stringify(ghost)); } catch (e) {}
        }
        if (beat) ghostMsg = " 👻 <b>Ghost beaten!</b>";
      }
      funLevel++;
      if (funLevel > funMax) funMax = funLevel;                  // replaying a low level must never lower the ceiling
      try { localStorage.setItem("av_ms_funlvl", "" + funMax); } catch (e) {}
      delete funFails[cleared];                                  // 🕊 mercy resets on a win
      funCaught = 0; funMode = false;
      Sound.win(); confetti(Math.min(4, 1 + 0.15 * (cleared - 1)));            // denser celebration each level (soft-capped 4x)
      closeArena();
      toast("🏆 <b>LEVEL " + cleared + " CLEARED!</b>" + ghostMsg + " Next: Level " + funLevel, 3800);
      if (pop) refreshPop();
    }
  }
  function startArena() {
    /* 🎯 THE BACKSTOP. Even if some future surface calls this, a medal round
       that could reach win() must not open while the cannon owns the
       milestone — that is the second route to the code, by definition.
       funMode and ARCADE rounds are exempt because they CANNOT grant it:
       gainCatch() sends every catch in those rounds to funGain(), which
       keeps its own counter and never touches setUnlocked(). The arcade
       easter-egg badge therefore still works on a cannon page. */
    if (GAME_ON && !funMode && !ARCADE) return;
    if (ARCADE) funMode = true;                                  // 🕹 arcade rounds are always no-stakes
    tutForce = funMode && funLevel === 1;                        // 📖 level 1 replays every tutorial card
    if (isUnlocked() && !funMode) return;
    if (arena) closeArena();                                     // never stack two arenas
    if (pop) pop.hidden = true;
    var DUR0 = funMode ? funSecs() * 1000 : 60000;
    ghostTracking = funMode && funCaught === 0;                  // 👻 pace race only on clean full rounds
    if (ghostTracking) { funRunStart = perfNow(); funRunLog = []; }
    var showGhost = ghostTracking && ghost && ghost.t && ghost.t.length;
    muts = funMode && funLevel >= 3 ? pickMuts(funLevel) : [];   // 🃏 this level's card(s)
    windX = muts.indexOf("CROSSWIND") > -1 ? (funLevel % 2 ? 1 : -1) * 0.9 : 0;
    wallTier = funMode && funLevel >= 5 && funLevel % 5 === 0 ? funLevel / 5 : 0;   // 🧱 every 5th level
    var mercy = funMode && (funFails[funLevel] || 0) >= 2;       // 🕊 two losses on this level -> quiet help
    if (mercy) DUR0 += 5000;
    var trapRate = !funMode || funLevel < 5 ? 0 : Math.min(0.26, 0.08 + (funLevel - 5) * 0.012);
    if (muts.indexOf("MINEFIELD") > -1) trapRate = 0.34;
    if (mercy) trapRate *= 0.5;
    var era = funMode && funLevel >= 11 ? ["ion", "void", "aurora", "solar"][Math.floor((funLevel - 11) / 3) % 4] : "";
    var modal = tier(el("div", "av-ms-modal av-ms-modal--arena is-open"));
    modal.innerHTML =
      '<div class="av-ms-modal__scrim"></div>' +
      '<div class="av-ms-arena">' +
        '<div class="av-ms-dawn" data-stage="0"><i class="d0"></i><i class="d1"></i><i class="d2"></i><i class="d3"></i></div>' +
        '<div class="av-ms-arena__timebar"><i></i></div>' +
        '<div class="av-ms-arena__hud">' +
          '<div class="av-ms-arena__stat"><b data-got>' + (funMode ? funCaught : getCaught()) + '</b><span>caught / ' + GOAL + '</span></div>' +
          '<div class="av-ms-arena__stat"><b data-time>' + Math.ceil(DUR0 / 1000) + '</b><span>seconds</span></div>' +
          (showGhost ? '<div class="av-ms-arena__stat av-ms-ghoststat"><b data-ghost>0</b><span>👻 pace</span></div>' : '') +
          (windX ? '<div class="av-ms-arena__stat av-ms-windstat"><b data-wind>' + (windX > 0 ? '»»»' : '«««') + '</b><span>🌬 wind</span></div>' : '') +
        '</div>' +
        (funMode
          ? '<div class="av-ms-arena__title"><b>LEVEL ' + funLevel + ' — Catch ' + GOAL + '</b><span>' + funSecs() + 's on the clock · boss ×' + funBoost().toFixed(1) + (funLevel >= 5 ? ' · 🚫 avoid the RED fakes (−5s)!' : ' speed · just for fun!') + '</span></div>'
          : '<div class="av-ms-arena__title"><b>Catch ' + GOAL + ' ' + TIER_NAME + ' tokens</b><span>Rare glow = +2 · <b>?</b> = mystery · ⏱ = +5s · some medals fight back!</span></div>') +
        '<div class="av-ms-arena__foot"><button class="av-ms-btn av-ms-btn--ghost" type="button" data-quit>Quit</button></div>' +
      '</div>';
    document.body.appendChild(modal); arena = modal;
    modal.setAttribute("data-tier", activeTier());               // fun L5+: the arena glows gold/platinum
    if (ARCADE) modal.setAttribute("data-arcade", "1");          // 🕹 badges the round as the easter egg
    if (era) modal.setAttribute("data-era", era);                // 🌌 L11+: named ERAS retint the whole arena
    try { var _w2 = new Image(); _w2.src = BOSS_SRC[activeTier()]; var _w3 = new Image(); _w3.src = MEDALS[activeTier()]; } catch (e) {}
    var holdUntil = 0;                                           // clock + spawns stay frozen while the intro card is up
    if (funMode && (muts.length || wallTier)) {                  // 🃏 the LEVEL STAMP slams its rules in
      holdUntil = perfNow() + 2400;
      var stampC = tier(el("div", "av-ms-mutstamp"));
      stampC.innerHTML =
        '<b>L' + funLevel + (wallTier ? ' · 🧱 WALL: ' + (WALLNAMES[Math.min(wallTier, 5)] || "APEX") : '') + (era ? ' · ' + era.toUpperCase() : '') + '</b>' +
        muts.map(function (m) { return '<span>' + (MUTS[m] ? MUTS[m].icon + " " : "") + m + '</span>'; }).join("") +
        '<i>' + muts.map(function (m) { return MUTS[m] ? MUTS[m].rule : ""; }).join(" · ") + (funLevel >= 4 ? ' · every catch +0.6s' : '') + '</i>';
      modal.appendChild(stampC);
      var ttl0 = modal.querySelector(".av-ms-arena__title");
      if (ttl0) ttl0.classList.add("is-min");                     // never stack the stamp on the title
      setTimeout(function () { Sound.fx("bosshit"); hitStop(100); arenaShake(); buzz(30); }, 350);
      setTimeout(function () {
        stampC.classList.add("is-out");
        if (ttl0) ttl0.classList.remove("is-min");                // hand the panel back once the stamp leaves
        setTimeout(function () { stampC.remove(); }, 500);
      }, 2200);
    }
    if (mercy) setTimeout(function () { toast("🕊 <b>The arena favors you</b>", 2200); }, 2900);
    // the arena scrim already hides the page -> park the site's heavy WebGL so the round
    // stays smooth even on weak devices (their IO-gated loops stop drawing when hidden)
    document.documentElement.classList.add("av-ms-lowfx");
    var playfield = arena.querySelector(".av-ms-arena");
    fieldSize();                                                 // paint the letterbox for THIS arena
    weaponsInit(playfield);                                      // ✒️ the pen is armed from the first second
    var windLayer = null;
    if (windX && !reduce) {                                      // 🌬 visible air: streaks blowing across the arena
      windLayer = tier(el("div", "av-ms-wind"));
      windLayer.setAttribute("data-dir", windX > 0 ? "r" : "l");
      var ws = "", wn = coarse ? 7 : 11;
      for (var wi = 0; wi < wn; wi++) {
        ws += '<i style="top:' + rnd(5, 92).toFixed(1) + '%;width:' + rnd(70, 190).toFixed(0) + 'px;' +
              'animation-duration:' + rnd(1.5, 3).toFixed(2) + 's;animation-delay:' + (-rnd(0, 3)).toFixed(2) + 's"></i>';
      }
      windLayer.innerHTML = ws;
      playfield.appendChild(windLayer);
    }
    var timeI = arena.querySelector(".av-ms-arena__timebar i");
    var gotB  = arena.querySelector("[data-got]");
    var timeB = arena.querySelector("[data-time]");
    arena.querySelector("[data-quit]").addEventListener("click", closeArena);
    arena.querySelector(".av-ms-modal__scrim").addEventListener("click", closeArena);

    var DURATION = DUR0, t0 = perfNow(), aActive = 0, AMAX = coarse ? 4 : 6;
    var timeBonus = 0, frenzyAt = 15000 + Math.random() * 18000, frenzyDone = false;
    // ⏱ The +5s medals used to stop spawning at a FLAT 15s on every level, while the
    // difficulty kept climbing around them: armour 1 -> 5 layers, and the round melting
    // from 52s to the 20s floor. That flat cap is why deep levels became unfinishable.
    var timeCap = 15000 + (funMode ? Math.max(0, funLevel - 5) * 1800 : 0);   // L18 -> ~38s
    var clutchOn = false, lastBeat = 0;                          // final-5s photo finish
    var gAhead = null, goldFlipped = false;                      // ghost chip state + BEST PACE flip
    var rainAt = 6000 + Math.random() * 7000, rainDone = false;    // ☔ guaranteed MEDAL RAIN — early enough that fast players see it too
    // ⛔ MINEFIELD is the round where the field fills with medals you must NOT touch, so the
    // bomb is its natural answer: it comes 3x instead of once, always the bomb, and sooner /
    // tighter — those rounds melt to 20s at high level, so a 9s gap would never fit three.
    var mineRound = muts.indexOf("MINEFIELD") > -1;
    var spMax = mineRound ? 3 : 1, spGap = mineRound ? 6000 : 9000;
    var spAt = rainAt + (mineRound ? 2000 : 6000), spCount = 0, dropAt = 0;    // ⚡💥🪞 a SECOND set piece after the rain
    pinballUntil = 0; pinballHits = 0; chromeDipUntil = 0;
    var lastEmber = 0, dawnSt = -1, bedOk = false, lastBedTry = 0;   // combo embers · tier dawn · tonal bed
    var mpOn = false, lastMpDash = 0, mpDashes = 0, windFlipped = false;   // 🎯 match point · 🌬 wind shift
    var lastLoopAt = 0;                                          // frame-gap watchdog (tab backgrounded)
    maxCombo = 0; combo = 0;
    addTime = funMode && funLevel >= 4 ? function (ms) { DURATION = Math.min(DURATION + ms, 90000); } : null;   // ⏱ PUMP THE CLOCK
    var titleEl = arena.querySelector(".av-ms-arena__title");    // auto-minimize so the field stays clear (esp. mobile)
    setTimeout(function () { if (titleEl && arena) titleEl.classList.add("is-min"); }, 4000);
    function loop() {
      var now = perfNow();
      var dt = lastLoopAt ? now - lastLoopAt : 0;
      lastLoopAt = now;
      // PAUSE (don't reset) the clock while a cinematic holds, and don't charge the
      // round for time a backgrounded tab spent with rAF suspended.
      if (now < holdUntil || guidePause || dt > 1000) { t0 += dt; arenaEnd = t0 + DURATION; }
      if (now < holdUntil || guidePause) { arenaRaf = requestAnimationFrame(loop); return; }
      var left = Math.max(0, DURATION - (now - t0));
      timeI.style.transform = "scaleX(" + (left / DURATION) + ")";
      timeB.textContent = Math.ceil(left / 1000);
      gotB.textContent = funMode ? funCaught : getCaught();
      var clutch = left <= 5000 && left > 0 && (funMode ? funCaught : getCaught()) >= GOAL - 4 && (funMode || !isUnlocked());
      if (!winning && !bossDying) slowmo = clutch ? 0.92 : 1;    // CLUTCH: photo-finish mercy slow (boss death owns slowmo)
      if (clutch && !clutchOn) { clutchOn = true; var pfc = arena.querySelector(".av-ms-arena"); if (pfc && !reduce) pfc.classList.add("is-clutch"); }
      else if (!clutch && clutchOn) { clutchOn = false; var pfc2 = arena.querySelector(".av-ms-arena"); if (pfc2) pfc2.classList.remove("is-clutch"); }
      if (clutch && now - lastBeat > 1000) { lastBeat = now; Sound.fx("beat"); timeB.classList.remove("is-pop"); void timeB.offsetWidth; timeB.classList.add("is-pop"); }
      if (ghostTracking && ghost && ghost.t) {                   // 👻 where was the PB run at this moment?
        var ge = now - t0, gcnt = 0;
        while (gcnt < ghost.t.length && ghost.t[gcnt] <= ge) gcnt++;
        var gEl = arena.querySelector("[data-ghost]");
        if (gEl) {
          gEl.textContent = gcnt;
          var ahead = funCaught >= gcnt;
          if (ahead !== gAhead) {
            var wasBehind = gAhead === false;
            gAhead = ahead; var gsn = gEl.parentNode; gsn.classList.toggle("is-ahead", ahead); gsn.classList.toggle("is-behind", !ahead);
            if (ahead && wasBehind && !goldFlipped) {             // 🥇 the frame you overtake your ghost
              goldFlipped = true; gsn.classList.add("is-goldflip");
              toast("🥇 <b>BEST PACE!</b>", 1300); Sound.fx("goldflip"); buzz([12, 30, 12]);
            }
          }
        }
      }
      var cRain = funMode ? funCaught : getCaught();             // fire by TIME or by PROGRESS (fast catchers hit 12 before rainAt), but never once the boss is due
      if (!rainDone && (now - t0 > rainAt || cRain >= 12) && cRain < GOAL - 3) { rainDone = true; toast("☔ <b>MEDAL RAIN!</b>", 2400); rain(); }
      // 🧲💣❄✒️ BOSS DROPS — the finale clears the field, so these are the only
      // other things on screen. First one lands ~2.6s after the boss settles.
      if (bossO && !bossDying && !reduce) {
        if (!dropAt) dropAt = now + 2600;
        else if (now > dropAt && document.querySelectorAll(".av-ms-drop:not(.is-caught)").length < 2) {
          dropAt = now + rnd(4200, 6200); bossDrop(playfield);
        }
      }
      if (spCount < spMax && rainDone && cRain < GOAL - 4 &&      // ⚡💥🪞 repeats are TIME-gated only, so the
          (now - t0 > spAt || (spCount === 0 && cRain >= 20))) {  // progress trigger can't fire all three at once
        spCount++; spAt = (now - t0) + spGap;
        if (mineRound) spPinball(playfield); else setPiece(playfield);
      }
      if (combo >= 4 && now - lastCatch < 2600 && now - lastEmber > (combo >= 6 ? 350 : 700) && !reduce) {   // combo EMBERS rise
        lastEmber = now;
        if (playfield.querySelectorAll(".av-ms-ember").length < 6) {
          var em = tier(el("div", "av-ms-ember" + (combo >= 7 ? " is-warm" : "")));
          em.style.left = (5 + Math.random() * 90) + "%"; em.style.top = (innerHeight - 90) + "px";
          playfield.appendChild(em); (function (e2) { setTimeout(function () { e2.remove(); }, 2700); })(em);
        }
      }
      var cNow = funMode ? funCaught : getCaught();               // TIER DAWN: the arena sunrise tracks progress
      var st = cNow >= GOAL - 3 ? 4 : cNow >= 30 ? 3 : cNow >= 20 ? 2 : cNow >= 10 ? 1 : 0;
      if (st !== dawnSt) {
        dawnSt = st;
        var dw = arena.querySelector(".av-ms-dawn"); if (dw) dw.setAttribute("data-stage", st);
        Sound.bed.level(Math.min(st, 3), funMode);
      }
      if (!bedOk && now - lastBedTry > 1500) { lastBedTry = now; bedOk = Sound.bed.start(funMode, Math.min(Math.max(dawnSt, 0), 3)); }
      if (funMode && funLevel >= 6 && !mpOn && funCaught === GOAL - 1) {   // 🎯 MATCH POINT: the last hit resists
        mpOn = true; toast("🎯 <b>MATCH POINT</b>", 1800); Sound.fx("beat"); buzz([20, 40, 20]);
        var shade = tier(el("div", "av-ms-mpshade")); arena.querySelector(".av-ms-arena").appendChild(shade);
      }
      if (mpOn && now - lastMpDash > (funLevel >= 13 ? 2100 : 3100) && mpDashes < 3) {
        lastMpDash = now;
        for (var mi2 = 0; mi2 < mobs.length; mi2++) {
          var bm = mobs[mi2];
          if (bm.bossFight && !bm.el.__caught && !bm.removed) {
            mpDashes++;
            bm.dashUntil = perfNow() + 400; bm.el.classList.add("is-dashing");
            (function (m) { setTimeout(function () { if (!m.removed) m.el.classList.remove("is-dashing"); }, 410); })(bm);
            if (pointerX > -9000) { var mdx2 = (bm.x + bm._hw) - pointerX, mdy2 = (bm.y + bm._hh) - pointerY, mdd2 = Math.sqrt(mdx2 * mdx2 + mdy2 * mdy2) || 1; bm.vx = (mdx2 / mdd2) * 8; bm.vy = (mdy2 / mdd2) * 8; }
            Sound.fx("beat"); break;
          }
        }
      }
      if (windX && funLevel >= 10 && !windFlipped && now - t0 > DURATION / 2) {   // 🌬 mid-round WIND SHIFT
        windFlipped = true; windX = -windX;
        if (windLayer) windLayer.setAttribute("data-dir", windX > 0 ? "r" : "l");
        var wEl = arena.querySelector("[data-wind]");
        if (wEl) { wEl.textContent = windX > 0 ? "»»»" : "«««"; wEl.parentNode.classList.remove("is-flip"); void wEl.offsetWidth; wEl.parentNode.classList.add("is-flip"); }
        for (var wj = 0; wj < mobs.length; wj++) if (mobs[wj].mode === "arena") mobs[wj].bvx = -mobs[wj].bvx * 0.5;   // the gust turns them
        toast((windX > 0 ? "»»» " : "««« ") + "<b>WIND SHIFT</b>", 1900); Sound.fx("magnet");
      }
      if (isUnlocked() && !winning && !funMode) { closeArena(); return; }   // keep the arena during the win slow-mo (fun replays run unlocked)
      if (!frenzyDone && now - t0 > frenzyAt && (funMode ? funCaught : getCaught()) < GOAL - 4 && !playHalted()) {   // 🔥 once-per-round medal wave
        frenzyDone = true; toast("🔥 <b>FRENZY!</b>", 2200); Sound.fx("frenzy"); eventPulse();
        for (var fi = 0; fi < 8; fi++) (function (k) { setTimeout(function () { if (arena && !playHalted()) spawnMini(); }, k * 220); })(fi);
      }
      if (left <= 0 && !bossDying) { endArena(gotB); return; }   // never cut the boss-death show short
      arenaRaf = requestAnimationFrame(loop);
    }
    function spawnFast() {
      if (playHalted()) return;
      var finale = (funMode ? funCaught : getCaught()) >= GOAL - 3;   // final stretch: clear the arena, only the BOSS
      if (finale) { if (playfield.querySelector(".av-ms-token.is-boss:not(.is-decoy)")) return; clearField("arena"); }
      else if (aActive >= AMAX) return;
      var boss = finale, kind = null, rare = false, worth = 1, persona = null;
      if (!boss) {
        if (forceRare) { rare = true; worth = 2; forceRare = false; }          // comeback: guaranteed rare (arena)
        else {
        var roll = Math.random();
        var chromeOdds = perfNow() < chromeDipUntil ? 1 : (muts.indexOf("CHROME RUSH") > -1 ? 0.125 : 0.025);   // 🪞 during the DIP everything spawns plated
        if (roll < chromeOdds) { kind = "chrome"; worth = 3; }
        else if (roll < chromeOdds + 0.18) { rare = true; worth = 2; }
        else if (roll < chromeOdds + 0.255) { kind = "wild"; }
        else if (roll < chromeOdds + 0.325 && timeBonus < timeCap) { kind = "time"; }
        else if (trapRate > 0 && roll < chromeOdds + 0.325 + trapRate) { kind = "trap"; }   // level-scaled fake medals (−5s)
        else { var pp = Math.random(); persona = pp < 0.22 ? "zig" : pp < 0.37 ? "dart" : pp < 0.47 ? "heavy" : null; if (persona === "dart" || persona === "heavy") worth = 2; }
        }
      }
      var scale = boss ? 1.4 : kind === "chrome" ? rnd(0.72, 0.9) : kind === "wild" ? rnd(0.72, 0.92) : kind === "time" ? rnd(0.58, 0.72) : kind === "trap" ? rnd(0.6, 0.9) : rare ? rnd(0.85, 1.1) : persona === "heavy" ? rnd(1.12, 1.3) : persona === "dart" ? rnd(0.4, 0.55) : rnd(0.55, 1.0);
      var b = makeToken(rare, scale, boss, kind); aActive++;
      if (persona) b.classList.add("is-" + persona);
      var w = b._hw * 2, h = b._hh * 2, pad = 60;
      var minX = FLD.x0 + pad, maxX = FLD.x1 - pad - w, minY = pad + 48, maxY = innerHeight - pad - h;
      var yTop = minY, yBot = maxY;
      if (waveY) yBot = Math.max(minY + 40, Math.min(maxY, waveY - h - 10));    // 🪞 while the bath is up, medals live ABOVE the waterline
      var x0 = minX + Math.random() * (maxX - minX), y0 = yTop + Math.random() * (yBot - yTop);
      var ang = Math.random() * 6.283, spd = boss ? rnd(1.5, 2.5) : persona === "heavy" ? rnd(0.5, 0.9) : persona === "dart" ? rnd(1.6, 2.4) : rnd(1.1, 2.1);
      var o = { el: b, x: x0, y: y0, vx: Math.cos(ang) * spd, vy: Math.sin(ang) * spd, bvx: Math.cos(ang) * spd, bvy: Math.sin(ang) * spd,
        _hw: b._hw, _hh: b._hh, rad: boss ? 110 : 96, dead0: 34, push: boss ? 0.5 : persona === "heavy" ? 0.14 : 0.36,
        maxSp: boss ? 4.2 : persona === "dart" ? 5.2 : persona === "heavy" ? 2 : 3.5, mode: "arena",
        minX: minX, maxX: maxX, minY: minY, maxY: maxY, ttl: boss ? 120000 : persona === "heavy" ? rnd(6500, 9000) : rnd(4500, 7200), born: perfNow(), combo: true, onGone: function () { aActive--; } };
      if (persona === "zig") { o.zig = 1; o.seed = Math.random() * 6.28; }
      else if (persona === "dart") { o.dart = 1; o.nextDart = perfNow() + 800; }
      else if (persona === "heavy") o.hp = 2;
      if (kind === "chrome") o.chromeTok = 1;
      if (kind === "wild") o.special = function (x, y) { wildEffect(x, y); };
      if (kind === "time") o.special = function (x, y) { timeBonus += 5000; DURATION += 5000; Sound.fx("time"); toast("⏱ <b>+5 seconds!</b>", 1800); if (!reduce) { burst.spawn(x, y, 6); impactRing(x, y); } };
      if (kind === "trap") {
        o.trapTok = 1; o.special = function (x, y) { DURATION -= 5000; Sound.fx("trap"); showPenalty(x, y, "−5s"); toast("🚫 <b>Fake medal!</b> −5 seconds", 2200); };
        if (muts.indexOf("MINEFIELD") > -1) {                    // MINEFIELD: dodging IS scoring — untouched fakes pay time
          var og2 = o.onGone; o.onGone = function () { og2(); if (!o.el.__caught && addTime) { addTime(500); Sound.fx("plink"); } };
        }
      }
      if (boss) armBoss(o, b);
      if (boss && funMode) { var fb2 = funBoost(); o.maxSp *= fb2; o.push *= fb2; o.vx *= fb2; o.vy *= fb2; o.bvx *= fb2; o.bvy *= fb2; }   // fun levels: faster boss
      if (!boss && funMode) { var fsp = funSpeed(); o.vx *= fsp; o.vy *= fsp; o.bvx *= fsp; o.bvy *= fsp; o.maxSp *= fsp; }                 // fun levels: faster medals
      playfield.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
      if (boss) bossEntrance(o, b);
      if (boss && wallTier >= 2) (function (m) { setTimeout(function () { if (!m.removed && !m.el.__caught) spawnDecoys(m, wallTier >= 5 ? 2 : 1); }, ENTRANCE + 250); })(o);   // 🧱 TWIN SIGNAL: after the entrance
      bindCatch(o, worth); addMob(o);
    }
    function bossEntrance(o, b) {                                // ⚠ THE ARRIVAL — mirrors the kill cam, so the fight is bookended
      o.frozen = true;
      o.dashUntil = perfNow() + ENTRANCE;                        // untouchable while it lands
      o.x = FLD.x0 + FLD.w / 2 - o._hw; o.y = innerHeight * 0.42 - o._hh;
      b.style.transform = "translate(" + o.x + "px," + o.y + "px)";
      Sound.fx("bossin"); buzz([15, 60, 15, 60, 90]);
      if (reduce) { o.frozen = false; o.dashUntil = 0; toast("🏁 <b>FINAL BOSS</b>", 3000); return; }
      holdUntil = Math.max(holdUntil, perfNow() + ENTRANCE);     // the clock waits for the cinematic
      b.classList.add("is-arriving");
      var cam = tier(el("div", "av-ms-killcam")); cam.innerHTML = "<i></i>";
      playfield.appendChild(cam);
      requestAnimationFrame(function () { requestAnimationFrame(function () { cam.classList.add("is-on"); }); });
      var nm = tier(el("div", "av-ms-bossname"));
      nm.innerHTML = '<span>⚠ FINAL BOSS</span><b>' + esc(wallTier ? (WALLNAMES[Math.min(wallTier, 5)] || "APEX") : activeTier().toUpperCase()) + '</b>' +
        '<i>' + (o.hpShield ? "🛡 " + o.hpShield + " armour · " : "") + o.hp + " HP</i>";
      playfield.appendChild(nm);
      setTimeout(function () {                                   // it LANDS
        if (o.removed) return;
        arenaShake(); hitStop(160);
        if (!reduce) { burst.spawn(o.x + o._hw, o.y + o._hh, 20); impactRing(o.x + o._hw, o.y + o._hh); }
        var sw = tier(el("div", "av-ms-shock")); document.body.appendChild(sw); setTimeout(function () { sw.remove(); }, 900);
      }, 980);
      setTimeout(function () {                                   // ...and the fight is on
        b.classList.remove("is-arriving");
        cam.classList.remove("is-on"); setTimeout(function () { cam.remove(); }, 450);
        nm.classList.add("is-out"); setTimeout(function () { nm.remove(); }, 450);
        if (!o.removed) { o.frozen = false; o.dashUntil = 0; bossPhaseStart(o); }   // ✒️/✂️ weapons out, pen selected
      }, ENTRANCE);
    }
    function spawnMini() {                                       // 🔥 frenzy shower minis
      var b = makeToken(false, rnd(0.4, 0.55)); b.classList.add("is-lite"); aActive++;
      var pad = 60, w = b._hw * 2, h = b._hh * 2, minX = FLD.x0 + pad, maxX = FLD.x1 - pad - w, minY = pad + 48, maxY = innerHeight - pad - h;
      var x0 = minX + Math.random() * (maxX - minX), y0 = minY + Math.random() * (maxY - minY);
      var ang = Math.random() * 6.283, spd = rnd(2.2, 3.2);
      var o = { el: b, x: x0, y: y0, vx: Math.cos(ang) * spd, vy: Math.sin(ang) * spd, bvx: Math.cos(ang) * spd, bvy: Math.sin(ang) * spd,
        _hw: b._hw, _hh: b._hh, rad: 80, dead0: 30, push: 0.3, maxSp: 4, mode: "arena",
        minX: minX, maxX: maxX, minY: minY, maxY: maxY, ttl: rnd(2800, 4200), born: perfNow(), combo: true, onGone: function () { aActive--; } };
      if (funMode) { var fsm = funSpeed(); o.vx *= fsm; o.vy *= fsm; o.bvx *= fsm; o.bvy *= fsm; o.maxSp *= fsm; }
      playfield.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
      bindCatch(o, 1); addMob(o);
    }
    var spawnEvery = Math.round((coarse ? 720 : 560) * (muts.indexOf("CHROME RUSH") > -1 ? 1.15 : 1));
    function beginSpawning() {                                   // the seed burst AND the interval both wait for the card
      if (!arena) return;
      arenaSpawn = setInterval(spawnFast, spawnEvery);
      for (var i = 0; i < (coarse ? 3 : 4); i++) spawnFast();
    }
    if (holdUntil) setTimeout(beginSpawning, holdUntil - perfNow());
    else beginSpawning();
    arenaRaf = requestAnimationFrame(loop);
    arenaEnd = t0 + DURATION;
  }
  function flashCombo(x, y) {
    Sound.combo(combo);
    var heat = combo >= 8 ? 5 : combo >= 5 ? 4 : combo >= 3 ? 3 : 2;   // combo "heats up" bronze->white
    var c = tier(el("div", "av-ms-arena__combo", "COMBO ×" + combo)); c.setAttribute("data-heat", heat);
    c.style.cssText += ";left:" + (x + 10) + "px;top:" + (y - 24) + "px;";
    (arena || document.body).appendChild(c); setTimeout(function () { c.remove(); }, 850);
    if (combo === 3 || combo === 5 || combo === 8) {
      var s = tier(el("div", "av-ms-streak", combo >= 8 ? "🔥 ON FIRE!" : combo >= 5 ? "🔥 STREAK!" : "STREAK!"));
      s.style.cssText += ";left:" + x + "px;top:" + (y - 60) + "px;";
      (arena || document.body).appendChild(s); setTimeout(function () { s.remove(); }, 1000);
    }
  }
  function endArena(gotB) {
    clearInterval(arenaSpawn); cancelAnimationFrame(arenaRaf);
    // Round over -> put the tools away FIRST. The weapon bar sits dead-centre at the
    // bottom on z-index 9; leaving it up covered the debrief's Retry / Keep browsing
    // buttons and swallowed their clicks.
    cutClear(); weaponsEnd(); closeGuide(true);
    var need = GOAL - (funMode ? funCaught : getCaught());
    var t = arena.querySelector(".av-ms-arena__title");
    if (t) t.classList.remove("is-min");                        // bring the panel back for the verdict
    if (need <= 0) { closeArena(); return; }
    if (funMode) funFails[funLevel] = (funFails[funLevel] || 0) + 1;   // 🕊 mercy counter
    var got = GOAL - need;
    if (t) t.innerHTML = '<b>' + got + ' banked ✦</b><span>' + need + ' more to go — ' + (ARCADE || funMode ? 'just for fun.' : 'progress saved.') + (maxCombo >= 3 ? ' Longest combo: ×' + maxCombo + '.' : '') + ' Try again!</span>';
    var pfd = arena.querySelector(".av-ms-arena");
    if (pfd) { pfd.classList.remove("is-clutch", "is-fever"); pfd.classList.add("is-debrief"); }   // ember-copper, not failure grey
    if (!reduce && hud && got > 0) {                             // medal ghosts arc into the HUD bank
      var hr = hud.getBoundingClientRect(), hx = hr.left + hr.width / 2, hy = hr.top + hr.height / 2;
      var GN = Math.min(6, got);
      for (var gi2 = 0; gi2 < GN; gi2++) (function (k) { setTimeout(function () {
        var fl2 = el("img", "av-ms-bankfly"); fl2.src = MEDALS[activeTier()] || MEDAL_SRC; fl2.setAttribute("aria-hidden", "true");
        var sx = innerWidth * (0.25 + Math.random() * 0.5), sy = innerHeight * (0.22 + Math.random() * 0.38);
        fl2.style.transform = "translate(" + sx + "px," + sy + "px)";
        document.body.appendChild(fl2);
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          fl2.style.transform = "translate(" + hx + "px," + hy + "px) scale(.3)"; fl2.style.opacity = "0.15";
        }); });
        Sound.combo(k + 2);
        setTimeout(function () { fl2.remove(); }, 700);
      }, 250 + k * 130); })(gi2);
      setTimeout(function () { if (hud) { hud.classList.add("is-bank"); setTimeout(function () { hud.classList.remove("is-bank"); }, 700); } }, 250 + GN * 130 + 500);
    }
    var foot = arena.querySelector(".av-ms-arena__foot");
    if (foot) foot.innerHTML =
      '<button class="av-ms-btn" type="button" data-retry>↻ Retry round</button>' +
      '<button class="av-ms-btn av-ms-btn--ghost" type="button" data-quit>Keep browsing</button>';
    if (foot) {
      foot.querySelector("[data-retry]").addEventListener("click", function () { closeArena(); startArena(); });
      foot.querySelector("[data-quit]").addEventListener("click", closeArena);
    }
  }
  function closeArena() {
    document.documentElement.classList.remove("av-ms-lowfx");   // restore the site's 3D
    slowmo = 1; feverUntil = 0;                                 // clear clutch slow / fever state
    muts = []; windX = 0; addTime = null; wallTier = 0;         // clear level modifiers
    pinballUntil = 0; chromeDipUntil = 0;                       // clear set-piece windows
    waveEl = null; waveY = 0;                                   // drain the bath
    cutClear(); weaponsEnd(); cannonEnd(); closeGuide(true);     // ✂️ drop the template, tools, the cannon round and any open guide
    bossDying = !1;                                             // a boss killed mid-teardown left this true forever, which then
                                                                // froze penActive(), the cage check and slowmo for the next round
    Sound.bed.stop();                                           // fade the tonal bed out
    clearInterval(arenaSpawn); cancelAnimationFrame(arenaRaf);
    for (var i = mobs.length - 1; i >= 0; i--) { if (mobs[i].mode === "arena") { mobs[i].removed = true; mobs.splice(i, 1); } }
    if (arena) { arena.remove(); arena = null; }
    updateHUD();
  }

  /* =====================================================================
     ACCESSIBLE / low-motion variant (static, keyboard-first, mandatory catch)
     ===================================================================== */
  var a11yPanel;
  function buildA11y() {
    a11yPanel = tier(el("div", "av-ms-a11y"));
    a11yPanel.setAttribute("role", "group");
    a11yPanel.setAttribute("aria-label", milestone.n + " milestone reward — catch " + GOAL + " tokens");
    a11yPanel.innerHTML =
      '<h4>' + fmt(milestone.n) + ' templates! Catch ' + GOAL + '</h4>' +
      '<p>AutoVectors reached a new library milestone. Press the glowing medals (Tab + Enter works) to unlock your ' + (LABEL ? esc(LABEL) + ' ' : '') + 'discount code.</p>' +
      '<div class="av-ms-a11y__grid" data-grid></div>' +
      '<div class="av-ms-a11y__bar"><i></i></div>' +
      '<div class="av-ms-mini"><button type="button" data-rich>' + (reduce ? "" : "switch to animated mode") + '</button></div>';
    document.body.appendChild(a11yPanel);
    var richBtn = a11yPanel.querySelector("[data-rich]");
    if (!richBtn.textContent) richBtn.parentNode.style.display = "none";
    else richBtn.addEventListener("click", function () { a11y = false; rebuild(); });
    var grid = a11yPanel.querySelector("[data-grid]");
    for (var i = 0; i < 3; i++) placeA11yToken(grid);
    updateA11y();
  }
  function placeA11yToken(grid) {
    if (isUnlocked() || getCaught() >= GOAL) return;
    var rare = Math.random() < 0.18, b = makeToken(rare, rnd(0.6, 0.9));
    var gw = grid.clientWidth || 280, gh = grid.clientHeight || 150, w = b._hw * 2, h = b._hh * 2;
    b.style.transform = "translate(" + rnd(4, Math.max(6, gw - w - 4)) + "px," + rnd(4, Math.max(6, gh - h - 4)) + "px)";
    grid.appendChild(b);
    b.addEventListener("click", function (ev) {
      ev.preventDefault(); if (b.__caught) return; b.__caught = 1;
      var r = b.getBoundingClientRect(); b.classList.add("is-caught");
      setTimeout(function () { b.remove(); if (!isUnlocked() && getCaught() < GOAL) placeA11yToken(grid); }, 320);
      gainCatch(rare ? 2 : 1, r.left + r.width / 2, r.top + r.height / 2);
      updateA11y();
    });
  }
  function updateA11y() {
    if (!a11yPanel) return;
    var i = a11yPanel.querySelector(".av-ms-a11y__bar i");
    if (i) i.style.width = Math.min(100, (getCaught() / GOAL) * 100) + "%";
  }

  /* =====================================================================
     REVEAL + confetti
     ===================================================================== */
  var winning = false, slowmo = 1, winDurMs = null, winIsBest = false, winPrevBest = null;
  function bloom() { var b = tier(el("div", "av-ms-bloom")); document.body.appendChild(b); setTimeout(function () { b.remove(); }, 600); }
  function win() {
    if (ARCADE || CANNON_EGG || !GENUINE) return;                // 🕹 arcade, egg round and forced-URL milestone: no prize to give
    setUnlocked(); updateHUD(); Sound.win();
    try {                                                        // personal-best hunt time (skip multi-day resumes)
      var t0v = parseInt(localStorage.getItem(KEY + "_t0") || "0", 10);
      if (t0v) {
        var du = Date.now() - t0v;
        if (du > 3000 && du < 1800000) {
          winDurMs = du;
          var pb = parseInt(localStorage.getItem("av_ms_best") || "0", 10); winPrevBest = pb || null;
          if (!pb || du < pb) { winIsBest = true; localStorage.setItem("av_ms_best", "" + du); }
        }
      }
    } catch (e) {}
    if (eventLayer) eventLayer.classList.add("is-pulse");
    var finish = function () {
      slowmo = 1; winning = false;
      if (arena) closeArena();
      clearTimeout(spawnTimer);
      mobs.length = 0; if (motionRaf) { cancelAnimationFrame(motionRaf); motionRaf = 0; }
      if (overlay) { overlay.remove(); overlay = null; active = 0; }
      if (a11yPanel) { a11yPanel.remove(); a11yPanel = null; }
      reveal(); confetti();
    };
    if (reduce) { finish(); return; }
    winning = true; slowmo = 0.3; bloom();     // brief slow-mo + white bloom, then the reveal
    setTimeout(finish, 480);
  }
  function reveal() {
    var modal = tier(el("div", "av-ms-modal is-open"));
    var bits = [];
    if (LABEL) bits.push('<b>' + esc(LABEL) + '</b>');   // the reward IS the discount code; no "points" line
    // 🎯 "catching all 40" describes the medal game. The cannon round has 6
    // templates and no tokens at all.
    var achieveDeed = WON_BY_CANNON
      ? 'cutting all six templates to shards!'
      : 'catching all ' + GOAL + '!';
    var achieveLine = '<p class="av-ms-reveal__sub">AutoVectors just published its <b>' + fmt(milestone.n) + 'th</b> pre-cut PPF template — a brand-new library milestone. Thanks for celebrating with us; here’s your reward for ' + achieveDeed + '</p>';
    var rewardLine = bits.length ? '<p class="av-ms-reveal__sub" style="margin-top:-6px">Reward: ' + bits.join(' · ') + '</p>' : '';
    var timeLine = winDurMs ? '<p class="av-ms-reveal__sub" style="margin-top:-6px">⏱ Unlocked in <b>' + fmtDur(winDurMs) + '</b>' + (winIsBest ? (winPrevBest ? ' — new personal best! 🏆' : '') : (winPrevBest ? ' · your best: ' + fmtDur(winPrevBest) : '')) + '</p>' : '';
    var ctxLine = '';                                            // contextual bridge: peak-dopamine, zero pressure
    try {
      var mpath = location.pathname.match(/^\/(collections|products)\/([a-z0-9-]+)/);
      if (mpath) {
        var nice = mpath[2].replace(/-/g, " ").replace(/\b\w/g, function (ch) { return ch.toUpperCase(); });
        ctxLine = '<p class="av-ms-reveal__sub" style="margin-top:10px">Valid on everything — including the <b>' + esc(nice) + '</b> templates you were browsing. <a class="av-ms-ctx" href="' + location.pathname + '?from=game">Back to ' + esc(nice) + ' →</a></p>';
      } else ctxLine = '<p class="av-ms-reveal__sub" style="margin-top:10px">Valid on all ' + fmt(Math.floor(COUNT / 100) * 100) + '+ templates in the library.</p>';
    } catch (e) {}
    modal.innerHTML =
      '<div class="av-ms-modal__scrim"></div>' +
      '<div class="av-ms-reveal">' +
        '<button class="av-ms-reveal__x" aria-label="Close">✕</button>' +
        // 🎯 the cannon winner never saw a medal — they broke six templates —
        // so the medal art would be a claim about a game they did not play.
        '<div class="av-ms-reveal__medal">' + (WON_BY_CANNON ? cannonMarkSVG() : '<img src="' + MEDAL_SRC + '" alt="" aria-hidden="true">') + '<span class="av-ms-gleam"></span></div>' +
        '<div class="av-ms-reveal__k">' + esc(FX.rank) + '-grade unlocked</div>' +
        '<div class="av-ms-reveal__h">' + fmt(milestone.n) + ' templates reached 🎉</div>' +
        achieveLine + rewardLine + timeLine +
        // PLOTTER-CUT reveal: a blade traces the card outline (registration crosshairs
        // blink in), then the PPF liner film peels off the code — the store's own ritual.
        '<div class="av-ms-cut' + (reduce ? '' : ' will-cut') + '">' +
          '<div class="av-ms-lamp"><span></span><span></span><span></span><span></span><span></span><span></span></div>' +
          '<div class="av-ms-code"><input readonly value="' + esc(CODE) + '" aria-label="Promo code"><button type="button" data-copy>Copy</button></div>' +
          '<svg class="av-ms-cut__svg" viewBox="0 0 100 32" preserveAspectRatio="none" aria-hidden="true"><rect x="1" y="1" width="98" height="30" rx="4" pathLength="100"/></svg>' +
          '<span class="av-ms-cut__corner c1"></span><span class="av-ms-cut__corner c2"></span><span class="av-ms-cut__corner c3"></span><span class="av-ms-cut__corner c4"></span>' +
          '<div class="av-ms-cut__film"></div>' +
        '</div>' +
        ctxLine +
        '<p class="av-ms-founder" aria-hidden="true"></p>' +
        '<a class="av-ms-btn" href="/discount/' + encodeURIComponent(CODE) + '?redirect=/pages/template-library">Shop with code →</a>' +
        '<div class="av-ms-reveal__timer"></div>' +              // ⌛ exactly how long the reward lasts
        // 🎯 both buttons start a MEDAL round (startArena / arcadeStart(1)),
        // which is a level picker for a game the cannon player never played.
        // The wiring below is already null-guarded, so swapping the row is
        // enough — there is no second place to change.
        //
        // …BUT AN EMPTY ROW WAS A DEAD END. The first build dropped the row
        // outright for a cannon winner, and the reward panel — the single
        // most triumphant screen in the whole game — then offered no way back
        // into it at all. The player had to close the panel, find the
        // milestone bar and open the popover to discover there was more game.
        // "Now what?" deserves an answer for the game that was actually
        // played, so the row keeps its place and carries ONE button pointing
        // at the range. It cannot re-award anything: every row the picker
        // opens for an already-unlocked visitor fails cannonMayStake() on
        // !isUnlocked(), so there is no milestone row to press.
        (WON_BY_CANNON ?
        '<div class="av-ms-reveal__more">' +                     // 🎯 the code is won — now what?
          '<button class="av-ms-btn av-ms-btn--ghost" type="button" data-cannon-range>☰ Keep playing — pick a level</button>' +
        '</div>' :
        '<div class="av-ms-reveal__more">' +                     // 🎮 the code is won — now what?
          '<button class="av-ms-btn av-ms-btn--ghost" type="button" data-next>▶ Next: level ' + funLevel + '</button>' +
          '<button class="av-ms-btn av-ms-btn--ghost" type="button" data-again>↻ Level 1 + tips</button>' +
        '</div>') +
        '<p class="av-ms-reveal__fine">Copy the code and paste it at checkout. The reward retires when the celebration window closes.</p>' +
      '</div>';
    document.body.appendChild(modal);
    var cut = modal.querySelector(".av-ms-cut");
    if (cut && !reduce) {
      Sound.fx("plotter"); buzz([15, 40, 15, 40, 30, 40, 60]);
      requestAnimationFrame(function () { requestAnimationFrame(function () { cut.classList.add("is-cutting"); }); });
    }
    var fl = modal.querySelector(".av-ms-founder");              // "cut with care" — a note from a human, typed in
    if (fl) {
      var fmsg = "Cut with care — thank you for being part of the first " + fmt(milestone.n) + ".  — AutoVectors";
      if (reduce) fl.textContent = fmsg;
      else setTimeout(function () {
        if (!document.body.contains(fl)) return;
        for (var fk = 0; fk < fmsg.length; fk++) {
          var sp = el("span", "", esc(fmsg[fk]));                 // real spaces -> the line can WRAP inside the card
          sp.style.transitionDelay = (fk * 26) + "ms"; fl.appendChild(sp);
        }
        Sound.fx("typeline");
        requestAnimationFrame(function () { requestAnimationFrame(function () { fl.classList.add("is-write"); }); });
      }, 2350);
    }
    var close = function () { modal.remove(); };
    var rt = modal.querySelector(".av-ms-reveal__timer");
    if (rt) rt.appendChild(makeCountdown("av-ms-count--reveal"));
    modal.querySelector(".av-ms-reveal__x").addEventListener("click", close);
    // both routes onward: keep climbing, or go back to the teaching level with every
    // card replayed. `finish()` already cleared `winning` and closed the arena, so
    // startArena/arcadeStart are free to run.
    var rgb = modal.querySelector("[data-cannon-range]");
    if (rgb) rgb.addEventListener("click", function () { close(); cannonRange(); });
    var nb = modal.querySelector("[data-next]");
    if (nb) nb.addEventListener("click", function () { close(); funMode = true; funCaught = 0; startArena(); });
    var ab = modal.querySelector("[data-again]");
    if (ab) ab.addEventListener("click", function () { close(); arcadeStart(1); });
    modal.querySelector(".av-ms-modal__scrim").addEventListener("click", close);
    wireCopy(modal);
    // "forge" the code in: scramble the characters, then settle to the real code
    var inp = modal.querySelector(".av-ms-code input");
    if (inp && !reduce) {
      var TGT = CODE, CH = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789", t0f = Date.now(), DUR = 850;
      inp.value = "";
      var fv = setInterval(function () {
        var t = Math.min(1, (Date.now() - t0f) / DUR), settled = Math.floor(t * TGT.length), s = TGT.slice(0, settled);
        for (var i = settled; i < TGT.length; i++) s += CH[(Math.random() * CH.length) | 0];
        inp.value = s;
        if (t >= 1) { clearInterval(fv); inp.value = TGT; }
      }, 45);
    }
    var f = modal.querySelector(".av-ms-reveal__x"); if (f) f.focus();
  }
  function wireCopy(scope) {
    var btn = scope.querySelector("[data-copy]"); if (!btn) return;
    btn.addEventListener("click", function () {
      var ok = function () { btn.textContent = "Copied ✓"; btn.classList.add("is-copied"); setTimeout(function () { btn.textContent = "Copy"; btn.classList.remove("is-copied"); }, 1800); };
      try { navigator.clipboard.writeText(CODE).then(ok, function () { legacyCopy(scope); ok(); }); }
      catch (e) { legacyCopy(scope); ok(); }
    });
  }
  function legacyCopy(scope) { var inp = scope.querySelector(".av-ms-code input"); if (inp) { inp.focus(); inp.select(); try { document.execCommand("copy"); } catch (e) {} } }

  function confetti(mult) {
    if (reduce) return;
    var cv = el("canvas", "av-ms-confetti is-on"); document.body.appendChild(cv);
    var g = cv.getContext("2d"), W, H, dpr = Math.min(devicePixelRatio || 1, 2);
    function size() { W = cv.width = innerWidth * dpr; H = cv.height = innerHeight * dpr; cv.style.width = innerWidth + "px"; cv.style.height = innerHeight + "px"; }
    size();
    var tierCol = { bronze: ["#e8a15a", "#b76e2c"], silver: ["#e9f2ff", "#9fb3c8"], gold: ["#ffd875", "#e0a422"], platinum: ["#eaf4ff", "#a9c6e0"] }[TIER] || ["#e9f2ff", "#9fb3c8"];
    var pal = tierCol.concat(["#ffffff", "#12e0c4"]), P = [];
    for (var i = 0, N = Math.round(FX.confetti * (mult || 1)); i < N; i++) P.push({ x: W * pseudo(), y: -20 * dpr - pseudo() * H * 0.4, vx: (pseudo() - 0.5) * 6 * dpr, vy: (2 + pseudo() * 5) * dpr, s: (4 + pseudo() * 6) * dpr, rot: pseudo() * 6.28, vr: (pseudo() - 0.5) * 0.3, c: pal[(pseudo() * pal.length) | 0] });
    var start = perfNow();
    (function frame() {
      var t = perfNow() - start; g.clearRect(0, 0, W, H);
      for (var i = 0; i < P.length; i++) { var p = P[i]; p.vy += 0.06 * dpr; p.x += p.vx; p.y += p.vy; p.rot += p.vr; p.vx *= 0.995;
        g.save(); g.translate(p.x, p.y); g.rotate(p.rot); g.globalAlpha = Math.max(0, 1 - t / 2600); g.fillStyle = p.c; g.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 0.6); g.restore(); }
      if (t < 2600) requestAnimationFrame(frame); else cv.remove();
    })();
    addEventListener("resize", size, { once: true });
  }

  /* --------------------- "time left" drain bar -------------------------- */
  // Honest, count-based: the bar shows the REAL templates remaining in the window
  // (buffer - used) and drains as new templates are added. No days/hours text
  // (that would be an inaccurate rate estimate) — just an hourglass + the bar.
  // The window closes by TEMPLATE COUNT (at milestone + BUFFER), not by clock — so the
  // template figure is exact and the days are an estimate from the publishing rate
  // (theme setting "Templates published per day"; 0 hides the estimate entirely).
  function eventLeft() {
    var left = Math.max(0, milestone.n + BUFFER - COUNT);
    return {
      left: left,
      days: RATE > 0 && left > 0 ? Math.max(1, Math.ceil(left / RATE)) : 0,
      pct: Math.max(0, Math.min(100, Math.round(left / BUFFER * 100)))
    };
  }
  function countdownText() {
    var e = eventLeft();
    if (!e.left) return "Event is closing — code retires now";
    var tail = e.left + " more template" + (e.left > 1 ? "s" : "") + " to go";
    if (!e.days) return "Code valid for " + tail;
    return "Code expires in <b>~" + e.days + " day" + (e.days > 1 ? "s" : "") + "</b> · " + tail;
  }
  function makeCountdown(extraCls) {
    var wrap = el("div", "av-ms-count" + (extraCls ? " " + extraCls : ""));
    var e = eventLeft();
    wrap.innerHTML =
      '<span class="av-ms-count__row">' +
        '<span class="av-ms-count__ico" aria-hidden="true">⌛</span>' +
        '<span class="av-ms-count__bar"><i style="width:' + e.pct + '%"></i></span>' +
      '</span>' +
      '<span class="av-ms-count__txt">' + countdownText() + '</span>';
    return wrap;
  }

  /* --------------------------- welcome modal ---------------------------- */
  // Prominent first-visit announcement while the celebration is live. Shows ONCE
  // per milestone (persistent flag) — never nags again — and only ever appears
  // during the active window, so it self-retires when the event ends.
  function consentOpen() {              // is a cookie-consent banner currently on screen?
    // NOTE: don't use offsetParent — it is null for position:fixed elements, and consent
    // banners are fixed. Measure the box + computed styles instead.
    var sels = ["#shopify-pc__banner", ".shopify-pc__banner", "[id^='shopify-pc__']", "#cookie-banner", ".cookie-banner", ".cookie-consent"];
    for (var i = 0; i < sels.length; i++) {
      var e = document.querySelector(sels[i]); if (!e) continue;
      var cs = getComputedStyle(e), r = e.getBoundingClientRect();
      if (cs.display !== "none" && cs.visibility !== "hidden" && parseFloat(cs.opacity || "1") > 0.05 && r.height > 8 && r.width > 8) return true;
    }
    return false;
  }
  // The consent dialog is injected a moment AFTER load and sits at z-index 2,000,000,
  // so a one-shot check at boot cannot decide this — it would always run too early.
  // WATCH it instead: while it is up the game's surfaces hide, and the moment it is
  // dealt with they come back. No artificial delay on a normal load, and it is correct
  // whichever order the two appear in. The arena is exempt: a banner must never kill a
  // round that is already running.
  function consentWatch() {
    var on = null;
    setInterval(function () {
      var open = consentOpen();
      if (open === on) return;
      on = open;
      document.documentElement.classList.toggle("av-ms-consent", open);
      if (open && pop) pop.hidden = true;
    }, 400);
  }
  // Is a consent banner even POSSIBLE on this page? "Not on screen right now"
  // is not the same as "there is none" — Shopify injects its banner a moment
  // after load — but the machinery that will inject it is already in the page
  // by then, and these are its fingerprints. When not one of them is present,
  // nothing is going to cover anything and there is nothing to wait for.
  function consentPresent() {
    try {
      var S = window.Shopify;
      if (S && (S.customerPrivacy || S.trackingConsent || S.privacyBanner)) return true;
      if (window.privacyBanner) return true;
      if (document.querySelector("#shopify-pc__banner,#shopify-pc__banner__dialog,[id^='shopify-pc__']," +
                                 "#cookie-banner,.cookie-banner,.cookie-consent")) return true;
      var sc = document.getElementsByTagName("script");
      for (var i = 0; i < sc.length; i++) {
        var src = sc[i].src || "";
        if (/consent[-_]tracking|customer[-_]privacy|privacy[-_]banner|cookie[-_]?(banner|consent)/i.test(src)) return true;
      }
    } catch (e) {}
    return false;
  }
  // "yes" a banner is up or is certainly coming; "no" nothing will cover the
  // page; "?" the machinery is here but has not decided yet. Shopify's own
  // shouldShowBanner() is the exact answer whenever it has loaded, so ask it
  // rather than guessing from a stopwatch.
  function consentVerdict() {
    try {
      if (consentOpen()) return "yes";
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.shouldShowBanner === "function") return cp.shouldShowBanner() ? "yes" : "no";
      if (consentPresent()) return "?";
    } catch (e) {}
    return "no";
  }
  function afterConsent(cb) {          // NEVER cover the cookie banner — but never wait on one that isn't coming
    var waited = 0, saw = false;
    (function chk() {
      if (consentOpen()) {                                   // banner up -> keep waiting (max ~60s)
        saw = true; if (waited < 240) { waited++; return setTimeout(chk, 250); }
      } else if (!saw && consentVerdict() !== "no" && waited < 24) {
        waited++; return setTimeout(chk, 250);               // it is coming (or undecided) -> up to ~6s
      }
      setTimeout(cb, saw ? 1000 : 0);                        // handled -> settle; never shown -> now
    })();
  }
  function welcome() {
    if (isUnlocked()) return;
    var wkey = "av_ms_welcome_" + milestone.n;
    try { if (localStorage.getItem(wkey) === "1") return; } catch (e) {}
    afterConsent(function () {
      if (isUnlocked()) return;
      try { if (localStorage.getItem(wkey) === "1") return; localStorage.setItem(wkey, "1"); } catch (e) {}
      var modal = tier(el("div", "av-ms-modal is-open"));
      var reward = LABEL ? 'an exclusive <b>' + esc(LABEL) + '</b> discount code' : 'an exclusive discount code';
      modal.innerHTML =
        '<div class="av-ms-modal__scrim"></div>' +
        '<div class="av-ms-welcome">' +
          '<button class="av-ms-welcome__x" aria-label="Close">✕</button>' +
          '<div class="av-ms-welcome__medal"><img src="' + MEDAL_SRC + '" alt="" aria-hidden="true"></div>' +
          '<div class="av-ms-welcome__k">' + esc(FX.rank) + '-grade milestone reached</div>' +
          '<h2 class="av-ms-welcome__h">' + fmt(milestone.n) + ' templates — unlocked! 🎉</h2>' +
          '<p class="av-ms-welcome__p">AutoVectors just published its <b>' + fmt(milestone.n) + 'th</b> pre-cut PPF template. To celebrate, beat the <b>Challenge Round</b> — catch <b>' + GOAL + '</b> ' + TIER_NAME + ' medals against the clock to unlock ' + reward + '.</p>' +
          '<div class="av-ms-welcome__timer"><div class="av-ms-welcome__badge">Limited-time celebration</div></div>' +
          '<button class="av-ms-btn av-ms-welcome__cta" type="button">▶ Start challenge round</button>' +
          '<p class="av-ms-welcome__fine">Available only while the milestone celebration is live — don’t miss it.</p>' +
          (function () { try { var pb = parseInt(localStorage.getItem("av_ms_best") || "0", 10); return pb ? '<p class="av-ms-welcome__fine">🏆 Your record: <b>' + fmtDur(pb) + '</b> — think you can beat it?</p>' : ''; } catch (e) { return ''; } })() +
        '</div>';
      document.body.appendChild(modal);
      if (!reduce) { var sw = tier(el("div", "av-ms-shock")); document.body.appendChild(sw); setTimeout(function () { sw.remove(); }, 900); }   // milestone-hit shockwave
      modal.querySelector(".av-ms-welcome__timer").appendChild(makeCountdown());
      var close = function () { modal.classList.add("is-closing"); setTimeout(function () { modal.remove(); }, 320); };
      modal.querySelector(".av-ms-welcome__x").addEventListener("click", close);
      modal.querySelector(".av-ms-welcome__cta").addEventListener("click", function () {
        close(); funMode = false; primerThen(startArena);
      });
      modal.querySelector(".av-ms-modal__scrim").addEventListener("click", close);
    });
  }

  /* ---------------------------- teaser (pre-milestone) ------------------- */
  function buildTeaser() {
    var dkey = "av_ms_teaser_dismissed_" + milestone.n;
    try { if (sessionStorage.getItem(dkey) === "1") return; } catch (e) {}
    var lead = leadFor(milestone), pct = Math.max(4, Math.min(100, Math.round((lead - remaining) / lead * 100)));
    var t = tier(el("div", "av-ms-teaser"));
    t.setAttribute("role", "status");
    t.innerHTML =
      '<button class="av-ms-teaser__x" aria-label="Dismiss">✕</button>' +
      '<div class="av-ms-teaser__medal"><img src="' + MEDAL_SRC + '" alt="" aria-hidden="true"><span class="av-ms-teaser__q">?</span></div>' +
      '<div class="av-ms-teaser__body">' +
        '<div class="av-ms-teaser__k">Milestone incoming</div>' +
        '<div class="av-ms-teaser__n"><b>' + fmt(remaining) + '</b> ' + (remaining === 1 ? 'template' : 'templates') + ' to go</div>' +
        '<div class="av-ms-teaser__s">until the <b>' + fmt(milestone.n) + '</b>-template milestone. Keep watching — a surprise reward unlocks the moment we hit it 🎁</div>' +
        '<div class="av-ms-teaser__bar"><i style="width:' + pct + '%"></i></div>' +
      '</div>';
    document.body.appendChild(t);
    requestAnimationFrame(function () { requestAnimationFrame(function () { t.classList.add("is-in"); }); });
    t.querySelector(".av-ms-teaser__x").addEventListener("click", function () {
      t.classList.remove("is-in"); setTimeout(function () { t.remove(); }, 420);
      try { sessionStorage.setItem(dkey, "1"); } catch (e) {}
    });
  }

  /* ------------------------- build / teardown --------------------------- */
  var eventLayer;
  function buildEventMode() {                                    // site-wide "the store went LIVE" tier light (from the top)
    if (reduce || eventLayer) return;
    eventLayer = tier(el("div", "av-ms-event")); eventLayer.setAttribute("aria-hidden", "true");
    eventLayer.style.setProperty("--ev-op", (0.26 + (FX.rays - 3) * 0.08).toFixed(2));   // tier-scaled intensity
    eventLayer.innerHTML = '<span class="av-ms-event__glow"></span>';
    document.body.appendChild(eventLayer);
  }
  function eventPulse() { if (!eventLayer) return; eventLayer.classList.add("is-pulse"); clearTimeout(eventLayer._pt); eventLayer._pt = setTimeout(function () { if (eventLayer) eventLayer.classList.remove("is-pulse"); }, 450); }
  function liteHint() {                 // weak device still on full 3D -> gently offer Lite mode
    if (document.documentElement.classList.contains("av-lite")) return;
    var weak = (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4) ||
               (navigator.deviceMemory && navigator.deviceMemory <= 4);
    if (!weak) return;
    try { if (sessionStorage.getItem("av_ms_litehint") === "1") return; sessionStorage.setItem("av_ms_litehint", "1"); } catch (e) {}
    var show = function () {
      if (document.querySelector(".av-ms-welcome")) { setTimeout(show, 1500); return; }   // don't stack on the welcome
      var t = tier(el("div", "av-ms-litehint",
        '<span>⚡ Running slow? <b>Lite mode</b> is lighter — the game stays smooth.</span>' +
        '<button class="av-ms-btn" type="button" data-lite>Switch to Lite</button>' +
        '<button class="av-ms-litehint__x" type="button" data-x aria-label="Dismiss">✕</button>'));
      document.body.appendChild(t);
      requestAnimationFrame(function () { requestAnimationFrame(function () { t.classList.add("is-in"); }); });
      var hide = function () { t.classList.remove("is-in"); setTimeout(function () { t.remove(); }, 400); };
      t.querySelector("[data-lite]").addEventListener("click", function () { try { localStorage.setItem("av-lite", "1"); } catch (e) {} location.reload(); });
      t.querySelector("[data-x]").addEventListener("click", hide);
      setTimeout(hide, 14000);
    };
    setTimeout(show, 5000);
  }
  function buildGame() {
    /* 🎯 The ambient medals, the spawn timer and buildA11y()'s token grid all
       live here, and every one of them is a way to raise getCaught() toward
       the code. Every legitimate fallback to the medal game clears GAME_ON
       first (cannonDowngrade), so arriving here with it still set is a bug,
       and the safe thing to do with a bug is nothing. */
    if (GAME_ON) return;
    Sound.arm();
    buildEventMode();
    if (a11y) buildA11y();
    else { buildOverlay(); scheduleSpawn(); }
    liteHint();
  }
  function rebuild() {
    // switch between rich and a11y without losing progress
    if (overlay) { clearTimeout(spawnTimer); overlay.remove(); overlay = null; active = 0; }
    if (a11yPanel) { a11yPanel.remove(); a11yPanel = null; }
    if (isUnlocked()) return;
    buildGame();
  }
  function teardown(userHid) {
    clearTimeout(spawnTimer); if (overlay) overlay.remove();
    if (a11yPanel) a11yPanel.remove(); if (pop) pop.remove();
    if (hud) hud.remove();
    if (userHid) { try { sessionStorage.setItem("av_ms_hidden_" + milestone.n, "1"); } catch (e) {} }
  }

  /* ------------------------------- utils -------------------------------- */
  function fmt(n) { return (n + "").replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
  function fmtDur(ms) { var s = Math.round(ms / 1000), m = Math.floor(s / 60); return m ? m + "m " + (s % 60) + "s" : s + "s"; }
  function esc(s) { return (s + "").replace(/[&<>"']/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]; }); }
  function perfNow() { return (window.performance && performance.now) ? performance.now() : +new Date(); }

  document.addEventListener("visibilitychange", function () { if (!document.hidden && overlay && !isUnlocked()) scheduleSpawn(); });

  /* 🕹 ------------------------ ARCADE launcher --------------------------- */
  // A page may carry an opt-in launcher — [data-av-ms-arcade="1000"], today the "easter
  // egg" badge on the knowledge-hub reward table — that starts a round ON DEMAND in any
  // mode. It can never award the code: funMode routes every point to funGain, and
  // win()/setUnlocked() are barred while ARCADE.
  function arcadeLaunch(ev) {                            // the badge opens the LEVEL PICKER
    if (ev) {
      if (ev.isTrusted === false) return false;          // ignore the page's synthetic cursor FX
      ev.preventDefault(); ev.stopPropagation();
    }
    if (arena || winning) return false;                  // never interrupt a live round
    return arcadePicker();
  }
  function arcadePicker() {
    var old = document.querySelector(".av-ms-lvlmodal"); if (old) old.remove();
    try { Sound.arm(); } catch (e) {}
    var cells = "";
    for (var L = 1; L <= funMax; L++) {                   // every level you have ever reached
      cells += '<button type="button" class="av-ms-lvl' +
        (L >= 5 && L % 5 === 0 ? " is-wall" : "") + (L === funMax ? " is-best" : "") +
        '" data-lvl="' + L + '"' + (L >= 5 && L % 5 === 0 ? ' title="Wall boss level"' : '') + '>' + L + '</button>';
    }
    var m = tier(el("div", "av-ms-modal av-ms-lvlmodal is-open"));
    m.innerHTML =
      '<div class="av-ms-modal__scrim"></div>' +
      '<div class="av-ms-lvlpick">' +
        '<button class="av-ms-lvlpick__x" type="button" aria-label="Close">✕</button>' +
        '<b>🕹 ARCADE</b>' +
        '<span>Replay any level you have reached — just for fun, no code at stake.</span>' +
        '<div class="av-ms-lvlgrid">' + cells + '</div>' +
        '<u>🧱 every 5th level is a WALL boss · your best: LEVEL ' + funMax + '</u>' +
      '</div>';
    document.body.appendChild(m);
    function shut() { if (m.parentNode) m.remove(); }
    m.querySelector(".av-ms-lvlpick__x").addEventListener("click", shut);
    m.querySelector(".av-ms-modal__scrim").addEventListener("click", shut);
    m.querySelector(".av-ms-lvlgrid").addEventListener("click", function (ev2) {
      var b = ev2.target && ev2.target.closest ? ev2.target.closest("[data-lvl]") : null;
      if (!b) return;
      shut(); arcadeStart(parseInt(b.getAttribute("data-lvl"), 10) || 1);
    });
    document.addEventListener("keydown", function esc(kv) {
      if (kv.key !== "Escape") return;
      document.removeEventListener("keydown", esc); shut();
    });
    var best = m.querySelector(".av-ms-lvl.is-best"); if (best) best.scrollIntoView({ block: "nearest" });
    return true;
  }
  /* 📖 HOW TO PLAY — the animated primer shown before EVERY level-1 round.
     Level 1 is the on-ramp, so it never gets marked "seen": a first-timer and a
     returning player both get the same demo. It loops one full cycle of the real
     loop — draw a strand, a medal gets caught in it, click the medal, score. */
  function howToPlay(onPlay, playLabel, closeCancels) {
    var old = document.querySelector(".av-ms-htpmodal"); if (old) old.remove();
    // the primer REPLACES the welcome modal — stacked, its stage bled through the card
    [].forEach.call(document.querySelectorAll(".av-ms-modal"), function (o) {
      if (o.querySelector(".av-ms-welcome")) o.remove();
    });
    try { Sound.arm(); } catch (e) {}
    var m = tier(el("div", "av-ms-modal av-ms-htpmodal is-open"));
    m.innerHTML =
      '<div class="av-ms-modal__scrim"></div>' +
      '<div class="av-ms-htp">' +
        '<button class="av-ms-htp__x" type="button" aria-label="Close">✕</button>' +
        '<b>📖 HOW TO PLAY</b>' +
        '<span>Catch ' + GOAL + ' medals before the clock runs out.</span>' +
        '<div class="av-ms-htp__stage" aria-hidden="true">' +
          '<svg viewBox="0 0 320 180">' +
            '<path class="av-ms-htp__ink" d="M26,138 C80,60 150,165 214,104" />' +
            '<path class="av-ms-htp__loop" d="M258,26 A32,32 0 1 1 258,90 A32,32 0 1 1 258,26" />' +
          '</svg>' +
          '<i class="av-ms-htp__web"></i>' +                       // the golden "held" glow
          '<img class="av-ms-htp__m1" src="' + MEDAL_SRC + '" alt="" />' +
          '<img class="av-ms-htp__m2" src="' + MEDAL_SRC + '" alt="" />' +
          '<i class="av-ms-htp__ring"></i>' +
          '<i class="av-ms-htp__ring2"></i>' +
          '<i class="av-ms-htp__cursor"></i>' +
          '<s class="av-ms-htp__plus">+1</s>' +
          '<u class="av-ms-htp__beats">' +
            '<span>① DRAW A CURVE</span><span>② IT STICKS</span>' +
            '<span>③ LOOP = TRAPPED</span><span>④ CLICK = +1</span>' +
          '</u>' +
        '</div>' +
        '<p><i>1</i><span><em>Hold and drag</em> anywhere to draw a vector curve.</span></p>' +
        '<p><i>2</i><span>Medals that touch your curve <em>stick to it</em> — draw a web and they pile up waiting for you.</span></p>' +
        '<p><i>3</i><span>Loop a curve <em>around</em> a medal and it is trapped inside.</span></p>' +
        '<p><i>4</i><span><em>Click a medal</em> to collect it. That is your point.</span></p>' +
        '<u>Curves fade after a few seconds · ink refills by itself</u>' +
        '<button class="av-ms-btn" type="button" data-play>' + (playLabel || "▶ START") + '</button>' +
      '</div>';
    document.body.appendChild(m);
    // ---- ONE CLOCK, ONE THREAD, ONE RULER -------------------------------
    // CSS ran the ink on the main thread and the cursor on the compositor, and
    // the two clocks start a frame or two apart — the visible "line draws ahead
    // of the mouse". So the whole trio is driven from a single rAF: every frame
    // ONE number (distance along the tour) sets the dash of both strokes AND
    // the cursor position, all measured with the browser's own path ruler.
    try {
      var _ink = m.querySelector(".av-ms-htp__ink"), _loop = m.querySelector(".av-ms-htp__loop");
      var _cur = m.querySelector(".av-ms-htp__cursor"), _svg = _ink.ownerSVGElement;
      var TOUR = "M26,138 C80,60 150,165 214,104 L258,26 A32,32 0 1 1 258,90 A32,32 0 1 1 258,26 L117,95 L258,58";
      var _tp = document.createElementNS("http://www.w3.org/2000/svg", "path");
      _tp.setAttribute("d", TOUR); _tp.setAttribute("fill", "none"); _tp.setAttribute("stroke", "none");
      _svg.appendChild(_tp);                                     // stays: the ruler lives as long as the scene
      var LA = _ink.getTotalLength(), LC = _loop.getTotalLength(), LT = _tp.getTotalLength();
      var T1 = Math.hypot(258 - 214, 26 - 104);                  // pen-up glides are straight, so exact
      var D3 = LA + T1 + LC, D4 = LT - Math.hypot(258 - 117, 58 - 95);
      [_ink, _loop, _cur].forEach(function (e) { e.style.animation = "none"; });
      _cur.style.offsetPath = "none"; _cur.style.transformOrigin = "0 0";   // press shrinks toward the TIP
      _ink.style.strokeDasharray = LA; _loop.style.strokeDasharray = LC;
      function _apply(f) {                                       // f = 0..1 through the 11s story
        var d;                                                   //   the ONE number everything shares
        if      (f < 0.02) d = 0;
        else if (f < 0.17) d = LA * (f - 0.02) / 0.15;           // ✒ draw the strand
        else if (f < 0.22) d = LA + T1 * (f - 0.17) / 0.05;      // pen up, glide
        else if (f < 0.38) d = LA + T1;                          // watch the medal get caught
        else if (f < 0.54) d = LA + T1 + LC * (f - 0.38) / 0.16; // ⭕ draw the loop
        else if (f < 0.58) d = D3;                               // TRAPPED beat
        else if (f < 0.66) d = D3 + (D4 - D3) * (f - 0.58) / 0.08;   // glide to the caught medal
        else if (f < 0.74) d = D4;                               // 🖱 click #1
        else if (f < 0.80) d = D4 + (LT - D4) * (f - 0.74) / 0.06;   // glide to the trapped one
        else d = LT;                                             // 🖱 click #2
        _ink.style.strokeDashoffset = Math.max(0, LA - Math.min(LA, d));
        _loop.style.strokeDashoffset = Math.max(0, LC - Math.max(0, Math.min(LC, d - LA - T1)));
        _ink.style.stroke = f >= 0.31 ? "#ffd875" : "#7df9ff";   // gold the frame the medal sticks
        _loop.style.stroke = f >= 0.56 ? "#ffd875" : "#7df9ff";  // gold the frame the trap closes
        var so = f >= 0.96 ? 0 : f >= 0.88 ? 1 - (f - 0.88) / 0.08 : 1;
        _ink.style.opacity = so; _loop.style.opacity = so;
        var p = _tp.getPointAtLength(Math.max(0, Math.min(LT, d)));
        var sc = 1;                                              // the pointer visibly PRESSES
        function dip(a, b, mid, lo) { if (f >= a && f <= b) { var q = f < mid ? (f - a) / (mid - a) : (b - f) / (b - mid); sc = 1 - (1 - lo) * Math.max(0, Math.min(1, q)); } }
        dip(0.02, 0.05, 0.028, 0.8); dip(0.375, 0.41, 0.388, 0.8);
        dip(0.68, 0.73, 0.70, 0.75); dip(0.795, 0.85, 0.82, 0.75);
        _cur.style.opacity = f < 0.02 ? f / 0.02 : f >= 0.97 ? 0 : f >= 0.91 ? 1 - (f - 0.91) / 0.06 : 1;
        _cur.style.transform = "translate(" + p.x.toFixed(2) + "px," + p.y.toFixed(2) + "px) scale(" + sc.toFixed(3) + ")";
      }
      m.__htpApply = _apply;                                     // deterministic hook for tests
      var _t0 = performance.now();
      (function _tick() {
        if (!document.body.contains(m)) return;                  // modal closed -> driver dies with it
        _apply(((performance.now() - _t0) % 11000) / 11000);
        requestAnimationFrame(_tick);
      })();
    } catch (e) {}
    function go(start) {
      if (m.parentNode) m.remove();
      if (start && onPlay) onPlay();
    }
    m.querySelector("[data-play]").addEventListener("click", function () { go(true); });
    // dismissing the primer on the FIRST round still starts it (you already pressed Start);
    // from the arcade picker it cancels, so you can go back and choose another level.
    m.querySelector(".av-ms-htp__x").addEventListener("click", function () { go(!closeCancels); });
    m.querySelector(".av-ms-modal__scrim").addEventListener("click", function () { go(!closeCancels); });
    document.addEventListener("keydown", function esc(kv) {
      if (kv.key !== "Escape") return;
      document.removeEventListener("keydown", esc);
      if (m.parentNode) go(false);
    });
    return true;
  }
  // 📖 The primer IS the level-1 experience: it plays EVERY time level 1 is played,
  // whatever route got you there. And a first-time visitor's very first challenge round
  // is their level 1 too, so it plays once there as well.
  function primerThen(cb, always) {
    if (reduce) { cb(); return true; }
    var seen = false;
    try { seen = localStorage.getItem("av_ms_htp") === "1"; } catch (e) {}
    if (!always && seen) { cb(); return true; }
    try { localStorage.setItem("av_ms_htp", "1"); } catch (e) {}
    return howToPlay(cb, always ? "▶ START LEVEL 1" : "▶ START THE ROUND", !always);
  }
  function arcadeStart(L, skipHowTo) {
    if (arena || winning || arcadeBusy) return false;    // no re-entry, never tear down a live round
    // level 1 is the on-ramp: always show the primer first, then start on PLAY
    if (L === 1 && !skipHowTo) return primerThen(function () { arcadeStart(1, true); }, true);
    arcadeBusy = true; setTimeout(function () { arcadeBusy = false; }, 600);
    try { Sound.arm(); } catch (e) {}                    // arcade has no HUD toggle to arm audio
    funMode = true; funCaught = 0;                       // always a fun round: no code, no progress
    funLevel = Math.max(1, Math.min(funMax, L || funMax));
    if (pop) pop.hidden = true;
    try { startArena(); }
    catch (e) {                                          // a throw mid-build must never leave the article covered
      try {
        document.documentElement.classList.remove("av-ms-lowfx");
        var m = document.querySelectorAll(".av-ms-modal");
        for (var i = 0; i < m.length; i++) m[i].remove();
      } catch (e2) {}
      arena = null; return false;
    }
    if (arena && !document.__avMsEsc) {                   // Escape gets the reader back to the article
      document.__avMsEsc = 1;
      document.addEventListener("keydown", function (kv) { if (kv.key === "Escape" && arena) closeArena(); });
    }
    return !!arena;
  }
  function bindArcade() {
    var btns = document.querySelectorAll("[data-av-ms-arcade]");
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].__avMsEgg) continue; btns[i].__avMsEgg = 1;
      btns[i].classList.add("is-armed");                  // the badge only becomes visible once the engine is here
      btns[i].addEventListener("click", function (ev) {
        var b = ev.currentTarget;
        if (arcadeLaunch(ev) === false) { b.classList.add("is-egg-failed"); setTimeout(function () { b.classList.remove("is-egg-failed"); }, 1200); }
      });
    }
  }

  // Sanctioned programmatic entry — the click path deliberately refuses untrusted events,
  // so tests and any future launcher call this instead. It still grants nothing.
  root.__avMsArcade = arcadeLaunch;                       // open the level picker
  root.__avMsStart  = arcadeStart;                        // start a specific level straight away
  root.__avMsBind   = bindArcade;                         // re-arm badges added after boot


  /* =====================================================================
     ===== CANNON (1500) =====
     ---------------------------------------------------------------------
     The milestone cannon mini-game, ported from web/test-drop.html.

     WHY IT IS IN HERE AND NOT IN ITS OWN FILE
       reveal(), win(), setUnlocked(), Sound, tier(), esc(), fmt(), FLD,
       toast(), confetti(), closeArena() and `arena` are all private to this
       IIFE. The cannon has to call win() directly to hand the visitor the
       real reward panel, so it has to live inside the same closure.

     WHAT IS *NOT* IN HERE
       The physics engine and the baked panel geometry. `assets/av-phys.js`
       is `var AVPhys = (() => { ... })()` — a top-level `var`, with no
       assignment to globalThis — so it CANNOT be nested inside this IIFE:
       the var would become a local of this function and nothing would ever
       see it. Both bundles are therefore loaded as ordinary top-level
       <script src> assets by cannonLoad(), and everything below waits for
       them. If either fails to arrive the visitor silently gets the ordinary
       medal game instead (see cannonWelcome).

     THEME TRAPS — READ THIS BEFORE ADDING AN ELEMENT
       assets/av-milestone.css contains two rules that fire while the arena
       is open (they key off html.av-ms-lowfx, which cannonArena adds):

         html.av-ms-lowfx body > *:not([class*="av-ms"])...
             { visibility: hidden !important }
         html.av-ms-lowfx canvas[aria-hidden="true"]
             :not(.av-ms-burst):not(.av-ms-confetti)
             { display: none !important }

       Neither produces a console message. So:
         1. EVERY element created below carries a class containing the
            literal substring "av-ms". Every id and class here is prefixed
            "av-ms-cannon-".
         2. THE GAME CANVAS MUST NEVER CARRY aria-hidden="true". It has
            role="img" and a real aria-label instead, and cannonArena()
            installs a MutationObserver that takes the attribute straight
            back off if anything ever adds one.

     THE COORDINATE FRAME, WHICH CATCHES EVERYONE
       Studio's engine has gravity along -X and its floor is the VERTICAL
       plane walls.startX. In world millimetres:
           world +X = up      world -X = down (the way things fall)
           world +Y = screen right
       cannonDraw() plots (worldY, -worldX). That is the only place any
       per-point maths happens: each body's outline becomes a Path2D ONCE,
       from b.local, and each frame is one setTransform plus one fill.

     THE NUMBERS
       Every constant in CANNON_CFG was measured. engine/TUNING.md in the
       milestone-cannon-game project carries the experiments; the short
       version is in the comments below. Do not "tidy" them.

     EXACTLY ONE ROUTE TO THE CODE  (read this before adding a button)
       While GAME_ON is true the ONLY way to reach the discount code is to
       destroy all six templates. That is not a rule the CSS enforces — the
       first build tried, with a rule keyed off html.av-ms-cannon-on, and it
       failed the moment the arena closed, because the class only exists
       while the arena is OPEN. The medal bar came back, its popover still
       offered "Start challenge round", and a visitor could win a medal round
       for the same code without firing a shot.
       So every medal surface is now NOT BUILT rather than hidden:
         · buildHUD()/updateHUD()  render the shard mark and "▶", never a
           medal image and never a "0 / 40" ring that cannot move.
         · refreshPop()            renders cannonPopHTML(); there is no
           [data-round] and no [data-a11y] element to click.
         · startArena()            refuses outright unless the round is a
           no-stakes funMode/arcade one, which can never grant the code.
         · buildGame()             refuses outright.
       PREFER NOT RENDERING A SURFACE OVER HIDING ONE.

       AND THE ROUND ITSELF HAS TO BE HANDED THE CAPABILITY. cannonArena()
       will not set CN.stakes unless its caller passed CN_STAKES, a private
       object only cannonOpen() and the picker's milestone row hold. See
       cannonMayStake() and THE BARRIERS at the foot of this file.

     WHICH GAME WON  (WON_BY_CANNON, not GAME_ON)
       reveal() shows the shard mark and "cutting all six templates to
       shards" only when WON_BY_CANNON is set, and that flag is written in
       exactly one place: the win branch of cannonShatter(), immediately
       before win(). GAME_ON is a property of the PAGE; WON_BY_CANNON is a
       property of the ROUND that was actually played, so the reward panel
       can no longer describe a game the visitor did not play.

     ONE MORE THING THIS SECTION CHANGES OUTSIDE ITSELF
       closeArena() gained `bossDying = !1;`. It is not cannon-specific: a
       boss killed while the arena was being torn down left that flag true
       forever, which then froze penActive(), the cage check and slowmo for
       every later round of the MEDAL game too. It is a leak fix, kept
       deliberately, and edit (d) in theme/apply-theme-edits.mjs is where it
       is applied.
     ===================================================================== */

  /* ====================================================================
     🎟 CN_STAKES — THE CAPABILITY THAT LETS A ROUND PAY.
     --------------------------------------------------------------------
     A module-private object, minted once, that nothing outside this file
     can name or forge. cannonArena() will not compute a true `stakes`
     unless its caller handed it THIS OBJECT, so "may this round pay?" is
     decided by WHICH CALL SITE OPENED IT, not by re-deriving the page's
     mode inside the round. Exactly two call sites pass it:
       · cannonOpen()        — the celebration's own door (welcome card CTA,
                               the milestone bar's popover, the reward
                               panel's replay)
       · cannonPick()        — and only from the MILESTONE ROW, which is
                               only rendered when the picker was not opened
                               from the easter egg
     Everything else — the level rows, the clear card's [Next]/[Replay],
     the arena's ☰ Levels button, root.__avMsCannon.openLevel(), the egg —
     passes nothing, and `undefined !== CN_STAKES`, so the default of every
     path that does not spell the capability out is a no-stakes round.
     ==================================================================== */
  var CN_STAKES = { milestone: 1 };

  /* ====================================================================
     🎫 TICKETS — WHY THE PICKER ROW CANNOT CARRY THE CAPABILITY ITSELF.
     --------------------------------------------------------------------
     🚨 THE DEFECT THIS REPLACES, REPRODUCED BY A VERIFIER. The shipped
     build marked the milestone row with `data-cnstake="1"` and read it
     back in the picker's click handler:

         b.getAttribute("data-cnstake") === "1" ? CN_STAKES : null

     Setting that one attribute on the LEVEL 1 ROW of an egg-opened picker
     made the picker hand over the real capability object. The authority
     was a truthy string in the markup, and markup is the one thing on the
     page that anybody with a devtools panel — or any injected script, or
     any browser extension — can write.

     SO THE CAPABILITY NEVER TRAVELS THROUGH THE DOM AGAIN. cannonPick()
     MINTS a ticket: a random id that is meaningful only as a key of this
     module-private table. The row carries the ID and nothing else — an
     opaque reference, not a claim — and the id is BOUND to that exact
     element once the picker is in the document. Redeeming needs all
     three to agree: the id, an entry in the table, and the same element
     the entry was bound to.
       · Inventing a value fails the table lookup.
       · Copying a real id onto another row fails the element check.
       · An egg-opened picker mints NOTHING, so the table is empty and no
         id of any kind can redeem to anything.
     Tickets are single-use and the table is dropped when the picker
     closes, so no capability outlives the surface that issued it.
     ==================================================================== */
  var CN_TICKETS = null;                    // { id: { el, grant } } while a picker is up
  var cnTicketN = 0;
  function cannonTicketMint(grant) {
    if (!CN_TICKETS) CN_TICKETS = {};
    var id = "cnt" + (++cnTicketN) + "-" +
             Math.random().toString(36).slice(2, 12) +
             Math.random().toString(36).slice(2, 12);
    CN_TICKETS[id] = { el: null, grant: grant };
    return id;
  }
  function cannonTicketBind(id, el) {
    if (CN_TICKETS && Object.prototype.hasOwnProperty.call(CN_TICKETS, id)) CN_TICKETS[id].el = el;
  }
  function cannonTicketRedeem(id, el) {
    if (!CN_TICKETS || typeof id !== "string" || !id) return null;
    if (!Object.prototype.hasOwnProperty.call(CN_TICKETS, id)) return null;
    var rec = CN_TICKETS[id];
    delete CN_TICKETS[id];                  // single use, whatever happens next
    if (!rec || !rec.el || rec.el !== el) return null;
    return rec.grant;
  }
  function cannonTicketsDrop() { CN_TICKETS = null; }

  /**
   * IS THIS MILESTONE THE ONE THE SHOP HAS ACTUALLY REACHED?
   *
   * `milestone` can be forced by ?av_milestone=<n>, which also persists into
   * sessionStorage as av_ms_preview — so a single shared URL used to force
   * mode === "celebration" for ANY number in the ladder, at any time, years
   * after the event, with ARCADE false. That made a code-granting round
   * reachable from a link. pickAuto() is the only function that answers the
   * honest question — which milestone does the LIVE product count put us in
   * the celebration window of — and it reads no query string at all.
   *
   * ⚠ THE OWNER'S PREVIEW LEVER STILL WORKS: ?av_milestone=1500&av_ms_game=1
   * on a page whose real count is inside the 1500 window is genuine, because
   * pickAuto() returns 1500 there too. What it can no longer do is mint a
   * code for a milestone the shop has not reached.
   */
  function cannonGenuineMilestone() {
    if (!milestone) return false;
    var live = null;
    try { live = pickAuto(); } catch (e) { live = null; }
    return !!(live && live.n === milestone.n);
  }

  /**
   * MAY A ROUND AT LEVEL `L`, OPENED BY A CALLER HOLDING `grant`, PAY?
   *
   * ONE FUNCTION, ASKED BY EVERY SURFACE THAT NEEDS THE ANSWER — cannonPlay()
   * (to decide whether to interpose the primer), cannonArena() (to set
   * CN.stakes) and cannonPick() (to decide whether to render the milestone
   * row at all). The shipped build spelled the four conjuncts out three
   * times in three places and they drifted; now there is one place to read
   * and one place to break.
   *
   * Its conjuncts carry F1 (the capability), F2 (the round's egg mark) and
   * F3 (the genuine milestone). See THE BARRIERS at the foot of this file for
   * which of them is a fact of its own and which are second readings of one.
   */
  function cannonMayStake(L, grant, egg) {
    return grant === CN_STAKES &&            /* F1  the caller held the capability   */
           !CANNON_EGG && !egg &&            /* F2  no egg round is open, and the
                                                    round being considered is not
                                                    one either                       */
           L === 1 &&                        /*     only the milestone round         */
           GAME_ON && !ARCADE &&             /*     the cannon owns a live milestone */
           !isUnlocked() &&                  /*     never twice                      */
           cannonGenuineMilestone();         /* F3  not a forced ?av_milestone= URL  */
  }

  /* The whole live round. null when no cannon game is running — cannonEnd()
     puts it back to null, and closeArena() calls cannonEnd() unconditionally,
     so there is exactly one teardown path for the cannon as well. */
  var CN = null;
  /**
   * THE LOWEST QUALITY TIER THE GOVERNOR HAS EVER HAD TO REACH ON THIS PAGE
   * LOAD, AND WHY IT OUTLIVES THE ROUND.
   *
   * The old comment above cannonSpawn()'s reset said a demotion "is a
   * statement about a pile, not about a machine". That is half right, and
   * the wrong half was costing every round after the first one: the FIRST
   * demotion of a session is almost entirely about the machine, and throwing
   * it away meant a slow phone re-learned the same fact from scratch — two
   * 30-frame windows of visible stutter — every single time the player
   * pressed "New pile" or opened the next level.
   *
   * So the tier is remembered, and a new round starts ONE TIER ABOVE the
   * worst ever seen: high enough that a light pile on a phone that struggled
   * once still gets its sheen back, low enough that the relearning costs one
   * window instead of two. It is per page load — nothing is stored — so a
   * device that was busy for one minute is not judged forever.
   */
  var CANNON_QSEEN = 2;
  /**
   * THE CANVAS PIXEL-RATIO CEILING. 2 for everybody, until a device runs out
   * of quality tiers and is still over budget — then 1.5, for the rest of the
   * page load. See the comment in cannonResize() for the measurement, and
   * cannonGovern() for the one line that lowers it.
   */
  var CANNON_DPRCAP = 2;
  /* Bundle loading state: "idle" | "loading" | "ready" | "failed". */
  var cannonState = "idle", cannonQueue = [];
  /* True from the moment a button asks for a round until that request has
     either opened an arena or given up. It is the idempotence latch: two fast
     clicks on "Fire the cannon again" must not stack two waiting cards, two
     cannonReady() callbacks or two arenas. cannonLoad() is separately
     idempotent (it returns unless cannonState === "idle"), so this guards the
     UI, not the download. */
  var cannonOpening = false;
  /* The "Loading the cannon…" card, while cannonOpening. null when none. */
  var cannonWaitEl = null;
  /* Which pile we are on. A restart bumps it, so a win scheduled by the pile
     before it cannot land on the pile after it. See cannonShatter(). */
  var cannonRound = 0;
  /* ?av_ms_tune=1 — the owner's frame-time readout. A customer never sees it,
     and it is the ONLY thing this flag does: there are no gameplay knobs on
     the storefront. The tuning instrument lives in the project's
     web/test-drop.html, where scripts/prove-game.mjs checks it. */
  var TUNE_UI = qs.get("av_ms_tune") === "1";

  /**
   * Everything the cannon can be told. `physics` values are pushed into the
   * engine's live knob board (AVPhys.setTune); the rest are the game's own.
   * These are the shipped, measured values — see engine/TUNING.md.
   */
  function cannonCfg() {
    return {
      /* --- arena, world millimetres ---------------------------------- */
      floorX: 0,           // walls.startX: the floor plane. Gravity is -X.
      fieldHalfY: 3000,    // playfield is world y in [-3000, +3000] = 6 m
      gapMm: 2,            // NEVER 0. The engine throws AVPhysGapError below 0.5.
      // SIDE WALLS AS STATICS. The engine's own side walls are switched off
      // for an unconfined body, and `confined:false` is also what enables
      // FLOOR_FRICTION — so the game cannot have one without losing the
      // other. Two immovable outlines at the field edges is the way out.
      sideWalls: true,
      wallThickMm: 500,
      wallHeightMm: 12000,

      /* --- physics knobs (mirrored into AVPhys.TUNE) ----------------- */
      // 3. Measured over 12 seeds: 3 -> 6 of 72 panels creep past 90 mm at
      // 6.25 ms p95; 2 -> 12 of 72 at 5.12 ms; 4 -> 9 of 72 at 7.02 ms.
      substeps: 3,
      restitution: 0.35,
      wallRestitution: 0.40,
      friction: 0.35,
      // 1.20, not the engine preset's 0.5: a panel that has landed on an
      // open floor with no ENGINE side walls slides for as long as anything
      // nudges it. 1.2 cut the 30 s creep from 224 mm to 145 mm on its own.
      floorFriction: 1.20,
      gravityScale: 1.0,
      // 0.5 — Studio's own number. An earlier build shipped 10.0 claiming it
      // was what stopped the creep; re-measured over 44 seeds, 10.0 LOSES on
      // every creep statistic (worst-5% drift 326/343 mm against 174/154).
      contactDampTan: 0.5,
      // How long a body must be crawling before the settle assist drains it.
      // At 1.0 one seed of 24 never goes quiet; at 2.5 the pile takes 8 s;
      // 1.5 gets all 24 quiet in about 4 s.
      settleIdleS: 1.5,

      /* --- cannon ---------------------------------------------------- */
      /**
       * THE GUN LIVES OUTSIDE THE ARENA, BEHIND THE LEFT WALL.
       *
       * It used to be at (300, -2680): 300 mm off the floor and 320 mm INSIDE
       * the left wall, standing in the drop zone, so panels fell on it and
       * settled on top of it. Moving it a little would have made that rare;
       * this makes it impossible. The left wall is a STATIC spanning world y
       * in [-3500, -3000] for 12 m of height, so no body can ever be left of
       * -3000 (measured over 48 rounds: -2998.0 mm, hard against the wall).
       * Every point of the gun is within cannonReach() = 840.6 mm of the
       * trunnion at -4350, so the closest it can come to the playfield is
       * -3509.4 mm — 509 mm of guaranteed clearance, at every aim angle and
       * every seed at once. scripts/prove-cannon-clear.mjs measures 442.8 mm
       * to the convex hull of every barrel pose, which under-reports on
       * purpose.
       */
      cannonX: 3100,       // world x of the TRUNNION (the pivot), mm up
      cannonY: -4350,      // world y of the trunnion — LEFT OF THE LEFT WALL
      // The barrel is a PROFILE in barrel-local mm (t along the bore, s
      // across it), not a pixel sprite: it scales with the arena and it has a
      // world extent a clearance proof can measure. cannonBarrelPoly() turns
      // these into the twelve world points the renderer fills.
      barrelLenMm: 820,    // trunnion -> muzzle tip
      barrelHalfMm: 135,   // half-thickness of the tube
      bellHalfMm: 185,     // half-thickness of the muzzle bell
      bellMm: 60,          // how long the bell is
      breechMm: 180,       // how far the breech block runs BEHIND the trunnion
      breechHalfMm: 205,   // half-thickness of the breech block
      breechEndMm: 100,    // where the block stops and the taper begins
      taperMm: 70,         // length of the taper from block to tube
      mountRadiusMm: 210,  // the trunnion cap drawn at the pivot
      // THE AIM IS CLAMPED TO A CONE. Bearing runs from world +Y (screen
      // right) toward world -X (screen down). Every settled target lies in
      // -4.3..65.7 deg, measured over 24 seeds; outside [-30, 76] the barrel
      // swings backwards off the canvas and past 76 deg the shot plunges down
      // the OUTSIDE of the wall and can never enter the arena at all.
      aimUpDeg: 30,
      aimDownDeg: 76,
      aimRestDeg: 26,      // where the barrel sits before the pointer arrives
      // THE VIEW HAS TO MAKE ROOM FOR THE GUN. sx() maps world y to screen x
      // and the field used to be centred with nothing outside it, so on any
      // width-limited canvas — every phone — world y = -3000 was screen x = 0
      // and the gun would have been off-canvas. 1900 = 1610 (field edge to
      // the outside of the mounting shelf over every aim angle) + 290 of air.
      viewPadLeftMm: 1900,
      viewPadRightMm: 320,
      cannonPower: 14000,  // projectile speed, mm/s; also scales the blast
      ballRadiusMm: 90,
      // Unchanged: the longest sightline in the arena is muzzle -> far bottom
      // corner = 7210 mm, so this only ever limits a shot that misses.
      shotRangeMm: 26000,

      /* --- the ricochet ---------------------------------------------- */
      /**
       * THE BALL BOUNCES OFF THE PILLARS NOW. It used to fly straight
       * through them, and the owner found that in about ten seconds:
       * "kiaurai sienas praeina kulka, reikia kad atsimustu i siena".
       *
       * WHY IT HAPPENED. `world.statics` was pushed into the SOLVER (so
       * panels collided with the pillars correctly) and drawn — but the shot
       * is not a physics body. cannonHit() is an analytic ray against
       * CN.world.bodies, and statics are not bodies. So the one thing on the
       * field that looks solid was the only thing the ball ignored.
       *
       * IT IS A MECHANIC, NOT A STOP. A ricochet keeps flying, so a pillar
       * becomes a way to reach a panel you cannot see from the muzzle
       * instead of a wall that eats a shot. That is worth more than a hard
       * stop and it costs the same code.
       *
       * WHY ONLY THE PILLARS, AND NOT THE FLOOR OR THE RIGHT-HAND WALL.
       * Those two already END a shot with their own event — the mat scorch
       * and the wall strike — and those reads are the only thing that tells
       * a player where a wide shot went. Bouncing off them would delete that
       * feedback, and it would change LEVEL 1, which is frozen. A level with
       * no pillars therefore behaves exactly as it did before this existed;
       * CN.pil is empty and cannonSegPil() returns on its first line.
       */
      maxBounces: 2,
      /* WHICH SURFACES A LEVEL LETS THE BALL COME OFF. The pillars always do —
       * that is the bug this fixes. The ROOM (the mat and the right-hand wall)
       * is per level, and it is what turns the ricochet from a correctness fix
       * into something a player can actually plan with.
       *
       * MEASURED, AND THIS IS WHY THE ROOM IS IN IT. Sweeping the whole aim
       * cone on 12 settled level-2 piles (scratch/pillar-reach.mjs), 401
       * bearings a pile: with pillars alone a PILLAR is the first thing the
       * ball would hit on 0.7% of lines, and 9 of 12 piles have no bank shot
       * available at all — the gun fires DOWN into the heap and 820 mm of
       * steel is buried by the pile it is holding up. Raising the pillars to
       * 1700 mm (and the spawn floor with them) only reaches 4.3%. The mat and
       * the back wall, on the other hand, are on 34% of lines by themselves:
       * they are the surfaces that are ALWAYS there.
       *
       * LEVEL 1 KEEPS 0. A shot into the mat scorches it and dies, which is
       * the feedback the milestone round has always given, and the frozen
       * level does not change. */
      bounceRoom: 0,
      /* WHAT A BOUNCE COSTS, AND WHY IT IS ONE NUMBER. Speed and blast are
       * the SAME scalar (`shot.pow`), so the ball visibly slows as it loses
       * strength — on a screen with no numbers on it that is the only honest
       * way to show energy. 0.78 twice leaves 61%.
       *
       * A RICOCHET STILL KILLS WHAT IT HITS. A hit is a hit: the panel
       * shatters at full certainty, because "your bank shot connected and
       * bounced off" is the worst possible lesson to teach. What scales is
       * the BLAST — the speed the shards leave at — so a two-bank shot
       * clears its panel without blowing the pile apart, which is exactly
       * the trade a trick shot should make. */
      bounceLoss: 0.78,
      bounceMinPow: 0.30,
      /* How far off the face the reflected ball is re-seeded, mm. One ball
       * radius: any less and the next step's segment can start inside the
       * pillar and immediately re-hit the same face, which reads as the ball
       * sticking. */
      bounceLiftMm: 95,

      /* --- bouncy panels --------------------------------------------- */
      /**
       * "kitos gali ir buti bounci kaip guminis kamuoliukas sokinetu kad
       * sunkiau butu pataikyt kituose lygiuose" — some panels should behave
       * like a rubber ball so they are harder to hit in the later levels.
       *
       * The engine's restitution was one number for the whole world, which
       * cannot say that: raising it turns the WHOLE heap to jelly and the
       * pile stops going quiet. engine/patches/60-body-restitution.mjs makes
       * it per body, with these two values written onto the bodies a level's
       * `bouncy` list names. A contact takes the LARGER of the two bodies'
       * coefficients, so a rubber panel bounces off the ordinary pile it
       * lives in.
       *
       * 0.72 IS MEASURED, not chosen. Swept 0.5..0.9 in
       * scratch/bouncy-sweep.mjs (apex off a bare floor) and then on the real
       * piles through prove-levels' settle column, which is the number that
       * matters: a bouncy panel must still let the pile reach awake == 0.
       */
      bouncyRest: 0.65,
      bouncyWallRest: 0.65,

      /* --- shatter --------------------------------------------------- */
      fragCount: 9,        // the 9 baked shards tile the panel exactly
      // 2.0 s. At the worst realistic pacing — a hit every second — the peak
      // is 22 bodies and 4.27 ms p95; at 2.5 it is 30 bodies and 5.43 ms.
      // Fading is the only thing that removes bodies the cap cannot.
      fragLifeS: 2.0,
      fragFadeS: 0.9,
      // HARD BODY BUDGET. The broadphase is O(n^2), so frame time is set by
      // this number and nothing else. cap 64 -> 12.01 ms p95, 48 -> 9.65,
      // 40 -> 7.49, 32 -> 4.06, 24 -> 3.97. 32 is where the curve flattens.
      maxBodies: 32,
      /* ==================================================================
         THE 200 mm SHARE, MEASURED ONCE ON 2026-09-02 AND PRINTED IN ONE
         PLACE. scratch/measure-blast.mjs, 60 seeds and 540 shards, on the
         shipping level-1 pile: the share of shards that travel more than
         200 mm within 1.5 s of a REAL shot at a settled pile.

           blastScale   0.26  54.6%     0.50  53.0%     0.70  53.1%
           blastUpMm     900  47.4%     2500  47.8%     5000  51.1%
                        6000  57.0%     6600  54.8%     7200  54.4%
           forward-transfer clip:  clipped 53.1%   raw sdx 54.3%

         Three DIFFERENT figures for this one quantity used to sit in the
         tree — "97% at 0.70" here, "63%" beside the shove, and "81% at
         5000" below — and none of them survived re-measurement. The honest
         summary is that the share is about half, that blastScale barely
         moves it, and that blastUpMm moves it a few points. The knobs are
         kept where they are because of what the pile LOOKS like and because
         a null result is not a reason to change shipped physics; they are
         no longer credited with a win they never had.
         ================================================================== */
      blastScale: 0.70,
      blastForward: 0.10,
      // World +X (up) added to every shard. A panel at the bottom of the pile
      // is boxed in and the speculative clamp eats a purely sideways blast in
      // one substep, so this is not decoration — see the table above.
      blastUpMm: 5000,

      /* --- misc ------------------------------------------------------ */
      wakeRadiusMm: 2600,  // clear b.asleep this far from an impact
      seed: 20260901
    };
  }

  /* ======================================================================
     THE LEVEL TABLE.
     ----------------------------------------------------------------------
     WHAT USED TO BE HERE was a module-level CANNON_LAYOUT / CANNON_ROWS
     pair — one pile, forever. They are now FIELDS of a level, read through
     CN.level, and `cfg` is shallow-merged over cannonCfg() when the round is
     built, so nothing outside this table needs a per-level branch.

     THE LITERAL BELOW IS DUPLICATED, ON PURPOSE, IN web/test-drop.html AS
     `AVGame.levels`.  Every node proof (prove-settle, prove-nofloat,
     prove-game, prove-levels, prove-cannon-clear) loads THAT file, not this
     one. If the two ever disagree the proofs measure a pile the shop does not
     build — and they pass while doing it. theme/verify-theme.mjs must extract
     both literals and assert byte-equality after whitespace normalisation;
     that is a mechanical barrier, not a promise, and it is the only thing
     standing between this table and a silent lie.

     LEVEL 1 IS FROZEN. Its ids, its rows, its (empty) cfg and its viewTopMm
     are the exact shipped values, so every existing measurement still
     describes the level everybody plays.

     viewTopMm 5600 ON LEVEL 1 IS NOT A TYPO and is not the 6000 the design
     doc asked for: scripts/prove-cannon-clear.mjs line 371 recomputes the
     view as Math.min(W / span, (H - 60) / 5600) to prove the gun clears the
     score strip at every viewport. Changing level 1's divisor would leave
     that proof measuring a gun position the game never draws — the exact
     class of silent failure this file exists to avoid. Levels 2 and 3 raise
     it because they have more sky to show; neither is covered by that proof.

     THE TABLE IS SHAPED FOR FIVE LEVELS AND SHIPS THREE. Adding levels 4 and
     5 later is a data + geometry-pack change with no architecture change:
     bump CANNON_MAX_LEVEL, add the rows, bake the pack.
     ====================================================================== */
  var CANNON_MAX_LEVEL = 3;
  var CANNON_LEVELS = [null,
    {
      n: 1, name: "PROOF SHEET", kit: "Skoda Kodiaq", pack: 1, par: 8,
      accent: "#7fe7d8", feature: "",
      ids: [
        { id: "kodiaq-p1", row: 0, slot: 0 },
        { id: "kodiaq-p20", row: 0, slot: 1 },
        { id: "kodiaq-p38", row: 0, slot: 2 },
        { id: "kodiaq-p3", row: 1, slot: 0 },
        { id: "kodiaq-p42", row: 1, slot: 1 },
        { id: "kodiaq-p41", row: 1, slot: 2 }
      ],
      rows: [
        { bottomX: 900, jitterDeg: 28, spinMax: 2.5, driftMax: 250 },
        { bottomX: 3300, jitterDeg: 40, spinMax: 4.5, driftMax: 500 }
      ],
      viewTopMm: 5600, cfg: {}
    },
    {
      n: 2, name: "FULL KIT", kit: "Skoda Kodiaq", pack: 2, par: 14,
      accent: "#ffce6a", feature: " \u00b7 bank a shot off the pillars",
      /* LEVEL 2 IS THE RICOCHET LEVEL. That is its whole reason to exist and
         it is what the picker says about it. Eleven panels — the six that
         ship plus the two rear quarters and the three MIRROR panels baked on
         2026-09-02, so "FULL KIT" finally means both sides of the car.
         Five/three/three across three rows: row 0 carries the five narrow
         bodies (worst-case extent 5214 of the 5520 the spawner allows at
         18 deg, measured by prove-levels section C), and the two big ones —
         the hood and the roof — head rows 1 and 2. */
      ids: [
        { id: "kodiaq-p20", row: 0, slot: 0 },
        { id: "kodiaq-p25", row: 0, slot: 1 },
        { id: "kodiaq-p40", row: 0, slot: 2 },
        { id: "kodiaq-p38", row: 0, slot: 3 },
        { id: "kodiaq-p39", row: 0, slot: 4 },
        { id: "kodiaq-p3", row: 1, slot: 0 },
        { id: "kodiaq-p42", row: 1, slot: 1 },
        { id: "kodiaq-p41", row: 1, slot: 2 },
        { id: "kodiaq-p1", row: 2, slot: 0 },
        { id: "kodiaq-p44", row: 2, slot: 1 },
        { id: "kodiaq-p43", row: 2, slot: 2 }
      ],
      /* THE JITTER IS DELIBERATELY LOWER THAN LEVEL 1'S, and that is a
         design decision rather than the fit gate taking it away. A row with
         five bodies in it has no room to tumble; asking for 28 deg and
         letting the spawner halve it to 14 gives a WORSE pile than asking
         for 18 and getting 18, because the halving is all-or-nothing per row
         and lands wherever the seed puts it. */
      rows: [
        { bottomX: 900, jitterDeg: 18, spinMax: 2.5, driftMax: 250 },
        { bottomX: 3200, jitterDeg: 26, spinMax: 4.5, driftMax: 500 },
        { bottomX: 5500, jitterDeg: 26, spinMax: 4.5, driftMax: 500 }
      ],
      pillars: [
        { y: -1100, x0: 0, h: 820, w: 320 },
        { y: 1400, x0: 0, h: 820, w: 320 }
      ],
      /* ONE RUBBER PANEL, AS AN INTRODUCTION — AND IT IS THE BUMPER.
         The bumper centre is the wide flat dome the rest of the kit lands on
         and slides off, which makes "the bumper is made of rubber" the one
         choice here a player does not need explaining.
         IT IS ALSO THE ONLY ONE THAT SETTLES. Over 24 seeds at a 400 s cap
         (scratch/settle-ab.mjs), quiet median / p90 / max and how many never
         got there:
           kodiaq-p20  bumper centre    9.3 / 20.9 /  24.0   0 never  <- ships
           kodiaq-p39  front fender R   9.7 / 43.8 /  95.8   0 never
           kodiaq-p42  front door      13.7 / 33.0 /  58.8   0 never
           kodiaq-p25  rear quarter    10.8 / 20.6 / 400.0   1 never
           kodiaq-p38  front fender    14.3 / 75.3 / 400.0   2 never
         The rear quarter is the L-shaped body the bake picked precisely
         because it WEDGES against a neighbour instead of stacking flat, and a
         wedged body that also bounces is one that never stops arguing with
         the pile. Level 3 has three rubber panels and they matter. */
      bouncy: ["kodiaq-p20"],
      /* THE SETTLE OVERRIDES ARE NOT LEVEL 3'S ANY MORE. Eleven panels
         settle like fourteen: MEASURED over 16 seeds (scratch/settle-ab.mjs),
         level 2 without them is median 14.4 s / p90 30.3 / max 31.2 and with
         them and one rubber panel it is 13.2 / 29.3 / 45.1. Without them AND
         with the rubber panel it is 23.3 / 59.8 / 60.6, which is a pile that
         is still visibly moving when the player takes their second shot. */
      viewTopMm: 7200, cfg: { fragCount: 7, fragLifeS: 1.8, contactDampTan: 1.5, settleIdleS: 0.9, bounceRoom: 1 }
    },
    {
      n: 3, name: "CUSTOMER'S CAR", kit: "Audi A6 C8", pack: 2, par: 18,
      accent: "#c9b3ff", feature: " \u00b7 rubber panels, and one you must not cut",
      /* LEVEL 3 IS THE CROWD. Fourteen panels in four rows, 4/3/4/3 — the ten
         it shipped with plus the bumper-corner mirror, the fender mirror, the
         second bonnet sheet and the trunk ledge (the narrowest legal body in
         the kit, which is what lets a row that has spent its width on doors
         still take one more). */
      ids: [
        { id: "a6-p33", row: 0, slot: 0 },
        { id: "a6-p28", row: 0, slot: 1 },
        { id: "a6-p56", row: 0, slot: 2 },
        { id: "a6-p73", row: 0, slot: 3 },
        { id: "a6-p11", row: 1, slot: 0 },
        { id: "a6-p15", row: 1, slot: 1 },
        { id: "a6-p58", row: 1, slot: 2 },
        { id: "a6-p32", row: 2, slot: 0 },
        { id: "a6-p27", row: 2, slot: 1 },
        { id: "a6-p67", row: 2, slot: 2 },
        { id: "a6-p55", row: 2, slot: 3 },
        { id: "a6-p72", row: 3, slot: 0 },
        { id: "a6-p66", row: 3, slot: 1 },
        { id: "a6-p12", row: 3, slot: 2 }
      ],
      /* FOUR ROWS AT 1950 mm OF PITCH, not the 2400 three rows could afford.
         The pitch has to clear the tallest body a row can spawn — the A6
         bonnet is 1842 mm of world-X extent at 26 deg — or a panel is born
         inside the row above it and the barrier spends the drop unpicking it.
         1950 clears 1842 and no more, which is why the two bonnet sheets are
         pinned to rows 1 and 3 and the tall trims are not in the pack. */
      rows: [
        { bottomX: 900, jitterDeg: 22, spinMax: 2.5, driftMax: 250 },
        { bottomX: 2900, jitterDeg: 26, spinMax: 4.5, driftMax: 500 },
        { bottomX: 4850, jitterDeg: 26, spinMax: 4.5, driftMax: 500 },
        { bottomX: 6800, jitterDeg: 26, spinMax: 4.5, driftMax: 500 }
      ],
      /* THREE RUBBER PANELS, AND THE FIRST OF THEM IS THE PROTECTED PANEL'S
         OWN TWIN. a6-p32 is the same outline as a6-p27 — the level already
         asks the player to read the cyan rather than the silhouette, and now
         one of the two identical doors will not hold still. The other two are
         a rear door and a fender: flat, square bodies that bounce
         predictably. The two shallow bumper arcs are deliberately NOT bouncy;
         a6-p56 is the rocking chair that owns this level's settle tail and
         adding restitution to it would be picking a fight with a known bug.
         THE THIRD ONE IS THE BIG ONE, and it is chosen by settle tail. Over
         24 seeds at a 400 s cap (scratch/settle-ab.mjs), quiet median / p90 /
         max, third panel varied:
           + a6-p12  bonnet, second sheet   16.1 / 28.9 / 33.7   <- ships
           + a6-p66  bumper corner R        17.0 / 35.1 / 40.9
           + a6-p72  front fender R         13.9 / 47.7 / 64.7
         A rubber slab of 1621x1411 in the top row is also the most legible
         version of the mechanic in the game: it is the biggest thing on
         screen and it will not sit still. */
      bouncy: ["a6-p32", "a6-p28", "a6-p12"],
      /* WHERE THE PROTECTED PANEL IS PINNED, AND WHY THE ROW INDEX MOVED.
         The 2026-09-02 sweep (30 seeds a placement, see scripts/lib/levels.mjs
         for the table) measured the pin on a THREE-row pile and landed on
         row 1 slot 2 — the middle of the pile, where the panel is a real
         obstacle without standing in the firing line of half the field. This
         level now has FOUR rows, so "the middle" is row 2, and slot 1 puts it
         next to its own twin. Row 1 in a four-row pile is the old row 0: near
         the bottom, buried, and no rule left. */
      protect: "a6-p27", protectPin: { row: 2, slot: 1 },
      viewTopMm: 8800,
      /* LEVEL 3 IS THE ONLY LEVEL WITH PHYSICS OVERRIDES, and they are here
         because of one shape: a6-p56, the Audi front bumper, is a shallow
         convex arc — a rocking chair. The geometry lane proved it is not a
         geometry problem (row heights, swapping the arc, halving spawn spin
         and drift, and a coarser bake were all tried and recorded as dead
         ends), so it is a contact-damping problem, and contact damping is a
         cfg knob. MEASURED over 26 seeds at a 90 s cap, scratch/vis/l3-quiet.mjs:
           baseline            median 23.9s  p90 71.0s  max 76.9s  2 never quiet
           damp 1.5 + idle 0.9 median 12.0s  p90 40.4s  max 50.0s  1 never quiet
         It halves the typical settle and closes one of the two stubborn seeds.
         It does NOT close the tail: seed 432052172 still rocks past 90 s, and
         the cost of that is one awake body, which is 0.2 ms and no gameplay.
         fragCount 6 and fragLifeS 1.5 are THE PRICE OF THE FOURTEEN PANELS:
         fourteen templates hold fourteen of the 32 body slots forever, so a
         kill has to spend fewer and give them back sooner or the cap culls
         the spray before the player has seen it. See the ladder in README.
         LEVEL 1 KEEPS cfg {} AND ALWAYS WILL. */
      cfg: { fragCount: 6, fragLifeS: 1.5, contactDampTan: 1.5, settleIdleS: 0.9 }
    }
  ];

  // +90 degrees: the bake is in Studio's screen frame (+y DOWN) and the
  // renderer plots (worldY, -worldX), so at theta 0 a panel reads a quarter
  // turn out. At +pi/2 the world maps bake +x to screen right — the SVG exactly.
  var CANNON_BASE_THETA = Math.PI / 2;

  /* ------------------------------------------------- the palette ------ */
  /**
   * FOUR COLOURS AND ONE PER-LEVEL ACCENT. Written once, obeyed everywhere.
   *
   * The floor's old amber tint is GONE — the cutting mat replaced it — and
   * that is what freed amber for the HUD and let the aim line become cyan.
   * Cyan means "a cut line, or something the machine is telling you"; amber
   * means "you"; lime means "ready / done".
   */
  var CN_CYAN = "#35e0e8", CN_AMBER = "#ffb02e", CN_LIME = "#b8f24a";
  /* A FIFTH COLOUR, AND IT IS SPENT ON ONE THING. Magenta appears nowhere
     else in the game — not in the HUD, not on the mat, not on a panel —
     so a magenta dashed outline can only mean "this one is rubber". A
     mechanic the player meets by being ambushed is not a mechanic. */
  var CN_RUBBER = "#ff6ec7";
  /* A SIXTH, AND IT IS SPENT ON THE ONE THING THAT CAN END A ROUND BADLY.
     Red appears nowhere else in the live game — the scrap flash is a paler
     #f87171 on a round that is already over — so a red aim line, a red
     reticle and a red outline can only mean ONE thing: fire this and you
     lose. That is the whole of the fairness contract in a colour. */
  var CN_DANGER = "#ff3b3b";

  /* --------------------------------------------- the storage keys ----- */
  /**
   * FOUR KEYS, ALL PREFIXED av_ms_ SO ?av_ms_reset=1 STILL CLEARS THEM.
   *
   *   av_ms_cannon_lvl     int 1..CANNON_MAX_LEVEL — the ladder ceiling
   *   av_ms_cnshots_{L}    int — your best clear of level L
   *   av_ms_cannon_htp     "1" — the primer has been seen
   *   av_ms_cannon_hello   "1" — the egg's welcome has been seen
   *
   * ⚠ av_ms_cannon_lvl IS DELIBERATELY *OUTSIDE* THE `NS` NAMESPACE, and it
   * must stay that way. NS is "av_ms_arc_" on an arcade/easter-egg page and
   * "av_ms_" on the celebration page. A level cleared from the easter egg has
   * to show as cleared during the celebration, and a level cleared during the
   * celebration has to still be there a year later when the only door left is
   * the egg. That is the owner's "unlocked forever", and namespacing this key
   * would split every player's ladder in two — silently, with no error.
   *
   * IT IS SAFE PRECISELY BECAUSE IT GRANTS NOTHING. The discount code lives
   * behind KEY + "_unlocked", which IS inside NS and is written only by
   * setUnlocked(), which returns immediately while ARCADE. Setting
   * av_ms_cannon_lvl to 3 by hand in devtools opens three levels and zero
   * discount codes. See §10.5 of the build spec and THE BARRIERS below.
   *
   * (This is the same reasoning as the medal game's av_ms_funlvl, which is
   * also outside NS, and for the same reason.)
   */
  var CANNON_LVL_KEY = "av_ms_cannon_lvl";
  /** The ladder ceiling: the highest level ever opened. Never lowers. */
  function cannonMax() {
    try {
      return Math.max(1, Math.min(CANNON_MAX_LEVEL,
        parseInt(localStorage.getItem(CANNON_LVL_KEY) || "1", 10) || 1));
    } catch (e) { return 1; }
  }
  /**
   * THE ONLY WRITER OF THE CEILING, and monotone by construction: it refuses
   * to write anything that is not strictly higher than what is already there,
   * so replaying level 1 after clearing level 3 cannot lower anything.
   * Returns true when it actually raised the ceiling.
   */
  /**
   * THE LEVEL-CLEAR CHORD, in a function of its own.
   * It is here rather than inline in cannonClear() for one reason: the static
   * audit reads cannonClear()'s body for the literal word `win`, and it audits
   * the WORD rather than the call precisely so that no amount of cleverness
   * can slip past it. Sound.win() is a chord, not the code path — but a check
   * that has to reason about which `win` it is looking at is not a check.
   */
  function cannonFanfare() { try { Sound.win(); } catch (e) {} }
  function cannonLadderRaise(n) {
    var m = cannonMax();
    if (n <= m || n > CANNON_MAX_LEVEL) return false;
    try { localStorage.setItem(CANNON_LVL_KEY, "" + Math.min(CANNON_MAX_LEVEL, n)); } catch (e) {}
    return true;
  }
  /** Your best clear of a level, in shots, or 0 for "never cleared". */
  function cannonBest(L) {
    try { return parseInt(localStorage.getItem("av_ms_cnshots_" + L) || "0", 10) || 0; } catch (e) { return 0; }
  }
  /**
   * THE ONLY WRITER OF A BEST-RUN RECORD, and monotone like the ladder: it
   * refuses anything that is not strictly fewer shots than what is there.
   * Returns true when the record moved, which is what the clear card prints.
   *
   * IT IS A FUNCTION BECAUSE TWO PATHS CLEAR A LEVEL, NOT ONE. The stakes
   * round takes the win() branch of cannonShatter() and never reaches
   * cannonClear(), so a record written only inside cannonClear() can never be
   * set for the round most players play level 1 as. Both callers now go
   * through here, and neither can forget.
   *
   * LIKE THE LADDER, IT GRANTS NOTHING: "av_ms_cnshots_1" is an integer read
   * only by cannonBest() and printed by the picker.
   */
  function cannonBestRaise(L, shots) {
    var best = cannonBest(L);
    if (best && shots >= best) return false;
    try { localStorage.setItem("av_ms_cnshots_" + L, "" + shots); } catch (e) {}
    return true;
  }
  function cannonSeenHTP() {
    try { return localStorage.getItem("av_ms_cannon_htp") === "1"; } catch (e) { return false; }
  }
  /**
   * WHICH LEVEL A PLAIN cannonOpen() SHOULD GIVE YOU.
   * During the celebration, before the code is won, that is always level 1 —
   * the milestone round. Afterwards it is wherever the player got to.
   */
  function cannonDefaultLevel() {
    return (GAME_ON && !isUnlocked()) ? 1 : cannonMax();
  }

  /* ------------------------------------------------------- loading ---- */

  /**
   * LOAD THE TWO TOP-LEVEL BUNDLES, ONCE.
   *
   * They go in as ordinary <script src> elements on <head> because
   * assets/av-phys.js declares `var AVPhys` at top level. Both carry an
   * av-ms class so theme trap 1 cannot reach them (it excludes <script>
   * anyway; the class is belt and braces and keeps the house rule true).
   *
   * A script that neither loads nor errors — blocked by an extension, a
   * proxy that swallows the request — would leave the visitor with nothing
   * at all, so there is a hard 12 s timeout that fails the same way a 404
   * does. Failure is never an error message: cannonWelcome() falls back to
   * the ordinary medal game.
   */
  function cannonLoad() {
    if (cannonState !== "idle") return;
    cannonState = "loading";
    var srcs = [PHYS_SRC, PARTS_SRC];
    if (!srcs[0] || !srcs[1]) { cannonSettle(false); return; }
    var left = srcs.length, dead = false, timer = 0;
    function done(ok) {
      if (dead) return;
      if (!ok) { dead = true; clearTimeout(timer); cannonSettle(false); return; }
      if (--left > 0) return;
      dead = true; clearTimeout(timer);
      // Both files answered 200 — but a 200 that is the placeholder comment,
      // or a CDN error page, still leaves the globals missing. Check them.
      cannonSettle(!!(window.AVPhys && window.AVPhys.createBody &&
                      window.AVGameParts && window.AVGameParts.parts));
    }
    timer = setTimeout(function () { done(false); }, 12000);
    for (var i = 0; i < srcs.length; i++) {
      var s = el("script", "av-ms-cannon-lib");
      s.async = false;                       // keep AVPhys before AVGameParts
      s.addEventListener("load", function () { done(true); });
      s.addEventListener("error", function () { done(false); });
      s.src = srcs[i];
      document.head.appendChild(s);
    }
  }
  function cannonSettle(ok) {
    cannonState = ok ? "ready" : "failed";
    // Hand the milestone back BEFORE the queue flushes, so every waiting
    // callback (cannonWelcome's fallback, cannonOpen's) already sees a page
    // where GAME_ON is false and the medal surfaces are the real ones.
    if (!ok) cannonDowngrade();
    var q = cannonQueue; cannonQueue = [];
    for (var i = 0; i < q.length; i++) { try { q[i](ok); } catch (e) {} }
    if (!ok) { try { console.warn("[av-ms] cannon bundles unavailable — falling back to the medal game"); } catch (e) {} }
  }
  /** Run cb(ok) once the bundles have resolved one way or the other. */
  function cannonReady(cb) {
    if (cannonState === "ready") { cb(true); return; }
    if (cannonState === "failed") { cb(false); return; }
    cannonQueue.push(cb);
  }

  /* --------------------------------------------- the geometry packs --- */
  /**
   * ONE EXTRA PACK, FETCHED ONLY WHEN A LEVEL NEEDS IT.
   *
   * build/av-game-parts.js (pack 1) is byte-frozen and holds level 1's six
   * Kodiaq panels. build/av-game-parts-2.js (pack 2) holds the two extra
   * Kodiaq quarters and the ten Audi A6 panels, and calls
   * window.AVGameParts.merge() — which it defines itself, so pack 1 never
   * changes. A shopper who plays only the milestone round downloads ZERO
   * extra geometry: this function is never called with L > 1 for them.
   *
   * THE URL COMES FROM LIQUID, NOT FROM JAVASCRIPT. Shopify's asset URLs are
   * content-hashed and only Liquid can build them, which is why the two
   * existing data-*-src attributes exist and why this one has to as well.
   * If data-parts-src-2 is missing (an older snippet), levels 2 and 3 fail
   * gracefully through cb(false) -> cannonFailUI(); level 1 is untouched.
   */
  var PARTS_SRC_2 = "";
  try { PARTS_SRC_2 = (root.getAttribute("data-parts-src-2") || "").trim(); } catch (e) {}
  var cannonPack2 = "idle", cannonPack2Q = [];
  function cannonPackHave(L) {
    var lv = CANNON_LEVELS[L] || CANNON_LEVELS[1];
    if (lv.pack === 1) return true;
    var P = window.AVGameParts;
    if (!P || !P.parts) return false;
    for (var i = 0; i < lv.ids.length; i++) {
      var found = false;
      for (var j = 0; j < P.parts.length; j++) if (P.parts[j].id === lv.ids[i].id) { found = true; break; }
      if (!found) return false;
    }
    return true;
  }
  /** Make sure level L's geometry is in window.AVGameParts, then cb(ok). */
  function cannonPack(L, cb) {
    cannonReady(function (ok) {
      if (!ok) { cb(false); return; }
      if (cannonPackHave(L)) { cb(true); return; }
      if (!PARTS_SRC_2) { cb(false); return; }
      if (cannonPack2 === "ready") { cb(cannonPackHave(L)); return; }
      if (cannonPack2 === "failed") { cb(false); return; }
      cannonPack2Q.push(function () { cb(cannonPack2 === "ready" && cannonPackHave(L)); });
      if (cannonPack2 !== "idle") return;
      cannonPack2 = "loading";
      var dead = false, timer = 0;
      function settle(good) {
        if (dead) return; dead = true; clearTimeout(timer);
        cannonPack2 = good ? "ready" : "failed";
        var q = cannonPack2Q; cannonPack2Q = [];
        for (var i = 0; i < q.length; i++) { try { q[i](); } catch (e) {} }
      }
      timer = setTimeout(function () { settle(false); }, 12000);
      var s = el("script", "av-ms-cannon-lib");
      s.async = false;
      s.addEventListener("load", function () { settle(true); });
      s.addEventListener("error", function () { settle(false); });
      s.src = PARTS_SRC_2;
      document.head.appendChild(s);
    });
  }

  /* ---------------------------------------------------------- boot ---- */

  /**
   * Replaces buildGame() when GAME_ON. It only PRE-WARMS the download;
   * nothing is built until cannonWelcome()'s CTA is pressed, so a visitor who
   * never plays pays for two cached assets and no simulation at all.
   *
   * ⚠ NOTHING MAY DEPEND ON THIS HAVING RUN. startEverything() reaches it
   * only on the branch a not-yet-unlocked visitor takes, so on an already
   * unlocked page it never runs — which is exactly how the replay button
   * came to be dead. cannonOpen() starts the load itself; this is an
   * optimisation, not the load path.
   */
  function cannonBoot() {
    Sound.arm();
    buildEventMode();
    cannonLoad();
  }

  /**
   * IS SOMETHING OF THIS GAME'S ALREADY ON SCREEN?
   *
   * The one question every deferred callback in this file has to ask before
   * it appends a full-screen card. `arena` is the module-level modal the
   * medal game and the cannon share, `winning` is the beat between the last
   * kill and the reward panel, and CN is a live round that has not been torn
   * down yet; .av-ms-cnlvl and .av-ms-cannon-end are the picker and the
   * end-of-round card, which are modals in their own right.
   *
   * ⚠ IT ALSO HAS TO COVER THE TWO SURFACES THAT COME *BEFORE* AN ARENA.
   * `cannonOpening` is true while a round has been asked for and the geometry
   * pack is still downloading — with the "Loading the cannon…" card on screen
   * and no arena, no CN and no picker to be found — and .av-ms-cannon-htp is
   * the primer, which is a full-screen modal that the visitor is expected to
   * read. Both were invisible to this function, so the welcome card could
   * land on top of either: press the egg badge on a cold load, pick level 2,
   * and the celebration's afterConsent callback stacked a welcome card over
   * the loader that was already fetching pack 2. That is exactly the class of
   * defect the arena checks below were added for; these are the same fact for
   * the two beats either side of the arena.
   */
  function cannonBusyOnScreen() {
    if (arena || winning || CN || cannonOpening) return true;
    try {
      return !!(document.querySelector(".av-ms-cnlvl") ||
                document.querySelector(".av-ms-cannon-end") ||
                document.querySelector(".av-ms-cannon-wait") ||
                document.querySelector(".av-ms-cannon-htp") ||
                document.querySelector(".av-ms-cannon-hello"));
    } catch (e) { return false; }
  }

  /**
   * Replaces welcome() when GAME_ON. Same shape as welcome(): once per
   * milestone, after the cookie banner is handled, and never once the code
   * is already unlocked.
   */
  function cannonWelcome() {
    if (isUnlocked()) return;
    var wkey = "av_ms_welcome_" + milestone.n;
    try { if (localStorage.getItem(wkey) === "1") return; } catch (e) {}
    afterConsent(function () {
      if (isUnlocked()) return;
      if (cannonBusyOnScreen()) return;
      cannonReady(function (ok) {
        /* ⚠ RE-CHECK THE SCREEN, NOT ONLY THE STORAGE.
           This callback lands a variable number of seconds after the click
           that started it — two script downloads and the cookie banner sit
           between them — and the shopper is not obliged to sit still for it.
           Click the easter-egg badge on a cold load and by 2,913 ms the DOM
           held BOTH a live .av-ms-cannon-modal arena and this welcome card
           stacked on top of it, because the callback re-checked isUnlocked()
           and nothing else. `arena` is the state that says a round is up;
           winning and CN cover the two beats either side of it, and the
           picker and the end card are the other two surfaces that must not be
           buried. Nothing here is a shopper losing the welcome: it is written
           back to localStorage only on the branch that actually shows it, so
           a suppressed card is shown on the next load. */
        if (!ok) { buildGame(); welcome(); return; }
        if (cannonBusyOnScreen()) return;
        try { if (localStorage.getItem(wkey) === "1") return; localStorage.setItem(wkey, "1"); } catch (e) {}
        var modal = tier(el("div", "av-ms-modal av-ms-cannon-hello is-open"));
        var reward = LABEL ? 'an exclusive <b>' + esc(LABEL) + '</b> discount code' : 'an exclusive discount code';
        modal.innerHTML =
          '<div class="av-ms-modal__scrim"></div>' +
          '<div class="av-ms-welcome av-ms-cannon-hellocard">' +
            '<button class="av-ms-welcome__x av-ms-cannon-hellox" aria-label="Close">✕</button>' +
            '<div class="av-ms-cannon-hellomark" aria-hidden="true">' + cannonMarkSVG() + '</div>' +
            '<div class="av-ms-welcome__k">' + esc(FX.rank) + '-grade milestone reached</div>' +
            '<h2 class="av-ms-welcome__h">' + fmt(milestone.n) + ' templates — unlocked! 🎉</h2>' +
            '<p class="av-ms-welcome__p">AutoVectors just published its <b>' + fmt(milestone.n) + 'th</b> pre-cut PPF template. To celebrate: six real <b>Skoda Kodiaq</b> templates are about to fall into a heap. Aim the cannon, blow every one of them apart, and ' + reward + ' is yours.</p>' +
            '<div class="av-ms-welcome__timer"><div class="av-ms-welcome__badge">Limited-time celebration</div></div>' +
            '<button class="av-ms-btn av-ms-welcome__cta av-ms-cannon-hellocta" type="button">▶ Load the cannon</button>' +
            '<p class="av-ms-welcome__fine">Click or tap anywhere in the field to fire. Available only while the milestone celebration is live.</p>' +
          '</div>';
        document.body.appendChild(modal);
        if (!reduce) { var sw = tier(el("div", "av-ms-shock")); document.body.appendChild(sw); setTimeout(function () { sw.remove(); }, 900); }
        modal.querySelector(".av-ms-welcome__timer").appendChild(makeCountdown());
        var close = function () { modal.classList.add("is-closing"); setTimeout(function () { modal.remove(); }, 320); };
        modal.querySelector(".av-ms-cannon-hellox").addEventListener("click", close);
        modal.querySelector(".av-ms-modal__scrim").addEventListener("click", close);
        modal.querySelector(".av-ms-cannon-hellocta").addEventListener("click", function () {
          // cannonOpen(), not cannonArena(): this card only exists on the
          // ok===true branch, so cannonState is "ready" and cannonOpen()
          // opens synchronously — but there is now exactly ONE way in, and
          // that is the one that can also load on demand.
          close(); cannonOpen();
        });
      });
    });
  }

  /**
   * The shattered-template mark. Used on the welcome card and, when the
   * cannon won the round, in place of the medal on the reward panel: the
   * visitor never saw a medal, so showing one there would be a lie about
   * what they just did. Inline SVG, so it costs no request and cannot 404.
   */
  function cannonMarkSVG() {
    return '<svg class="av-ms-cannon-marksvg" viewBox="0 0 120 120" width="120" height="120" role="img" aria-label="A PPF template broken into shards">' +
      '<g class="av-ms-cannon-markg" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round">' +
      '<path class="av-ms-cannon-mp" d="M14 40 L44 16 L60 30 L38 52 Z"/>' +
      '<path class="av-ms-cannon-mp" d="M66 26 L96 14 L108 44 L78 46 Z"/>' +
      '<path class="av-ms-cannon-mp" d="M12 58 L34 62 L30 96 L8 84 Z"/>' +
      '<path class="av-ms-cannon-mp" d="M44 62 L74 56 L86 86 L52 100 Z"/>' +
      '<path class="av-ms-cannon-mp" d="M92 58 L112 60 L110 92 L90 88 Z"/>' +
      '</g></svg>';
  }

  /* ----------------------------------------------- medal surfaces ---- */

  /**
   * THE POPOVER BEHIND THE MILESTONE BAR, WHEN THE CANNON OWNS THE ROUND.
   *
   * refreshPop() branches to this instead of building the medal panel. Note
   * what is absent and why:
   *   · no [data-round]  — there is no medal round to start. This is the
   *     element the first build left in place and merely CSS-hid, which is
   *     how a second working route to the discount code survived.
   *   · no [data-a11y]   — the keyboard/low-motion toggle rebuilds the medal
   *     token grid. GAME_ON is false under prefers-reduced-motion anyway, so
   *     a reduced-motion visitor gets the accessible medal game, not this.
   *   · no progress bar and no "c / 40" line — a cannon round counts
   *     templates, never touches getCaught(), and would print a frozen 0.
   * The ✕, the countdown and the outside-click close are the shared parts of
   * the panel and stay exactly as they are.
   */
  function cannonPopHTML() {
    var reward = LABEL ? ' — <b>' + esc(LABEL) + '</b>' : '';
    /* ☰ THE RANGE, WHEN THERE IS SOMETHING IN IT.
       The ladder promises "unlocked forever", and until now the only door to
       it during a live celebration was the ☰ Levels button INSIDE a round —
       so a returning player who pressed Quit had to re-enter the milestone
       round just to reach a level they had already cleared. The row that pays
       is still the primary button and still opens the milestone round on one
       click; this is a secondary link, and it is not rendered at all for a
       first-time visitor (cannonMax() === 1), whose popover should say one
       thing. It is not a second route to the code: the picker's milestone row
       carries the capability whichever button opened the picker, and every
       other row opens a practice round. */
    var range = cannonMax() > 1
      ? '<button class="av-ms-btn av-ms-btn--ghost" type="button" data-cn-poprange style="margin-top:8px">☰ The range — replay a cleared level</button>'
      : '';
    return '<button class="av-ms-pop__x" type="button" aria-label="Close">✕</button>' +
      '<h4>We just hit ' + fmt(milestone.n) + ' templates! 🎉</h4>' +
      '<p>AutoVectors just published its <b>' + fmt(milestone.n) + 'th</b> pre-cut PPF template — a new library milestone. To celebrate: six real <b>Skoda Kodiaq</b> templates fall into a heap. Aim the cannon, blow every one of them apart, and the discount code is yours' + reward + '.</p>' +
      '<div class="av-ms-pop-timer"></div>' +
      '<button class="av-ms-btn" type="button" data-cannon>▶ Load the cannon</button>' +
      range +
      '<div class="av-ms-mini">Six templates · one cannon · click or tap in the field to fire</div>';
  }

  /**
   * OPEN A ROUND FROM A BUTTON.  ← THE DEMAND-DRIVEN LOAD LIVES HERE
   *
   * THE BUG THIS SHAPE FIXES
   *   cannonBoot() used to be the ONLY caller of cannonLoad(), and
   *   startEverything() only reaches cannonBoot() on the `else` branch —
   *   the one an already-unlocked visitor never takes ("you have won, you do
   *   not play again", inherited from the medal game). So on a page where the
   *   milestone was already unlocked:
   *       AVPhys       undefined
   *       AVGameParts  undefined
   *       <script> tags for them in the DOM: none
   *   …and the reward panel's "↻ Fire the cannon again" button was DEAD.
   *   It called cannonOpen(), cannonOpen() called cannonReady(), and
   *   cannonReady() pushed the callback onto cannonQueue — where nothing
   *   could ever resolve it, because no load had ever been started. No error,
   *   no console message, no arena. A button that does nothing at all.
   *
   * SO THE LOAD IS NOW DEMAND-DRIVEN, NOT BOOT-DRIVEN.
   *   Whoever wants a round starts the download if one has not started.
   *   cannonBoot() still pre-warms it for the visitor who is about to be
   *   offered the welcome card, because a warm bundle makes the first round
   *   instant — but nothing DEPENDS on cannonBoot() having run any more.
   *
   * IDEMPOTENCE — the requirement two fast clicks must satisfy
   *   · cannonLoad()  returns immediately unless cannonState === "idle", so
   *     it can never start two downloads.
   *   · cannonOpening is the UI latch: the second click inside the same wait
   *     is dropped, so there is one waiting card and one queued callback.
   *   · cannonArena() itself returns false when `arena` is already set, so
   *     even a race that got past both cannot stack two arenas.
   *
   * WHAT THE VISITOR SEES
   *   The bundles are ~37 kB + ~15 kB and normally already cached, so the
   *   wait is usually a single frame — cannonWait() is therefore deliberately
   *   quiet, but it EXISTS, because a dead-looking button is the defect being
   *   fixed and swapping it for a different silent failure fixes nothing.
   *   On a real failure the visitor is told, in the UI, and the popover comes
   *   back open on the medal panel instead of being left hidden behind
   *   nothing at all.
   *
   * Returns true when a round is now open, false otherwise (a wait that has
   * only just started also returns false — the arena is not open yet).
   */
  function cannonOpen() {
    /* IT TAKES NO ARGUMENT, ON PURPOSE. "Open the cannon" is what the welcome
       card, the popover and root.__avMsCannon.open() have always meant, and
       cannonDefaultLevel() answers it: level 1 during the celebration, the top
       of the player's ladder afterwards. Every existing caller therefore keeps
       working unchanged and gets the round it got before.
       Asking for a SPECIFIC level is a different verb — cannonOpenLevel() —
       so the two can never be confused at a call site.
       The load starts here, not at boot: scripts/prove-replay.mjs section 7
       asserts exactly this shape, because a boot-driven load is the defect
       that once left the replay button dead with no error of any kind. */
    cannonLoad();                             // no-op unless cannonState is "idle"
    /* THE CELEBRATION'S OWN DOOR IS THE ONE THAT CARRIES THE CAPABILITY.
       CN_STAKES is handed over here and nowhere else outside the picker's
       milestone row. It does not MAKE the round pay — cannonArena() still
       has to agree that this is the genuine, unwon, non-egg milestone — it
       only makes paying POSSIBLE, which is the half a call site can own. */
    return cannonPlay(cannonDefaultLevel(), false, CN_STAKES);
  }
  /**
   * Open a NAMED level. The picker's level rows, the clear card and the egg
   * use this — and none of them pass a grant, so a named level opens a
   * practice round unless the caller was the picker's own milestone row.
   */
  function cannonOpenLevel(L, grant, egg) {
    cannonLoad();
    return cannonPlay(L == null ? cannonDefaultLevel() : L, false, grant, egg);
  }

  /**
   * 🎚 OPEN THE RANGE — "let me choose", as opposed to "give me a round".
   *
   * 🚨 THE OWNER'S OWN FINDING, IN HIS WORDS: "pirma leveli pereinu islenda
   * milestone unlock kodas, ji isjungiu ir tada galiu zaisti vel, tai tipo
   * fire the cannon again ir iskarto imeta i antra leveli be perspejimo ir
   * pasirinkimo, ko pasigedau." He clears level 1, the reward panel appears
   * with the code, he closes it, presses "↻ Fire the cannon again" — and is
   * dropped straight into LEVEL 2, a different car, a longer pile, with no
   * warning and no choice. The button did what it said (cannonOpen() ->
   * cannonDefaultLevel(), which after the win is cannonMax() === 2) and what
   * it said was not what a person pressing it meant.
   *
   * SO "AGAIN" NOW MEANS "THE RANGE", NOT "THE NEXT RUNG". The picker is
   * where every unlocked level is named, scored and reachable — including
   * the one he just cleared — so the choice is made by the player and not by
   * a default buried three functions away.
   *
   * IT STARTS THE DOWNLOAD ITSELF, for the same reason cannonOpen() does: on
   * an already-unlocked page cannonBoot() never ran, so the bundles may not
   * be here at all. The picker is pure DOM and needs neither of them, so the
   * fetch runs underneath while the visitor reads the rows, and the row they
   * press finds a warm bundle. Nothing DEPENDS on it having finished:
   * cannonPlay() waits, shows the loader and fails loudly if it never lands.
   *
   * Returns whatever cannonPick() returns — true when the range is up.
   */
  function cannonRange() {
    cannonLoad();                             // no-op unless cannonState is "idle"
    return cannonPick();
  }

  /**
   * THE ONE ENTRY POINT FOR A ROUND AT A GIVEN LEVEL.
   *
   * Everything funnels through here: the welcome card's CTA, the popover
   * button, the reward panel's replay, the level picker, the clear card's
   * [Next] and [Replay], the easter-egg badge and root.__avMsCannon.open().
   *
   *   · L is CLAMPED to the ladder ceiling, so no route — not a crafted URL,
   *     not a stale card, not a hand-typed console call — can open a level
   *     that has not been earned.
   *   · Level 1 shows the primer once, ever (av_ms_cannon_htp). It is a
   *     three-line card, not the medal game's eleven-second animation: this
   *     game is "point at a thing, click it".
   *   · cannonPack() fetches level 2/3 geometry on demand and only then.
   *
   * Returns true when a round is open on return; false when it had to wait
   * for a download, when it showed the primer, or when it refused.
   */
  function cannonPlay(L, skipHowTo, grant, egg) {
    if (arena || winning || cannonOpening) return false;
    L = Math.max(1, Math.min(cannonMax(), L || 1));

    /* cannonBoot() armed the audio for a first-time visitor; an already
       unlocked one never went through it. Sound.arm() only registers the
       same two named listeners that unlock the AudioContext on the first
       gesture, so calling it again is a no-op — addEventListener dedupes an
       identical listener. Without this, a replay round is silent. */
    try { Sound.arm(); } catch (e) {}

    /* THE PRIMER IS FOR SOMEBODY WHO HAS NEVER PLAYED, and that is a
       narrower set than "has never seen this card".
         · A visitor who has already WON the code has destroyed six panels;
           putting a how-to-play card in front of their replay is insulting,
           and it is also a second thing to dismiss between them and the game.
         · The celebration's own welcome card already says "aim the cannon,
           click or tap in the field to fire", so during the event the primer
           would be the second card in a row saying the same thing.
       So it is skipped for anyone who is already unlocked. Its real job is the
       easter egg, years later, where there is no welcome card at all.

       IT IS ALSO SKIPPED FOR THE MILESTONE ROUND ITSELF. That round is the
       one where the discount code is at stake, and this file's standing rule
       is that there is nothing on screen between the shopper and the code.
       The predicate is deliberately cannonMayStake() — the same function
       cannonArena() asks — so if this round can pay, it opens on the first
       click, and the two answers can never drift apart. */
    var wouldPay = cannonMayStake(L, grant, egg);
    if (L === 1 && !skipHowTo && !cannonSeenHTP() && !isUnlocked() && !wouldPay) {
      return cannonPrimer(function () { cannonPlay(1, true, grant, egg); });
    }

    if (pop) pop.hidden = true;

    // Ready AND the geometry is already here: open synchronously, exactly as
    // the shipped build did, so nothing about the milestone round changes.
    if (cannonState === "ready" && cannonPackHave(L)) return cannonArena(L, grant, egg);
    if (cannonState === "failed") { cannonFailUI(); return false; }

    cannonOpening = true;                     // ← two fast clicks: drop the 2nd
    cannonWait(true);
    cannonLoad();                             // no-op unless cannonState is "idle"
    cannonPack(L, function (ok) {
      cannonOpening = false;
      cannonWait(false);
      if (!ok) { cannonFailUI(); return; }
      try { cannonArena(L, grant, egg); }
      catch (e) {
        // A throw mid-build must never leave the article covered.
        try {
          document.documentElement.classList.remove("av-ms-lowfx");
          document.documentElement.classList.remove("av-ms-cannon-on");
          var mm = document.querySelectorAll(".av-ms-modal");
          for (var i = 0; i < mm.length; i++) mm[i].remove();
        } catch (e2) {}
        arena = null;
      }
    });
    return false;
  }

  /**
   * HOW TO PLAY — three lines and a picture made of two divs.
   *
   * The medal game's primer is an eleven-second animated demonstration
   * because "draw a curve, loop a medal, click it" genuinely needs one. This
   * game is "point at the pile and click", so the card is short and it is
   * marked seen the first time it is shown. Under prefers-reduced-motion it
   * is skipped entirely — there is nothing here a still card teaches that
   * the first shot does not.
   */
  function cannonPrimer(cb) {
    if (reduce) { cb(); return false; }
    try { localStorage.setItem("av_ms_cannon_htp", "1"); } catch (e) {}
    var old = document.querySelector(".av-ms-cannon-htp");
    if (old) old.remove();
    var m = tier(el("div", "av-ms-modal av-ms-cannon-htp is-open"));
    m.innerHTML =
      '<div class="av-ms-modal__scrim av-ms-cannon-htpscrim"></div>' +
      '<div class="av-ms-cannon-htpcard">' +
        '<button class="av-ms-cannon-htpx" type="button" aria-label="Close">✕</button>' +
        '<b class="av-ms-cannon-htph">🎯 HOW TO PLAY</b>' +
        '<span class="av-ms-cannon-htps">A pile of real PPF templates. One cannon. Cut them all.</span>' +
        '<div class="av-ms-cannon-htpstage" aria-hidden="true">' +
          '<i class="av-ms-cannon-htpgun"></i>' +
          '<i class="av-ms-cannon-htpline"></i>' +
          '<i class="av-ms-cannon-htppanel av-ms-cannon-htppanel--a"></i>' +
          '<i class="av-ms-cannon-htppanel av-ms-cannon-htppanel--b"></i>' +
          '<i class="av-ms-cannon-htppanel av-ms-cannon-htppanel--c"></i>' +
          '<i class="av-ms-cannon-htpdot"></i>' +
        '</div>' +
        '<p class="av-ms-cannon-htpp"><i>1</i><span><em>Move the pointer</em> — the barrel tracks it and the cyan line shows the cut path.</span></p>' +
        '<p class="av-ms-cannon-htpp"><i>2</i><span><em>Click or tap</em> anywhere in the field to fire. One shot at a time.</span></p>' +
        '<p class="av-ms-cannon-htpp"><i>3</i><span>A template that takes a direct hit <em>shatters into its own cut shards</em>. Clear the sheet.</span></p>' +
        '<u class="av-ms-cannon-htpu">R rebuilds the pile · Escape leaves</u>' +
        '<button class="av-ms-btn av-ms-cannon-htpgo" type="button">▶ LOAD THE CANNON</button>' +
      '</div>';
    document.body.appendChild(m);
    /* THE ESCAPE LISTENER IS REMOVED BY WHICHEVER EXIT RUNS FIRST, not only
       by Escape itself. It used to unregister only inside its own handler, so
       closing this card with ✕, the scrim or the CTA left a live document
       keydown listener behind for the rest of the page load — one per card
       shown. None of them could do harm on their own (they act on a detached
       node) but they are listeners on the document that outlive their
       surface, and the picker and the end card had the same shape. */
    function go(start) {
      document.removeEventListener("keydown", esc);
      if (m.parentNode) m.remove();
      if (start) cb();
    }
    function esc(kv) { if (kv.key === "Escape") go(false); }
    m.querySelector(".av-ms-cannon-htpgo").addEventListener("click", function () { go(true); });
    m.querySelector(".av-ms-cannon-htpx").addEventListener("click", function () { go(false); });
    m.querySelector(".av-ms-cannon-htpscrim").addEventListener("click", function () { go(false); });
    document.addEventListener("keydown", esc);
    return false;
  }

  /**
   * THE WAITING CARD. Shown while the two bundles are in flight.
   *
   * It reuses the store's own .av-ms-modal shell so it inherits the same
   * fixed/inset-0/z-index tier every other cannon surface uses, and every
   * class on it contains the literal "av-ms" (theme trap 1). The message
   * element carries role="status" so a screen reader announces it; nothing
   * here is a canvas, so theme trap 2 cannot reach it.
   */
  function cannonWait(on) {
    if (!on) {
      if (cannonWaitEl) { try { cannonWaitEl.remove(); } catch (e) {} cannonWaitEl = null; }
      return;
    }
    if (cannonWaitEl) return;                 // idempotent: one card, ever
    var w = tier(el("div", "av-ms-modal av-ms-cannon-wait is-open"));
    w.innerHTML =
      '<div class="av-ms-modal__scrim av-ms-cannon-waitscrim"></div>' +
      '<div class="av-ms-cannon-waitcard">' +
        '<div class="av-ms-cannon-waitspin" aria-hidden="true"></div>' +
        '<div class="av-ms-cannon-waitmsg" role="status">Loading the cannon…</div>' +
      '</div>';
    cannonWaitEl = w;
    document.body.appendChild(w);
  }

  /**
   * THE LOAD GENUINELY FAILED — SAY SO, THEN FALL BACK.
   *
   * cannonSettle(false) has already called cannonDowngrade(), so GAME_ON is
   * clear and the bar and popover have been rebuilt as MEDAL surfaces. Two
   * things still have to happen, and neither of them used to:
   *   1. TELL THE VISITOR. They pressed a button and are owed an answer.
   *   2. PUT SOMETHING BACK ON SCREEN. Every caller hides the popover before
   *      opening a round, so failing quietly left an unlocked visitor staring
   *      at a page with their reward panel gone and no arena in its place.
   * cannonDowngrade() is called again (it is idempotent, and returns false
   * when there was nothing to downgrade) because this button also exists on a
   * page where the failure happened before any surface was rebuilt.
   */
  function cannonFailUI() {
    cannonDowngrade();
    cannonWait(false);
    try { if (pop) { pop.hidden = false; } } catch (e) {}
    try {
      toast('⚠ The cannon could not load — check your connection and try again.', 5000);
    } catch (e) {}
  }

  /**
   * GIVE THE MILESTONE BACK TO THE MEDAL GAME.
   *
   * GAME_ON is one variable with one meaning — "the cannon owns this
   * milestone" — and four surfaces read it: the bar, the popover,
   * startArena()'s refusal and buildGame()'s refusal. So the only honest way
   * to fall back when the physics bundle never arrives is to CLEAR it and
   * re-render the two surfaces that were built while it was still true.
   * The alternative the first build used — leave GAME_ON set and call
   * buildGame() anyway — puts a cannon bar and a cannon popover on top of a
   * running medal game, and a medal win then gets the cannon reward panel.
   *
   * Returns true if it actually downgraded, so the caller can tell.
   */
  function cannonDowngrade() {
    if (!GAME_ON) return false;
    GAME_ON = false;
    try {
      if (hud) { hud.remove(); hud = null; }
      if (pop) { pop.remove(); pop = null; }
      buildHUD(); buildPop();                 // …now with the medal content
    } catch (e) {}
    return true;
  }

  /* --------------------------------------------------------- arena ---- */

  /**
   * BUILD THE FULL-SCREEN ROUND.
   *
   * It reuses the store's own .av-ms-modal shell (position:fixed, inset:0,
   * z-index 2147482000) and sets the module-level `arena` to it, so the
   * cannon inherits the arena contract the rest of this file already keeps:
   * Escape closes it, win()'s finish() closes it, startArena() refuses to
   * stack on it, and closeArena() is the single teardown path.
   */
  function cannonArena(L, grant, egg) {
    if (arena || winning) return false;
    if (pop) pop.hidden = true;
    var P = window.AVPhys, PARTS = window.AVGameParts;
    if (!P || !PARTS) return false;

    L = Math.max(1, Math.min(CANNON_MAX_LEVEL, L || 1));
    var lv = CANNON_LEVELS[L] || CANNON_LEVELS[1];

    /* ------------------------------------------------------------------
       🥚 THE EGG MARK — A PROPERTY OF THIS ROUND, NOT OF THE PAGE LOAD.
       ------------------------------------------------------------------
       🚨 WHAT THIS REPLACES, AND WHY IT WAS A REAL COST TO A REAL SHOPPER.
       CANNON_EGG used to be latched true by cannonEggLaunch() and cleared by
       NOTHING. It was a property of the page load, and win() reads it — so a
       visitor on the knowledge-hub page during the celebration who pressed
       the cyan badge first could never win the discount code on that page
       load again. Not from the badge (correct), and not from the celebration
       bar three inches above it (wrong). They lost a real reward for touching
       a button that promised only a practice game.
       IT IS NOW SET FROM THE DISPATCH THAT OPENED THIS ROUND. `egg` is a
       parameter, threaded cannonPick -> cannonOpenLevel -> cannonPlay -> here,
       and cannonEggLaunch() is the only thing that ever makes it true. It is
       written HERE, before `stakes` is computed one line below, and cleared in
       cannonEnd() when the round is torn down — so:
         · an egg round is marked for the whole of its life, including the
           1200 ms award beat, and cannot pay; and
         · a genuine milestone round opened AFTERWARDS, on the same page load,
           is marked from its own dispatch and pays normally.
       A later stakes round cannot inherit the mark because nothing carries
       it: the only writers are this line and cannonEnd()'s clear, and this
       line reads a parameter, never the previous round's state.
       ------------------------------------------------------------------ */
    CANNON_EGG = !!egg;

    /* ------------------------------------------------------------------
       CN.stakes — WHETHER THE CODE IS ON THE TABLE FOR THIS ROUND.
       It is cannonMayStake() and nothing else, so the round's answer is the
       same answer the picker and the primer already gave. Anything that is
       not a positive yes is a no-stakes round: the default of every path
       that does not hand over CN_STAKES is false, by construction.
       cannonShatter() reads this AND the round's own egg mark to decide
       between win() and cannonClear(). See THE BARRIERS at the foot of this
       file.
       ------------------------------------------------------------------ */
    var stakes = cannonMayStake(L, grant, egg);

    var nPanels = lv.ids.length;
    var nTargets = lv.protect ? nPanels - 1 : nPanels;
    var modal = tier(el("div", "av-ms-modal av-ms-modal--arena av-ms-cannon-modal is-open"));
    modal.innerHTML =
      '<div class="av-ms-modal__scrim av-ms-cannon-scrim"></div>' +
      '<div class="av-ms-cannon-root av-ms-cannon-root--l' + L + '" id="av-ms-cannon-root">' +
        '<div class="av-ms-cannon-stage" id="av-ms-cannon-stage">' +
          // THEME TRAP 2 LIVES ON THIS ELEMENT — never add aria-hidden="true".
          // It is the game, not decoration, so it carries role + a label.
          '<canvas class="av-ms-cannon-canvas" id="av-ms-cannon-canvas" role="img" ' +
            'aria-label="Cannon mini-game, level ' + L + ': ' + esc(nPanels + ' real ' + lv.kit) +
            ' PPF templates fall into a pile. Click or tap to fire the cannon at them."></canvas>' +
          '<div class="av-ms-cannon-top">' +
            '<div class="av-ms-cannon-score av-ms-cannon-score--left">' +
              '<b class="av-ms-cannon-scoren" data-cn-left>' + nTargets + '</b>' +
              '<span class="av-ms-cannon-scorek">templates left</span>' +
              '<span class="av-ms-cannon-pips" data-cn-pips aria-hidden="true"></span></div>' +
            '<div class="av-ms-cannon-title">' +
              '<b class="av-ms-cannon-titleb">' + esc(cannonBanner(lv, nTargets)) + '</b>' +
              '<span class="av-ms-cannon-titles">' +
                (lv.protect ? 'The cyan panel is the customer\'s — cut it and the round is over'
                            : 'Click or tap in the field to fire · R for a new pile') +
              '</span>' +
              '<span class="av-ms-cannon-lvl">LEVEL ' + L + ' · ' + esc(lv.name) + '</span></div>' +
            '<div class="av-ms-cannon-score av-ms-cannon-score--right">' +
              '<b class="av-ms-cannon-scoren" data-cn-shots>0</b>' +
              '<span class="av-ms-cannon-scorek" data-cn-shotk>' +
                (stakes ? "shots fired" : "of " + lv.par + " shots") + '</span></div>' +
          '</div>' +
          '<div class="av-ms-cannon-bar"><i class="av-ms-cannon-bari" data-cn-bar style="width:0%"></i></div>' +
          '<div class="av-ms-cannon-diag" data-cn-diag hidden></div>' +
        '</div>' +
        '<div class="av-ms-cannon-foot">' +
          '<button class="av-ms-btn av-ms-btn--ghost av-ms-cannon-restart" type="button" data-cn-restart>↻ New pile</button>' +
          /* THE LEVEL BUTTON DURING A STAKES ROUND — THE OWNER'S "BET KADA".
             It used to be omitted outright, and the picker it opens used to
             render only a MILESTONE ROUND row, so for the length of a
             celebration a player who had already cleared levels 1-3 could not
             replay ANY of them. That is the opposite of what the ladder
             promises. It is now shown to anyone who has something to replay
             (cannonMax() > 1) and still omitted for a first-time visitor,
             whose stakes round should have nothing on screen but the round.
             It is not a second route to the code: the picker's milestone row
             is the only row that carries the CN_STAKES capability, and it
             carries it whichever button opened the picker. */
          (stakes && cannonMax() <= 1 ? "" :
            '<button class="av-ms-btn av-ms-btn--ghost av-ms-cannon-levels" type="button" data-cn-range>☰ Levels</button>') +
          '<button class="av-ms-btn av-ms-btn--ghost av-ms-cannon-quit" type="button" data-cn-quit>Quit</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    arena = modal;
    modal.setAttribute("data-tier", TIER);

    // The scrim already hides the page, so park the site's heavy WebGL. THIS
    // is the line that arms both theme traps — everything above had better
    // carry an av-ms class, and the canvas had better not be aria-hidden.
    document.documentElement.classList.add("av-ms-lowfx");
    // …and hide the medal HUD, whose "0 / 40" ring counts something this
    // round does not have. It comes back in cannonEnd().
    document.documentElement.classList.add("av-ms-cannon-on");

    var cv = modal.querySelector(".av-ms-cannon-canvas");
    cv.removeAttribute("aria-hidden");
    var obs = null;
    if (window.MutationObserver) {
      obs = new window.MutationObserver(function () {
        if (cv.hasAttribute("aria-hidden")) cv.removeAttribute("aria-hidden");
      });
      obs.observe(cv, { attributes: true, attributeFilter: ["aria-hidden"] });
    }

    // cfg IS THE BASE MERGED WITH THE LEVEL'S OVERRIDES, once, here — so no
    // code below this line has ever to ask which level it is running.
    var cfg = cannonCfg(), k;
    if (lv.cfg) for (k in lv.cfg) if (Object.prototype.hasOwnProperty.call(lv.cfg, k)) cfg[k] = lv.cfg[k];

    CN = {
      modal: modal, cv: cv, ctx: null,
      stage: modal.querySelector(".av-ms-cannon-stage"),
      elLeft: modal.querySelector("[data-cn-left]"),
      elShots: modal.querySelector("[data-cn-shots]"),
      elShotK: modal.querySelector("[data-cn-shotk]"),
      elPips: modal.querySelector("[data-cn-pips]"),
      elBar: modal.querySelector("[data-cn-bar]"),
      elDiag: modal.querySelector("[data-cn-diag]"),
      obs: obs,
      cfg: cfg,
      /* The level, and whether the code is on the table. Both are per-ROUND
         and both are read-only from here on. */
      /* CN.egg is the ROUND-LOCAL copy of the mark. cannonShatter()'s award
         branch reads THIS, not the module variable, so the decision cannot be
         changed by anything that happens to the page while the round runs. */
      L: L, level: lv, stakes: stakes, egg: !!egg, accent: lv.accent || "#7fe7d8",
      P: P, PARTS: PARTS, byId: {},
      world: null, meta: null, paths: null,
      t: 0, frame: 0, seq: 0, awake: 0,
      shot: null, shots: 0, hits: 0,
      templatesLeft: 0, templatesTotal: 0,
      // ONLY cannonShatter() increments this, and only it can win the round.
      templatesDestroyed: 0,
      // Evidence, not decoration — see cannonCull().
      templatesRecovered: 0, templatesLost: 0,
      won: false, round: 0, lastImpact: null, lastImpactSeen: -1,
      /* cannonDanger()'s banner restore and its latch — per ROUND, so
         cannonEnd() drops them with everything else and a warning cannot
         outlive the arena it was warning about. */
      subText: null, dangerUI: 0,
      /* Draw-side, published by cannonDraw() and read by peek(): 1 while the
         aim line under the pointer would cut the customer's panel. */
      aimDanger: 0,
      sparks: [], rand: null,
      /* RICOCHET MARKS — one per bounce, {x,y,nx,ny,t}. Drawn as a
         short-lived flare and a chevron on the face that was struck, and
         emptied by cannonSpawn() with every other draw-side pool. A
         bounce the player cannot see is a bug that flatters itself. */
      ricos: [],
      /* The pillar rings, in world mm, as plain point arrays. The SHOT
         reads these, not world.statics: the side walls are statics too and
         they must keep ending a shot with their own miss event. Empty on
         every level that has no pillars, which is what keeps level 1
         byte-identical. */
      pil: [],
      view: { scale: 0.18, wire: 0, halfY: 3000, W: 0, H: 0, dpr: 1, x0: 0, y0: 0 },
      pointer: { x: 0, y: 0, has: false },
      raf: 0, running: false, acc: 0, last: 0,
      ring: new Float64Array(60), rp: 0, rn: 0,
      /* what one fixed step costs on THIS machine, smoothed. It is the only
         input to the catch-up cap in cannonLoop(); 0 means "not measured
         yet", which reads as the old uncapped 4. */
      stepMs: 0,
      onKey: null, onResize: null, ro: null, onVis: null,
      tabVisible: !document.hidden,

      /* ---------------------------------------------------- the look ---
         Everything below this line is DRAWING STATE. Not one field of it is
         read by the solver, by cannonHit(), by the win test or by any proof.
         That separation is deliberate: the whole visual rebuild is paint on
         top of a simulation that is byte-identical to the one that shipped.
         ----------------------------------------------------------------- */
      /* the quality governor — see cannonGovern().
         fring is the WHOLE main-thread frame: sim + effects + draw. dring is
         the draw alone and exists only for the ?av_ms_tune=1 readout. The
         governor used to decide on the draw's p95 plus one frame's sim, which
         is not a quantity anything experiences; the frame is. */
      q: Math.min(2, CANNON_QSEEN + 1),
      dring: new Float64Array(60), dp: 0, dn: 0, over: 0,
      fring: new Float64Array(60), fp: 0, fn: 0,
      /* effects scale inversely with body count, PRE-EMPTIVELY (see §1.3):
         the impact burst and the physics burst are the same event, so the
         only frame that could go over budget is the one that already was. */
      fx: 1,
      /* the servo the barrel tracks the pointer with */
      gunBr: cfg.aimRestDeg * Math.PI / 180, gunBrV: 0,
      /* screen shake, added into the two draw origins and nowhere else */
      shk: 0, shkT: 0, shkX: 0, shkY: 0, shkDX: -1, shkDY: 0,
      /* the firing beat */
      fireT: -9, fireDX: 1, fireDY: 0, charge: 1,
      ledAmber: -9,
      /* effect pools, all cleared by cannonSpawn() */
      smoke: [], shreds: [], puffs: [], ghosts: [], scorch: [], dust: null,
      /* the cut-line ghost needs its OWN reference to the dead panel's path:
         cannonForgetDead() drops CN.paths[id] the moment CN.meta[id] goes,
         and cannonShatter() deletes the meta before the shards are pushed. */
      /* cached paint */
      bg: null, bgRaw: null, bgKey: "", blob: null, flash: null, sheen: {},
      barrelGrad: null, sweepGrad: null, matGrad: null,
      wallGrad: null, railGrad: null,
      /* the win beat */
      slowmo: 1, winT: -9, scrapT: -9, grazeT: -9, grazes: 0,
      warm: 0
    };
    for (var i = 0; i < PARTS.parts.length; i++) CN.byId[PARTS.parts[i].id] = PARTS.parts[i];
    CN.ctx = cv.getContext("2d", { alpha: false });
    /* ------------------------------------------------------------------
       WHAT THIS PARTICULAR 2D CONTEXT CAN ACTUALLY DO.
       Probed once, here, and obeyed by every layer in cannonDraw().

       This is NOT defensive padding. The renderer is now made of radial
       gradients, ellipses, bitmap blits, clipping and one string of text,
       and a context that is missing any one of them THROWS — which, inside
       cannonArena()'s try/catch, silently downgrades the visitor to the
       medal game. Three real contexts lack pieces of this list: very old
       Safari (no ctx.ellipse), any canvas-less test harness (the jsdom stub
       scripts/prove-replay.mjs and theme/verify-theme.mjs install has neither
       createRadialGradient nor drawImage), and printing contexts.

       Every one of these has a real fallback below, and the game looks
       slightly plainer rather than not existing.
       ------------------------------------------------------------------ */
    var cx0 = CN.ctx || {};
    CN.can = {
      /* `rad` is now a PROBE ONLY. The impact flash used to build a radial
         gradient on the live context every frame and asked this before it
         did; it is a blit of a baked bitmap now, so the question moved to
         where the baking happens — cannonBuildFlash() asks the OFFSCREEN
         context, which is a different context and can be poorer than this
         one (see the same note on cannonBuildBg). Kept because it is the one
         place this list is enumerated and a future radial belongs here. */
      rad: typeof cx0.createRadialGradient === "function",
      ell: typeof cx0.ellipse === "function",
      img: typeof cx0.drawImage === "function",
      clip: typeof cx0.clip === "function",
      text: typeof cx0.fillText === "function",
      lin: typeof cx0.createLinearGradient === "function"
    };

    try {
      cannonEngine();
      cannonSpawn();
    } catch (e) {
      try { console.error("[av-ms-cannon] could not start:", e); } catch (e2) {}
      cannonEnd(); if (arena) { arena.remove(); arena = null; }
      document.documentElement.classList.remove("av-ms-lowfx");
      // buildGame() refuses while GAME_ON is set, and it is right to: the
      // downgrade is what makes the medal game the honest one again.
      cannonDowngrade(); buildGame(); return false;   // never leave the shop covered
    }

    modal.querySelector("[data-cn-quit]").addEventListener("click", closeArena);
    modal.querySelector(".av-ms-cannon-scrim").addEventListener("click", closeArena);
    modal.querySelector("[data-cn-restart]").addEventListener("click", function () { cannonSpawn(); });
    if (!document.__avMsEsc) {
      document.__avMsEsc = 1;
      document.addEventListener("keydown", function (kv) { if (kv.key === "Escape" && arena) closeArena(); });
    }
    if (TUNE_UI && CN.elDiag) CN.elDiag.hidden = false;

    var rangeBtn = modal.querySelector("[data-cn-range]");
    if (rangeBtn) rangeBtn.addEventListener("click", function () { closeArena(); cannonRange(); });

    cv.addEventListener("pointermove", cannonAim);
    cv.addEventListener("pointerleave", function () { if (CN) CN.pointer.has = false; });
    cv.addEventListener("pointerdown", function (e) {
      e.preventDefault();
      cannonAim(e);
      if (!CN) return;
      var w = cannonWorldFrom(CN.pointer.x, CN.pointer.y);
      /* ⚠ SNAP THE SERVO TO THE SHOT BEFORE FIRING, AND DO NOT FIRE ALONG IT.
         On a phone `pointerdown` is the FIRST pointer event the canvas ever
         sees: cannonAim() sets the pointer and cannonFire() runs in the same
         handler, with the tracking spring still sitting at its 26 deg rest
         angle. Firing along CN.gunBr would send every tap to 26 degrees no
         matter where the player touched. So the shot is still computed from
         the pointer — gameplay is byte-identical to what ships today — and
         the drawn barrel is snapped onto it, so the gun is pointing along
         the shot from frame zero. The spring only ever governs idle
         tracking. */
      var sd = cannonAimDir(CN.cfg, w.x, w.y);
      CN.gunBr = sd.br; CN.gunBrV = 0;
      cannonFire(w.x, w.y);
    });

    CN.onResize = function () { cannonResize(); };
    // ResizeObserver hears a drawer opening or a font loading; the window
    // listener hears a devicePixelRatio change (a drag to a second monitor)
    // which no ResizeObserver ever reports. cannonResize() is idempotent.
    if (window.ResizeObserver) { CN.ro = new window.ResizeObserver(CN.onResize); CN.ro.observe(CN.stage); }
    window.addEventListener("resize", CN.onResize);
    CN.onKey = cannonKey;
    window.addEventListener("keydown", CN.onKey);
    CN.onVis = function () { if (!CN) return; CN.tabVisible = !document.hidden; cannonSync(); };
    document.addEventListener("visibilitychange", CN.onVis);

    // Seen means PLAYED, not "the card was rendered": a visitor who reaches
    // level 1 through the welcome card never sees the primer and must not be
    // shown it later from the picker either.
    if (L === 1) { try { localStorage.setItem("av_ms_cannon_htp", "1"); } catch (e) {} }

    Sound.fx("go");
    try { Sound.bed.start(true, 0); } catch (e) {}   // the room hums before anything happens
    cannonResize();
    cannonHUD();
    /* ------------------------------------------------------------------
       WARM THE CANVAS BEFORE THE PANELS DROP.
       MEASURED, and it was not known to this project before: the first pass
       over a freshly sized canvas rasterizes on Chrome's software path at
       roughly 4x the warm cost, and the penalty falls almost entirely on the
       new large-area layers — full stack 13.4 ms cold against 3.4 ms warm,
       with the body draw at 3.9 both times. That window lands exactly on the
       panel drop, i.e. on the first second anybody ever sees.
       Three throwaway full-stack draws is about 40 ms of wall clock, spent
       behind the loader card that was already on screen.
       cannonResize() warms again on every resize for the same reason: writing
       cv.width reallocates the backing store and puts the canvas straight
       back on the cold path, so an orientation change mid-round would
       otherwise silently re-enter the 4x regime.
       ------------------------------------------------------------------ */
    cannonWarm();
    cannonSync();
    return true;
  }

  /** Three throwaway full-stack frames. See the note in cannonArena(). */
  function cannonWarm() {
    if (!CN) return;
    for (var i = 0; i < 3; i++) cannonDraw();
    CN.warm = 1;
  }

  /** The banner over the field. Level 3 names the rule instead of the count. */
  function cannonBanner(lv, n) {
    if (lv.protect) return "Cut " + n + " panels — spare the cyan one";
    return "Destroy all " + n + " templates";
  }

  /* -------------------------------------------------------- engine ---- */

  /**
   * Push the game's knobs into the engine's live board.
   *
   * bounceMinSpeed is NOT a free choice: gravity re-adds g*h of approach
   * every substep — 54.5 mm/s at 3 substeps, 163.5 at 1 — and anything below
   * that threshold does not bounce, so a resting pile hums forever. It is
   * derived, never exposed, and AVPhys.bounceFloor() owns the formula.
   */
  function cannonEngine() {
    var c = CN.cfg, n = Math.max(1, Math.round(c.substeps));
    CN.P.setTune({
      substeps: n,
      restitution: c.restitution,
      wallRestitution: c.wallRestitution,
      friction: c.friction,
      floorFriction: c.floorFriction,
      contactDampTan: c.contactDampTan,
      bounceMinSpeed: CN.P.bounceFloor(n, c.gravityScale)
    });
  }

  /** Small deterministic PRNG so a pile can be repeated exactly. */
  function cannonRng(seed) {
    var s = seed >>> 0;
    return function () { s = (Math.imul(s, 1664525) + 1013904223) >>> 0; return s / 4294967296; };
  }
  /** Signed area of a flat [x0,y0,x1,y1,...] ring. */
  function cannonRingArea(flat) {
    var a = 0;
    for (var i = 0, n = flat.length; i < n; i += 2) {
      var j = (i + 2) % n;
      a += flat[i] * flat[j + 1] - flat[j] * flat[i + 1];
    }
    return Math.abs(a) / 2;
  }
  /** Where a segment p->q first crosses a closed ring, as t in [0,1], or -1. */
  function cannonSegRing(px, py, qx, qy, pts) {
    var rx = qx - px, ry = qy - py, best = -1;
    for (var i = 0, n = pts.length; i < n; i++) {
      var a = pts[i], b = pts[(i + 1) % n];
      var sx = b.x - a.x, sy = b.y - a.y;
      var den = rx * sy - ry * sx;
      if (den > -1e-12 && den < 1e-12) continue;
      var ex = a.x - px, ey = a.y - py;
      var t = (ex * sy - ey * sx) / den;
      if (t < 0 || t > 1) continue;
      var u = (ex * ry - ey * rx) / den;
      if (u < 0 || u > 1) continue;
      if (best < 0 || t < best) best = t;
    }
    return best;
  }

  /**
   * Make a body out of a bake-local ring placed at (theta, tx, ty).
   *
   * `__off` is the fixed translation from BAKE-local into BODY-local:
   * createBody re-centres a ring on its own centroid and the bake centres on
   * the bounding box, so the two frames differ by a constant — and because
   * both are de-rotated by the same theta the difference really is a pure
   * translation, forever, however the body later moves. Holes ride on it.
   */
  function cannonBody(id, flatRing, theta, tx, ty) {
    var cos = Math.cos(theta), sin = Math.sin(theta), pts = [];
    for (var i = 0; i < flatRing.length; i += 2) {
      pts.push({ x: flatRing[i] * cos - flatRing[i + 1] * sin + tx,
                 y: flatRing[i] * sin + flatRing[i + 1] * cos + ty });
    }
    return cannonFinish(id, pts, theta, tx, ty);
  }
  /** The same, for a ring ALREADY in world mm — which is what a shard is. */
  function cannonBodyWorld(id, flatWorld, theta, ax, ay) {
    var pts = [];
    for (var i = 0; i < flatWorld.length; i += 2) pts.push({ x: flatWorld[i], y: flatWorld[i + 1] });
    return cannonFinish(id, pts, theta, ax, ay);
  }
  function cannonFinish(id, pts, theta, tx, ty) {
    var b = CN.P.createBody({ id: id, points: pts, toleranceMm: 0, theta: theta, sheet: 0, confined: false });
    /* ONE HIDDEN CLASS FOR EVERY BODY IN THE GAME, and this is the whole
       reason the sentinel is -1 rather than undefined. The per-body
       restitution patch reads b.rest / b.wrest at every contact; if only the
       bouncy panels carried the fields, the solver's hot loop would see two
       object shapes and go megamorphic on its innermost read. Negative means
       "use TUNE"; cannonSpawn() overwrites these on the panels a level's
       `bouncy` list names. See engine/patches/60-body-restitution.mjs. */
    b.rest = -1; b.wrest = -1;
    var ic = Math.cos(-theta), is = Math.sin(-theta);
    var dx = tx - b.cx, dy = ty - b.cy;
    b.__off = { x: dx * ic - dy * is, y: dx * is + dy * ic };
    return b;
  }
  /** Bake-local -> body-local, using the offset cannonFinish stored. */
  function cannonLocalRing(flat, off) {
    var v = [];
    for (var i = 0; i < flat.length; i += 2) v.push({ x: flat[i] + off.x, y: flat[i + 1] + off.y });
    return v;
  }
  function cannonLocalRings(flats, off) {
    var out = [];
    for (var i = 0; i < flats.length; i++) out.push(cannonLocalRing(flats[i], off));
    return out;
  }

  /**
   * START A NEW DROP. Also the "New pile" button and the R key.
   *
   * The row is laid out from each part's extent AT THE ANGLE IT WILL SPAWN
   * AT, not from its upright width: the roof is 1252 mm wide upright but
   * 2568 at 55 degrees, and laying out on the upright figure spawns it
   * inside its neighbour. If the drawn angles do not fit, the whole row's
   * jitter is halved and redrawn — a big jitter degrades into a small one
   * instead of into an overlap.
   */
  function cannonSpawn(seed) {
    var c = CN.cfg, P = CN.P;
    if (seed !== undefined) c.seed = seed >>> 0;
    else c.seed = (Date.now() ^ (Math.random() * 0xffffffff)) >>> 0;
    CN.round = ++cannonRound;
    CN.rand = cannonRng(c.seed);
    CN.world = P.makeArena(c.floorX, c.gapMm);
    CN.meta = {}; CN.paths = Object.create(null);
    CN.t = 0; CN.frame = 0; CN.seq = 0; CN.awake = 0;
    CN.shot = null; CN.shots = 0; CN.hits = 0;
    CN.won = false; CN.lastImpact = null; CN.lastImpactSeen = -1;
    CN.templatesDestroyed = 0; CN.templatesRecovered = 0; CN.templatesLost = 0;
    CN.sparks.length = 0; CN.rn = 0; CN.rp = 0;
    CN.pil.length = 0;

    /* EVERY DRAW-SIDE POOL IS EMPTIED HERE, and this list is load-bearing.
       "New pile", the R key and a fresh level all come through this function.
       Without the reset a new round opens on the previous round's scorch
       marks and half-faded shreds, and CN.scorch in particular grows past its
       own cap across a session because the cap only trims on push. */
    CN.smoke.length = 0; CN.shreds.length = 0; CN.puffs.length = 0;
    CN.ghosts.length = 0; CN.scorch.length = 0; CN.ricos.length = 0;
    CN.shk = 0; CN.shkX = 0; CN.shkY = 0;
    CN.fireT = -9; CN.charge = 1; CN.ledAmber = -9;
    CN.slowmo = 1; CN.winT = -9; CN.scrapT = -9; CN.grazeT = -9; CN.grazes = 0; CN.fx = 1;
    CN.gunBr = c.aimRestDeg * Math.PI / 180; CN.gunBrV = 0;
    /* THE GOVERNOR'S WINDOWS RESET PER ROUND — one heavy pile must not carry
       its verdict into the next one — but the TIER starts one step above the
       worst this page load has needed, not at Q2. See CANNON_QSEEN. A phone
       that had to drop to Q1 in the milestone round opens level 2 at Q1, not
       at Q2, so it does not stutter its way back down to the same answer.
       CN.stepMs is deliberately NOT reset: what one fixed step costs is a
       fact about the machine, and it is what the catch-up cap reads. */
    CN.q = Math.min(2, CANNON_QSEEN + 1);
    CN.dn = 0; CN.dp = 0; CN.over = 0; CN.fn = 0; CN.fp = 0;

    P.resetStats();
    cannonEngine();

    /* PILLARS ARE STATICS, exactly like the side walls: they do not count
       against maxBodies and they are not in the O(n^2) body broadphase, so
       level 2's one new idea costs 0.04 ms and no budget. They stand 820 mm
       high — BELOW row 0's 900 mm spawn floor, deliberately, so no panel can
       ever be born inside one — and what they buy is an underside: panels
       tent and bridge across them instead of forming one flat heap, so a shot
       into the base of a bridged panel drops two more. */
    /* THE SAME FOUR CORNERS GO TO TWO PLACES, AND THAT IS THE FIX.
       They used to go to `world.statics` only, so the SOLVER knew about the
       pillars (panels tent across them correctly) and the SHOT did not:
       cannonHit() is an analytic ray against CN.world.bodies, and a static is
       not a body. The ball flew through the one thing on the field that looks
       solid. CN.pil is the ring the shot tests — see cannonSegPil(). */
    var pil = CN.level.pillars;
    if (pil) {
      for (var pz = 0; pz < pil.length; pz++) {
        var pp = pil[pz], phw = pp.w / 2;
        var pring = [
          { x: pp.x0, y: pp.y - phw },
          { x: pp.x0, y: pp.y + phw },
          { x: pp.x0 + pp.h, y: pp.y + phw },
          { x: pp.x0 + pp.h, y: pp.y - phw }
        ];
        CN.world.statics.push({ sheet: 0, outline: P.outlineOf(pring, 0) });
        CN.pil.push(pring);
      }
    }

    if (c.sideWalls) {
      var hy = c.fieldHalfY, tk = c.wallThickMm, ht = c.wallHeightMm;
      var sides = [[-1, -hy], [1, hy]];
      for (var w = 0; w < sides.length; w++) {
        var sgn = sides[w][0], y = sides[w][1];
        CN.world.statics.push({ sheet: 0, outline: P.outlineOf([
          { x: c.floorX - 200, y: y },
          { x: c.floorX - 200, y: y + sgn * tk },
          { x: c.floorX + ht,  y: y + sgn * tk },
          { x: c.floorX + ht,  y: y }
        ], 0) });
      }
    }

    var LAYOUT = CN.level.ids, ROWS = CN.level.rows, PROTECT = CN.level.protect || null;
    /* THE RUBBER PANELS. A level's `bouncy` list names the parts that get
       their own coefficient of restitution instead of the world's — see
       engine/patches/60-body-restitution.mjs and cfg.bouncyRest. */
    var BOUNCY = CN.level.bouncy || null;
    var order = 0;
    for (var r = 0; r < ROWS.length; r++) {
      var inRow = LAYOUT.filter(function (e) { return e.row === r; })
        .sort(function (a, b) { return a.slot - b.slot; });
      // shuffle which panel gets which slot, so the same three shapes do not
      // arrive in the same order every game (Fisher-Yates on the seeded rng)
      // — EXCEPT the protected panel, which is pinned. Buried at the bottom
      // of the pile it would be trivially safe and the level would be a coin
      // flip; pinned to the top row it is permanently in the line of fire,
      // which is the whole point of it.
      for (var sh = inRow.length - 1; sh > 0; sh--) {
        var sw = Math.floor(CN.rand() * (sh + 1));
        if (PROTECT && (inRow[sh].id === PROTECT || inRow[sw].id === PROTECT)) continue;
        var tmp = inRow[sh]; inRow[sh] = inRow[sw]; inRow[sw] = tmp;
      }
      var span = c.fieldHalfY * 2;
      var jit = ROWS[r].jitterDeg * Math.PI / 180;
      var thetas, extY, halfXs, total, m, part, j;
      for (var attempt = 0; attempt < 8; attempt++) {
        thetas = []; extY = []; halfXs = []; total = 0;
        for (m = 0; m < inRow.length; m++) {
          part = CN.byId[inRow[m].id];
          j = (CN.rand() * 2 - 1) * jit;
          thetas.push(CANNON_BASE_THETA + j);
          var cs = Math.abs(Math.cos(j)), sn = Math.abs(Math.sin(j));
          // at BASE_THETA a part's world-Y extent is its bake WIDTH and its
          // world-X extent its bake HEIGHT; a jitter of j mixes the two
          extY.push(part.widthMm * cs + part.heightMm * sn);
          halfXs.push((part.heightMm * cs + part.widthMm * sn) / 2);
          total += extY[m];
        }
        if (total < span * 0.92) break;
        jit *= 0.5;
      }
      var gap = (span - total) / (inRow.length + 1);
      var cursor = -c.fieldHalfY + gap;
      for (m = 0; m < inRow.length; m++) {
        part = CN.byId[inRow[m].id];
        var ty = cursor + extY[m] / 2;                    // world y = across
        var tx = ROWS[r].bottomX + halfXs[m];             // world x = height
        var b = cannonBody(part.id, part.ring, thetas[m], tx, ty);
        var bouncy = (BOUNCY && BOUNCY.indexOf(part.id) >= 0) ? 1 : 0;
        /* WRITTEN BEFORE THE FIRST step(), so the panel is rubber from the
           moment it is dropped and not from the moment it first lands. */
        if (bouncy) { b.rest = c.bouncyRest; b.wrest = c.bouncyWallRest; }
        P.shove(b, 0,
          (CN.rand() * 2 - 1) * (ROWS[r].driftMax || 0),
          (CN.rand() * 2 - 1) * (ROWS[r].spinMax || 0));
        CN.world.bodies.push(b);
        CN.meta[b.id] = {
          kind: "template", partId: part.id, name: part.name,
          outer: b.local, holes: cannonLocalRings(part.holes, b.__off),
          born: 0, life: Infinity, alpha: 1,
          /* draw-only, never read by the solver: the intro fade's start
             offset, the settle wobble's decay clock and the landing-puff
             latch. See cannonDraw()'s body loop. */
          intro: (order++) * 0.09, landed: 0, wob: 0, wobT: -9,
          protect: (PROTECT && part.id === PROTECT) ? 1 : 0,
          bouncy: bouncy
        };
        cursor += extY[m] + gap;
      }
    }
    /* templatesTotal COUNTS TARGETS, NOT BODIES. The protected panel is a
       template — it draws like one, it collides like one, a shard can bury it
       — but it is not something to destroy, so the HUD's "templates left"
       and the win test both leave it out. */
    CN.templatesTotal = CN.templatesLeft = CN.world.bodies.length - (PROTECT ? 1 : 0);
    cannonDust();
    cannonHUD(true);
  }

  /**
   * 24 MOTES OF AIR. Built once per pile, in normalised 0..1 coordinates so a
   * resize does not have to touch them, and drawn as one fillStyle write plus
   * 24 fillRects — measured at 0.00 ms for 34 of them, so 24 is free.
   * Under prefers-reduced-motion they hold still at 60% alpha: the room still
   * has air in it, nothing moves.
   */
  function cannonDust() {
    var d = [];
    for (var i = 0; i < 24; i++) {
      d.push({ x: Math.random(), y: Math.random(),
               s: 0.3 + Math.random(), a: 0.03 + Math.random() * 0.09 });
    }
    CN.dust = d;
  }

  /* ---------------------------------------------------------- aim ----- */

  function cannonWorldFrom(sxp, syp) {
    var v = CN.view;
    return { x: (v.y0 - syp) / v.scale, y: (sxp - v.x0) / v.scale - CN.cfg.fieldHalfY };
  }
  function cannonAim(e) {
    if (!CN) return;
    var r = CN.cv.getBoundingClientRect();
    var t = (e.touches && e.touches[0]) ? e.touches[0] : e;
    CN.pointer.x = t.clientX - r.left;
    CN.pointer.y = t.clientY - r.top;
    CN.pointer.has = true;
  }

  /* ------------------------------------------------------ the gun ----- */
  /**
   * WHERE THE GUN POINTS, WHERE ITS MUZZLE IS, AND WHAT VOLUME IT OCCUPIES —
   * DERIVED HERE AND NOWHERE ELSE.
   *
   * Five things used to work this out independently: the fire, the aim line,
   * the barrel sprite, the muzzle dot and the blast direction. They agreed
   * only because the muzzle was one point that never moved. It moves now —
   * the trunnion is fixed and the MUZZLE swings on the end of an 820 mm
   * barrel — so all five call these four functions instead.
   *
   * BEARING is the one angle in the cannon: from world +Y (screen right)
   * turning toward world -X (screen down), so 0 is a flat shot to the right
   * and +90 deg is straight down.
   */

  /** Wrap to (-pi, pi] without a branch. */
  function cannonWrapPi(a) { return Math.atan2(Math.sin(a), Math.cos(a)); }

  /**
   * The bearing to a world point, CLAMPED to the cone the arena needs. A
   * pointer behind the gun must not wrap round to the far limit, so the clamp
   * takes whichever end is the shorter way round the circle.
   */
  function cannonBearing(c, wx, wy) {
    var br = Math.atan2(-(wx - c.cannonX), wy - c.cannonY);
    if (!isFinite(br)) br = 0;
    var lo = -c.aimUpDeg * Math.PI / 180, hi = c.aimDownDeg * Math.PI / 180;
    if (br >= lo && br <= hi) return br;
    return Math.abs(cannonWrapPi(br - hi)) <= Math.abs(cannonWrapPi(br - lo)) ? hi : lo;
  }

  /**
   * The unit vector along the barrel. dy is never below cos(76 deg) = 0.242,
   * so a shot ALWAYS travels rightward into the field and can never leave
   * through the side it was fired from.
   */
  function cannonAimDir(c, wx, wy) {
    var br = cannonBearing(c, wx, wy);
    return { br: br, dx: -Math.sin(br), dy: Math.cos(br) };
  }

  /** The muzzle TIP for a direction — the shot's origin, not the pivot. */
  function cannonMuzzle(c, d) {
    return { x: c.cannonX + d.dx * c.barrelLenMm, y: c.cannonY + d.dy * c.barrelLenMm };
  }

  /**
   * The barrel profile in barrel-local mm: breech block, taper, tube, bell,
   * anticlockwise. One array, and it is what both the renderer and
   * scripts/prove-cannon-clear.mjs use.
   */
  function cannonBarrelProfile(c) {
    var L = c.barrelLenMm, R = c.barrelHalfMm, BH = c.bellHalfMm, BL = c.bellMm;
    var B = c.breechMm, BR = c.breechHalfMm, E = c.breechEndMm, T = c.taperMm;
    return [
      [-B, -BR], [E, -BR], [E + T, -R], [L - BL, -R], [L - BL, -BH], [L, -BH],
      [L, BH], [L - BL, BH], [L - BL, R], [E + T, R], [E, BR], [-B, BR]
    ];
  }

  /** That profile placed in the world at the aim direction `d`. */
  function cannonBarrelPoly(c, d) {
    var ux = d.dx, uy = d.dy, vx = -d.dy, vy = d.dx;
    var pr = cannonBarrelProfile(c), out = [];
    for (var i = 0; i < pr.length; i++) {
      out.push({ x: c.cannonX + ux * pr[i][0] + vx * pr[i][1],
                 y: c.cannonY + uy * pr[i][0] + vy * pr[i][1] });
    }
    return out;
  }

  /** World-y span the view must show: left pad, playfield, right pad. */
  function cannonViewSpan(c) {
    return c.viewPadLeftMm + c.fieldHalfY * 2 + c.viewPadRightMm;
  }

  /**
   * Fire at a world point. Ignored while a shot is already in flight.
   * THE SHOT LEAVES THE MUZZLE TIP, NOT THE TRUNNION — it used to leave the
   * pivot with the barrel drawn forward of it, so the ball was born inside
   * its own gun.
   */
  function cannonFire(aimX, aimY) {
    if (!CN || CN.shot || CN.won) return false;
    var c = CN.cfg;
    var d = cannonAimDir(c, aimX, aimY);
    var m = cannonMuzzle(c, d);

    /* ------------------------------------------------------------------
       LEVEL 3'S ONE RULE. THE CANNON NO LONGER REFUSES THE SHOT.

       WHAT WAS HERE UNTIL 2026-09-02, AND WHY IT WENT. A PRE-FLIGHT
       INTERLOCK ran this same line test and returned false: a shot that
       would cut the customer's panel simply did not leave the barrel. It was
       added for a real measurement — scratch/probe-l3.mjs, 40 seeds: a player
       aiming only at legal targets lost 39 of 40 rounds, because the
       protected panel was pinned to the row that spawns highest and was
       therefore the first thing the ball crossed. But the owner's verdict on
       the result is the one that counts: "i ji net neina saut" — you cannot
       even shoot at it. A rule you are physically prevented from breaking is
       not a rule, it is a wall. THE PLAYER MAY NOW FIRE ANYWHERE.

       WHAT REPLACES IT IS A WARNING, NOT A LOCK. The same predicate now runs
       every frame under the pointer (cannonAimLethal) and paints the aim line
       and the reticle RED with the words on them. Fire anyway and the round
       ends — cannonShatter() takes the scrap path and cannonScrap() raises
       the fail card that has always existed.

       AND THE ANSWER IS RECORDED ON THE SHOT ITSELF. `lethal` is the state of
       that warning at the instant of the click, and it is the ONLY thing that
       can scrap the round (see cannonShatter). That is the whole fairness
       contract in one flag:

            THE CUSTOMER'S PANEL CAN ONLY BE CUT BY A SHOT THE GAME
            PAINTED RED BEFORE THE PLAYER TOOK IT.

       It closes two holes the interlock's own comment admitted to. A pile
       that shifts during the 0.3 s of flight can still put the panel in front
       of the ball — that arrival is now a survivable graze, because nothing
       warned anybody. And a RICOCHET can never be lethal either: this test is
       the straight muzzle line, so a ball that arrives after a bounce carries
       lethal = 0 by construction. See the note in cannonShatter().

       THE BLAST STILL IS NOT THE MECHANISM. cannonShatter() has exactly one
       caller, cannonHit(), and cannonHit() only ever runs on the live
       projectile: shards cannot cut anything, then or now.
       ------------------------------------------------------------------ */
    var lethal = cannonAimLethal(aimX, aimY) ? 1 : 0;

    /* `pow` is the ball's remaining energy: 1 at the muzzle, multiplied by
       cfg.bounceLoss at every ricochet, and it scales the speed AND the
       blast. `leg` is how far it has flown since the last bounce and
       `kx/ky/pdx/pdy` are the kink — all four exist so the trail can draw a
       corner instead of a straight line through solid steel. */
    CN.shot = { x: m.x, y: m.y, dx: d.dx, dy: d.dy, flown: 0, born: CN.t,
                pow: 1, bounces: 0, leg: 0, kx: 0, ky: 0, pdx: 0, pdy: 0,
                lethal: lethal };
    CN.aimBearing = d.br;
    CN.shots++;

    /* THE FIRING BEAT. There is no wind-up: the shot leaves on the click and
       the CHARGE ARC is what precedes it — the arc has been full since the
       last shot resolved, and it empties now. That is the only thing on
       screen that explains why clicking again mid-flight does nothing. */
    CN.fireT = CN.t; CN.fireDX = d.dx; CN.fireDY = d.dy;
    CN.charge = 0;
    cannonShake(3.2, 0.075, -d.dx, -d.dy);
    if (!reduce) {
      var n = Math.round(3 * CN.fx);
      for (var i = 0; i < n; i++) {
        CN.smoke.push({ x: m.x + d.dx * 120, y: m.y + d.dy * 120,
                        r0: 150 + i * 60, t: 0, life: 0.9, rot: Math.random() * 6.2832,
                        vx: 140 * d.dx, vy: 320 + 140 * d.dy });
      }
    }
    Sound.fx("cutsnap"); Sound.fx("beat");
    cannonHUD();
    return true;
  }

  /**
   * WHICH TEMPLATE A SHOT FROM (px,py) ALONG (dx,dy) WOULD REACH FIRST.
   *
   * The same question cannonHit() answers one frame-step at a time, asked
   * once over the whole of c.shotRangeMm. It has to be the same ring test —
   * cannonSegRing — or the warning would paint a panel red that the ball
   * would actually have got past, which is worse than not warning at all.
   *
   * cannonLineFirstAt() also returns WHERE, because the danger reticle has to
   * be drawn on the exact millimetre the ball would arrive at; cannonLineFirst
   * keeps the body-only signature the proofs and web/test-drop.html mirror.
   */
  function cannonLineFirstAt(px, py, dx, dy) {
    var c = CN.cfg, qx = px + dx * c.shotRangeMm, qy = py + dy * c.shotRangeMm;
    var bs = CN.world.bodies, bestT = -1, best = null;
    for (var i = 0; i < bs.length; i++) {
      var b = bs[i], mt = CN.meta[b.id];
      if (!mt || mt.kind !== "template") continue;
      var t = cannonSegRing(px, py, qx, qy, b.world.points);
      if (t >= 0 && (bestT < 0 || t < bestT)) { bestT = t; best = b; }
    }
    return best ? { b: best, t: bestT,
                    x: px + (qx - px) * bestT, y: py + (qy - py) * bestT } : null;
  }
  function cannonLineFirst(px, py, dx, dy) {
    var h = cannonLineFirstAt(px, py, dx, dy);
    return h ? h.b : null;
  }

  /**
   * WOULD A SHOT AIMED HERE CUT THE CUSTOMER'S PANEL?
   *
   * THE ONE PREDICATE BEHIND BOTH HALVES OF THE RULE. cannonDraw() calls it
   * every frame with the pointer's world point to decide whether the aim line
   * is cyan or red; cannonFire() calls it with the SAME point at the click to
   * stamp `shot.lethal`. They cannot disagree — the warning the player saw and
   * the shot that ends the round are literally the same computation on the
   * same argument, which is the only way "you were warned" is a true sentence.
   *
   * It works from cannonAimDir/cannonMuzzle, NOT from the drawn barrel: the
   * servo in cannonDraw() lags the pointer by ~0.15 s while it swings, and a
   * warning derived from the lagging picture would be wrong for exactly as
   * long as the picture was. Returns the impact point so the reticle can sit
   * on it, or null when the shot is safe.
   */
  function cannonAimLethal(aimX, aimY) {
    if (!CN || !CN.level || !CN.level.protect) return null;
    var c = CN.cfg, d = cannonAimDir(c, aimX, aimY), m = cannonMuzzle(c, d);
    var h = cannonLineFirstAt(m.x, m.y, d.dx, d.dy);
    if (!h || !CN.meta[h.b.id] || !CN.meta[h.b.id].protect) return null;
    return { x: h.x, y: h.y, mx: m.x, my: m.y, dx: d.dx, dy: d.dy };
  }

  /**
   * THE DOM HALF OF THE WARNING, AND IT ONLY TOUCHES THE DOM ON A CHANGE.
   *
   * The canvas carries the danger (red line, red reticle, the words on it) and
   * this is the second channel for it: the subtitle over the arena goes red
   * and says the rule in a full sentence. Two channels because one of them is
   * 11 px of monospace over a moving pile and the other is not.
   *
   * `CN.dangerUI` latches the last state written, so a hovering pointer costs
   * zero DOM work per frame — the class and the textContent are only ever set
   * on the frame the aim crosses the line. `.is-danger` is the old `.is-held`
   * rule from the interlock, kept because red-and-a-nudge is exactly what it
   * always was; only the reason changed.
   */
  function cannonDanger(on) {
    on = on ? 1 : 0;
    if (!CN || CN.dangerUI === on) return;
    CN.dangerUI = on;
    var m = CN.modal;
    if (!m) return;
    var sub = m.querySelector(".av-ms-cannon-titles");
    if (sub && CN.subText == null) CN.subText = sub.textContent;
    if (on) {
      m.classList.add("is-danger");
      if (sub) sub.textContent = "⚠ DO NOT CUT — that line hits the customer's panel and ends the round";
      try { Sound.fx("zap3"); } catch (e) {}
      if (!reduce) buzz([12]);
    } else {
      m.classList.remove("is-danger");
      if (sub && CN.subText != null) sub.textContent = CN.subText;
    }
  }

  /**
   * SCREEN SHAKE — TWO SCALARS, NEVER A DOM TRANSFORM.
   *
   * cannonDraw() adds shkX/shkY into its two screen origins (the sx()/sy()
   * pair and the per-body setTransform), which is two adds and zero extra
   * draw calls. It is emphatically NOT arenaShake(): that helper looks for
   * `.av-ms-arena`, the cannon's root is `.av-ms-cannon-root`, and it is
   * therefore a silent no-op in here — as are eventPulse() and hitStop().
   * None of the three logs anything.
   */
  function cannonShake(px, decay, dx, dy) {
    if (reduce) return;
    if (px <= CN.shk * Math.exp(-(CN.t - CN.shkT) / (CN.shkD || 0.09))) return;
    CN.shk = px; CN.shkT = CN.t; CN.shkD = decay;
    var L = Math.hypot(dx, dy) || 1;
    CN.shkDX = dx / L; CN.shkDY = dy / L;
  }

  /**
   * WHERE A SEGMENT FIRST CROSSES A PILLAR, AND WHICH FACE IT CROSSED.
   *
   * cannonSegRing() answers the first half of that question and throws the
   * second half away — and the second half IS the ricochet. Same maths, one
   * more output: the unit normal of the edge that was hit, flipped to oppose
   * the incoming direction so the reflection is always OUT of the pillar
   * whichever way the ring happens to wind.
   *
   * IT RETURNS ON ITS FIRST LINE ON EVERY LEVEL WITH NO PILLARS. That is what
   * keeps level 1 exactly what it was and keeps this off the milestone
   * round's frame budget entirely.
   */
  function cannonSegPil(px, py, qx, qy) {
    var pil = CN.pil;
    if (!pil.length) return null;
    var rx = qx - px, ry = qy - py, bestT = -1, bnx = 0, bny = 0;
    for (var g = 0; g < pil.length; g++) {
      var pts = pil[g];
      for (var i = 0, n = pts.length; i < n; i++) {
        var a = pts[i], b = pts[(i + 1) % n];
        var ux = b.x - a.x, uy = b.y - a.y;
        var den = rx * uy - ry * ux;
        if (den > -1e-12 && den < 1e-12) continue;
        var ex = a.x - px, ey = a.y - py;
        var t = (ex * uy - ey * ux) / den;
        if (t < 0 || t > 1) continue;
        var u = (ex * ry - ey * rx) / den;
        if (u < 0 || u > 1) continue;
        if (bestT >= 0 && t >= bestT) continue;
        var L = Math.hypot(ux, uy) || 1;
        var nx = uy / L, ny = -ux / L;
        if (nx * rx + ny * ry > 0) { nx = -nx; ny = -ny; }
        bestT = t; bnx = nx; bny = ny;
      }
    }
    return bestT < 0 ? null : { t: bestT, nx: bnx, ny: bny, kind: 1 };
  }

  /**
   * EVERY SOLID THE SHOT CAN COME OFF, NEAREST FIRST.
   *
   * The pillars, plus — on a level that asks for it — THE ROOM: the mat
   * (the floor plane at c.floorX, normal pointing up) and the right-hand wall
   * (y = c.fieldHalfY, normal pointing back left). Those two are the reason
   * the ricochet is a mechanic and not a footnote: measured over 12 settled
   * piles and 401 bearings each, a pillar is the first thing on 0.7% of aim
   * lines and the room is on 34%. See cfg.bounceRoom.
   *
   * `kind` is 1 pillar, 2 mat, 3 wall — the three have different feedback and
   * the caller needs to know which one it just hit.
   *
   * The left wall and the top of the field are deliberately absent: the aim
   * cone guarantees dy >= cos(76 deg), so a shot always travels rightward and
   * can never reach either.
   */
  function cannonSegSolid(px, py, qx, qy) {
    var c = CN.cfg;
    var best = cannonSegPil(px, py, qx, qy);
    if (!c.bounceRoom) return best;
    var dx = qx - px, dy = qy - py;
    // the mat: crossing x = floorX going down, and only inside the field
    if (dx < 0) {
      var tf = (c.floorX - px) / dx;
      if (tf >= 0 && tf <= 1) {
        var fy = py + dy * tf;
        if (fy >= -c.fieldHalfY && fy <= c.fieldHalfY && (!best || tf < best.t)) {
          best = { t: tf, nx: 1, ny: 0, kind: 2 };
        }
      }
    }
    // the right-hand wall: crossing y = fieldHalfY, and only above the mat
    if (dy > 0) {
      var tw = (c.fieldHalfY - py) / dy;
      if (tw >= 0 && tw <= 1) {
        var wx = px + dx * tw;
        if (wx >= c.floorX && (!best || tw < best.t)) {
          best = { t: tw, nx: 0, ny: -1, kind: 3 };
        }
      }
    }
    return best;
  }

  /**
   * A STRIKE ON STEEL — the sparks, the flare and the shove that make a
   * bounce READABLE. `strong` is the difference between "it came off" and
   * "it stopped there": a spent ball throws twice the sparks and shakes twice
   * as hard, because that is the last thing the player will see of it.
   */
  function cannonPling(x, y, nx, ny, strong) {
    CN.ricos.push({ x: x, y: y, nx: nx, ny: ny, t: CN.t, big: strong ? 1 : 0 });
    if (CN.ricos.length > 6) CN.ricos.shift();
    cannonShake(strong ? 3.4 : 2.2, 0.06, nx, ny);
    if (!reduce) {
      var n = Math.round((strong ? 16 : 9) * CN.fx);
      for (var i = 0; i < n; i++) {
        // a cone about the OUTWARD normal: sparks come off the face, never
        // into the pillar the ball just failed to go through
        var a = (Math.random() - 0.5) * 2.1;
        var sp = 700 + Math.random() * 2600;
        var ca = Math.cos(a), sa = Math.sin(a);
        CN.sparks.push({
          x: x + nx * 40, y: y + ny * 40,
          vx: (nx * ca - ny * sa) * sp,
          vy: (nx * sa + ny * ca) * sp,
          life: 0.22 + Math.random() * 0.3, t: 0, hot: Math.random() < 0.8
        });
      }
    }
    Sound.fx(strong ? "crack" : "zap3");
    if (!reduce) buzz([strong ? 22 : 12]);
  }

  /**
   * REFLECT THE SHOT ABOUT A PILLAR FACE AND KEEP IT FLYING.
   *
   * WHAT A BOUNCE COSTS, AND WHY IT IS ONE SCALAR. `s.pow` scales BOTH the
   * ball's speed and the blast it will deliver, so the ball visibly slows as
   * it weakens — the only honest way to show energy on a screen with no
   * numbers on it. It still KILLS what it hits at full certainty: a hit is a
   * hit, and "your bank shot connected and bounced off" is the worst lesson
   * this game could teach. See cfg.bounceLoss.
   *
   * `s.kx/ky` and `s.pdx/pdy` are the kink: where the previous leg ended and
   * which way it was going. The trail draws them, so the turn is a shape on
   * screen and not something the player has to infer.
   */
  function cannonRicochet(s, hit, nx, ny) {
    var c = CN.cfg;
    var ix = s.x + (nx - s.x) * hit.t, iy = s.y + (ny - s.y) * hit.t;
    s.bounces = (s.bounces || 0) + 1;
    s.pow *= c.bounceLoss;
    /* THE ROOM KEEPS ITS OWN FEEDBACK. A shot into the mat still scorches it
       and a shot into the back wall still strikes it — those marks are how a
       player reads where a wide shot went, and a bounce must not delete them.
       It bounces AND leaves the mark; the mark is now a record of where the
       line turned rather than where it ended. */
    if (hit.kind === 2) cannonMiss(s, c.floorX, iy, 1);
    else if (hit.kind === 3) cannonMiss(s, ix, c.fieldHalfY, 0);
    if (s.bounces > c.maxBounces || s.pow < c.bounceMinPow) {
      /* SPENT. It ends here, and it ends as a strike rather than as a shot
         that simply stopped existing — that silence is the bug this whole
         change is about, and re-introducing it two bounces later would be
         the same bug with a longer fuse. */
      if (hit.kind === 1) cannonPling(ix, iy, hit.nx, hit.ny, 1);
      CN.ledAmber = CN.t;
      CN.shot = null;
      return;
    }
    s.pdx = s.dx; s.pdy = s.dy;
    var dot = s.dx * hit.nx + s.dy * hit.ny;
    s.dx -= 2 * dot * hit.nx; s.dy -= 2 * dot * hit.ny;
    var L = Math.hypot(s.dx, s.dy) || 1;
    s.dx /= L; s.dy /= L;
    s.kx = ix; s.ky = iy; s.leg = 0;
    /* RE-SEEDED ONE BALL RADIUS OFF THE FACE. Any less and the next step's
       segment can start inside the pillar and immediately re-hit the same
       edge, which reads as the ball sticking to the steel. */
    s.x = ix + hit.nx * c.bounceLiftMm;
    s.y = iy + hit.ny * c.bounceLiftMm;
    if (hit.kind === 1) cannonPling(ix, iy, hit.nx, hit.ny, 0);
    else {
      // the room gets the flare and the kink mark, but not a second set of
      // sparks — cannonMiss() has already thrown its own
      CN.ricos.push({ x: ix, y: iy, nx: hit.nx, ny: hit.ny, t: CN.t, big: 0 });
      if (CN.ricos.length > 6) CN.ricos.shift();
    }
  }

  /**
   * ADVANCE THE PROJECTILE AND RESOLVE THE FIRST RING IT CROSSES.
   *
   * THE HIT IS ANALYTIC. The cannonball is not a physics body: making it one
   * was measured and it moved the pile by 0 to 46 mm before the hit even
   * registered, which reads as the shot pushing rather than striking. Here
   * it is a segment per step tested against every TEMPLATE's live
   * world.points, nearest crossing wins.
   */
  function cannonHit(dt) {
    var s = CN.shot;
    if (!s) return;
    var c = CN.cfg;
    // THE BALL SLOWS AS IT WEAKENS. Same scalar as the blast, so what the
    // player SEES and what the shot DOES cannot drift apart.
    var step = c.cannonPower * s.pow * dt;
    var nx = s.x + s.dx * step, ny = s.y + s.dy * step;
    var bestT = -1, bestB = null, bs = CN.world.bodies;
    for (var i = 0; i < bs.length; i++) {
      var b = bs[i], m = CN.meta[b.id];
      if (!m || m.kind !== "template") continue;
      var bx = b.world.box;                          // cheap reject on the box
      if (Math.max(s.x, nx) < bx.minX - 1 || Math.min(s.x, nx) > bx.maxX + 1 ||
          Math.max(s.y, ny) < bx.minY - 1 || Math.min(s.y, ny) > bx.maxY + 1) continue;
      var t = cannonSegRing(s.x, s.y, nx, ny, b.world.points);
      if (t < 0 && CN.P.pointInPolygon({ x: nx, y: ny }, b.world.points)) t = 1;
      if (t >= 0 && (bestT < 0 || t < bestT)) { bestT = t; bestB = b; }
    }
    /* THE PILLAR IS TESTED AGAINST THE SAME SEGMENT AND THE NEARER OF THE
       TWO WINS. A panel standing in front of a pillar is still hit; a pillar
       standing in front of a panel now deflects instead of being scenery. */
    var pilHit = cannonSegSolid(s.x, s.y, nx, ny);
    if (pilHit && (bestT < 0 || pilHit.t < bestT)) {
      cannonRicochet(s, pilHit, nx, ny);
      return;
    }

    if (bestB) {
      var ix = s.x + (nx - s.x) * bestT, iy = s.y + (ny - s.y) * bestT;
      CN.hits++;
      CN.lastImpact = { x: ix, y: iy, t: CN.t, dx: s.dx, dy: s.dy };
      CN.shot = null;
      cannonShatter(bestB, ix, iy, s.dx, s.dy, s.pow, s.lethal);
      return;
    }
    s.x = nx; s.y = ny; s.flown += step; s.leg += step;

    /* ------------------------------------------------------------------
       A MISS IS ALSO AN EVENT. All three of these branches used to null
       CN.shot in silence, so a shot that went wide simply stopped existing
       and the player was told nothing at all about where it went.
       ------------------------------------------------------------------ */
    /* BOTH SURFACE STRIKES ARE GATED ON BEING INSIDE THE ARENA. A steep shot
       (the cone allows 76 degrees down) crosses the floor plane while it is
       still left of the left wall, out in the bare ground the gun stands on —
       there is no mat out there to scorch, so that one is an ordinary
       out-of-range miss and falls through to the LED below. */
    if (s.x < c.floorX && s.y >= -c.fieldHalfY && s.y <= c.fieldHalfY) {
      cannonMiss(s, c.floorX, s.y, 1);                     // into the mat
      CN.shot = null; return;
    }
    if (s.y > c.fieldHalfY && s.x >= c.floorX) {
      cannonMiss(s, s.x, c.fieldHalfY, 0);                 // into the right wall
      CN.shot = null; return;
    }
    if (s.flown > c.shotRangeMm || s.x < c.floorX - 400 || s.x > 40000 ||
        Math.abs(s.y) > c.fieldHalfY + 4000) {
      // Off the top, or out of range: no impact to draw, so the trunnion LED
      // flicks amber for 400 ms and that is the whole feedback.
      CN.ledAmber = CN.t;
      CN.shot = null;
    }
  }

  /**
   * A SHOT THAT HIT THE ROOM INSTEAD OF A PANEL.
   * `floor` picks which surface: 1 = the mat (the decal lies flat along the
   * floor line), 0 = the right wall (the same set, stood on its edge).
   */
  function cannonMiss(s, x, y, floor) {
    CN.lastImpact = null;
    cannonShake(2.0, 0.06, -s.dx, -s.dy);
    if (!reduce) {
      var i, n = Math.round(10 * CN.fx);
      for (i = 0; i < n; i++) {
        // near-zero velocity along the surface normal, so they SLIDE
        var sp = 500 + Math.random() * 2400;
        var a = (Math.random() - 0.5) * 1.3;
        CN.sparks.push({
          x: x, y: y,
          vx: floor ? Math.abs(Math.sin(a)) * sp * 0.35 : -Math.sin(a) * sp,
          vy: floor ? -Math.cos(a) * sp * (s.dy < 0 ? -1 : 1) : -Math.abs(Math.cos(a)) * sp,
          life: 0.3 + Math.random() * 0.35, t: 0, hot: Math.random() < 0.73
        });
      }
      CN.puffs.push({ x: x, y: y, t: 0, life: 0.7, r0: 240, r1: 900, floor: floor });
      /* THE SCORCH DECAL. Capped at 8, oldest dropped — and cannonSpawn()
         empties the array, so a fresh pile never opens on the last round's
         misses. */
      CN.scorch.push({ x: x, y: y, floor: floor, born: CN.t });
      if (CN.scorch.length > 8) CN.scorch.shift();
    }
    Sound.fx(floor ? "crack" : "zap3");
  }

  /**
   * THE BALL REACHED THE CUSTOMER'S PANEL WITHOUT A WARNING IN FRONT OF IT.
   *
   * A near miss with a bang, and deliberately NOT a scrap: see the block in
   * cannonShatter() for the two ways a shot gets here (a ricochet, or a pile
   * that slid under a shot in flight) and why neither may end the round. The
   * shot is spent, the panel is untouched, the counters do not move.
   *
   * IT STILL HAS TO READ AS A NEAR MISS, or the player learns nothing from it.
   * So: sparks and a knock off the panel's own face, a hard shake, and the
   * subtitle says what just did not happen. `CN.grazeT` is what cannonDraw()
   * reads to flash the panel's outline amber for 0.6 s — amber, not the red
   * that means the round is over, because it is not.
   */
  function cannonGraze(ix, iy, sdx, sdy) {
    CN.shot = null;
    CN.grazeT = CN.t;
    CN.grazes = (CN.grazes || 0) + 1;
    CN.lastImpact = null;
    cannonShake(3.0, 0.08, -sdx, -sdy);
    if (!reduce) { cannonSparks(ix, iy, -sdx, -sdy); buzz([14, 40, 14]); }
    try { Sound.fx("zap3"); } catch (e) {}
    var m = CN.modal, sub = m && m.querySelector(".av-ms-cannon-titles");
    if (sub) {
      if (CN.subText == null) CN.subText = sub.textContent;
      sub.textContent = "Off the customer's panel — no warning, no scrap. It held.";
      var rid = cannonRound;
      setTimeout(function () {
        if (!CN || CN.round !== rid || CN.dangerUI) return;
        if (CN.subText != null) sub.textContent = CN.subText;
      }, 1600);
    }
  }

  /* ------------------------------------------------------- shatter ---- */

  /**
   * REPLACE A TEMPLATE WITH ITS BAKED SHARDS AND THROW THEM OUTWARD.
   *
   * THIS IS THE ONLY PLACE A TEMPLATE CAN BE DESTROYED, and therefore the
   * only place the round can be won. cannonCull() may not destroy one.
   *
   * Order matters: the parent must leave world.bodies BEFORE the shards
   * arrive, or the shards are born inside a body still occupying the same
   * material and the retreat spends the frame unpicking it.
   */
  function cannonShatter(parent, ix, iy, sdx, sdy, pow, lethal) {
    var c = CN.cfg, P = CN.P;
    var pm = CN.meta[parent.id];

    /* ------------------------------------------------------------------
       THE PROTECTED PANEL (level 3), CHECKED BEFORE ANY COUNTER MOVES.
       ONLY A DIRECT BALL IMPACT CAN REACH IT AT ALL, and that is structural
       rather than a rule: this function has exactly one caller, cannonHit(),
       and cannonHit() only ever runs on the live projectile. Shards may push
       the customer's panel, bury it and knock it over all round long; nothing
       but a shot can touch it.

       AND OF THOSE SHOTS, ONLY A WARNED ONE SCRAPS. `lethal` is shot.lethal,
       stamped in cannonFire() by the same cannonAimLethal() call that painted
       the aim line red under the player's pointer. If it is 0 the ball is
       arriving somewhere the game never said it would, and the panel survives
       — see cannonGraze(). Two ways that happens, and both of them would
       otherwise be the trap the owner asked us not to build:

         1  THE RICOCHET. cannonAimLethal() tests the straight muzzle line, so
            a ball that has bounced carries lethal = 0 always. A bank shot
            therefore CANNOT kill the run. It has to be that way round: the
            preview cannot honestly predict where a bounced ball ends up on a
            pile that is still moving, so a bounce that scrapped the round
            would be a death with no warning in front of it. (On level 3 as
            shipped this is belt and braces — it has no pillars and
            cfg.bounceRoom is 0, so nothing there ricochets at all. It is
            written down because the next protected level might.)
         2  THE PILE MOVED. The ball takes ~0.3 s to cross the arena; a pile
            still settling under a shot in flight can slide the customer's
            panel into a line that was clear at the click. That used to be a
            live loss the old interlock's own comment admitted to. Now it is a
            graze.
       ------------------------------------------------------------------ */
    if (pm && pm.protect && !lethal) { cannonGraze(ix, iy, sdx, sdy); return; }
    if (pm && pm.protect) {
      /* ⚠ THE TEARDOWN IS DEFERRED, AND IT HAS TO BE.
         The first build called cannonScrap() straight from here — and this
         function is called from cannonHit(), which runs INSIDE cannonLoop()'s
         fixed-step while loop, between settleAssist() and step(). cannonScrap
         calls closeArena() -> cannonEnd() -> CN = null, so the very next line
         of the loop dereferenced a null CN and the round died with
         "Cannot read properties of null (reading 'P')" the instant a level-3
         player cut the customer's panel. Nothing else in the game tears the
         arena down synchronously, which is exactly why the loop never had to
         defend against it.
         So the scrap now behaves like the win: a beat on screen first, the
         surface afterwards, both behind a captured round id. */
      if (CN.won) return;
      CN.won = true;                       // no further shatter, and no win
      CN.scrapT = CN.t;
      cannonShake(4.2, 0.10, -sdx, -sdy);
      cannonSparks(ix, iy, sdx, sdy);
      try { Sound.fx("crack"); } catch (e) {}
      if (!reduce) buzz([25, 60, 25]);
      var rid2 = cannonRound, LV2 = CN.L, nm2 = pm.name;
      setTimeout(function () { cannonScrap(rid2, LV2, nm2); }, 700);
      return;
    }

    var part = CN.byId[pm.partId];
    var idx = CN.world.bodies.indexOf(parent);
    if (idx >= 0) CN.world.bodies.splice(idx, 1);

    /* THE CUT-LINE GHOST NEEDS ITS OWN REFERENCE TO THE PATH, TAKEN HERE.
       cannonForgetDead() drops CN.paths[id] the frame after CN.meta[id] goes,
       and the two lines below delete that meta — so by the time the ghost
       wants to draw, the cache entry it was going to borrow is gone. Nothing
       would log; the single most on-brand moment in the whole game would
       simply never appear. */
    var gp = CN.paths[parent.id];
    if (gp) CN.ghosts.push({ path: gp, cx: parent.cx, cy: parent.cy,
                             theta: parent.theta, t0: CN.t });
    delete CN.meta[parent.id];
    CN.templatesLeft--;
    CN.templatesDestroyed++;

    // the N largest shards; below 9 the panel genuinely loses material
    var order = part.frags.map(function (f, n) { return { n: n, a: cannonRingArea(f) }; })
      .sort(function (a, b) { return b.a - a.a; })
      .slice(0, Math.max(1, Math.min(part.frags.length, Math.round(c.fragCount))));

    var cos = Math.cos(parent.theta), sin = Math.sin(parent.theta);
    /* THE BLAST CARRIES THE BALL'S REMAINING ENERGY. A clean shot is
       pow 1; a one-bank shot is 0.78 and a two-bank 0.61, so a trick shot
       clears its panel without blowing the pile apart — which is exactly
       the trade a trick shot should make. `pow` is undefined for every
       caller that is not the projectile, and there is only one. */
    var off = parent.__off, power = c.cannonPower * (pow === undefined ? 1 : pow);
    // where the BAKE-LOCAL ORIGIN of this part currently sits in the world
    var anchorX = off.x * cos - off.y * sin + parent.cx;
    var anchorY = off.x * sin + off.y * cos + parent.cy;

    for (var k = 0; k < order.length; k++) {
      var flat = part.frags[order[k].n];
      var world = new Array(flat.length);
      for (var i = 0; i < flat.length; i += 2) {
        var lx = flat[i] + off.x, ly = flat[i + 1] + off.y;
        world[i] = lx * cos - ly * sin + parent.cx;
        world[i + 1] = lx * sin + ly * cos + parent.cy;
      }
      var id = part.id + "#f" + order[k].n + "#" + (CN.seq++);
      var b;
      // the shard's points are ALREADY world here, so this must not rotate
      // them again; the anchor is where the bake-local origin now sits
      try { b = cannonBodyWorld(id, world, parent.theta, anchorX, anchorY); }
      catch (e) { continue; }

      var rx = b.cx - ix, ry = b.cy - iy, d = Math.hypot(rx, ry);
      if (d < 1e-6) { rx = -sdx; ry = -sdy; d = 1; }
      var nx = rx / d, ny = ry / d;
      var falloff = 380 / (380 + d);                  // near the hit = hit hardest
      var sp = power * c.blastScale * (0.55 + 0.60 * falloff);
      P.shove(b,
        // MATH.MAX(0, sdx), NOT sdx: the forward transfer may push a shard
        // sideways and upward but never DOWN. The gun fires down into the
        // heap now, so sdx is negative on every shot and the raw term was
        // subtracting about 1,300 mm/s of world +X from every shard, fighting
        // blastUpMm — which exists only because a shard born inside a pile
        // has neighbours on three sides and the speculative clamp deletes any
        // approach into them within one substep.
        // ⚠ THE NUMBER THAT USED TO BE HERE ("raw 58%, clipped 63%") IS WRONG
        // in value AND in direction. Re-measured 2026-09-02 with the clip
        // patched out, 60 seeds, 540 shards: clipped 53.1%, raw 54.3%. The
        // clip buys that metric nothing. It is kept for the directional reason
        // above — a shard is never pushed into the floor — and the table at
        // blastScale is now the one place this quantity is printed.
        nx * sp + Math.max(0, sdx) * power * c.blastForward + c.blastUpMm + (CN.rand() - 0.5) * sp * 0.25,
        ny * sp + sdy * power * c.blastForward + (CN.rand() - 0.5) * sp * 0.25,
        (CN.rand() * 2 - 1) * 7 + (nx * sdy - ny * sdx) * 5);

      CN.world.bodies.push(b);
      // THE SHARD KEEPS ITS SHARE OF THE PANEL'S CUTOUTS. The bake clips
      // every hole against every shard and emits fragHoles[n]; without this
      // a door's handle recess heals over the instant the door breaks.
      var fh = (part.fragHoles && part.fragHoles[order[k].n]) || [];
      CN.meta[id] = {
        kind: "frag", partId: part.id, name: part.name,
        outer: b.local, holes: cannonLocalRings(fh, b.__off),
        born: CN.t, life: c.fragLifeS, alpha: 1
      };
    }

    // A SLEEPING BODY THROWS AWAY A WRITTEN VELOCITY, and the pile around a
    // hit is usually asleep. Waking the neighbourhood is what makes a hit
    // shift the pile instead of stopping at the shards.
    var R = c.wakeRadiusMm;
    for (var j = 0; j < CN.world.bodies.length; j++) {
      var nb = CN.world.bodies[j];
      if (Math.hypot(nb.cx - ix, nb.cy - iy) < R) { nb.asleep = false; nb.sleepT = 0; }
    }

    /* FILM SHREDS — the strips of offcut that come off a real cut, in the
       dead panel's OWN colour pair so the eye can still tell which template
       just went. The four corners are emitted straight from a precomputed
       cos/sin pair: a save/translate/rotate/restore per strip measured no
       cheaper and burns ten context saves a hit. */
    if (!reduce) {
      var col = CANNON_COLORS[part.id] || CANNON_FALLBACK;
      var ns = Math.round(10 * CN.fx);
      for (var q = 0; q < ns; q++) {
        var ang = Math.random() * 6.2832, spd = 900 + Math.random() * 1700;
        CN.shreds.push({
          x: ix + Math.cos(ang) * 120, y: iy + Math.sin(ang) * 120,
          vx: Math.cos(ang) * spd + 900, vy: Math.sin(ang) * spd,
          rot: Math.random() * 6.2832, spin: (Math.random() * 2 - 1) * 9,
          t: 0, life: 0.5, col: q % 3 ? col[0] : col[1]
        });
      }
    }
    cannonShake(5.0, 0.09, -sdx, -sdy);
    Sound.fx("bosshit");
    setTimeout(function () { try { Sound.fx("crack"); } catch (e) {} }, 40);
    if (!reduce) buzz(24);
    cannonHUD();

    /* ------------------------------------------------------------------
       THE WIN. Straight to win(), NOT through gainCatch().
       gainCatch clamps every non-boss award to GOAL-3 and its whole body is
       wrapped in if(!isUnlocked()), so routing six templates through it
       would freeze the visitor at 37/40 and never unlock anything. win()
       runs setUnlocked(), updateHUD(), Sound.win(), bloom(), and then
       finish() — which calls closeArena() (and so cannonEnd()) and reveal().
       ------------------------------------------------------------------ */
    if (CN.templatesDestroyed >= CN.templatesTotal && !CN.won) {
      CN.won = true;
      CN.winT = CN.t;
      CN.slowmo = reduce ? 1 : 0.30;              // 600 ms of visible resolve
      var banner = CN.modal && CN.modal.querySelector(".av-ms-cannon-titleb");
      if (banner) banner.textContent = "Every template cut";
      try { Sound.win(); } catch (e) {}
      try { bloom(); } catch (e) {}
      if (!reduce) setTimeout(function () { try { confetti(2.0); } catch (e) {} }, 500);
      // 0.94 s: the compositor-only crossfade, so the arena is already
      // dissolving when the card arrives instead of being cut away.
      var rid0 = cannonRound;
      setTimeout(function () {
        if (CN && CN.round === rid0 && CN.modal) {
          var rt = CN.modal.querySelector(".av-ms-cannon-root");
          if (rt) rt.classList.add("av-ms-cannon-root--out");
        }
      }, 940);
      /* Let the last shards fly, and the plotter sweep run, before anything
         lands on top of them. The round id is captured so that pressing "New
         pile" inside this window cannot hand out the code for a pile that no
         longer exists — while quitting after the last hit still pays, because
         it was earned. 1200 ms, not 620: the win beat is 1.9x wider now, and
         cannonEnd() tears the sweep, the slow motion and the crossfade down
         correctly if the player quits in the middle of it. */
      var rid = cannonRound, LV = CN.L;
      setTimeout(function () {
        if (winning) return;
        if (CN && CN.round !== rid) return;
        /* ------------------------------------------------------------
           THE AWARD POINT, NOT THE ENTRY POINT.
           The egg mark is read HERE, on the last kill, and not only where
           CN.stakes was computed. That is the whole difference between this
           build and the one that leaked: a fact consulted only at the door
           is one careless edit to the door away from being no fact at all.
           If a future change makes CN.stakes true for an egg round, this
           line still routes it to cannonClear() and no code is granted.
           IT READS CN.egg FIRST — the round's own copy, frozen at
           cannonArena() — so this branch is decided by the round that is
           actually being awarded and not by whatever the page has since done
           to the module variable. CANNON_EGG is read too, because the two are
           written on different lines and either one holding is enough.
           ------------------------------------------------------------ */
        if (CN && CN.stakes && !CN.egg && !CANNON_EGG) {
          /* CLEARING THE MILESTONE ROUND *IS* CLEARING LEVEL 1 — one clear,
             one unlock, no special case. The ladder is raised BEFORE win(),
             because win() closes the arena on its way to reveal() and CN is
             gone by the time it returns.
             …AND SO IS THE BEST-RUN RECORD. The shipped build wrote
             av_ms_cnshots_1 only in cannonClear(), which a stakes round never
             reaches — so level 1's best score could never be set by the one
             round most players will ever play it as, and the picker showed
             "01 PROOF SHEET … —" under a footer reading "Cleared 2 of 3". */
          cannonBestRaise(1, CN.shots);
          cannonLadderRaise(2);
          // THE ONLY WRITE TO THIS FLAG IN THE WHOLE FILE. reveal() reads it
          // instead of GAME_ON, so the reward panel describes the round that
          // was actually played and the two can never disagree.
          WON_BY_CANNON = true;
          win();
        } else {
          cannonClear(rid, LV);
        }
      }, 1200);
    }
  }

  /* ---------------------------------------------------- level clear ---- */

  /**
   * A LEVEL CLEARED WITH NOTHING AT STAKE — and the path that was MISSING.
   *
   * The shipped build called win() unconditionally, and win() returns on its
   * first line while ARCADE. So an easter-egg round would have destroyed
   * every panel and then hung forever: no closeArena(), so no cannonEnd(), so
   * the rAF loop, the ResizeObserver, the aria-hidden MutationObserver and
   * three window listeners all leak while a dead arena sits on top of the
   * article. This function is a prerequisite for the levels and for the egg,
   * not a nicety.
   *
   * ⚠ AUDIT PROPERTY, AND theme/verify-theme.mjs MUST ENFORCE IT:
   * the body of this function contains ZERO occurrences of `win`,
   * `setUnlocked`, `reveal`, `CODE`, `isUnlocked`, `setCaught` and
   * `gainCatch`. It cannot hand out the discount code, and a future edit that
   * reaches for win() to "reuse the celebration" fails the build instead of
   * opening a second route to it. (The static audit, P2.)
   */
  function cannonClear(rid, L) {
    if (!CN || CN.round !== rid) return;
    var shots = CN.shots, lv = CANNON_LEVELS[L] || CANNON_LEVELS[1];
    var clean = shots <= lv.par;
    var isBest = cannonBestRaise(L, shots);
    var raised = cannonLadderRaise(L + 1);
    cannonFanfare();
    if (!reduce) { try { confetti(Math.min(3, 1 + 0.4 * (L - 1))); } catch (e) {} }
    closeArena();                                  // ← the fix: cannonEnd() runs
    cannonClearCard(L, shots, clean, isBest, raised);
  }

  /**
   * LEVEL 3 ONLY: the customer's panel was cut. Not a level failure in any
   * lasting sense — it neither raises nor lowers the ladder — so it reuses
   * the clear card's shell with different copy rather than being a second
   * surface with its own lifecycle.
   */
  function cannonScrap(rid, L, panelName) {
    if (!CN || CN.round !== rid) return;
    closeArena();
    var m = cannonCard(
      '<b class="av-ms-cannon-endh av-ms-cannon-endh--bad">❌ SCRAP</b>' +
      '<span class="av-ms-cannon-endl">You cut the customer\'s ' + esc(panelName || "panel") + '. That one was not yours.</span>' +
      '<u class="av-ms-cannon-endf">Nothing is lost — level 3 stays unlocked.</u>',
      [{ k: "again", label: "↻ Retry level " + L, primary: 1 },
       { k: "range", label: "☰ Pick a level" }], L);
    return m;
  }

  /**
   * THE SHARED END-OF-ROUND CARD.
   *
   * IT IS BUILT AFTER closeArena(), NEVER BEFORE. The medal game's guideCard()
   * trap is instructive: `guidePause` is only read by the medal loop, so a
   * card raised over a live cannon arena would sit there with the pile still
   * falling behind it. Here the round is already torn down when the card
   * appears, which is also why the buttons can call cannonPlay() directly.
   */
  function cannonCard(html, buttons, L) {
    var old = document.querySelector(".av-ms-cannon-end");
    if (old) old.remove();
    var btns = "";
    for (var i = 0; i < buttons.length; i++) {
      btns += '<button class="av-ms-btn' + (buttons[i].primary ? "" : " av-ms-btn--ghost") +
        ' av-ms-cannon-endb" type="button" data-cn-end="' + buttons[i].k + '">' +
        esc(buttons[i].label) + '</button>';
    }
    var m = tier(el("div", "av-ms-modal av-ms-cannon-end is-open"));
    m.innerHTML =
      '<div class="av-ms-modal__scrim av-ms-cannon-endscrim"></div>' +
      '<div class="av-ms-cannon-endcard av-ms-cannon-endcard--l' + L + '">' +
        '<button class="av-ms-cannon-endx" type="button" aria-label="Close">✕</button>' +
        html +
        '<div class="av-ms-cannon-endbtns">' + btns + '</div>' +
      '</div>';
    document.body.appendChild(m);
    /* Same shape as cannonPrimer(): the keydown listener comes off on EVERY
       exit, not only on the Escape that would have removed it. */
    function shut() {
      document.removeEventListener("keydown", esc2);
      if (m.parentNode) m.remove();
    }
    function esc2(kv) { if (kv.key === "Escape") shut(); }
    m.querySelector(".av-ms-cannon-endx").addEventListener("click", shut);
    m.querySelector(".av-ms-cannon-endscrim").addEventListener("click", shut);
    m.querySelector(".av-ms-cannon-endbtns").addEventListener("click", function (ev) {
      var b = ev.target && ev.target.closest ? ev.target.closest("[data-cn-end]") : null;
      if (!b) return;
      var k = b.getAttribute("data-cn-end");
      shut();
      if (k === "range") cannonRange();
      else if (k === "again") cannonOpenLevel(L);
      else if (k === "next") cannonOpenLevel(L + 1);
    });
    document.addEventListener("keydown", esc2);
    return m;
  }

  /** 🏆 the level-cleared card. */
  function cannonClearCard(L, shots, clean, isBest, raised) {
    var lv = CANNON_LEVELS[L], nx = CANNON_LEVELS[L + 1];
    var n = lv.ids.length - (lv.protect ? 1 : 0);
    var stat = esc(lv.name) + " — " + n + " panel" + (n === 1 ? "" : "s") +
               " down in " + shots + " shot" + (shots === 1 ? "" : "s") + ".";
    if (clean) stat += " ✂ CLEAN SHEET (par " + lv.par + ").";
    if (isBest) stat += " ⭑ New best.";

    var head, unlock = "";
    if (L >= CANNON_MAX_LEVEL) {
      head = "🏁 THE WHOLE SHOP";
      unlock = '<u class="av-ms-cannon-endf">Every panel in the range, cut. The range stays open — now go beat your shot counts.</u>';
    } else {
      head = "🏆 LEVEL " + L + " CLEARED";
      unlock = raised
        ? '<u class="av-ms-cannon-endf av-ms-cannon-endf--new">🔓 LEVEL ' + (L + 1) + ' UNLOCKED — ' +
            esc(nx.name) + ' · ' + esc(nx.kit) + ' · ' + (nx.ids.length - (nx.protect ? 1 : 0)) +
            ' panels' + esc(nx.feature || "") + '</u>'
        : '<u class="av-ms-cannon-endf">Level ' + (L + 1) + ' is already open.</u>';
    }
    /* A REPLAY IS NOT A DEAD END. Before the levels existed, winning a replay
       round re-opened the store's reward panel with the code on it. It does
       not any more — a no-stakes round takes the cannonClear() branch and
       win() is never called, which is the whole point — so the card has to
       say where the code went. It POINTS at the milestone bar rather than
       reprinting the code: exactly one surface prints it, and that surface is
       reveal(). (This line is in cannonClearCard, not cannonClear: the static
       audit reads cannonClear's body, and it still contains no `isUnlocked`.) */
    var owned = "";
    try {
      if (isUnlocked()) owned = '<u class="av-ms-cannon-endf">🎟 Your discount code is still where you left it — open the milestone bar.</u>';
    } catch (e) {}

    /* THREE ROUTES, AND THE FIRST ONE SAYS WHERE IT GOES.
       The owner's complaint was "be perspejimo ir pasirinkimo" — no warning
       and no choice. The choice is these three buttons; the WARNING is that
       [Next] names the level it opens instead of only numbering it, so
       nobody presses "▶ Level 2" and is surprised to find a different car
       and a longer pile. [Pick a level] is spelled out rather than called
       "the range", because "the range" is this game's word and a shopper
       three minutes into their first round has not learned it yet. */
    var btns = [];
    if (L < CANNON_MAX_LEVEL) {
      btns.push({ k: "next", label: "▶ Level " + (L + 1) + " · " + (nx ? nx.name : ""), primary: 1 });
    }
    btns.push({ k: "again", label: "↻ Replay level " + L });
    btns.push({ k: "range", label: "☰ Pick a level" });
    return cannonCard(
      '<b class="av-ms-cannon-endh">' + head + '</b>' +
      '<span class="av-ms-cannon-endl">' + stat + '</span>' + unlock + owned, btns, L);
  }

  /* ------------------------------------------------------- the range --- */

  /**
   * THE LEVEL PICKER — structurally the medal game's arcadePicker(), visually
   * a plotter job queue. One row per level, not a grid: each level has a
   * name, a kit and a best score, and a grid of numbers cannot carry any of
   * that.
   *
   * EVERY UNLOCKED LEVEL IS OFFERED, ALWAYS — "bet kada", at any time.
   * The shipped build rendered ONLY a MILESTONE ROUND row while a cannon
   * milestone was live and unwon, so a player who had already cleared levels
   * 1-3 could not replay any of them for the length of the celebration. That
   * contradicted the one thing the ladder promises ("unlocked forever"), and
   * it was never a security property: the milestone round is the row that
   * carries stakes, and it carries them because it is the only row whose
   * handler passes CN_STAKES — not because the other rows are absent.
   *
   * `fromEgg` CARRIES BOTH BARRIERS, AND IT IS A PARAMETER RATHER THAN A READ
   * OF ANY PAGE FLAG ON PURPOSE. cannonEggLaunch() is the only caller that
   * passes it, and it does two separate things with it:
   *   F1  no milestone row is rendered, so no ticket is minted, so nothing
   *       this picker dispatches can hand cannonArena() the capability; and
   *   F2  it is passed on to cannonOpenLevel() as `egg`, which marks the round
   *       itself — so even a round that somehow acquired the capability is
   *       refused at the door, at the award and inside win().
   * Delete either one and the other still holds. See THE BARRIERS below.
   */
  function cannonPick(fromEgg) {
    if (arena || winning) return false;
    var old = document.querySelector(".av-ms-cnlvl");
    if (old) old.remove();
    try { Sound.arm(); } catch (e) {}

    /* THE MILESTONE ROW IS RENDERED ONLY WHEN IT COULD ACTUALLY PAY, and the
       question is asked of cannonMayStake() with the capability this picker
       would hand over — so the row and the round agree by construction, and
       a row that says "the discount code" can never open a round that has
       none. */
    var stakesRow = !fromEgg && cannonMayStake(1, CN_STAKES, fromEgg);
    var max = cannonMax(), rows = "", foot;

    /* Every picker starts with an empty ticket table. Nothing a previous
       picker minted can be redeemed through this one. */
    cannonTicketsDrop();
    var ticket = "";
    if (stakesRow) {
      /* 🎫 THE ROW CARRIES AN OPAQUE REFERENCE, NOT A CLAIM. data-cnticket is
         a random id whose only meaning is as a key of the module-private
         table; the capability itself never enters the document. Writing
         data-cnticket by hand redeems to null, and so does copying this id
         onto any other row, because the entry is bound to this element. */
      ticket = cannonTicketMint(CN_STAKES);
      rows += '<button type="button" class="av-ms-cnlvl__row is-milestone is-open" data-cnlvl="1" data-cnticket="' + ticket + '">' +
        '<i class="av-ms-cnlvl__n">★</i>' +
        '<span class="av-ms-cnlvl__t">MILESTONE ROUND</span>' +
        '<span class="av-ms-cnlvl__d">' + fmt(milestone.n) + ' templates · the discount code</span>' +
        '<span class="av-ms-cnlvl__b">▶</span></button>';
    }
    /* THE THREE STATES A ROW CAN BE IN, AND THE ONE WORD EACH OF THEM OWES
       THE PLAYER.
         cleared  → the best shot count. That is the score to beat.
         NEW      → open, never cleared. This is the rung that was just
                    unlocked (or, for a first-time visitor, level 1), and
                    "—" said nothing at all about it. The lime is-next edge
                    already draws the eye; the word says WHY it is lit.
         locked   → 🔒, and the description says plainly what opens it. */
    for (var L = 1; L <= CANNON_MAX_LEVEL; L++) {
      var lv = CANNON_LEVELS[L], open = L <= max, cur = (L === max);
      var best = cannonBest(L);
      var nn = lv.ids.length - (lv.protect ? 1 : 0);
      var mark = open ? (best ? best + " shot" + (best === 1 ? "" : "s") : "NEW") : "🔒";
      rows += '<button type="button" class="av-ms-cnlvl__row' +
        (open ? " is-open" : " is-locked") + (cur && open ? " is-next" : "") +
        (open && !best ? " is-fresh" : "") + '"' +
        (open ? ' data-cnlvl="' + L + '"' : ' disabled aria-disabled="true"') + '>' +
        '<i class="av-ms-cnlvl__n">' + (L < 10 ? "0" : "") + L + '</i>' +
        '<span class="av-ms-cnlvl__t">' + (open ? esc(lv.name) : "— — — — —") + '</span>' +
        '<span class="av-ms-cnlvl__d">' +
          (open ? esc(lv.kit) + " · " + nn + " panels" + esc(lv.feature || "")
                : "Clear level " + (L - 1) + " to open · " + nn + " panels" + esc(lv.feature || "")) +
        '</span>' +
        '<span class="av-ms-cnlvl__b">' + mark + '</span></button>';
    }
    /* 🚨 THE FOOTER USED TO LIE TO THE PLAYER WHO FINISHED THE GAME.
       It read `max - 1`, i.e. it inferred "levels cleared" from the LADDER
       CEILING — and the ceiling stops at CANNON_MAX_LEVEL, because
       cannonLadderRaise() refuses anything above it. So clearing level 3, the
       last one, could not move `max` past 3, and the card that congratulated
       the player with "🏁 THE WHOLE SHOP" was followed by a picker reading
       "Cleared 2 of 3". Count the CLEARS instead: cannonBest(L) is non-zero
       for exactly the levels that have actually been finished (cannonBestRaise
       writes on the first clear, from both the stakes and the no-stakes
       path), so this is the honest number and it needs no new storage. */
    var bestL = 0, bestN = 0, cleared = 0;
    for (var q = 1; q <= CANNON_MAX_LEVEL; q++) {
      var bb = cannonBest(q);
      if (bb) { cleared++; if (!bestN || q > bestL) { bestL = q; bestN = bb; } }
    }
    foot = "Cleared " + cleared + " of " + CANNON_MAX_LEVEL +
           (bestN ? " · your best run: " + bestN + " shots on level " + bestL : "");
    /* WHEN THE EGG OPENED THIS PICKER DURING A LIVE MILESTONE, SAY SO. The
       badge promises no discount code and this picker keeps that promise, so
       the footer has to point at the surface that does have one rather than
       leave a shopper hunting for a row that is deliberately not here. */
    if (fromEgg && GAME_ON && !ARCADE && !isUnlocked()) {
      foot = "Practice only — the milestone round is on the celebration bar, not here.";
    }

    var m = tier(el("div", "av-ms-modal av-ms-cnlvl is-open"));
    m.innerHTML =
      '<div class="av-ms-modal__scrim av-ms-cnlvl__scrim"></div>' +
      '<div class="av-ms-cnlvl__card">' +
        '<button class="av-ms-cnlvl__x" type="button" aria-label="Close">✕</button>' +
        '<b class="av-ms-cnlvl__h">🎯 THE CANNON RANGE</b>' +
        '<span class="av-ms-cnlvl__s">' +
          (stakesRow
            ? "The milestone round is live — that is the row with the code on it. Everything you have cleared stays open too."
            : "Every level you have cleared stays open — forever. No code at stake here, just the pile.") +
        '</span>' +
        '<div class="av-ms-cnlvl__list">' + rows + '</div>' +
        '<u class="av-ms-cnlvl__f">' + esc(foot) + '</u>' +
      '</div>';
    document.body.appendChild(m);
    /* BIND THE TICKET TO THE ELEMENT IT WAS MINTED FOR. This can only happen
       after the picker is in the document, and it is what makes copying the
       id onto another row useless. */
    if (ticket) {
      var trow = m.querySelector('[data-cnticket="' + ticket + '"]');
      if (trow) cannonTicketBind(ticket, trow);
    }
    /* shut() DROPS THE TICKET TABLE, so no capability outlives this surface —
       and it now also takes the Escape listener off the document, which used
       to survive every exit but Escape itself. */
    function shut() {
      document.removeEventListener("keydown", esc3);
      if (m.parentNode) m.remove();
      cannonTicketsDrop();
    }
    function esc3(kv) { if (kv.key === "Escape") shut(); }
    m.querySelector(".av-ms-cnlvl__x").addEventListener("click", shut);
    m.querySelector(".av-ms-cnlvl__scrim").addEventListener("click", shut);
    m.querySelector(".av-ms-cnlvl__list").addEventListener("click", function (ev) {
      var b = ev.target && ev.target.closest ? ev.target.closest("[data-cnlvl]") : null;
      if (!b) return;
      /* F1, THE OTHER HALF: the capability is REDEEMED, not read. Redeeming
         happens BEFORE shut() empties the table, and it needs the row itself —
         so a level row, a hand-written attribute and a copied id all get null
         and open a practice round, however the picker was reached.
         F2 travels beside it: `fromEgg` marks the round the picker dispatches,
         and it is the picker's own closure parameter, not anything in the
         markup. */
      var pickL = parseInt(b.getAttribute("data-cnlvl"), 10) || 1;
      var pickGrant = cannonTicketRedeem(b.getAttribute("data-cnticket"), b);
      shut();
      cannonOpenLevel(pickL, pickGrant, fromEgg);
    });
    document.addEventListener("keydown", esc3);
    var cur2 = m.querySelector(".av-ms-cnlvl__row.is-next");
    if (cur2 && cur2.scrollIntoView) { try { cur2.scrollIntoView({ block: "nearest" }); } catch (e) {} }
    return true;
  }

  /* ==================================================================== */
  /* 🎯 THE PERMANENT EASTER EGG                                          */
  /* -------------------------------------------------------------------- */
  /**
   * A badge on the knowledge-hub reward table opens the cannon range at any
   * time — including years after the milestone celebration has ended, when
   * GAME_ON is false and there is no other door into the game at all.
   *
   * IT HAS ITS OWN ATTRIBUTE, data-av-ms-cannon, AND MUST NEVER REUSE
   * data-av-ms-arcade. The boot detector takes the FIRST match of that
   * selector, so a second one would silently launch a MEDAL round labelled
   * with the wrong milestone, and bindArcade() would bind both badges to the
   * medal picker. Nothing would log.
   *
   * ====================================================================
   * WHY THE PREVIOUS SET OF BARRIERS ALL FELL OVER AT ONCE
   * --------------------------------------------------------------------
   * They were four readings of ONE CONDITION: `ARCADE`. And ARCADE is set
   * CONDITIONALLY — the boot block enters arcade mode only when there is no
   * live celebration and no teaser:
   *
   *     if (arcForce !== "off" && (!milestone || !mode || arcForce === "1"))
   *
   * So during the 1500 celebration, on the very page the badge lives on,
   * ARCADE was FALSE. B1 never armed, B2's `&& !ARCADE` conjunct was
   * satisfied, and the egg paid out the real discount code. "Four
   * independent barriers" that share one conditional premise are one
   * barrier with four names.
   *
   * THE FIX IS NOT ANOTHER PAGE-SCOPED FLAG. The build after that one made
   * CANNON_EGG the cannon's answer to arcadeStart()'s `funMode = true`, set
   * unconditionally and cleared by nothing — which closed the leak and opened
   * a different hole: a shopper who pressed the badge on the celebration page
   * could not win the code on that page load afterwards, from any door. What
   * the egg needs is not a flag about the PAGE but a fact about the ROUND, and
   * that is what `fromEgg` and `egg` are: parameters, passed from the one call
   * site that knows, cleared when the round they describe is torn down.
   * ====================================================================
   *
   * THE BARRIERS — COUNTED HONESTLY THIS TIME.
   *
   * The last build claimed FIVE, and a verifier showed it had fewer: B1, B2
   * and B3 were three readings of ONE fact (the CANNON_EGG latch), written by
   * one line, and B4 was not a barrier at all — its capability could be
   * minted from the DOM by putting data-cnstake="1" on a level row.
   * Commenting out the single line that wrote the latch and setting that one
   * attribute produced a complete steal.
   *
   * SO THE UNIT IS NOW THE FACT, NOT THE LINE. Two INDEPENDENT FACTS stand
   * between the easter-egg badge and the discount code. They are read on five
   * different lines in five different functions, and that redundancy is worth
   * having — but five lines reading two facts is TWO barriers, and calling it
   * five is how the last one got shipped.
   *
   *  F1  THE CAPABILITY, WHICH CANNOT BE MINTED FROM MARKUP.
   *      lines: `var stakesRow = !fromEgg && cannonMayStake(1, CN_STAKES, fromEgg);`
   *             — the only thing that ever mints a ticket — and
   *             `grant === CN_STAKES` inside cannonMayStake(), with
   *             cannonTicketRedeem() as the only bridge from a row to the
   *             object.
   *      Alone: delete the egg mark from the file entirely and the egg still
   *      cannot pay. cannonEggLaunch() calls cannonPick(true); a picker opened
   *      that way mints NO ticket, so its table is empty, so every row —
   *      including one an attacker has written data-cnticket or data-cnstake
   *      onto — redeems to null, and `null !== CN_STAKES`.
   *      What changed: the authority is a module-private table keyed by a
   *      random id and BOUND to the element it was minted for. The row carries
   *      an opaque reference; the capability never enters the document.
   *
   *  F2  THE ROUND'S EGG MARK, WHICH IS A PROPERTY OF THE ROUND.
   *      lines: `CANNON_EGG = !!egg;` in cannonArena() (the only writer that
   *             can set it) and `CANNON_EGG = false;` in cannonEnd() (the only
   *             one that clears it), read by
   *               · `!CANNON_EGG && !egg` in cannonMayStake(),
   *               · `if (CN && CN.stakes && !CN.egg && !CANNON_EGG)` at the
   *                 AWARD point in cannonShatter(), 1200 ms after the last
   *                 kill, and
   *               · `if (ARCADE || CANNON_EGG || !GENUINE) return;` as the
   *                 first line of win() and of setUnlocked() (edits a2/a3 of
   *                 theme/apply-theme-edits.mjs).
   *      Alone: delete F1 — make every row hand over CN_STAKES — and an egg
   *      round still cannot pay. cannonMayStake() refuses at the door,
   *      cannonShatter() refuses at the award, win() returns before reveal()
   *      so no panel is built, and setUnlocked() — the only writer of
   *      KEY + "_unlocked" in the whole file — never writes, so the popover's
   *      code panel and every later page load stay shut too.
   *      ⚠ BE EXACT ABOUT WHICH LINE DOES WHICH. reveal() prints CODE
   *      unconditionally and does not consult isUnlocked(), so setUnlocked()'s
   *      guard alone would stop the code PERSISTING and not stop it being
   *      SHOWN once. It is win()'s guard that stops the surface.
   *      What changed: it used to be latched by cannonEggLaunch() and cleared
   *      by nothing, which cost a real shopper a real reward — press the badge
   *      on the celebration page and the milestone round could never pay again
   *      on that page load. It is now written from the `egg` parameter that
   *      travels cannonPick -> cannonOpenLevel -> cannonPlay -> cannonArena,
   *      and cleared in the single teardown path. An egg round is marked for
   *      the whole of its life; a genuine round opened after it is not marked
   *      at all, and pays.
   *
   * WHAT F1 AND F2 SHARE, SAID OUT LOUD: both are derived from the ONE literal
   * `cannonPick(true)` in cannonEggLaunch(). If that call were wrong, both
   * fall together. What makes them worth counting as two is that they diverge
   * IMMEDIATELY and never meet again — one becomes the absence of a ticket in
   * a private table, the other a boolean on the round — so no single later
   * edit can undo both. That is a weaker claim than "five independent
   * barriers" and it is the true one.
   *
   *  F3  A FORCED ?av_milestone= URL CANNOT MINT A CODE — a third independent
   *      fact, guarding a different route.
   *      lines: `cannonGenuineMilestone()` inside cannonMayStake(), and
   *             `GENUINE` in win()/setUnlocked() for the medal game.
   *      Alone: ?av_milestone=3000&av_ms_game=1 forced mode === "celebration"
   *      with ARCADE false at any time, years after the event, from a link.
   *      pickAuto() reads the live product count and no query string, so a
   *      forced milestone can be played and can never pay. The medal half was
   *      OPEN until this round: dropping &av_ms_game=1 from the same link
   *      handed the forced milestone to the medal game with nothing to stop
   *      it. GENUINE closes it for both games at one boot-time question.
   *
   *  AND THE STATIC AUDIT, which is not a fact about the round but is what
   *  keeps the two from being quietly undone: cannonClear() contains no `win`,
   *  `setUnlocked`, `reveal`, `CODE`, `isUnlocked`, `setCaught` or
   *  `gainCatch`, asserted by theme/verify-theme.mjs section P2. Whatever
   *  routes to cannonClear() cannot pay, whatever the flags say.
   *
   *  AND THE LADDER GRANTS NOTHING: av_ms_cannon_lvl and av_ms_cnshots_* are
   *  integers read only by cannonMax(), cannonBest() and this picker. Setting
   *  them by hand in devtools opens three levels and zero discount codes.
   *
   * EVERY CLAIM ABOVE IS RUN, NOT ARGUED — by theme/verify-theme.mjs, and by
   * nothing else. An earlier revision of this comment cited a proof script
   * that was never written, and that citation was shipped inside this bundle
   * and uploaded: the same class of mistake as the "four independent
   * barriers" it replaced. Section V of verify-theme.mjs now fails the build
   * if anything in this file names a project file that does not exist, which
   * is why the sentence you are reading does not name one either.
   * What actually runs:
   *   Q    the egg on the page the shop shows for most of the year
   *   R    the egg in the configuration that leaked — a live, unwon, cannon
   *        milestone — plus the forced ?av_milestone= URL and the sticky
   *        sessionStorage preview, six kills through the canvas each time
   *   R7   the control: the same live page with the egg untouched MUST pay,
   *        so "nothing leaks" cannot be satisfied by a broken game
   *   R4b  the other half, and the one that cost a shopper: after an egg
   *        round, the REAL milestone round on the same page load still pays
   *   P2   the static audit of cannonClear()
   *
   * INVARIANT, STATED ONCE: there is exactly one route to the code — destroy
   * every panel in a round that a caller holding CN_STAKES opened on the
   * genuine, unwon milestone, and that was not dispatched from the egg.
   */
  function cannonEggLaunch(ev) {
    if (ev) {
      /* THIS IS NOT A BARRIER AND THE COMMENT USED TO CLAIM IT WAS.
         The site runs a synthetic cursor effect that dispatches fake clicks;
         without this line the page opens the game by itself. That is ALL it
         does. `isTrusted` is spoofable on a hand-built event by anyone with a
         console, and a console can call cannonEggLaunch() with no event at
         all — which is deliberate, see root.__avMsCannonEgg. It is a
         cursor-FX filter, not a security check, and neither F1 nor F2 rests
         on it. It is `!== true` rather than `=== false` so that an event object
         with no isTrusted at all is also refused. */
      if (ev.isTrusted !== true) return false;
      ev.preventDefault(); ev.stopPropagation();
    }
    /* 🥚 THE EGG OPENS A PICKER, NEVER A ROUND, AND IT PASSES `true`.
       That literal is the source of BOTH facts that stop this door paying:
       cannonPick(fromEgg) mints no ticket (F1) and stamps every round it
       dispatches as an egg round (F2). It is a parameter all the way down —
       nothing here writes a page-scoped flag, so nothing here can cost a
       later, genuine milestone round its reward. */
    if (arena || winning) return false;
    return cannonPick(true);                      // the PICKER, never a round
  }
  function bindCannonEgg() {
    var b;
    try { b = document.querySelectorAll("[data-av-ms-cannon]"); } catch (e) { return; }
    for (var i = 0; i < b.length; i++) {
      if (b[i].__avMsCnEgg) continue;
      b[i].__avMsCnEgg = 1;
      b[i].classList.add("is-armed");             // only armed once the game is here
      b[i].addEventListener("click", function (ev) {
        var t = ev.currentTarget;
        if (cannonEggLaunch(ev) === false) {
          t.classList.add("is-egg-failed");
          setTimeout(function () { t.classList.remove("is-egg-failed"); }, 1200);
        }
      });
    }
    /* DISCOVERABILITY. The reward grid ships collapsed behind "Show reward
       scheme", so the badge is armed but unseen. #cannon opens the wrap,
       scrolls the badge into view and flags it for two seconds. */
    try {
      if (location.hash === "#cannon" && b.length) {
        var host = b[0];
        var wrap = host.closest ? host.closest("[hidden], .is-collapsed, .latest-library-rewards") : null;
        if (wrap) { wrap.hidden = false; wrap.classList.remove("is-collapsed"); }
        host.classList.add("is-egg-hint");
        setTimeout(function () { host.classList.remove("is-egg-hint"); }, 2000);
        if (host.scrollIntoView) host.scrollIntoView({ block: "center" });
      }
    } catch (e) {}
  }

  /* ---------------------------------------------------------- cull ---- */

  /**
   * PUT A TEMPLATE THAT LEFT THE PLAYFIELD BACK ON THE FLOOR.
   *
   * Deleting it is what an earlier build did, and it counted as a WIN: a
   * template that drifted past world x = 40 m was marked destroyed without
   * ever being hit, so the code could be collected without playing. Only
   * cannonShatter() may destroy a template now, so this has to leave the
   * body alive. The engine has no teleport call, so the pose goes in through
   * snapshotPoses/restorePoses — the same path the retreat uses.
   *
   * IT SHOULD NEVER RUN: with static side walls and a floor a template has
   * no way out except straight up 40 m, and nothing here pushes a template —
   * only shards get the blast. templatesRecovered counts it so "that branch
   * never fires" stays evidence rather than an assumption.
   */
  function cannonRecover(list) {
    var c = CN.cfg, hy = c.fieldHalfY, bs = CN.world.bodies;
    var snap = CN.P.snapshotPoses(CN.world);
    for (var i = 0; i < bs.length; i++) {
      var b = bs[i];
      if (list.indexOf(b) < 0) continue;
      var halfX = (b.world.box.maxX - b.world.box.minX) / 2;
      snap[i * 3] = c.floorX + halfX + 50;
      snap[i * 3 + 1] = Math.max(-hy + 800, Math.min(hy - 800, b.cy));
      b.vx = 0; b.vy = 0; b.omega = 0;
      b.asleep = false; b.sleepT = 0;
      CN.templatesRecovered++;
    }
    CN.P.restorePoses(CN.world, snap);
  }

  /**
   * THE BROADPHASE IS O(n^2), so culling is a frame-time requirement, not
   * housekeeping. A body leaves because a fragment outlived fragLifeS, a
   * FRAGMENT left the field, or the body budget is full (oldest fragments
   * first). A TEMPLATE is never culled for leaving — it is put back. The one
   * case that cannot be put back is a non-finite pose, which means the solver
   * has already broken: that body is dropped, counted in templatesLost, and
   * does NOT advance the win.
   */
  function cannonCull() {
    var c = CN.cfg, bs = CN.world.bodies;
    var outY = c.fieldHalfY + 2200, recover = null;
    for (var i = bs.length - 1; i >= 0; i--) {
      var b = bs[i], m = CN.meta[b.id];
      if (!m) { bs.splice(i, 1); continue; }
      var broken = !Number.isFinite(b.cx + b.cy + b.theta);
      var outside = b.cx < c.floorX - 900 || b.cx > 40000 || Math.abs(b.cy) > outY;
      var gone = broken || outside;
      if (!gone && m.kind === "frag" && CN.t - m.born > m.life) gone = true;
      if (!gone) {
        if (m.kind === "frag") {
          var left = m.life - (CN.t - m.born);
          m.alpha = left < c.fragFadeS ? Math.max(0, left / c.fragFadeS) : 1;
        }
        continue;
      }
      if (m.kind === "template") {
        if (!broken) { (recover || (recover = [])).push(b); continue; }
        CN.templatesLeft--;
        CN.templatesLost++;                          // NOT a win. See above.
      }
      delete CN.meta[b.id];
      bs.splice(i, 1);
    }
    if (recover) cannonRecover(recover);
    if (bs.length > c.maxBodies) {                    // hard budget, oldest first
      var frags = [];
      for (var j = 0; j < bs.length; j++) {
        var mm = CN.meta[bs[j].id];
        if (mm && mm.kind === "frag") frags.push({ i: j, born: mm.born });
      }
      frags.sort(function (a, b2) { return a.born - b2.born; });
      var drop = Math.min(frags.length, bs.length - c.maxBodies), kill = {};
      for (var d2 = 0; d2 < drop; d2++) kill[bs[frags[d2].i].id] = 1;
      for (var e2 = bs.length - 1; e2 >= 0; e2--) {
        if (kill[bs[e2].id]) { delete CN.meta[bs[e2].id]; bs.splice(e2, 1); }
      }
    }
  }

  /* ---------------------------------------------------------- loop ---- */

  var CANNON_FIXED = 1 / 60;

  /**
   * ONE FIXED STEP AND ONE FRAME.
   *
   * The step is always 1/60 with the remainder accumulated here: the
   * engine's substep count, its sleep thresholds and its bounce floor are
   * all tuned against that number, so a variable dt would silently retune
   * the pile on every machine.
   */
  function cannonLoop(now) {
    if (!CN || !CN.running) return;
    if (!CN.last) CN.last = now;
    var real = Math.min(0.25, (now - CN.last) / 1000);
    CN.last = now;
    /* SLOW MOTION IS APPLIED TO THE ACCUMULATOR AND NOWHERE ELSE. The fixed
       1/60 step is untouched, so determinism, the bounce floor, the sleep
       thresholds and every proof are unaffected — the pile simply resolves in
       visible slow motion while the last shards arc. It also REDUCES frame
       cost, because fewer steps run per frame. */
    if (CN.slowmo !== 1) {
      if (CN.t - CN.winT > 0.6) CN.slowmo = 1;
      else real *= CN.slowmo;
    }
    CN.acc += real;
    /* ================================================================== */
    /* HOW MANY FIXED STEPS ONE FRAME MAY CATCH UP — AND WHY IT IS NOT 4.  */
    /* ------------------------------------------------------------------ */
    /* MEASURED, at last, on a throttled phone (scripts/phone-lab.mjs):
     * at Emulation.setCPUThrottlingRate 6 one fixed step of level 1's peak
     * pile costs 11.8 ms. The frame budget is 16.7 ms. So the moment a frame
     * runs late, the old `steps < 4` let it take a SECOND step — 23.5 ms of
     * physics on a frame that was already late — which made the next frame
     * later still. Measured on the shipped bundle before this line existed:
     * main-thread p95 31.6 ms, max 41.2 ms, 44 of 163 frames over budget
     * during the shatter, and the round played at 46 fps.
     *
     * THE FIX IS NOT TO MAKE THE STEP CHEAPER, IT IS TO STOP COMPOUNDING.
     * A device that cannot afford two steps in a frame is told to take one.
     * The pile then runs a few percent slow instead of stuttering, which is
     * the trade the slow-motion code at the top of this function already
     * makes deliberately — same mechanism, same guarantee: THE STEP IS STILL
     * EXACTLY 1/60. Nothing about the physics changes. substeps, the sleep
     * thresholds, the bounce floor, prove-settle, prove-nofloat and
     * prove-reproducible all describe the same simulation as before, because
     * they drive the world one fixed step at a time and never through here.
     *
     * On a machine that can afford it — every desktop, and every phone at
     * 1x and 4x — stepMs is well under 3 ms and the cap is the old 4, so
     * this changes nothing that was already working.
     *
     * The budget is 12 ms, not 16.7: the draw, the effects and the browser's
     * own compositing have to fit in the same frame.
     */
    var stepCap = 4;
    if (CN.stepMs > 0) stepCap = Math.max(1, Math.min(4, Math.floor(12 / CN.stepMs)));
    var steps = 0, t0 = perfNow();
    while (CN.acc >= CANNON_FIXED && steps < stepCap) {
      // THE SETTLE ASSIST, AND IT MUST BE FIRST. The engine's own sleep test
      // demands 0.05 mm of daylight that a resting pair of real panels does
      // not have — measured, two panels rest at d = 2.000 against a barrier
      // of 2.000 — so sleepT is zeroed forever and the pile never sleeps.
      // Without this call 23 of 24 seeds are still awake after 35 s.
      CN.P.settleAssist(CN.world, { dt: CANNON_FIXED, idleS: CN.cfg.settleIdleS });
      cannonHit(CANNON_FIXED);
      // …and anything under cannonHit() may, in principle, end the round.
      // Today nothing does — the win and the scrap are both deferred to a
      // timeout precisely so that they cannot — but the cost of being sure is
      // one comparison per substep, and the cost of being wrong is a thrown
      // exception in the middle of a shopper's game.
      if (!CN) return;
      // There is no gravity knob in the engine, so gravity scaling goes
      // through shakeX, which the solver adds straight to -g.
      CN.awake = CN.P.step(CN.world, { dt: CANNON_FIXED, shakeX: 9810 * (1 - CN.cfg.gravityScale) });
      CN.t += CANNON_FIXED;
      CN.frame++;
      cannonCull();
      CN.acc -= CANNON_FIXED;
      steps++;
    }
    /* NEVER SPIRAL. The debt that could not be paid inside stepCap is
       dropped, not carried: carrying it is what turns one late frame into a
       permanent backlog. It is written against the cap that actually ran, so
       a capped device drops its debt on the same frame it was created. */
    if (CN.acc > CANNON_FIXED * stepCap) CN.acc = 0;
    if (steps > 0) {
      var per = (perfNow() - t0) / steps;
      CN.ring[CN.rp++ % 60] = per; if (CN.rn < 60) CN.rn++;
      /* THE COST OF ONE STEP, SMOOTHED, AND IT IS THE ONLY INPUT TO stepCap.
         An EMA rather than a mean over the ring because the cap has to react
         to the pile getting heavy WITHIN a round — the shatter frame is the
         one that matters — and a 60-frame mean is a second behind it at
         60 fps and four seconds behind it at 15. 0.2 settles in ~10 frames.
         It is seeded on the first step instead of ramping up from zero, so
         the very first shatter is already governed. */
      CN.stepMs = CN.stepMs > 0 ? CN.stepMs + (per - CN.stepMs) * 0.2 : per;
    }

    /* ------------------------------------------------------------------
       EFFECTS SCALE INVERSELY WITH BODY COUNT, PRE-EMPTIVELY.
       The impact burst and the physics burst are the SAME EVENT: naively
       stacking them puts 4.90 ms of p95 physics and 1.13 ms of impact paint
       on one frame, which at the phone multiplier is 24-48 ms. So the count
       of every burst is decided by how loaded the frame already is, one
       frame ahead, instead of being cut back after the fact.
         6 bodies  -> 1.00      24 bodies -> 0.50      32 (the cap) -> 0.35
       Worst combined frame: 4.90 + 1.13*0.35 = 5.30 ms against today's 4.90.
       +8% on the one frame that was already the worst, and 0% on the 95% of
       frames the player actually looks at.
       ------------------------------------------------------------------ */
    CN.fx = Math.max(0.35, Math.min(1, 1 - (CN.world.bodies.length - 12) / 24));
    if (steps > 0) cannonLandings();

    if (CN.lastImpact && CN.lastImpact.t !== CN.lastImpactSeen) {
      CN.lastImpactSeen = CN.lastImpact.t;
      cannonSparks(CN.lastImpact.x, CN.lastImpact.y, CN.lastImpact.dx, CN.lastImpact.dy);
      /* AND SMOKE AT THE KILL POINT. The muzzle has always breathed out
         (cannonFire pushes three puffs); the thing being destroyed never
         did, so the impact was pure light and had nothing left a tenth of a
         second later. These use the SAME pool and the same three-flat-arcs
         draw as the muzzle's, they carry the shot's own direction so the
         cloud leans away from the gun, and their count is CN.fx like every
         other burst — at the 32-body cap it is one puff, not four. */
      if (!reduce) {
        var li0 = CN.lastImpact, ns0 = Math.round(4 * CN.fx);
        for (var q0 = 0; q0 < ns0; q0++) {
          var qa = Math.random() * 6.2832;
          CN.smoke.push({
            x: li0.x + Math.cos(qa) * 130, y: li0.y + Math.sin(qa) * 130,
            r0: 190 + q0 * 90, t: 0, life: 0.85 + Math.random() * 0.35,
            rot: Math.random() * 6.2832, w: 1.6,

            vx: 260 + li0.dx * 420, vy: li0.dy * 420 + (Math.random() - 0.5) * 500
          });
        }
      }
    }
    cannonStepFx(real);
    cannonForgetDead();

    var d0 = perfNow();
    cannonDraw();
    var dms = perfNow() - d0;
    CN.dring[CN.dp++ % 60] = dms;
    if (CN.dn < 60) CN.dn++;
    /* THE WHOLE FRAME, which is what has to fit in 16.7 ms: the steps that
       actually ran, the effects, and the draw. t0 was taken before the first
       step, so this is everything this callback did. */
    CN.fring[CN.fp++ % 60] = perfNow() - t0;
    if (CN.fn < 60) CN.fn++;
    cannonGovern();

    if (TUNE_UI) cannonDiag();
    CN.raf = requestAnimationFrame(cannonLoop);
  }

  /**
   * A PANEL ARRIVING. Detected the only honest way — |vx| crossing DOWN
   * through 900 mm/s having been above it — and it buys the two things that
   * make the entrance readable: a puff of dust with a skid streak where it
   * touched, and 320 ms of settle wobble.
   *
   * ⚠ THE WOBBLE IS STORED ON THE META AND APPLIED IN cannonDraw() ONLY. It
   * is never written back to b.theta. If it ever were, the hit test, the
   * solver, prove-settle, prove-nofloat and prove-reproducible would all stop
   * describing the same game — and three of them would carry on passing.
   */
  function cannonLandings() {
    var bs = CN.world.bodies, i, b, m;
    for (i = 0; i < bs.length; i++) {
      b = bs[i]; m = CN.meta[b.id];
      if (!m || m.kind !== "template") continue;
      var sp = Math.abs(b.vx);
      if (!m.landed && sp > 900) { m.landed = 1; continue; }
      if (m.landed === 1 && sp < 900 && b.cx < 4200) {
        m.landed = 2;
        m.wob = Math.min(1, sp / 2200 + 0.35); m.wobT = CN.t;
        if (!reduce) {
          CN.puffs.push({ x: 60, y: b.cy, t: 0, life: 0.62, r0: 120, r1: 520, floor: 1 });
          try { Sound.fx("beat"); } catch (e) {}
        }
      }
    }
  }

  /* --------------------------------------------- the quality governor -- */
  /**
   * THE 4-8x PHONE MULTIPLIER IS AN ASSUMPTION THIS PROJECT HAS NEVER
   * MEASURED. This is what makes being wrong about it survivable, and what
   * finally makes it measurable: ?av_ms_tune=1 prints the tier next to the
   * frame times, so one minute on one real phone closes the question.
   *
   *   Q2 (default)  everything
   *   Q1            no panel sheen / kerf / lip, half the dust, no smoke
   *   Q0            …and no contact shadows, no parallax, no scorch, fewer
   *                 landing puffs
   *
   * WHAT IT WATCHES, AND WHAT IT USED TO WATCH. It now takes the p95 of the
   * WHOLE main-thread frame — sim, effects and draw together, the same
   * quantity scripts/phone-lab.mjs measures from outside the page — against
   * 13 ms of the 16.7 ms budget, leaving the rest for compositing. It used to
   * take the p95 of the DRAW ring plus one frame's per-step sim cost, which
   * is not a duration anything ever experiences, and it read low: measured on
   * a 6x-throttled phone the frames were 31.6 ms at p95 and the governor did
   * not move.
   *
   * DESCENDING ONLY, and only after TWO CONSECUTIVE 30-frame windows over
   * budget — one bad window is a garbage collection, two is a device. It
   * never promotes back inside a round, because a tier that oscillates is
   * worse than either tier. The windows were 60 frames, which at the 12 fps
   * a struggling phone actually runs at is TEN SECONDS to react — longer
   * than the whole shatter it was supposed to react to.
   *
   * ⚠ IT CANNOT SAVE A FRAME THE SIM IS SPENDING. On the same 6x phone the
   * split was sim 11.8 ms against draw 2.0, so every tier in this table put
   * together is worth about 2 ms. The lever that mattered was the catch-up
   * cap in cannonLoop(); this one stops the paint piling on top of it.
   */
  function cannonGovern() {
    if (CN.fn < 30 || (CN.fp % 30) !== 0) return;
    var i, n = CN.fn, arr = [];
    for (i = 0; i < n; i++) arr.push(CN.fring[i]);
    arr.sort(function (a, b) { return a - b; });
    var p95 = arr[Math.min(n - 1, Math.floor(n * 0.95))];
    if (p95 > 13) { CN.over++; } else { CN.over = 0; }
    if (CN.over >= 2 && CN.q > 0) {
      CN.q--; CN.over = 0; CN.bgKey = "";
      if (CN.q < CANNON_QSEEN) CANNON_QSEEN = CN.q;
      return;
    }
    /* OUT OF TIERS AND STILL OVER BUDGET — the last lever is the pixel count.
       Dropping the ceiling from 2 to 1.5 is 43% fewer pixels per frame. It
       costs one canvas reallocation and the cold-raster pass that follows it
       (about 13 ms, once), which is why it is the LAST thing tried and not
       the first, and why it happens once per page load and never reverses:
       a resolution that oscillates is worse than either resolution. */
    if (CN.over >= 2 && CN.q === 0 && CANNON_DPRCAP > 1.5) {
      CANNON_DPRCAP = 1.5; CN.over = 0;
      cannonResize();
    }
  }

  /**
   * THE LOOP ONLY RUNS WHILE THE ROUND IS VISIBLE.
   *
   * `tabVisible` starts from document.hidden and is rewritten by the
   * visibilitychange listener, so a round opened in a background tab does
   * not step until somebody looks at it, and one whose tab is buried stops.
   *
   * THERE IS DELIBERATELY NO IntersectionObserver HERE. An earlier draft
   * carried an `onScreen` field and a comment about an observer correcting
   * it; the observer was never written, and it would have had nothing to
   * say if it had been: the arena is the store's own .av-ms-modal, which is
   * position:fixed inset:0 at z-index 2147482000. The stage cannot be
   * scrolled out of the viewport, so its intersection ratio is constant.
   * Tab visibility is the only thing that can change, and it is right here.
   */
  function cannonSync() {
    if (!CN) return;
    if (CN.tabVisible) cannonStart(); else cannonStop();
  }
  function cannonStart() {
    if (!CN || CN.running) return;
    CN.running = true; CN.last = 0; CN.acc = 0;
    cannonResize();                       // the box may have changed while we slept
    CN.raf = requestAnimationFrame(cannonLoop);
  }
  function cannonStop() {
    if (!CN || !CN.running) return;
    CN.running = false;
    if (CN.raf) cancelAnimationFrame(CN.raf);
    CN.raf = 0;
  }

  /**
   * IS THE VISITOR TYPING SOMEWHERE?
   * 'r' anywhere on the page must not throw a round away, so guard on the
   * usual editable hosts plus contentEditable (which is inherited, so
   * isContentEditable is the right question) and ignore modifiers —
   * Ctrl+R is reload.
   */
  function cannonKey(e) {
    if (!CN || e.defaultPrevented || e.ctrlKey || e.metaKey || e.altKey) return;
    var t = e.target;
    if (t && t.nodeType === 1) {
      if (t.isContentEditable) return;
      var tag = t.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || tag === "OPTION") return;
    }
    if (e.key === "r" || e.key === "R") { e.preventDefault(); cannonSpawn(); }
  }

  /* ---------------------------------------------------------- draw ---- */

  /** [fill, outline] per baked part id. */
  var CANNON_COLORS = {
    "kodiaq-p1":  ["#3f6fd8", "#8fb6ff"],
    "kodiaq-p3":  ["#d8683f", "#ffb08f"],
    "kodiaq-p20": ["#4fb37a", "#9ff0c2"],
    "kodiaq-p38": ["#b25fd0", "#e0aef2"],
    "kodiaq-p41": ["#d8b23f", "#ffe08f"],
    "kodiaq-p42": ["#3fb9c8", "#9fe8f2"],
    /* level 2 finishes the Kodiaq kit: the two rear quarters take the two
       hues the first six left free, so eight panels are still eight colours */
    "kodiaq-p25": ["#d84f7a", "#ffa8c2"],
    "kodiaq-p40": ["#7a6fd8", "#b8b0ff"],
    /* level 3 is a DIFFERENT CAR, so it is a different palette — cooler and
       a little desaturated, which is what lets the one cyan panel read as
       "do not cut this" instead of as one more colour in a row of ten */
    "a6-p11": ["#4a7fc9", "#a8c8f5"],
    "a6-p15": ["#c96f4a", "#f5b89a"],
    "a6-p27": ["#5a6b86", "#9fb2cf"],
    "a6-p28": ["#4fa88c", "#a2e6d2"],
    "a6-p32": ["#a05fc0", "#d6aae8"],
    "a6-p33": ["#c9a64a", "#f0dc9a"],
    "a6-p55": ["#4fa0b8", "#a4dcec"],
    "a6-p56": ["#b8556b", "#eda3b3"],
    "a6-p67": ["#6f9a4a", "#c2e29a"],
    "a6-p73": ["#8a7fbf", "#c4bcea"]
  };
  var CANNON_FALLBACK = ["#888888", "#cccccc"];

  /**
   * THE CANVAS TAKES ITS SIZE FROM ITS OWN CONTAINER, NOT FROM THE PAGE.
   * If the stage ever measures zero — a display:none ancestor, a section not
   * laid out yet — fall back to a usable size rather than to the HTML
   * default 300x150, which produces no error anywhere.
   *
   * IDEMPOTENT ON PURPOSE: writing cv.width reallocates the backing store and
   * clears the canvas, so this returns early when nothing changed, which
   * makes it safe to call from the resume path as well.
   */
  function cannonResize() {
    if (!CN) return;
    var v = CN.view, r = CN.stage.getBoundingClientRect();
    /* THE PIXEL BUDGET, AND THE ONE CASE WHERE 2 IS NOT AFFORDABLE.
       At dpr 2 a 375x752 stage is a 750x1504 backing store — 1.13 Mpx redrawn
       every frame. Measured (scripts/phone-lab.mjs): on a GPU-rasterized
       canvas that is free at every throttle tested, so 2 stays the default
       and no phone is punished for being a phone. On a device where canvas2d
       falls back to SOFTWARE rasterization it is not free at all: 4x
       throttled, dpr 2 gave 20 fps at the busiest moment and 45 of 73 frames
       over budget; the same run at dpr 1.5 — 0.64 Mpx, 43% fewer pixels —
       gave 30 fps and cut the main-thread frame from 20.3 ms to 13.8.
       So the cap is lowered ONLY for a device that has already proved it
       cannot keep up: cannonGovern() writes CANNON_DPRCAP when it runs out
       of quality tiers. Guessing from `(pointer: coarse)` would have cost
       every good phone half its resolution to help a rare bad one. */
    var dpr = Math.min(CANNON_DPRCAP, window.devicePixelRatio || 1);
    var W = Math.max(240, Math.round(r.width) || 640);
    var H = Math.max(200, Math.round(r.height) || 420);
    if (W === v.W && H === v.H && dpr === v.dpr) return;
    v.dpr = dpr; v.W = W; v.H = H;
    CN.cv.width = Math.round(W * dpr);
    CN.cv.height = Math.round(H * dpr);
    // The whole view span across the canvas, clamped so the drop still fits
    // vertically. VIEW height 5600 mm is the spawn ceiling plus headroom: the
    // high row's lowest point starts at 3300 and the roof is 2261 mm tall.
    //
    // THE DIVISOR IS THE VIEW SPAN, NOT THE PLAYFIELD. The gun stands 1350 mm
    // outside the left wall; the old divisor was the 6 m field alone, which
    // on any width-limited canvas — every phone — put world y = -3000 exactly
    // at screen x = 0 and left nothing on screen for anything outside the
    // arena. x0 is still the screen x of world y = -fieldHalfY, so
    // cannonWorldFrom, the body transform and verify-theme's aimAt are all
    // unchanged by this.
    var span = cannonViewSpan(CN.cfg);
    // THE SKY THE SCALE KEEPS IN FRAME IS PER LEVEL. 5600 on level 1 is the
    // frozen value scripts/prove-cannon-clear.mjs recomputes; levels 2 and 3
    // have a third row and more to show, so they raise it. See CANNON_LEVELS.
    v.scale = Math.min(W / span, (H - 60) / ((CN.level && CN.level.viewTopMm) || 5600));
    v.halfY = CN.cfg.fieldHalfY;
    v.x0 = (W - v.scale * span) / 2 + v.scale * CN.cfg.viewPadLeftMm;
    v.y0 = H - 46;                                       // floor line

    /* ⚠ TWO KINDS OF CACHED GRADIENT LIVE IN THIS FILE AND THEY LOOK
       IDENTICAL IN SOURCE.
         · The PANEL SHEEN gradients are built in BODY-LOCAL MILLIMETRES.
           The CTM carries them, so they survive a resize untouched and they
           rotate with the panel — which is the whole trick that makes the
           highlight sweep across a tumbling template for free.
         · The BARREL gradient and the win SWEEP band are built in SCREEN
           coordinates. The moment the canvas changes size they are lit from
           the wrong place, forever, and the gun keeps drawing as if nothing
           happened. Nothing logs. So they are nulled here and rebuilt on the
           next frame.
       The backdrop bitmap is keyed on the pixel size for the same reason. */
    CN.barrelGrad = null; CN.sweepGrad = null; CN.matGrad = null;
    CN.wallGrad = null; CN.railGrad = null;
    CN.bgKey = "";
    // The backing store was just reallocated, which puts the canvas straight
    // back on Chrome's cold software path — the 4x penalty measured in §9.4.
    if (CN.warm) cannonWarm();
  }

  /**
   * SPARKS, SPLIT 73/27 INTO HOT AND COOL. The hot ones are the cut itself
   * (fast, amber, short); the cool ones are the film going with it (slow,
   * cyan, 1.6x the life), and having two populations is what stops a burst
   * reading as one uniform puff of confetti.
   */
  function cannonSparks(x, y, dx, dy) {
    if (reduce) return;
    var n = Math.round(26 * CN.fx);
    for (var i = 0; i < n; i++) {
      var a = Math.atan2(dy, dx) + Math.PI + (Math.random() - 0.5) * 2.4;
      var hot = Math.random() < 0.73;
      var sp = hot ? 1200 + Math.random() * 5200 : 600 + Math.random() * 1200;
      CN.sparks.push({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp,
                       life: (0.35 + Math.random() * 0.4) * (hot ? 1 : 1.6),
                       t: 0, hot: hot });
    }
  }

  /** Every draw-side pool, advanced on REAL time (they are paint, not physics). */
  function cannonStepFx(dt) {
    var i, s;
    for (i = CN.sparks.length - 1; i >= 0; i--) {
      s = CN.sparks[i];
      s.t += dt;
      if (s.t > s.life) { CN.sparks.splice(i, 1); continue; }
      s.x += s.vx * dt; s.y += s.vy * dt; s.vx -= 9810 * dt * 0.5;
    }
    for (i = CN.shreds.length - 1; i >= 0; i--) {
      s = CN.shreds[i];
      s.t += dt;
      if (s.t > s.life) { CN.shreds.splice(i, 1); continue; }
      s.x += s.vx * dt; s.y += s.vy * dt; s.vx -= 9810 * dt * 0.5;
      s.rot += s.spin * dt;
    }
    for (i = CN.smoke.length - 1; i >= 0; i--) {
      s = CN.smoke[i];
      s.t += dt;
      if (s.t > s.life) { CN.smoke.splice(i, 1); continue; }
      s.x += s.vx * dt; s.y += s.vy * dt;
    }
    for (i = CN.puffs.length - 1; i >= 0; i--) {
      s = CN.puffs[i];
      s.t += dt;
      if (s.t > s.life) CN.puffs.splice(i, 1);
    }
    for (i = CN.ghosts.length - 1; i >= 0; i--) {
      if (CN.t - CN.ghosts[i].t0 > 0.34) CN.ghosts.splice(i, 1);
    }
    /* the recoil charge refills over 260 ms once the shot has resolved, and
       the LED goes lime the moment it is full — the only thing on screen that
       says "you may fire again" */
    if (!CN.shot && CN.charge < 1) CN.charge = Math.min(1, CN.charge + dt / 0.26);

    /* SCREEN SHAKE, resolved to two scalars here so cannonDraw() does two
       adds instead of any maths. 42 Hz, seeded off the clock so it is the
       same jitter for the same frame. */
    if (CN.shk > 0) {
      var age = CN.t - CN.shkT, amp = CN.shk * Math.exp(-age / (CN.shkD || 0.09));
      if (amp < 0.05) { CN.shk = 0; CN.shkX = 0; CN.shkY = 0; }
      else {
        var j = Math.sin(age * 263.9) * 0.35;
        CN.shkX = CN.shkDY * amp + j;         // world +Y is screen right
        CN.shkY = -CN.shkDX * amp - j;        // world +X is screen up
      }
    }
  }

  function cannonAddRing(p, pts) {
    if (!pts || !pts.length) return;
    p.moveTo(pts[0].x, pts[0].y);
    for (var i = 1; i < pts.length; i++) p.lineTo(pts[i].x, pts[i].y);
    p.closePath();
  }
  /**
   * ONE PATH PER BODY, BUILT ONCE, CACHED BY BODY ID. `m.outer` is b.local:
   * the ring relative to the centroid and de-rotated to theta = 0, which the
   * engine never mutates (it rebuilds b.world from it instead). So the path
   * is valid for the body's whole life and the per-frame cost is one
   * setTransform and one fill. Holes go into the SAME path; 'evenodd' cuts
   * them out.
   */
  function cannonPath(b, m) {
    var p = CN.paths[b.id];
    if (p) return p;
    if (!m || !window.Path2D) return null;
    p = new window.Path2D();
    cannonAddRing(p, m.outer);
    for (var i = 0; i < m.holes.length; i++) cannonAddRing(p, m.holes[i]);
    CN.paths[b.id] = p;
    return p;
  }
  function cannonForgetDead() {
    for (var id in CN.paths) if (!CN.meta[id]) delete CN.paths[id];
  }

  /* ================================================================== */
  /* THE PAINT                                                          */
  /* ------------------------------------------------------------------ */
  /**
   * WHAT IS CACHED, AND WHY IT MATTERS MORE THAN ANYTHING ELSE IN HERE.
   *
   * The whole visual rebuild fits inside the frame budget because ONE line
   * changed sign: the per-frame createLinearGradient + full-canvas fillRect
   * that used to paint the background became a single drawImage of a cached
   * ImageBitmap. That is -1.30 ms, measured, and it pays for the mat, the
   * ruler, the dust, the contact shadows, the panel material and the gun,
   * which together come to +1.23. The steady state is a wash.
   *
   * ⚠ NEVER BLIT FROM A PLAIN document.createElement("canvas"). It is
   * software-backed and re-uploads ~3.7 MB every frame: measured at +5.70 ms.
   * A seven-millisecond swing on one line, with no error and no console
   * output. createImageBitmap() is what makes it a texture; the raw canvas is
   * used only for the handful of frames before the (async!) bitmap resolves,
   * and cannonArena()'s first draw runs before it does.
   *
   * IF createImageBitmap IS ABSENT the page keeps TODAY'S gradient fillRect
   * and boots at Q1 — never a plain offscreen blit.
   */
  function cannonBgKey() {
    return CN.cv.width + "x" + CN.cv.height + "@" + CN.L + "q" + CN.q;
  }
  function cannonBuildBg() {
    var key = cannonBgKey();
    if (CN.bgKey === key) return;
    CN.bgKey = key;
    if (CN.bg && CN.bg.close) { try { CN.bg.close(); } catch (e) {} }
    CN.bg = null; CN.bgRaw = null;
    if (!window.createImageBitmap) { CN.q = Math.min(CN.q, 1); return; }

    var d = CN.view.dpr, W = CN.cv.width + Math.round(24 * d), H = CN.cv.height;
    if (W < 8 || H < 8) return;
    var off = document.createElement("canvas");
    off.width = W; off.height = H;
    var g = off.getContext("2d");
    // The offscreen context is a DIFFERENT context and can be poorer than the
    // on-screen one. Without every piece of this the bitmap cannot be built,
    // and the honest answer is today's gradient fillRect, not a broken blit.
    if (!g || typeof g.createRadialGradient !== "function" ||
        typeof g.createLinearGradient !== "function" || !CN.can.img) return;
    var acc = CN.accent, i, j;

    /* ══════════════════════════════════════════════════════════════════
       THE BACKDROP IS NOW DRAWN IN THE SAME WORLD THE GAME IS PLAYED IN.
       ------------------------------------------------------------------
       Every piece of this used to be placed on a fraction of the bitmap's
       height — the "horizon" at H*0.62, the light pool at H*0.86 — while
       the floor the panels actually land on is at v.y0, which at a 1180x700
       stage is H*0.934. So the horizon sat 300 px of canvas ABOVE the floor
       and lit nothing that was standing on it, and the room's brightest
       band ran through empty air. That is a large part of why the frame
       read bottom-heavy: the composition and the playfield were two
       different pictures stacked on one canvas.

       bx()/by() below are sx()/sy() shifted by the 12*d the bitmap is blitted
       at, so anything placed with them lands exactly where the world says.
       THE PARALLAX IS WHY THE SHIFT EXISTS AT ALL: cannonDraw() slides this
       bitmap up to ±10 px with the gun's bearing, so it is built 24*d wider
       than the canvas and drawn from -12*d. Anything world-placed therefore
       drifts by up to 10 px against the live geometry — invisible on a soft
       glow or a wall of shelving, and the reason nothing SHARP and nothing
       the player aims at is baked in here.
       ══════════════════════════════════════════════════════════════════ */
    var v = CN.view, cf = CN.cfg;
    var bx = function (wy) { return (v.x0 + v.scale * (wy + cf.fieldHalfY)) * d + 12 * d; };
    var by = function (wx) { return (v.y0 - v.scale * wx) * d; };
    var fy = Math.max(1, Math.min(H - 1, by(0)));            // THE FLOOR, in bitmap px
    var wallL = bx(-cf.fieldHalfY - cf.wallThickMm);         // outer face, left wall
    var wallR = bx(cf.fieldHalfY);                           // inner face, right wall
    var gunX = bx(cf.cannonY), gunY = by(cf.cannonX);        // the trunnion
    var ceil = Math.max(10 * d, fy * 0.045);                 // the ceiling slab

    // 1. the room, back to front. The stops are keyed to the FLOOR now, so
    //    the wall darkens toward the ceiling and warms into the bed.
    var sky = g.createLinearGradient(0, 0, 0, H);
    sky.addColorStop(0, "#05070e");
    sky.addColorStop(0.35, "#0a111f");
    sky.addColorStop(Math.min(0.98, fy / H), "#131b2d");
    sky.addColorStop(1, "#0a1020");
    g.fillStyle = sky; g.fillRect(0, 0, W, H);

    /* 2. THE RACK, and it now fills the upper two thirds on purpose.
       ------------------------------------------------------------------
       The top ~60% of the frame used to be near-black — the owner's second
       finding. It is filled with the thing that belongs in a PPF shop and
       nothing else: bays of film. Five uprights, four shelves of rolls, each
       roll with a lit top face and a dark core, and every shelf a little
       dimmer and a little narrower toward the top so the wall recedes.
       It is all flat rectangles, baked once, and free forever. */
    /* THE RACK IS SET DRESSING AND IT MUST LOSE EVERY CONTEST WITH A PANEL.
       The first build of it was brighter and perfectly regular — thirteen
       identical lit rolls on four identical shelves — and it read as a block
       of flats behind the game: an even grid of bright rectangles pulls the
       eye exactly as hard as the six coloured shapes it is supposed to sit
       behind. So: low values, a stepped-back alpha per shelf, and a
       DETERMINISTIC stagger (a hash of the row and column, not Math.random —
       the bake must be the same picture every time it is rebuilt) that skips
       roughly one bay in four and varies the heights. Irregular and dim
       reads as depth; regular and bright reads as wallpaper. */
    var bays = 5, shelves = 4;
    var hash = function (a, b) { var n = Math.sin(a * 12.9898 + b * 78.233) * 43758.5453; return n - Math.floor(n); };
    for (i = 0; i <= bays; i++) {
      var ux = W * (i / bays);
      g.fillStyle = "#0c1322";
      g.fillRect(ux - 7 * d, ceil, 14 * d, fy - ceil);
      g.fillStyle = "rgba(120,150,200,.060)";               // one rim per upright
      g.fillRect(ux - 7 * d, ceil, 2.5 * d, fy - ceil);
    }
    for (i = 0; i < shelves; i++) {
      // depth: the top shelf is dimmest and stands furthest back
      var dep = 0.86 - i * 0.13;
      var sy0 = ceil + (fy - ceil) * (0.16 + i * 0.185);
      var rollH = (fy - ceil) * (0.050 + 0.016 * i);
      g.fillStyle = "rgba(8,13,24," + (0.62 + 0.10 * i) + ")";
      g.fillRect(0, sy0, W, 9 * d);
      g.fillStyle = "rgba(130,165,215,.085)";              // the shelf's lit lip
      g.fillRect(0, sy0, W, 1.4 * d);
      for (j = 0; j < 13; j++) {
        var hv = hash(i + 1, j + 1);
        if (hv > 0.76) continue;                           // an empty slot
        var rw = W * (0.030 + 0.018 * hv), rx = W * (0.021 + j * 0.0755);
        var rh = rollH * (0.66 + 0.5 * hash(j + 3, i + 7));
        g.fillStyle = "rgba(20,29,49," + dep + ")";
        g.fillRect(rx, sy0 - rh, rw, rh);
        g.fillStyle = "rgba(32,46,76," + dep + ")";        // the wound edge
        g.fillRect(rx, sy0 - rh, rw * 0.24, rh);
        if (i === shelves - 1) {                           // only the near shelf catches light
          g.fillStyle = "rgba(150,190,240,.045)";
          g.fillRect(rx, sy0 - rh, rw, 1.4 * d);
        }
      }
    }

    /* 2b. HANGING FILM. Four long sheets on a rail, drifting down over the
       rack — the one soft, tall shape in a frame otherwise made of boxes,
       and what stops the upper third reading as a bookcase. */
    var hangY = ceil + (fy - ceil) * 0.05;
    g.fillStyle = "#0e1526"; g.fillRect(0, hangY, W, 5 * d);
    for (i = 0; i < 4; i++) {
      var hx = W * (0.13 + i * 0.245), hw = W * 0.055;
      var hh = (fy - ceil) * (0.30 + (i % 2) * 0.17);
      var hg = g.createLinearGradient(hx, hangY, hx + hw, hangY);
      hg.addColorStop(0, "rgba(90,130,190,.048)");
      hg.addColorStop(0.42, "rgba(150,200,255,.115)");     // the sheet catching light
      hg.addColorStop(1, "rgba(70,105,160,.028)");
      g.fillStyle = hg;
      g.beginPath();
      g.moveTo(hx, hangY);
      g.lineTo(hx + hw, hangY);
      g.lineTo(hx + hw + hw * 0.22, hangY + hh);           // it hangs with a lean
      g.lineTo(hx + hw * 0.10, hangY + hh);
      g.closePath(); g.fill();
    }

    /* 3. THE CEILING, AND THE LAMPS THE SHAFTS COME OUT OF.
       The shafts used to start at y = 0 from nothing, which is why they read
       as a filter rather than as light. Now each one hangs off a housing and
       the beam is brightest at the lamp: the top of the frame explains
       itself, which is the only honest way to fill it. */
    g.fillStyle = "#080d18"; g.fillRect(0, 0, W, ceil);
    g.fillStyle = "rgba(120,150,200,.06)"; g.fillRect(0, ceil - 1.6 * d, W, 1.6 * d);
    g.strokeStyle = "rgba(90,120,170,.10)"; g.lineWidth = 1.4 * d;   // the roof truss
    g.beginPath();
    for (i = 0; i * (W / 14) < W; i++) {
      var tx = i * (W / 14);
      g.moveTo(tx, 0); g.lineTo(tx + W / 14, ceil);
      g.moveTo(tx + W / 14, 0); g.lineTo(tx, ceil);
    }
    g.stroke();

    for (i = 0; i < 3; i++) {
      var lx = W * (0.20 + i * 0.30), lw = W * 0.040, lean = (fy - ceil) * 0.34;
      // the beam: brightest at the housing, gone by the floor
      var bg2 = g.createLinearGradient(lx, ceil, lx + lean, fy);
      bg2.addColorStop(0, "rgba(170,220,255,.115)");
      bg2.addColorStop(0.45, "rgba(150,205,255,.045)");
      bg2.addColorStop(1, "rgba(140,195,255,0)");
      g.fillStyle = bg2;
      g.beginPath();
      g.moveTo(lx, ceil); g.lineTo(lx + lw, ceil);
      g.lineTo(lx + lw + lean, fy); g.lineTo(lx + lean, fy);
      g.closePath(); g.fill();
      // the housing, and the lit tube inside it
      g.fillStyle = "#111a2c";
      g.fillRect(lx - lw * 0.30, ceil - 5 * d, lw * 1.6, 11 * d);
      g.fillStyle = "rgba(206,235,255,.80)";
      g.fillRect(lx - lw * 0.16, ceil + 3 * d, lw * 1.32, 3.2 * d);
      var lg = g.createRadialGradient(lx + lw / 2, ceil + 5 * d, 0,
                                      lx + lw / 2, ceil + 5 * d, lw * 2.4);
      lg.addColorStop(0, "rgba(190,225,255,.22)");
      lg.addColorStop(1, "rgba(190,225,255,0)");
      g.fillStyle = lg;
      g.fillRect(lx - lw * 2, ceil - lw, lw * 5, lw * 4);
    }

    /* 3b. THE MACHINE'S BACK PANEL — the surface the drop zone happens in
       front of. Between the two walls, from the gantry down to the bed, the
       frame had nothing but shop wall: a large dark rectangle with six
       coloured shapes sitting along the bottom of it, which is most of what
       "bottom-heavy" was. This is not clutter added to fill it — it is the
       inside of the machine the panels are being cut on, and giving the
       field its own surface is what separates it from the shop behind and
       gives the upper half somewhere to be.

       It is a smooth vertical gradient plus four reference lines at very low
       alpha — the scale marks down the inside of a plotter's frame. Anything
       busier competes with the panels, which is the one thing set dressing
       must never do. */
    /* IT STOPS AT THE GANTRY, NOT AT THE CEILING, AND THAT IS THE WHOLE
       DIFFERENCE ON A PHONE. At 375 px the scale is set by the WIDTH, so the
       world's 5600 mm ceiling lands less than half way up a 700 px canvas
       and everything above it is room, not machine. Running the back panel
       to the top of the canvas there put a second, empty machine above the
       real one, divided by the gantry — two stacked rooms. Ending it at the
       gantry beam makes the gantry the top of the machine and gives
       everything above it back to the shop, which is what it is.
       ganX is computed exactly as cannonDraw() computes it; if the two ever
       disagree the panel and the beam separate, visibly. */
    var topXb = v.y0 / v.scale;
    var ganXb = Math.min(((CN.level && CN.level.viewTopMm) || 5600) - 150, topXb - 260);
    var panelTop = ganXb > 3000 ? Math.max(ceil, by(ganXb + 260)) : ceil;
    var fL = Math.max(0, wallL), fR = Math.min(W, bx(cf.fieldHalfY + cf.wallThickMm));
    if (fR > fL && fy > panelTop) {
      var bpg = g.createLinearGradient(0, panelTop, 0, fy);
      bpg.addColorStop(0, "rgba(16,24,42,.55)");
      bpg.addColorStop(0.58, "rgba(20,30,52,.45)");
      bpg.addColorStop(1, "rgba(30,44,72,.30)");
      g.fillStyle = bpg;
      g.fillRect(fL, panelTop, fR - fL, fy - panelTop);
      g.strokeStyle = "rgba(150,190,240,.045)"; g.lineWidth = 1.2 * d;
      g.beginPath();
      for (i = 1; i <= 4; i++) {
        var ry = panelTop + (fy - panelTop) * (i / 5);
        g.moveTo(fL + (fR - fL) * 0.02, ry); g.lineTo(fR - (fR - fL) * 0.02, ry);
      }
      g.stroke();
    }

    /* 4. THE FLOOR OF THE ROOM, at the floor line the panels really land on.
       It runs the FULL width, under the gun as well as under the bed, which
       is the thing that stops the machine looking like it is bolted to
       nothing — see §12's mount. The mat is drawn over the middle of it
       every frame; what shows here is the concrete either side. */
    var flr = g.createLinearGradient(0, fy, 0, H);
    flr.addColorStop(0, "#141c2e");
    flr.addColorStop(0.30, "#0d1322");
    flr.addColorStop(1, "#070b16");
    g.fillStyle = flr; g.fillRect(0, fy, W, H - fy);
    g.fillStyle = "rgba(150,190,240,.10)"; g.fillRect(0, fy - 1.4 * d, W, 1.4 * d);

    // 4b. THE LEVEL'S OWN LIGHT, pooled on the bed rather than in mid-air.
    var pool = g.createRadialGradient((wallL + wallR) / 2, fy, 0,
                                      (wallL + wallR) / 2, fy, (fy - ceil) * 1.05);
    pool.addColorStop(0, cannonRgba(acc, 0.19));
    pool.addColorStop(0.55, cannonRgba(acc, 0.055));
    pool.addColorStop(1, cannonRgba(acc, 0));
    g.fillStyle = pool; g.fillRect(0, 0, W, H);

    /* 5. THE GUN'S OWN LIGHT, THROWN ON THE ROOM BEHIND IT.
       ------------------------------------------------------------------
       The owner's first finding: the gun read as a sprite pasted onto the
       scene. A machine that is IN a room spills light on it. This is that
       spill — warm, centred on the trunnion, reaching about a barrel's
       length in every direction — plus the shadow the mounting plate casts
       down onto the floor beside it.

       IT IS BAKED, AND THAT IS THE ENTIRE POINT. The comment on the
       travelling light in cannonDraw() records the measurement that governs
       here: a large-area additive radial gradient painted per frame was the
       most expensive single operation ever tested in this renderer at
       +1.57 ms. The gun does not move, so its light does not either, and a
       thing that never changes belongs in the bitmap that never changes. */
    if (isFinite(gunX) && isFinite(gunY)) {
      var reach = Math.max(40 * d, cf.barrelLenMm * v.scale * d * 4.2);
      var lit = g.createRadialGradient(gunX, gunY, 0, gunX, gunY, reach);
      lit.addColorStop(0, "rgba(255,196,120,.115)");
      lit.addColorStop(0.34, "rgba(255,176,90,.045)");
      lit.addColorStop(1, "rgba(255,176,46,0)");
      g.fillStyle = lit;
      g.fillRect(gunX - reach, gunY - reach, reach * 2, reach * 2);
      // and the plate's shadow on the floor under it, so it has weight
      var shR = Math.max(14 * d, cf.barrelLenMm * v.scale * d * 1.5);
      var shG = g.createRadialGradient(gunX, fy, 0, gunX, fy, shR);
      shG.addColorStop(0, "rgba(2,4,9,.55)");
      shG.addColorStop(1, "rgba(2,4,9,0)");
      g.fillStyle = shG;
      g.fillRect(gunX - shR, fy - shR * 0.34, shR * 2, shR * 0.68);
    }

    // 6. THE VIGNETTE IS BAKED IN. Blitting it as a separate pass measured
    //    +0.40 ms for a thing that never changes. Its centre is the FIELD's
    //    centre now, not the bitmap's, so it frames the action rather than
    //    the canvas.
    var vcx = (wallL + wallR) / 2, vcy = ceil + (fy - ceil) * 0.62;
    var vg = g.createRadialGradient(vcx, vcy, (fy - ceil) * 0.42,
                                    vcx, vcy, (fy - ceil) * 1.32);
    vg.addColorStop(0, "rgba(2,4,9,0)");
    vg.addColorStop(1, "rgba(2,4,9,.58)");
    g.fillStyle = vg; g.fillRect(0, 0, W, H);

    // drawImage accepts BOTH, so the raw canvas covers the frames before the
    // async bitmap resolves. Without it the first frames are blank.
    CN.bgRaw = off;
    var mine = key;
    try {
      window.createImageBitmap(off).then(function (bm) {
        if (!CN || CN.bgKey !== mine) { try { bm.close(); } catch (e) {} return; }
        CN.bg = bm; CN.bgRaw = null;
      })["catch"](function () {});
    } catch (e) {}
  }

  /** "#rrggbb" + alpha -> "rgba(r,g,b,a)". Six lines beats a colour library. */
  function cannonRgba(hex, a) {
    var h = hex.charAt(0) === "#" ? hex.slice(1) : hex;
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    return "rgba(" + ((n >> 16) & 255) + "," + ((n >> 8) & 255) + "," + (n & 255) + "," + a + ")";
  }
  /** Multiply a hex colour toward black (<1) or white (>1). */
  function cannonShade(hex, k) {
    var h = hex.charAt(0) === "#" ? hex.slice(1) : hex;
    var n = parseInt(h, 16);
    function ch(v) { return Math.max(0, Math.min(255, Math.round(k <= 1 ? v * k : v + (255 - v) * (k - 1)))); }
    return "rgb(" + ch((n >> 16) & 255) + "," + ch((n >> 8) & 255) + "," + ch(n & 255) + ")";
  }

  /**
   * ONE 128x64 CONTACT-SHADOW BITMAP, REUSED FOR EVERY BODY.
   *
   * It is the only cue that tells the eye where a falling panel is going to
   * land, and it is what makes a six-panel entrance readable instead of
   * chaotic. TEMPLATES ONLY, never fragments — the cost is then bounded by
   * the panel count (6 to 10) and never by the 32-body cap.
   * It survives prefers-reduced-motion untouched: it is lighting, not motion.
   */
  function cannonBuildBlob() {
    if (CN.blob !== null) return;
    CN.blob = false;
    var off = document.createElement("canvas");
    off.width = 128; off.height = 64;
    var g = off.getContext("2d");
    if (!g || typeof g.createRadialGradient !== "function" || !CN.can.img) return;
    var rg = g.createRadialGradient(64, 32, 0, 64, 32, 32);
    rg.addColorStop(0, "rgba(0,0,0,.62)");
    rg.addColorStop(0.55, "rgba(0,0,0,.22)");
    rg.addColorStop(1, "rgba(0,0,0,0)");
    g.fillStyle = rg;
    g.save(); g.translate(64, 32); g.scale(2, 1); g.translate(-64, -32);
    g.fillRect(0, 0, 128, 64); g.restore();
    CN.blob = off;
    if (window.createImageBitmap) {
      try {
        window.createImageBitmap(off).then(function (bm) { if (CN) CN.blob = bm; })["catch"](function () {});
      } catch (e) {}
    }
  }

  /**
   * ONE 256x256 LIGHT BITMAP, AND IT IS WHY THE IMPACT CAN BE BIG.
   * ======================================================================
   * THE MEASUREMENT THIS EXISTS BECAUSE OF is the one recorded on the flash
   * in cannonDraw(): a per-frame createRadialGradient + fill measured
   * +0.149 ms at 650 mm and +1.57 ms at 2000 mm — a tenfold cliff on what
   * looked like a taste decision, and the most expensive single operation
   * ever tested in this renderer. That cliff is what capped the money moment
   * at 700 mm and made it read modestly against the frame.
   *
   * IT IS THE GRADIENT, NOT THE AREA. A drawImage of a pre-baked radial is a
   * blit: the browser scales a texture it already has, with no per-frame
   * gradient construction and no per-frame ramp evaluation. The contact
   * shadow has always exploited this — cannonBuildBlob() blits one bitmap
   * for every body in the field and costs nothing. So the flash is baked
   * once, here, and blitted. The impact can then be MORE than twice the
   * radius it was and cost LESS than it did.
   *
   * It is white-hot in the middle and amber at the edge, so blitting it with
   * globalCompositeOperation "lighter" gives a muzzle-flash colour ramp for
   * free; alpha alone controls how hard it lands. The trunnion halo — the
   * gun's own LIVE light, as opposed to the static pool cannonBuildBg()
   * bakes onto the wall — is the same bitmap at a small size.
   *
   * Like the contact shadow it is LIGHTING, not motion, so it survives
   * prefers-reduced-motion; what reduced motion turns off is the beat it is
   * drawn on, in cannonDraw().
   */
  function cannonBuildFlash() {
    if (CN.flash !== null) return;
    CN.flash = false;
    var off = document.createElement("canvas");
    off.width = 256; off.height = 256;
    var g = off.getContext("2d");
    if (!g || typeof g.createRadialGradient !== "function" || !CN.can.img) return;
    var rg = g.createRadialGradient(128, 128, 0, 128, 128, 128);
    rg.addColorStop(0.00, "rgba(255,252,238,1)");
    rg.addColorStop(0.10, "rgba(255,244,206,.92)");
    rg.addColorStop(0.26, "rgba(255,206,116,.46)");
    rg.addColorStop(0.52, "rgba(255,168,52,.15)");
    rg.addColorStop(0.78, "rgba(255,140,40,.04)");
    rg.addColorStop(1.00, "rgba(255,140,40,0)");
    g.fillStyle = rg;
    g.fillRect(0, 0, 256, 256);
    CN.flash = off;
    if (window.createImageBitmap) {
      try {
        window.createImageBitmap(off).then(function (bm) { if (CN) CN.flash = bm; })["catch"](function () {});
      } catch (e) {}
    }
  }

  /** Blit the baked light at a world point, radius in world mm. One call, no
   *  gradient, no state left behind. `a` is the peak alpha. */
  function cannonLight(ctx, cx, cy, rPx, a) {
    if (!CN.flash || !CN.can.img || a <= 0.004) return;
    var prev = ctx.globalCompositeOperation;
    ctx.globalCompositeOperation = "lighter";
    ctx.globalAlpha = a;
    ctx.drawImage(CN.flash, cx - rPx, cy - rPx, rPx * 2, rPx * 2);
    ctx.globalAlpha = 1;
    ctx.globalCompositeOperation = prev;
  }

  /**
   * THE FILM SHEEN — a linear gradient in BODY-LOCAL MILLIMETRES, cached per
   * part id. Because it lives in local coordinates the CTM rotates it, so the
   * highlight sweeps across a panel as it tumbles, for free, with no
   * per-frame gradient construction anywhere.
   * (Contrast the BARREL gradient, which is in screen space and must be
   * rebuilt on resize. The two look the same in source. They are not.)
   */
  function cannonSheenFor(m, base) {
    var s = CN.sheen[m.partId];
    if (s) return s;
    var minx = 1e9, maxx = -1e9, miny = 1e9, maxy = -1e9, p = m.outer, i;
    for (i = 0; i < p.length; i++) {
      if (p[i].x < minx) minx = p[i].x; if (p[i].x > maxx) maxx = p[i].x;
      if (p[i].y < miny) miny = p[i].y; if (p[i].y > maxy) maxy = p[i].y;
    }
    var g;
    try {
      if (!CN.can.lin) throw 0;
      g = CN.ctx.createLinearGradient(minx, miny, maxx, maxy);
      g.addColorStop(0, cannonShade(base, 1.30));
      g.addColorStop(0.42, base);
      g.addColorStop(0.78, cannonShade(base, 0.74));
      g.addColorStop(1, cannonShade(base, 0.92));
    } catch (e) { g = base; }
    CN.sheen[m.partId] = g;
    return g;
  }

  /**
   * THE WHOLE FRAME.
   *
   * THE ONE TRANSFORM IN THE PROJECT is the per-body setTransform below:
   * world +Y -> screen right, world -X -> screen down. The determinant is
   * s*s > 0, so nothing is mirrored and a template lands the way the SVG
   * drew it.
   *
   * SCREEN SHAKE IS TWO ADDS. shkX/shkY go into sx()/sy() and into the two
   * translation terms of the body transform, and nowhere else. There is no
   * DOM transform anywhere in this game.
   */
  function cannonDraw() {
    if (!CN) return;
    var ctx = CN.ctx, v = CN.view, c = CN.cfg, cv = CN.cv, d = v.dpr;
    var T = CN.t, Q = CN.q, acc = CN.accent, i, k, m, b;
    var shx = CN.shkX * d, shy = CN.shkY * d;
    function sx(wy) { return (v.x0 + v.scale * (wy + c.fieldHalfY)) * d + shx; }
    function sy(wx) { return (v.y0 - v.scale * wx) * d + shy; }
    /* THE DETAIL GATE. At scale 0.0456 one CSS pixel is 21.9 mm and the
       95 mm fin spacing is 4.3 px — mush. Below this, the small machined
       detail is not drawn at all rather than drawn as noise. */
    var DETAIL = v.scale > 0.058;
    var hy = c.fieldHalfY;
    var mm = v.scale * d;                       // one world mm, in device px

    /* ---------------------------------------- THE DANGER, DECIDED FIRST --
       IT IS RESOLVED BEFORE THE FIRST PIXEL, NOT DOWN IN SECTION 12 WITH THE
       REST OF THE GUN, because the panels are painted long before the aim
       line is and the customer's panel has to go red ON THE SAME FRAME its
       reticle does. Read it a section later and the outline lags the line by
       one frame — 16 ms of the two halves of one warning disagreeing, which
       is precisely the flicker that makes a warning look like a glitch.

       It is one cannonAimLethal() call per frame: a ray against at most
       fourteen rings, the same work the preview's first leg already does.
       On a level with no protected panel it returns on its first line. */
    var aimAt = (CN.pointer.has && !CN.won) ? cannonWorldFrom(CN.pointer.x - CN.shkX, CN.pointer.y - CN.shkY) : null;
    var lethalAt = aimAt ? cannonAimLethal(aimAt.x, aimAt.y) : null;
    CN.aimDanger = lethalAt ? 1 : 0;
    cannonDanger(CN.aimDanger);
    var grazeLit = CN.grazeT >= 0 && (T - CN.grazeT) < 0.6;

    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.globalAlpha = 1;
    ctx.globalCompositeOperation = "source-over";

    /* ---------------------------------------------------- 1. the room -- */
    cannonBuildBg();
    var bmp = CN.can.img ? (CN.bg || CN.bgRaw) : null;
    if (bmp) {
      // parallax driven by the GUN's bearing, so it reads as a camera
      // following the barrel rather than as a screensaver
      var px = Q >= 1 ? Math.max(-1, Math.min(1, CN.gunBr / 1.85)) * 10 * d : 0;
      ctx.drawImage(bmp, -12 * d + px, 0);
    } else {
      // the fallback is TODAY'S code, exactly: a linear gradient and a
      // fillRect. Never a blit from a plain offscreen canvas (+5.70 ms).
      if (CN.can.lin) {
        var grd = ctx.createLinearGradient(0, 0, 0, cv.height);
        grd.addColorStop(0, "#0a0f1c"); grd.addColorStop(1, "#131a2a");
        ctx.fillStyle = grd;
      } else { ctx.fillStyle = "#0d1424"; }
      ctx.fillRect(0, 0, cv.width, cv.height);
    }

    /* ------------------------------------------------------- 2. dust --- */
    if (CN.dust) {
      var dn = Q >= 2 ? CN.dust.length : Q >= 1 ? 12 : 0;
      ctx.fillStyle = "#bcd8ff";
      for (i = 0; i < dn; i++) {
        var mo = CN.dust[i];
        var dx0 = reduce ? mo.x : (mo.x + T * 0.006 * mo.s) % 1;
        var dy0 = reduce ? mo.y : (mo.y + T * 0.011 * mo.s) % 1;
        ctx.globalAlpha = mo.a * 1.7 * (reduce ? 0.6 : (0.6 + 0.4 * Math.sin(T * 1.4 + i)));
        var r0 = (1 + mo.s) * d;
        ctx.fillRect(dx0 * cv.width, dy0 * cv.height, r0, r0);
      }
      ctx.globalAlpha = 1;
    }

    /* --------------------------------------- 3. the mat and the ruler -- */
    /* THE PLOTTER BED. Four operations, measured at 0.00 ms, and between them
       they say more about what this shop does than anything else on screen:
       a cutting mat, a lit cut line with its own shadow so it reads as an
       EDGE rather than a highlight, and a ruler in millimetres — because the
       world already is in millimetres, 1:1. */
    var matL = sx(-hy), matR = sx(hy), matY = sy(0);
    if (!CN.matGrad) {
      try {
        if (!CN.can.lin) throw 0;
        var mg = ctx.createLinearGradient(0, matY, 0, cv.height);
        mg.addColorStop(0, "#26344f");
        mg.addColorStop(0.35, "#182136");
        mg.addColorStop(1, "#0b1120");
        CN.matGrad = mg;
      } catch (e) { CN.matGrad = "#141d2f"; }
    }
    ctx.fillStyle = CN.matGrad;
    ctx.fillRect(matL, matY, matR - matL, cv.height - matY);

    ctx.strokeStyle = "rgba(6,10,18,.85)"; ctx.lineWidth = 3 * d;
    ctx.beginPath(); ctx.moveTo(matL, matY + 2.4 * d); ctx.lineTo(matR, matY + 2.4 * d); ctx.stroke();
    ctx.strokeStyle = cannonRgba(acc, 0.18); ctx.lineWidth = 7 * d;
    ctx.beginPath(); ctx.moveTo(matL, matY); ctx.lineTo(matR, matY); ctx.stroke();
    ctx.strokeStyle = cannonRgba(acc, 0.95); ctx.lineWidth = 1.8 * d;
    ctx.beginPath(); ctx.moveTo(matL, matY); ctx.lineTo(matR, matY); ctx.stroke();

    ctx.strokeStyle = cannonRgba(acc, 0.45); ctx.lineWidth = 1.2 * d;
    ctx.beginPath();
    for (var tk = -3000; tk <= 3000; tk += 250) {
      var major = (tk % 1000) === 0;
      if (!major && !DETAIL) continue;
      var tx0 = sx(tk);
      ctx.moveTo(tx0, matY + 3 * d);
      ctx.lineTo(tx0, matY + (major ? 17 : 7) * d);
    }
    ctx.stroke();

    /* ----------------------------------------------- 4. scorch decals -- */
    if (Q >= 1) {
      ctx.fillStyle = "rgba(8,10,18,.42)";
      for (i = 0; i < CN.scorch.length; i++) {
        var sc = CN.scorch[i];
        ctx.beginPath();
        if (!CN.can.ell) {
          // no ctx.ellipse (old Safari): a flattened arc is not worth a
          // save/scale/restore for a decal, so it is a small round scorch
          ctx.arc(sc.floor ? sx(sc.y) : sx(hy), sc.floor ? matY : sy(sc.x), 60 * mm, 0, 6.2832);
        } else if (sc.floor) ctx.ellipse(sx(sc.y), matY, 170 * mm, 44 * mm, 0, 0, 6.2832);
        else ctx.ellipse(sx(hy), sy(sc.x), 44 * mm, 170 * mm, 0, 0, 6.2832);
        ctx.fill();
      }
    }

    /* -------------------------------------------- 5. contact shadows --- */
    var bs = CN.world.bodies, s = v.scale * d;
    if (Q >= 1) {
      cannonBuildBlob();
      if (CN.blob && CN.can.img) {
        for (i = 0; i < bs.length; i++) {
          b = bs[i]; m = CN.meta[b.id];
          if (!m || m.kind !== "template") continue;
          var hgt = Math.max(0, b.cx - 400);
          var al = Math.max(0, 1 - hgt / 1600);
          if (al <= 0.02) continue;
          var bb = b.world.box;
          var wpx = ((bb.maxX - bb.minX) + (bb.maxY - bb.minY)) * 0.42 * mm * (1 + hgt / 2600);
          ctx.globalAlpha = al * 1.0;
          ctx.drawImage(CN.blob, sx(b.cy) - wpx, matY - wpx * 0.22, wpx * 2, wpx * 0.44);
        }
        ctx.globalAlpha = 1;
      }
    }

    /* ---------------------------------- 6. the statics: walls, pillars -- */
    if (CN.world.statics.length) {
      var tw = c.wallThickMm * mm;
      /* THE WALL IS NOT A FLAT BLOCK ANY MORE.
         It used to be one #121a2b fillRect, and it is the surface the gun
         stands against — so a flat fill was the single largest reason the
         gun read as a sprite on a backdrop rather than a machine in a room:
         the light cannonBuildBg() bakes around the trunnion was painted over
         by an opaque slab exactly where it mattered. A cached vertical
         gradient costs the same one fillRect and lets the slab carry the
         light instead of erasing it. Cached, because it is in SCREEN space —
         cannonResize() nulls it beside the barrel and the sweep. */
      if (!CN.wallGrad) {
        try {
          if (!CN.can.lin) throw 0;
          var wg = ctx.createLinearGradient(0, 0, 0, matY);
          wg.addColorStop(0, "#0b1120");
          wg.addColorStop(0.68, "#141d31");
          wg.addColorStop(1, "#1b2740");
          CN.wallGrad = wg;
        } catch (e) { CN.wallGrad = "#121a2b"; }
      }
      ctx.fillStyle = CN.wallGrad;
      ctx.fillRect(matL - tw, 0, tw, matY);
      ctx.fillRect(matR, 0, tw, matY);
      ctx.strokeStyle = cannonRgba(acc, 0.30); ctx.lineWidth = 1.5 * d;
      ctx.beginPath();
      ctx.moveTo(matL, 0); ctx.lineTo(matL, matY);
      ctx.moveTo(matR, 0); ctx.lineTo(matR, matY);
      ctx.stroke();

      var pil = CN.level.pillars;
      if (pil) {
        for (i = 0; i < pil.length; i++) {
          var pp = pil[i], phw = pp.w / 2;
          var px0 = sx(pp.y - phw), px1 = sx(pp.y + phw);
          var py0 = sy(pp.x0 + pp.h), py1 = sy(pp.x0);
          ctx.fillStyle = "#1a2436";
          ctx.fillRect(px0, py0, px1 - px0, py1 - py0);
          ctx.strokeStyle = "#42536f"; ctx.lineWidth = 2 * d;
          ctx.strokeRect(px0, py0, px1 - px0, py1 - py0);
          if (DETAIL) {
            ctx.strokeStyle = cannonRgba(CN_CYAN, 0.5); ctx.lineWidth = 1.4 * d;
            ctx.beginPath();
            for (k = 1; k * 800 < pp.h; k++) {
              var pyk = sy(pp.x0 + k * 800);
              ctx.moveTo(px0 + 3 * d, pyk); ctx.lineTo(px1 - 3 * d, pyk);
            }
            ctx.stroke();
          }
        }
      }
    }

    /* ------------------------------------------- 6b. the plotter gantry - */
    /* A beam across the top of the bed with a lit underside. It is what makes
       the field read as a MACHINE the panels are being cut on rather than as
       a dark rectangle they happen to be falling through — and it gives the
       drop somewhere to come from. During the first second each panel's spawn
       column is marked under it: the head positioning itself. */
    /* THE GANTRY CARRIES THE TOP OF THE FRAME NOW.
       ------------------------------------------------------------------
       THE OWNER'S SECOND FINDING: the action lives in the lower third and
       the top 60% was near-empty dark. The camera cannot answer it —
       v.scale and v.y0 are recomputed verbatim by
       scripts/prove-cannon-clear.mjs, so moving them would leave that proof
       measuring a gun position the game never draws. The answer is
       therefore the one the brief allows: put something up there that
       BELONGS. cannonBuildBg() fills the wall behind (racks, hanging film,
       a ceiling and the lamps the shafts fall out of); this is the machine
       in front of it.

       It was a 130 mm bar with a cyan underline. It is now a 260 mm beam on
       two end brackets, with a carriage parked over the middle of the bed, a
       power chain hanging off it and a lit underside — a real gantry, and
       the thing the panels are dropping off. Fourteen operations, all flat
       fills and one stroke, at the top of a frame that had nothing in it. */
    var topX = v.y0 / v.scale;                        // world x of the canvas top
    var ganX = Math.min((CN.level.viewTopMm || 5600) - 150, topX - 260);
    if (ganX > 3000) {
      var ganH = 260, ganY0 = sy(ganX + ganH), ganY1 = sy(ganX);
      // the end brackets first, so the beam caps them
      ctx.fillStyle = "#101827";
      ctx.fillRect(matL - 14 * d, ganY0 - 26 * d, 14 * d, (ganY1 - ganY0) + 26 * d);
      ctx.fillRect(matR, ganY0 - 26 * d, 14 * d, (ganY1 - ganY0) + 26 * d);
      // the beam, lit along its top and dark along its underside
      ctx.fillStyle = "#141d31";
      ctx.fillRect(matL, ganY0, matR - matL, ganY1 - ganY0);
      ctx.fillStyle = "rgba(176,205,250,.16)";
      ctx.fillRect(matL, ganY0, matR - matL, 2.2 * d);
      ctx.fillStyle = "rgba(4,7,14,.55)";
      ctx.fillRect(matL, ganY1 - 3 * d, matR - matL, 3 * d);
      ctx.strokeStyle = cannonRgba(acc, 0.55); ctx.lineWidth = 1.6 * d;
      ctx.beginPath(); ctx.moveTo(matL, ganY1); ctx.lineTo(matR, ganY1); ctx.stroke();
      if (DETAIL) {
        ctx.strokeStyle = "rgba(20,26,42,.8)"; ctx.lineWidth = 1.2 * d;
        ctx.beginPath();
        for (k = -11; k <= 11; k++) { var gtx = sx(k * 260); ctx.moveTo(gtx, ganY0); ctx.lineTo(gtx, ganY1); }
        ctx.stroke();
        /* THE CARRIAGE — the cutting head, parked over the middle of the
           bed. It is the one object up there with a shape, and it is what
           makes the beam read as a machine rather than as a shelf. */
        var carW = 620 * mm, carX = sx(-250);
        ctx.fillStyle = "#1c2740";
        ctx.fillRect(carX - carW / 2, ganY0 - 10 * d, carW, (ganY1 - ganY0) + 22 * d);
        ctx.fillStyle = "rgba(176,205,250,.22)";
        ctx.fillRect(carX - carW / 2, ganY0 - 10 * d, carW, 2 * d);
        ctx.fillStyle = cannonRgba(acc, 0.75);            // the head's own lamp
        ctx.fillRect(carX - carW * 0.13, ganY1 + 8 * d, carW * 0.26, 4 * d);
        // the power chain, looping back to the left end
        ctx.strokeStyle = "rgba(40,54,84,.9)"; ctx.lineWidth = 5 * d;
        ctx.beginPath();
        ctx.moveTo(carX - carW / 2, ganY0 + 4 * d);
        ctx.lineTo(matL + (carX - matL) * 0.42, ganY0 - 30 * d);
        ctx.lineTo(matL + 8 * d, ganY0 - 6 * d);
        ctx.stroke();
      }
      if (CN.t < 1.2) {
        ctx.strokeStyle = cannonRgba(CN_CYAN, 0.25); ctx.lineWidth = 1.6 * d;
        ctx.beginPath();
        for (i = 0; i < bs.length; i++) {
          m = CN.meta[bs[i].id];
          if (!m || m.kind !== "template") continue;
          var gx = sx(bs[i].cy);
          ctx.moveTo(gx, ganY1); ctx.lineTo(gx, sy(bs[i].cx));
        }
        ctx.stroke();
      }
    }

    /* ------------------------------------------------- 7. the bodies --- */
    /* THE MATERIAL — sheen, kerf and lip — IS FOR TEMPLATES ONLY. Granting
       it to all 32 bodies measured +0.8 ms, and nobody reads material on a
       200 mm shard that lives for two seconds. This condition is one moved
       line away from being silently undone, so verify-theme.mjs asserts it
       rather than trusting this comment. */
    var slug = CN.shot;
    var litLeft = slug ? (CN.fx > 0.6 ? 2 : 1) : 0;
    var sweepX = -1, protX = -1, protY = 0;
    if (CN.winT >= 0 && !reduce) {
      var wu = (T - CN.winT - 0.10) / 0.75;
      if (wu >= 0 && wu <= 1) sweepX = matL - 200 * d + (matR - matL + 400 * d) * wu;
    }

    for (i = 0; i < bs.length; i++) {
      b = bs[i]; m = CN.meta[b.id];
      if (!m) continue;
      var path = cannonPath(b, m);
      if (!path) continue;
      var isT = m.kind === "template";

      /* THE SETTLE WOBBLE IS DRAWN, NEVER WRITTEN BACK. If theta_drawn ever
         reached b.theta, the hit test, the solver, prove-settle, prove-nofloat
         and prove-reproducible would all stop describing the same game — and
         three of them would keep passing. */
      var th = b.theta;
      if (isT && !reduce && m.wobT >= 0) {
        var wt = T - m.wobT;
        if (wt < 0.32) th += 0.022 * m.wob * Math.exp(-wt / 0.11) * Math.sin(6.2832 * 11 * wt);
        else m.wobT = -9;
      }
      var cos = Math.cos(th), sin = Math.sin(th);
      var ex = (v.x0 + v.scale * (b.cy + v.halfY)) * d + shx;
      var ey = (v.y0 - v.scale * b.cx) * d + shy;

      /* the intro fade — draw-only, and it never touches m.alpha, which the
         fragment fade owns */
      var al2 = m.alpha;
      if (isT && CN.t < 1.2) {
        var iu = (CN.t - m.intro) / 0.18;
        al2 *= iu <= 0 ? 0 : iu >= 1 ? 1 : iu;
      }
      if (al2 <= 0.004) continue;

      var col = CANNON_COLORS[m.partId] || CANNON_FALLBACK;

      if (isT && Q >= 2 && !v.wire) {
        /* THE LIP — thickness without a second fill. A 6 px perimeter STROKE
           offset down-SCREEN shows only along the panel's lower edges (the
           upper ones are covered by the face), which is exactly what
           thickness looks like, at a stroke's price rather than a fill's.
           The f term is offset, NOT a local translate: the extrude has to
           point down-screen whatever the panel's rotation, and a local
           translate would rotate the shadow with the panel. */
        ctx.setTransform(s * sin, -s * cos, s * cos, s * sin, ex, ey + 2.5 * d);
        ctx.lineWidth = 6 / s; ctx.strokeStyle = "#05070c";
        ctx.globalAlpha = al2 * 0.5;
        ctx.stroke(path);
      }

      ctx.setTransform(s * sin, -s * cos, s * cos, s * sin, ex, ey);
      ctx.globalAlpha = al2;
      if (!v.wire) {
        ctx.fillStyle = (isT && Q >= 2) ? cannonSheenFor(m, col[0]) : col[0];
        ctx.fill(path, "evenodd");
      }
      if (isT && Q >= 2) {
        // THE KERF: a dark cut under a bright film edge is literally what a
        // cut line looks like.
        ctx.lineWidth = 3.4 / s; ctx.strokeStyle = "rgba(8,12,20,.55)";
        ctx.stroke(path);
      }
      ctx.lineWidth = (isT ? 1.6 : 1.1) / s;
      ctx.strokeStyle = (sweepX >= 0 && Math.abs(ex - sweepX) < 40 * d) ? CN_LIME : col[1];
      ctx.stroke(path);

      /* THE PROTECTED PANEL — the only cyan object in the field, until the
         moment it is cut, when it is the only red one. */
      if (isT && m.protect) {
        protX = ex; protY = ey - (b.world.box.maxX - b.cx) * mm - 26 * d;
        var scrapped = CN.scrapT >= 0 && (T - CN.scrapT) < 0.7;
        /* THREE STATES ON ONE OUTLINE, AND THE COLOURS ARE THE WHOLE MESSAGE.
           cyan = the standing rule. AMBER = it was just struck and survived
           (cannonGraze) — amber because the round is still alive and red here
           would be a lie the player would believe. RED, PULSING = the shot you
           are lining up right now cuts it. The pulse is what carries at 11 px
           on a phone; it is one cos() and it stops under reduced motion. */
        var danger = CN.aimDanger && !scrapped && !grazeLit;
        var puls = danger ? (reduce ? 1 : 0.72 + 0.28 * Math.cos(T * 11)) : 1;
        ctx.lineWidth = (scrapped ? 5 : danger ? 5.2 : grazeLit ? 4.4 : 3.2) / s;
        ctx.strokeStyle = scrapped ? "#f87171" : danger ? CN_DANGER : grazeLit ? CN_AMBER : CN_CYAN;
        ctx.globalAlpha = al2 * 0.85 * puls; ctx.stroke(path);
        if (CN.can.clip) {
        ctx.save();
        ctx.clip(path, "evenodd");
        ctx.strokeStyle = scrapped ? "rgba(248,113,113,0.22)"
          : danger ? "rgba(255,59,59,0.30)"
          : grazeLit ? "rgba(255,176,46,0.20)" : "rgba(53,224,232,0.14)";
        ctx.lineWidth = 34 / s;
        ctx.beginPath();
        for (k = -9; k < 9; k++) { ctx.moveTo(k * 300, -4000); ctx.lineTo(k * 300 + 8000, 4000); }
        ctx.stroke();
        ctx.restore();
        }
        ctx.globalAlpha = al2;
      }

      /* THE RUBBER PANEL, MARKED BEFORE IT MOVES.
         A player who only finds out a panel bounces by watching it bounce has
         been ambushed, not challenged — and the whole point of the mechanic
         ("kad sunkiau butu pataikyt") is that the player PLANS around it. So
         it carries a dashed magenta outline in the one colour nothing else in
         this game uses, and at full detail a cross-hatch clipped to the panel
         — leaning the other way from the protected panel's, so the two are
         never confused at a glance. Dashed because "not solid" is what a
         dashed line has meant on every drawing anybody has ever read. */
      if (isT && m.bouncy && Q >= 2) {
        ctx.strokeStyle = CN_RUBBER;
        ctx.lineWidth = 3.0 / s;
        ctx.globalAlpha = al2 * 0.9;
        if (ctx.setLineDash) ctx.setLineDash([70 / s, 52 / s]);
        ctx.stroke(path);
        if (ctx.setLineDash) ctx.setLineDash([]);
        if (DETAIL && CN.can.clip) {
          ctx.save();
          ctx.clip(path, "evenodd");
          ctx.strokeStyle = "rgba(255,110,199,0.13)";
          ctx.lineWidth = 26 / s;
          ctx.beginPath();
          for (k = -9; k < 9; k++) { ctx.moveTo(k * 300 + 8000, -4000); ctx.lineTo(k * 300, 4000); }
          ctx.stroke();
          ctx.restore();
        }
        ctx.globalAlpha = al2;
      }

      /* THE TRAVELLING LIGHT. While a shot is in flight the nearest one or
         two templates take ONE extra stroke of the path already installed
         under the current transform.
         THE CAP IS THE WHOLE TRICK. Uncapped across 15 bodies: +0.52/+0.97 ms.
         At 3: +0.18/+0.24. At 1: +0.02/+0.14. And the intuitive alternative —
         one big additive radial disc over the neighbourhood — measured
         +1.57 ms, the most expensive single operation tested. LARGE-AREA
         ADDITIVE GRADIENT FILLS, NOT GEOMETRY, ARE WHAT COST. */
      /* THE RAMP IS THE ANTICIPATION. It used to be linear in distance, so
         the nearest panel glowed faintly for the whole flight and there was
         no moment before the hit — the impact arrived with nothing in front
         of it. Squared, over a longer reach and brighter at the end, the
         same single stroke ramps hard in the last few hundred millimetres:
         the panel lights up just before it dies. That is a beat of
         anticipation for no extra operation at all — the reason it is worth
         having is that it is the ONLY thing on screen between the click and
         the bang, and the bang is the money moment. */
      if (isT && litLeft > 0 && slug) {
        var dd = Math.hypot(b.cx - slug.x, b.cy - slug.y);
        if (dd < 2400) {
          litLeft--;
          var near = 1 - dd / 2400;
          ctx.strokeStyle = "#fff8dc"; ctx.lineWidth = (2.6 + 4.4 * near * near) / s;
          ctx.globalAlpha = al2 * Math.min(0.95, 0.20 + 1.15 * near * near);
          ctx.stroke(path);
        }
      }
      ctx.globalAlpha = 1;
    }
    ctx.setTransform(1, 0, 0, 1, 0, 0);

    /* THE ONLY TEXT ON THE CANVAS IN THE WHOLE GAME, and it earns its place:
       a cyan outline says "this one is not like the others", but only a word
       says WHICH WAY it is different. Everything else the player has to read
       is DOM, where it costs no frame time at all. */
    /* THE GATE DROPPED THE `DETAIL` HALF WHEN THE INTERLOCK WENT. At a small
       scale this used to disappear entirely, which was survivable while the
       cannon physically refused the shot and merely annoying to read. It is
       not survivable now: the words are the penalty notice. Only CN.can.text
       (a real capability check) still gates it. */
    if (protX >= 0 && CN.can.text) {
      var scrapNow = CN.scrapT >= 0 && (T - CN.scrapT) < 0.7;
      var dangNow = CN.aimDanger && !scrapNow && !grazeLit;
      var scrapCol = scrapNow ? "#f87171" : dangNow ? CN_DANGER : grazeLit ? CN_AMBER : CN_CYAN;
      ctx.font = ((dangNow ? 13 : 11) * d) + "px ui-monospace, SFMono-Regular, Menlo, monospace";
      ctx.textAlign = "center";
      ctx.fillStyle = scrapCol;
      ctx.fillText(scrapNow ? "SCRAP"
        : dangNow ? "⚠ DO NOT CUT — GAME OVER"
        : grazeLit ? "HELD — NO SCRAP" : "DO NOT CUT", protX, protY);
      ctx.strokeStyle = cannonRgba(scrapCol, 0.7);
      ctx.lineWidth = 1 * d;
      ctx.beginPath();
      var ulw = (dangNow ? 82 : 36) * d;
      ctx.moveTo(protX - ulw, protY + 4 * d);
      ctx.lineTo(protX + ulw, protY + 4 * d);
      ctx.stroke();
      ctx.textAlign = "start";
    }

    /* ------------------------------------------ 8. the cut-line ghost -- */
    /* THE BRAND BEAT. The destroyed panel's own cached Path2D, stroked once
       more in white at its dying pose, growing 9% and fading over 340 ms: the
       template lifts off the film AS A CUT LINE while its shards fly out of
       it. Under reduced motion it holds scale 1.0 — it is a fade, not motion. */
    for (i = 0; i < CN.ghosts.length; i++) {
      var gh = CN.ghosts[i], gu = (T - gh.t0) / 0.34;
      if (gu < 0 || gu > 1) continue;
      var gs = s * (reduce ? 1 : (1 + 0.09 * gu));
      var gc = Math.cos(gh.theta), gsn = Math.sin(gh.theta);
      ctx.setTransform(gs * gsn, -gs * gc, gs * gc, gs * gsn,
                       (v.x0 + v.scale * (gh.cy + v.halfY)) * d + shx,
                       (v.y0 - v.scale * gh.cx) * d + shy);
      ctx.globalAlpha = 0.55 * (1 - gu);
      ctx.strokeStyle = "#ffffff"; ctx.lineWidth = 3 / gs;
      ctx.stroke(gh.path);
    }
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.globalAlpha = 1;

    /* ------------------------------------------------- 9. film shreds -- */
    for (i = 0; i < CN.shreds.length; i++) {
      var sh = CN.shreds[i], su = sh.t / sh.life;
      var sc2 = Math.cos(sh.rot), ss2 = Math.sin(sh.rot);
      var hxx = 110, hyy = 21;                 // 220 x 42 mm strips
      var ax = sx(sh.y), ay = sy(sh.x);
      var ux = sc2 * hxx * mm, uy = ss2 * hxx * mm;
      var vx2 = -ss2 * hyy * mm, vy2 = sc2 * hyy * mm;
      ctx.globalAlpha = 0.55 * (1 - su);
      ctx.fillStyle = sh.col;
      ctx.beginPath();
      ctx.moveTo(ax - ux - vx2, ay - uy - vy2);
      ctx.lineTo(ax + ux - vx2, ay + uy - vy2);
      ctx.lineTo(ax + ux + vx2, ay + uy + vy2);
      ctx.lineTo(ax - ux + vx2, ay - uy + vy2);
      ctx.closePath(); ctx.fill();
    }
    ctx.globalAlpha = 1;

    /* --------------------------------------------- 10. landing puffs --- */
    for (i = 0; i < CN.puffs.length; i++) {
      var pf = CN.puffs[i], pu = pf.t / pf.life;
      var pn = Math.round((Q >= 1 ? 24 : 8) * CN.fx);
      ctx.fillStyle = "#cfe0ff";
      ctx.globalAlpha = 0.20 * (1 - pu);
      for (k = 0; k < pn; k++) {
        var spread = (k / pn - 0.5) * 2 * (pf.r0 + (pf.r1 - pf.r0) * pu);
        ctx.beginPath();
        if (pf.floor === 0) ctx.arc(sx(hy) - (40 + 150 * pu) * mm, sy(pf.x) + spread * mm * 0.5, (40 + 150 * pu) * mm + 1, 0, 6.2832);
        else ctx.arc(sx(pf.y + spread), sy(60), (40 + 150 * pu) * mm + 1, 0, 6.2832);
        ctx.fill();
      }
    }
    ctx.globalAlpha = 1;

    /* ------------------------------------------------- 11. the smoke --- */
    /* FLAT ARCS, NEVER RADIAL GRADIENTS. See the note on the travelling
       light: it is the large-area gradient fills that cost, not the geometry. */
    if (Q >= 2) {
      ctx.fillStyle = "#8fa0be";
      for (i = 0; i < CN.smoke.length; i++) {
        var sm = CN.smoke[i], mu = sm.t / sm.life;
        var er = 1 - Math.pow(1 - mu, 3);
        var rr2 = sm.r0 * (1 + 2.1 * er) * mm;
        // THREE OVERLAPPING BLOBS PER PUFF, NOT ONE DISC. A single flat arc
        // reads as a hard grey donut; three offset ones at a third of the
        // alpha read as smoke, and it is still nine flat fills — no radial
        // gradient anywhere near it (see the note on the travelling light).
        // `w` is the puff's WEIGHT: the muzzle breathes out (1, the default
        // when the field is absent), the kill point throws a real cloud.
        // One field on the pool beats a second pool and a second draw.
        ctx.globalAlpha = 0.075 * (sm.w || 1) * (1 - mu);
        for (k = 0; k < 3; k++) {
          var oa = sm.rot + k * 2.094;
          ctx.beginPath();
          ctx.arc(sx(sm.y) + Math.cos(oa) * rr2 * 0.42,
                  sy(sm.x) + Math.sin(oa) * rr2 * 0.42, rr2 * 0.78, 0, 6.2832);
          ctx.fill();
        }
      }
      ctx.globalAlpha = 1;
    }

    /* ================================================== 12. THE GUN ==== */
    /* EVERY PIECE OF IT IS IN WORLD MILLIMETRES and comes out of
       cannonAimDir / cannonMuzzle / cannonBarrelPoly, so the picture, the hit
       test and scripts/prove-cannon-clear.mjs cannot disagree about where the
       gun is. Everything added below is PAINT INSIDE THE PROVEN SILHOUETTE,
       plus a recoil that only ever pulls BACKWARD. */
    function ring(pts) {
      ctx.beginPath();
      for (var q2 = 0; q2 < pts.length; q2++) {
        var qx = sx(pts[q2].y), qy = sy(pts[q2].x);
        if (q2 === 0) ctx.moveTo(qx, qy); else ctx.lineTo(qx, qy);
      }
      ctx.closePath();
    }
    function box(x0, y0, x1, y1) {
      ring([{ x: x0, y: y0 }, { x: x1, y: y0 }, { x: x1, y: y1 }, { x: x0, y: y1 }]);
    }

    if (!aimAt) { CN.aimKinks = 0; CN.aimHit = 0; }

    /* THE SERVO. A critically damped spring toward the pointer's bearing, so
       the barrel has weight. The clamp is applied AFTER integrating: an
       overshoot that left the cone would put the drawn gun outside the volume
       prove-cannon-clear measured, and that proof reads cfg, not the
       renderer, so it would still pass. */
    var want = aimAt ? cannonBearing(c, aimAt.x, aimAt.y)
                     : (typeof CN.aimBearing === "number" ? CN.aimBearing : c.aimRestDeg * Math.PI / 180);
    if (!reduce) {
      var dtf = 1 / 60, w0 = 26;
      var a0 = w0 * w0 * (want - CN.gunBr) - 2 * w0 * CN.gunBrV;
      CN.gunBrV += a0 * dtf; CN.gunBr += CN.gunBrV * dtf;
    } else { CN.gunBr = want; CN.gunBrV = 0; }
    var lo = -c.aimUpDeg * Math.PI / 180, hi = c.aimDownDeg * Math.PI / 180;
    if (CN.gunBr < lo) { CN.gunBr = lo; CN.gunBrV = 0; }
    if (CN.gunBr > hi) { CN.gunBr = hi; CN.gunBrV = 0; }
    var drawBr = CN.gunBr + (reduce ? 0 : Math.sin(T * 4.4) * 0.006);   // rail hum
    var gd = { br: drawBr, dx: -Math.sin(drawBr), dy: Math.cos(drawBr) };
    var mz = cannonMuzzle(c, gd);

    /* ------------------------------- the cut-path preview and reticle -- */
    /* This survives prefers-reduced-motion (only the marching stops) because
       it is INFORMATION, not decoration: it is the only thing that tells the
       player what the shot is going to hit. */
    if (aimAt) {
      /* ══════════════════════════════════════════════════════════════════
         THE PREVIEW HAS TO BE HONEST, AND UNTIL 2026-09-02 IT WAS NOT.
         It drew ONE straight segment and stopped it at the first TEMPLATE —
         so on a level with pillars it drew a line through solid steel and put
         the reticle on a panel the ball could never reach. A preview that
         lies is worse than no preview, because the player believes it.

         It previews the BOUNCES now, running the same reflection
         cannonRicochet() performs, up to cfg.maxBounces of them. What the
         line says is what the shot does.

         IT COSTS LEVEL 1 NOTHING. CN.pil is empty on a level with no pillars,
         cannonSegPil() returns on its first line and the `while` runs exactly
         once — one leg, the same work as before. The per-leg body loop also
         gained the cheap box reject cannonHit() has always had, which more
         than pays for the extra leg on level 2.
         ══════════════════════════════════════════════════════════════════ */
      /* HOW FAR THE PREVIEW LOOKS. 6400 mm is the number the straight-line
         preview always used, and it is deliberately SHORT of the arena's
         longest sightline (muzzle -> far bottom corner, 7210 mm) because a
         line that ends in mid-air reads as "out of range" and nothing is ever
         out there to hit. That stops being true the moment the room bounces:
         the back wall is 6700-7400 mm away down most bearings, so at 6400 the
         preview would stop just short of the surface the shot is about to come
         off — which is the same lie, one wall further along. So a level that
         can ricochet looks far enough to SEE the bounce and to draw the leg
         after it; level 1 keeps 6400 and therefore keeps its exact line. */
      var reach = (CN.pil.length || c.bounceRoom) ? 15000 : 6400;
      var px2 = mz.x, py2 = mz.y, ddx = gd.dx, ddy = gd.dy, left = reach;
      var poly = [{ x: px2, y: py2, kink: 0, nx: 0, ny: 0 }];
      var hasHit = 0, hitX = 0, hitY = 0, guard = 0;
      while (guard++ <= c.maxBounces + 1 && left > 1) {
        var qx2 = px2 + ddx * left, qy2 = py2 + ddy * left;
        var stopT = -1;
        for (i = 0; i < bs.length; i++) {
          m = CN.meta[bs[i].id];
          if (!m || m.kind !== "template") continue;
          var bx2 = bs[i].world.box;
          if (Math.max(px2, qx2) < bx2.minX - 1 || Math.min(px2, qx2) > bx2.maxX + 1 ||
              Math.max(py2, qy2) < bx2.minY - 1 || Math.min(py2, qy2) > bx2.maxY + 1) continue;
          var tt = cannonSegRing(px2, py2, qx2, qy2, bs[i].world.points);
          if (tt >= 0 && (stopT < 0 || tt < stopT)) stopT = tt;
        }
        var ph = cannonSegSolid(px2, py2, qx2, qy2);
        var pilFirst = ph && (stopT < 0 || ph.t < stopT);
        if (pilFirst && poly.length <= c.maxBounces) {
          var bxk = px2 + ddx * left * ph.t, byk = py2 + ddy * left * ph.t;
          poly.push({ x: bxk, y: byk, kink: 1, nx: ph.nx, ny: ph.ny });
          var dtk = ddx * ph.nx + ddy * ph.ny;
          ddx -= 2 * dtk * ph.nx; ddy -= 2 * dtk * ph.ny;
          left *= 1 - ph.t;
          // 2 mm off the face so the next segment cannot re-hit the edge it
          // just left; invisible on screen, and the polyline still draws
          // through the contact point itself
          px2 = bxk + ddx * 2; py2 = byk + ddy * 2;
          continue;
        }
        var tEnd = pilFirst ? ph.t : (stopT >= 0 ? stopT : 1);
        var exq = px2 + ddx * left * tEnd, eyq = py2 + ddy * left * tEnd;
        poly.push({ x: exq, y: eyq, kink: 0, nx: 0, ny: 0 });
        if (!pilFirst && stopT >= 0) { hasHit = 1; hitX = exq; hitY = eyq; }
        break;
      }
      /* WHAT THE PREVIEW DECIDED, PUBLISHED. Draw-only state, but a number a
         proof can read: `peek().aimKinks` is how many bounces the line is
         showing and `aimHit` whether it ends on a panel. Without it "the
         preview previews the bounce" is a claim about pixels nobody can
         assert on. Both are reset below when the pointer leaves. */
      CN.aimKinks = poly.length - 2;
      CN.aimHit = hasHit;

      /* ════════════════════════════════════════════════════════════════
         THE LINE CHANGES COLOUR, NOT JUST TINT.

         `lethalAt` is set by cannonAimLethal() at the top of this function —
         the SAME call cannonFire() makes at the click — so red on screen and
         "the round ends" are one decision, taken once. Everything from here
         down that was cyan is drawn in CN_DANGER instead, at a heavier weight
         and a higher alpha, and the reticle grows a cross and the words. A
         subtle tint would be a trap; this is a notice.
         ════════════════════════════════════════════════════════════════ */
      var aimCol = lethalAt ? CN_DANGER : CN_CYAN;
      var aimPul = lethalAt ? (reduce ? 1 : 0.80 + 0.20 * Math.cos(T * 11)) : 1;
      // the continuous guide — ONE path over every leg
      ctx.strokeStyle = cannonRgba(aimCol, lethalAt ? 0.42 : 0.22); ctx.lineWidth = (lethalAt ? 2.2 : 1.2) * d;
      ctx.beginPath();
      ctx.moveTo(sx(poly[0].y), sy(poly[0].x));
      for (k = 1; k < poly.length; k++) ctx.lineTo(sx(poly[k].y), sy(poly[k].x));
      ctx.stroke();
      /* THE MARCHING TICKS, WALKED IN ARC LENGTH ALONG THE WHOLE POLYLINE so
         they carry round a corner instead of restarting at it — a tick train
         that resets at the bounce reads as two separate lines. Still ONE
         beginPath and one stroke, as before. */
      var phase = reduce ? 0 : (T * 2600) % 900;
      ctx.strokeStyle = cannonRgba(aimCol, (lethalAt ? 0.98 : 0.75) * aimPul);
      ctx.lineWidth = (lethalAt ? 3.4 : 2) * d;
      ctx.beginPath();
      var accL = 0;
      for (k = 1; k < poly.length; k++) {
        var A2 = poly[k - 1], B2 = poly[k];
        var Lk = Math.hypot(B2.x - A2.x, B2.y - A2.y);
        if (Lk > 0.5) {
          var uxk = (B2.x - A2.x) / Lk, uyk = (B2.y - A2.y) / Lk;
          var firstTick = Math.ceil((accL - phase) / 900) * 900 + phase - 900;
          for (var gp = firstTick; gp < accL + Lk; gp += 900) {
            var g0 = Math.max(accL, gp), g1 = Math.min(gp + 230, accL + Lk);
            if (g1 <= g0) continue;
            ctx.moveTo(sx(A2.y + uyk * (g0 - accL)), sy(A2.x + uxk * (g0 - accL)));
            ctx.lineTo(sx(A2.y + uyk * (g1 - accL)), sy(A2.x + uxk * (g1 - accL)));
          }
        }
        accL += Lk;
      }
      ctx.stroke();
      /* THE KINK MARKERS. A line that bends is a line that bends; a line that
         bends WITH A TICK ON THE FACE AND AN ARROW OFF IT is a bounce. */
      for (k = 1; k < poly.length; k++) {
        var kk = poly[k];
        if (!kk.kink) continue;
        ctx.strokeStyle = cannonRgba(aimCol, 0.9); ctx.lineWidth = 2.2 * d;
        ctx.beginPath();
        ctx.moveTo(sx(kk.y + kk.nx * 200), sy(kk.x - kk.ny * 200));
        ctx.lineTo(sx(kk.y - kk.nx * 200), sy(kk.x + kk.ny * 200));
        ctx.moveTo(sx(kk.y + kk.ny * 60), sy(kk.x + kk.nx * 60));
        ctx.lineTo(sx(kk.y + kk.ny * 300), sy(kk.x + kk.nx * 300));
        ctx.stroke();
      }
      // …and the reticle where the cut would land
      /* ON A LETHAL AIM THE RETICLE IS PLACED FROM `lethalAt`, NOT FROM THE
         PREVIEW'S OWN ENDPOINT. The preview is drawn off the SERVO barrel,
         which lags the pointer by about 0.15 s while it swings; the warning
         is not allowed to lag anything. So while the barrel is catching up
         the line is the picture and the reticle is the truth, and once it
         has caught up (every frame the player is actually aiming in) they
         are the same point to the millimetre. */
      if (hasHit || lethalAt) {
        var rx0 = lethalAt ? sx(lethalAt.y) : sx(hitY);
        var ry0 = lethalAt ? sy(lethalAt.x) : sy(hitX);
        var rr = (lethalAt ? 400 : 300) * mm;
        ctx.strokeStyle = lethalAt ? cannonRgba(CN_DANGER, aimPul) : CN_CYAN;
        ctx.lineWidth = (lethalAt ? 3.2 : 2) * d;
        ctx.beginPath();
        for (k = 0; k < 4; k++) {
          var a1c = k * 1.5708 + 0.35, a2c = k * 1.5708 + 1.2208;
          ctx.arc(rx0, ry0, rr, a1c, a2c);
          if (k < 3) ctx.moveTo(rx0 + rr * Math.cos((k + 1) * 1.5708 + 0.35), ry0 + rr * Math.sin((k + 1) * 1.5708 + 0.35));
        }
        if (lethalAt) {
          // the diagonal cross — the one shape on this canvas that has never
          // meant anything but "no"
          var xr = rr * 0.60;
          ctx.moveTo(rx0 - xr, ry0 - xr); ctx.lineTo(rx0 + xr, ry0 + xr);
          ctx.moveTo(rx0 + xr, ry0 - xr); ctx.lineTo(rx0 - xr, ry0 + xr);
        } else {
          ctx.moveTo(rx0 - rr * 0.28, ry0); ctx.lineTo(rx0 + rr * 0.28, ry0);
          ctx.moveTo(rx0, ry0 - rr * 0.28); ctx.lineTo(rx0, ry0 + rr * 0.28);
        }
        ctx.stroke();
        /* THE WORDS, ON THE RETICLE ITSELF. The panel carries the same notice
           over its own outline (section 9); this one is where the player is
           already looking, which is at the crosshair and not at the pile. Two
           placements of one sentence, because a warning you have to go and
           find is not a warning. */
        if (lethalAt && CN.can.text) {
          var lw = 78 * d, lh = 17 * d, ly = ry0 - rr - 12 * d;
          ctx.fillStyle = "rgba(10,14,24,0.82)";
          ctx.fillRect(rx0 - lw, ly - lh, lw * 2, lh);
          ctx.strokeStyle = cannonRgba(CN_DANGER, aimPul); ctx.lineWidth = 1.4 * d;
          ctx.strokeRect(rx0 - lw, ly - lh, lw * 2, lh);
          ctx.font = "700 " + (11 * d) + "px ui-monospace, SFMono-Regular, Menlo, monospace";
          ctx.textAlign = "center"; ctx.textBaseline = "middle";
          ctx.fillStyle = CN_DANGER;
          ctx.fillText("⚠ HIT = GAME OVER", rx0, ly - lh * 0.5);
          ctx.textAlign = "start"; ctx.textBaseline = "alphabetic";
        }
      }
    }

    /* ---------------------------------------------- the rail and body -- */
    // the backing plate, then today's shelf on top of it. Both stop at the
    // wall's OUTER face, so every part of the gun is left of -(hy + wall) and
    // the full 500 mm of wall stands between it and anything that can move.
    /* THE MOUNTING RAIL. A plate running from behind the trunnion to the
       wall's OUTER face — it stops there, not inside the slab, which is what
       keeps every part of the gun left of -(hy + wallThickMm) and the full
       500 mm of wall between it and anything that can move. Running it into
       the wall would look identical and cut the proved clearance to 122 mm. */
    var wallOuter = -hy - c.wallThickMm;
    var railLo = c.cannonX - 330, railHi = c.cannonX + 330;
    var railL = c.cannonY - 420;

    /* ══════════════════════════════════════════════════════════════════
       THE GUN IS BOLTED TO THE ROOM. IT IS NOT A SPRITE ON A BACKDROP.
       ------------------------------------------------------------------
       THE OWNER'S FIRST FINDING, and it was right: the gun sat in a dark
       rectangle. Three things put it there and all three are gone.

         · A FLAT FILL WITH A LIGHTER OUTLINE ALL THE WAY ROUND. #1a2237
           filled, #38466a stroked on every edge, is the recipe for a card
           pasted onto a picture. A plate in a room has a LIT edge and a DARK
           edge, and no outline at all: the eye reads the change of value as
           a change of surface. That is what it has now.
         · A RECTANGLE. Nothing machined is a rectangle. The plate is
           chamfered at the free end, which is both what a real mounting
           plate looks like and what stops the silhouette reading as a box.
         · NOTHING UNDERNEATH IT. It ended in mid-air 3.1 m off a floor that
           was not drawn. There is now a column, a splayed foot on the
           concrete cannonBuildBg() lays down under the whole room, a brace
           tying it back to the wall, and a contact shadow where the foot
           meets the ground.

       AND THE ROOM SEES IT. cannonBuildBg() bakes the gun's own light onto
       the wall and floor behind it and the wall slab is a gradient now
       instead of an opaque block, so the light survives to be seen.

       ⚠ NOTHING HERE MOVES ANY GEOMETRY. cannonX 3100 and cannonY -4350 are
       untouched, the barrel polygon and the muzzle helper are untouched, and
       every point drawn below stays within world y >= railL (-4770), which
       is the leftmost extent the shipped build already had — so
       prove-cannon-clear's "the whole gun is on the canvas" margin (13 px at
       375x560 against its own -4610 assumption, 5.9 px against the real
       -4770) is exactly what it was before this pass.
       ══════════════════════════════════════════════════════════════════ */

    /* THE MOUNT, DRAWN FIRST so the plate sits on top of it. It is static —
       it could have been baked into the backdrop for free — but the backdrop
       is blitted with up to 10 px of parallax and the trunnion it holds is
       drawn live, so a baked mount would slide out from under its own gun.
       It is a handful of path fills; that is cheaper than that would look. */
    /* AN A-FRAME PYLON, NOT A POST. The first version was one straight
       column and it read as a lamppost: the trunnion is 3.1 m off the floor
       and nothing real holds a machine that high on a single stick. Two
       splayed legs and two cross braces is what a stand of that height
       actually looks like, and — the reason it matters here — a triangle
       reads as STRUCTURE at a glance where a vertical bar reads as a line.
       Every point stays within world y >= -4760, inside the -4770 the
       shipped mounting face already reached. */
    var footY = 0;                                    // the floor plane
    var colTop = c.cannonX - 500;                     // just under the plate
    var legs = [[-4560, -4600], [-4180, -3760]];      // [top y, base y] per leg
    // the shadow the whole stand casts on the concrete, before the stand
    if (CN.blob && CN.can.img && Q >= 1) {
      var ftw = 1150 * mm;
      ctx.globalAlpha = 0.9;
      ctx.drawImage(CN.blob, sx(-4200) - ftw, sy(footY) - ftw * 0.19, ftw * 2, ftw * 0.38);
      ctx.globalAlpha = 1;
    }
    // the cross bracing, drawn under the legs so the legs cap it
    ctx.strokeStyle = "#0e1524"; ctx.lineWidth = Math.max(1.4 * d, 78 * mm);
    ctx.beginPath();
    for (k = 0; k < 2; k++) {
      var t0b = 0.14 + k * 0.42, t1b = 0.56 + k * 0.42;
      ctx.moveTo(sx(legs[0][0] + (legs[0][1] - legs[0][0]) * t0b), sy(colTop * (1 - t0b)));
      ctx.lineTo(sx(legs[1][0] + (legs[1][1] - legs[1][0]) * t1b), sy(colTop * (1 - t1b)));
      ctx.moveTo(sx(legs[1][0] + (legs[1][1] - legs[1][0]) * t0b), sy(colTop * (1 - t0b)));
      ctx.lineTo(sx(legs[0][0] + (legs[0][1] - legs[0][0]) * t1b), sy(colTop * (1 - t1b)));
    }
    ctx.stroke();
    for (k = 0; k < 2; k++) {
      var lt = legs[k][0], lb = legs[k][1], lw = k ? 150 : 140;
      ctx.fillStyle = "#141d30";
      ring([{ x: colTop, y: lt - lw / 2 }, { x: colTop, y: lt + lw / 2 },
            { x: footY + 170, y: lb + lw }, { x: footY + 170, y: lb - lw }]);
      ctx.fill();
      ctx.fillStyle = "rgba(150,180,225,.10)";        // one lit face per leg
      ring([{ x: colTop, y: lt - lw / 2 }, { x: colTop, y: lt - lw / 6 },
            { x: footY + 170, y: lb - lw / 3 }, { x: footY + 170, y: lb - lw }]);
      ctx.fill();
    }
    // the base plate on the concrete, with its own lit top edge
    ctx.fillStyle = "#182135";
    box(footY, -4750, footY + 170, -3540);
    ctx.fill();
    ctx.fillStyle = "rgba(160,195,240,.18)";
    box(footY + 140, -4750, footY + 170, -3540);
    ctx.fill();

    /* THE PLATE. Chamfered at the free end, filled with a cached vertical
       gradient, and edged with light instead of outlined with a colour. */
    var chm = 110;
    ring([{ x: railHi, y: railL + chm }, { x: railHi, y: wallOuter },
          { x: railLo, y: wallOuter }, { x: railLo, y: railL + chm },
          { x: railLo + chm, y: railL }, { x: railHi - chm, y: railL }]);
    if (!CN.railGrad) {
      try {
        if (!CN.can.lin) throw 0;
        var rgP = ctx.createLinearGradient(0, sy(railHi + 120), 0, sy(railLo - 200));
        rgP.addColorStop(0, "#26314c");
        rgP.addColorStop(0.34, "#1a2338");
        rgP.addColorStop(1, "#0c111e");
        CN.railGrad = rgP;
      } catch (e) { CN.railGrad = "#1a2237"; }
    }
    ctx.fillStyle = CN.railGrad; ctx.fill();
    // ONE lit edge along the top and ONE dark edge along the bottom. No
    // closed outline anywhere: an outline is what made it a card.
    ctx.strokeStyle = "rgba(176,205,250,.42)"; ctx.lineWidth = 1.6 * d;
    ctx.beginPath();
    ctx.moveTo(sx(railL + chm), sy(railHi)); ctx.lineTo(sx(wallOuter), sy(railHi));
    ctx.stroke();
    ctx.strokeStyle = "rgba(3,6,12,.75)"; ctx.lineWidth = 2.2 * d;
    ctx.beginPath();
    ctx.moveTo(sx(railL + chm), sy(railLo)); ctx.lineTo(sx(wallOuter), sy(railLo));
    ctx.stroke();

    // the machined face the trunnion actually bolts to
    ctx.fillStyle = "#222d45";
    box(c.cannonX - 500, c.cannonY - 420, c.cannonX - 300, wallOuter);
    ctx.fill();
    ctx.strokeStyle = "rgba(176,205,250,.30)"; ctx.lineWidth = 1.2 * d;
    ctx.beginPath();
    ctx.moveTo(sx(railL), sy(c.cannonX - 300)); ctx.lineTo(sx(wallOuter), sy(c.cannonX - 300));
    ctx.stroke();

    if (DETAIL) {
      // hazard chevrons along the rail's lower face, bolt heads down its
      // spine and cooling fins on the breech end: the three things that make
      // a machine read as machined rather than as a grey box.
      ctx.strokeStyle = "rgba(255,176,46,.38)"; ctx.lineWidth = 2 * d;
      ctx.beginPath();
      for (k = 0; k < 5; k++) {
        var cy0 = c.cannonY - 380 + k * 200;
        if (cy0 + 120 > wallOuter) break;
        ctx.moveTo(sx(cy0), sy(railLo + 40));
        ctx.lineTo(sx(cy0 + 110), sy(railLo + 150));
        ctx.lineTo(sx(cy0), sy(railLo + 260));
      }
      ctx.stroke();
      ctx.fillStyle = "#5d6d8f";
      for (k = 0; k < 5; k++) {
        var by0 = c.cannonY - 340 + k * 195;
        if (by0 > wallOuter - 60) break;
        ctx.beginPath();
        ctx.arc(sx(by0), sy(railHi - 90), Math.max(1.2 * d, 42 * mm), 0, 6.2832);
        ctx.fill();
      }
      ctx.strokeStyle = "rgba(20,26,42,.75)"; ctx.lineWidth = 1.6 * d;
      ctx.beginPath();
      for (k = 0; k < 5; k++) {
        var fy0 = c.cannonY - 400 + k * 95;
        ctx.moveTo(sx(fy0), sy(railLo + 60));
        ctx.lineTo(sx(fy0), sy(railHi - 60));
      }
      ctx.stroke();
    }

    /* ------------------------------------------------------ the recoil - */
    /* pull IS ALWAYS <= 0. The drawn barrel is therefore always a SUBSET of
       the hull prove-cannon-clear measured; a forward lunge would silently
       invalidate the 442.8 mm clearance while that proof carried on passing,
       because it reads cfg and not the renderer. */
    var pull = 0;
    var ft = T - CN.fireT;
    if (ft >= 0 && ft < 0.55) {
      if (reduce) pull = ft < 0.09 ? -165 * (1 - ft / 0.09) : 0;
      else if (ft < 0.028) pull = -165 * (1 - Math.pow(1 - ft / 0.028, 5));
      else pull = -165 * Math.exp(-(ft - 0.028) * 13.5) * Math.cos(6.2832 * 3.6 * (ft - 0.028));
      if (pull > 0) pull = 0;
    }
    var rc = { cannonX: c.cannonX + gd.dx * pull, cannonY: c.cannonY + gd.dy * pull,
               barrelLenMm: c.barrelLenMm, barrelHalfMm: c.barrelHalfMm,
               bellHalfMm: c.bellHalfMm, bellMm: c.bellMm, breechMm: c.breechMm,
               breechHalfMm: c.breechHalfMm, breechEndMm: c.breechEndMm,
               taperMm: c.taperMm };

    /* ---------------------------------------------- the gun's own light - */
    /* THE LIVE HALF OF "the gun lights the room". cannonBuildBg() bakes the
       STATIC pool onto the wall and floor behind the trunnion; this is the
       part that changes — it swells while the gun is charging and flares
       with the muzzle. One blit of the baked light bitmap, drawn BEFORE the
       barrel so the metal stays crisp on top of it rather than washing out.
       A per-frame radial gradient here would have been the +1.57 ms mistake
       recorded on cannonBuildFlash(); this is a texture scale. */
    cannonBuildFlash();
    if (Q >= 1) {
      var halo = 0.10 + 0.07 * CN.charge;
      if (ft >= 0 && ft < 0.30) halo += 0.42 * Math.pow(1 - ft / 0.30, 2.2);
      cannonLight(ctx, sx(c.cannonY + gd.dy * 260), sy(c.cannonX + gd.dx * 260),
                  Math.max(26 * d, 1150 * mm), reduce ? Math.min(halo, 0.14) : halo);
    }

    /* ------------------------------------------------------ the barrel - */
    // The gradient runs ACROSS the bore, not along it, which is what makes a
    // flat polygon read as a tube. It is in SCREEN space — cannonResize()
    // nulls it, and it is rebuilt here.
    // THE CHARGE ARC — the only thing on screen that explains why clicking
    // does nothing while a shot is in the air. It is drawn BEHIND the barrel:
    // over the top it crosses the tube and reads as a bent part of the gun.
    if (CN.charge < 1 || !CN.shot) {
      ctx.strokeStyle = CN_LIME; ctx.lineWidth = 2.0 * d;
      ctx.globalAlpha = 0.8;
      ctx.beginPath();
      ctx.arc(sx(c.cannonY), sy(c.cannonX), (c.mountRadiusMm + 105) * mm,
              -1.2, -1.2 + 4.4 * CN.charge);
      ctx.stroke();
      ctx.globalAlpha = 1;
    }

    ring(cannonBarrelPoly(rc, gd));
    if (!CN.barrelGrad) {
      try {
        if (!CN.can.lin) throw 0;
        var nx0 = -gd.dy, ny0 = gd.dx;         // across the bore
        var g1 = ctx.createLinearGradient(
          sx(c.cannonY + ny0 * -c.bellHalfMm), sy(c.cannonX + nx0 * -c.bellHalfMm),
          sx(c.cannonY + ny0 * c.bellHalfMm), sy(c.cannonX + nx0 * c.bellHalfMm));
        g1.addColorStop(0, "#2b3450");
        g1.addColorStop(0.34, "#7d8dae");
        g1.addColorStop(0.52, "#9fb0d0");
        g1.addColorStop(0.72, "#4a5674");
        g1.addColorStop(1, "#222b43");
        CN.barrelGrad = g1;
      } catch (e) { CN.barrelGrad = "#5b6a8a"; }
    }
    ctx.fillStyle = CN.barrelGrad; ctx.fill();
    ctx.strokeStyle = "#a8b8d8"; ctx.lineWidth = 1.4 * d; ctx.stroke();

    /* ---------------------------------------- the trunnion and its LED - */
    ctx.fillStyle = "#2f3a54";
    ctx.beginPath();
    ctx.arc(sx(c.cannonY), sy(c.cannonX), c.mountRadiusMm * mm, 0, 6.2832);
    ctx.fill();
    ctx.strokeStyle = "#7d8dae"; ctx.lineWidth = 1.5 * d; ctx.stroke();

    // idle: cyan, breathing at 0.49 Hz. Ready to fire: solid lime.
    // In flight, or 400 ms after a shot left the field: amber.
    var ledCol;
    if (CN.shot || T - CN.ledAmber < 0.4) ledCol = CN_AMBER;
    else if (CN.charge >= 1 && !CN.won) ledCol = CN_LIME;
    else ledCol = cannonRgba(CN_CYAN, reduce ? 0.6 : (0.35 + 0.5 * (0.5 + 0.5 * Math.sin(T * 3.1))));
    ctx.fillStyle = ledCol;
    ctx.beginPath();
    ctx.arc(sx(c.cannonY), sy(c.cannonX), Math.max(1.4 * d, 56 * mm), 0, 6.2832);
    ctx.fill();


    /* --------------------------------------- the muzzle flash, 3 layers - */
    if (CN.fireT >= 0 && ft < 0.09) {
      var fdx = CN.fireDX, fdy = CN.fireDY;
      var fm = cannonMuzzle(rc, { dx: fdx, dy: fdy });
      var prev = ctx.globalCompositeOperation;
      ctx.globalCompositeOperation = "lighter";
      if (ft < 0.045) {                                     // amber petals
        var pu2 = ft / 0.045;
        ring([
          { x: fm.x + fdx * 40, y: fm.y + fdy * 40 },
          { x: fm.x + fdx * 500 - fdy * 360, y: fm.y + fdy * 500 + fdx * 360 },
          { x: fm.x + fdx * 900, y: fm.y + fdy * 900 },
          { x: fm.x + fdx * 500 + fdy * 360, y: fm.y + fdy * 500 - fdx * 360 }
        ]);
        ctx.fillStyle = "rgba(255,176,46," + (0.45 * (1 - pu2)) + ")"; ctx.fill();
      }
      if (ft < 0.016) {                                     // the white lance
        ring([
          { x: fm.x + fdx * 30, y: fm.y + fdy * 30 },
          { x: fm.x + fdx * 420 - fdy * 210, y: fm.y + fdy * 420 + fdx * 210 },
          { x: fm.x + fdx * 820, y: fm.y + fdy * 820 },
          { x: fm.x + fdx * 420 + fdy * 210, y: fm.y + fdy * 420 - fdx * 210 }
        ]);
        ctx.fillStyle = "rgba(255,241,196,.92)"; ctx.fill();
      }
      var ru = ft / 0.09;                                   // the expanding ring
      ctx.strokeStyle = "rgba(255,206,106," + (0.5 * (1 - ru) * (1 - ru)) + ")";
      ctx.lineWidth = (16 - 13 * ru) * mm;
      ctx.beginPath();
      ctx.arc(sx(fm.y), sy(fm.x), (180 + 460 * ru) * mm, 0, 6.2832);
      ctx.stroke();
      ctx.globalCompositeOperation = prev;
    }
    // the breech vent, 60-260 ms — the gun breathing out behind the shot
    if (DETAIL && !reduce && ft >= 0.06 && ft < 0.26) {
      var vu = (ft - 0.06) / 0.2;
      ctx.fillStyle = "rgba(143,160,190," + (0.22 * (1 - vu)) + ")";
      var vl = 240 + 180 * vu, vw = 90 + 100 * vu;
      var bx0 = c.cannonX - gd.dx * c.breechMm, by0 = c.cannonY - gd.dy * c.breechMm;
      for (k = -1; k <= 1; k += 2) {
        ring([
          { x: bx0 - gd.dy * k * 60, y: by0 + gd.dx * k * 60 },
          { x: bx0 - gd.dy * k * (60 + vw), y: by0 + gd.dx * k * (60 + vw) },
          { x: bx0 - gd.dx * vl - gd.dy * k * (60 + vw), y: by0 - gd.dy * vl + gd.dx * k * (60 + vw) },
          { x: bx0 - gd.dx * vl - gd.dy * k * 60, y: by0 - gd.dy * vl + gd.dx * k * 60 }
        ]);
        ctx.fill();
      }
    }

    /* ------------------------------------------------- the projectile -- */
    if (slug) {
      var R = c.ballRadiusMm;
      /* THE RIBBON: a tapering wake, not a flat line — and after a bounce it
         is CLAMPED to how far the ball has flown since that bounce. Without
         the clamp the wake tapers back along the CURRENT direction, i.e.
         straight through the pillar the ball just came off, and the ricochet
         reads as a teleport. */
      var tail = slug.bounces ? Math.min(1500, Math.max(60, slug.leg)) : 1500;
      var tx1 = slug.x - slug.dx * tail, ty1 = slug.y - slug.dy * tail;
      var rg2;
      try {
        if (!CN.can.lin) throw 0;
        rg2 = ctx.createLinearGradient(sx(slug.y), sy(slug.x), sx(ty1), sy(tx1));
        rg2.addColorStop(0, "rgba(255,243,196,.85)");
        rg2.addColorStop(0.35, "rgba(255,176,46,.35)");
        rg2.addColorStop(1, "rgba(255,176,46,0)");
      } catch (e) { rg2 = "rgba(255,224,140,.5)"; }
      ctx.fillStyle = rg2;
      ring([
        { x: slug.x - slug.dy * 90, y: slug.y + slug.dx * 90 },
        { x: slug.x + slug.dy * 90, y: slug.y - slug.dx * 90 },
        { x: tx1, y: ty1 }
      ]);
      ctx.fill();
      /* THE OTHER HALF OF THE KINK: the leg the ball arrived on, drawn back
         from the contact point along the direction it was travelling THEN,
         shortening as the new leg grows. Two straight strokes meeting at a
         point on the steel is what a bounce looks like. */
      if (slug.bounces && slug.leg < 1500) {
        var remK = 1500 - slug.leg;
        var okx = slug.kx - slug.pdx * remK, oky = slug.ky - slug.pdy * remK;
        ctx.strokeStyle = "rgba(255,176,46,.30)"; ctx.lineWidth = 3.2 * d;
        ctx.beginPath();
        ctx.moveTo(sx(slug.ky), sy(slug.kx));
        ctx.lineTo(sx(oky), sy(okx));
        ctx.stroke();
      }
      // two short wake strokes 400 mm behind
      if (DETAIL) {
        ctx.strokeStyle = "rgba(255,224,140,.18)"; ctx.lineWidth = 1.6 * d;
        ctx.beginPath();
        var wx = slug.x - slug.dx * 400, wy = slug.y - slug.dy * 400;
        for (k = -1; k <= 1; k += 2) {
          ctx.moveTo(sx(wy + slug.dx * k * 40), sy(wx - slug.dy * k * 40));
          ctx.lineTo(sx(wy + slug.dx * k * 300), sy(wx - slug.dy * k * 300));
        }
        ctx.stroke();
      }
      // THE BOW SHOCK — an ARC, not a ring. A full circle around the slug
      // reads as a bubble travelling with it; 130 degrees of arc facing the
      // direction of travel reads as air being pushed.
      var bang = Math.atan2(-slug.dx, slug.dy);        // screen-space heading
      ctx.strokeStyle = "rgba(126,247,255,.45)"; ctx.lineWidth = 1.6 * d;
      ctx.beginPath();
      ctx.arc(sx(slug.y + slug.dy * 60), sy(slug.x + slug.dx * 60), 190 * mm,
              bang - 1.13, bang + 1.13);
      ctx.stroke();
      // the core, additive
      var prev2 = ctx.globalCompositeOperation;
      ctx.globalCompositeOperation = "lighter";
      ctx.fillStyle = "#fff6d8";
      ctx.beginPath();
      ctx.arc(sx(slug.y), sy(slug.x), Math.max(2.4 * d, R * mm), 0, 6.2832);
      ctx.fill();
      ctx.globalCompositeOperation = prev2;
    }

    /* ---------------------------------------------- the ricochet marks -- */
    /* SPARKS ALONE ARE NOT ENOUGH. Every miss in this game throws sparks, so
       sparks say "something happened here", not "the ball came off steel".
       This is the part that says steel: a hard flare on the contact point and
       an expanding arc pushed out along the face normal, 300 ms for a bounce
       and 420 for a ball that spent its last bounce there. Capped at 6 by
       cannonPling() and emptied with every other pool by cannonSpawn(). */
    for (i = 0; i < CN.ricos.length; i++) {
      var rc = CN.ricos[i], ru = (T - rc.t) / (rc.big ? 0.42 : 0.30);
      if (ru < 0 || ru > 1) continue;
      var rax = sx(rc.y), ray = sy(rc.x);
      var rang = Math.atan2(-rc.nx, rc.ny);
      ctx.strokeStyle = cannonRgba(rc.big ? CN_AMBER : "#fff6d8", 0.85 * (1 - ru));
      ctx.lineWidth = (rc.big ? 3.4 : 2.4) * d * (1 - 0.5 * ru);
      ctx.beginPath();
      ctx.arc(rax, ray, (120 + 900 * ru) * mm, rang - 1.25, rang + 1.25);
      ctx.stroke();
      if (ru < 0.5) {
        var pv3 = ctx.globalCompositeOperation;
        ctx.globalCompositeOperation = "lighter";
        ctx.globalAlpha = 0.9 * (1 - ru * 2);
        ctx.fillStyle = "#fff6d8";
        ctx.beginPath();
        ctx.arc(rax, ray, Math.max(2 * d, (150 - 130 * ru * 2) * mm), 0, 6.2832);
        ctx.fill();
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = pv3;
      }
    }

    /* ═══════════════════════════════════════════════ 13. THE IMPACT ════
       THE MONEY MOMENT, AND IT USED TO READ MODESTLY AGAINST THE FRAME —
       the owner's third finding. What was here: a 700 mm radial flash for
       70 ms, two thin ellipse rings, and that was all. On a 1180 px stage
       700 mm is 145 px across. The whole event was a scuff.

       WHY IT WAS SMALL, AND WHY IT NO LONGER HAS TO BE. The 700 mm clamp
       was not taste, it was a measurement: createRadialGradient + fill was
       +0.149 ms at 650 mm and +1.57 ms at 2000 mm. But the cost is the
       GRADIENT, not the area — see cannonBuildFlash(), which bakes the same
       ramp into a 256x256 bitmap once. A blit of that at 1700 mm is a
       texture scale, and it is cheaper than the 700 mm gradient it replaces.
       So the flash is 2.4x the radius and costs less.

       FOUR BEATS, NOT ONE, because size alone is a bigger scuff:
         · a 40 ms WHITE CORE that reads as the strike itself
         · the FLASH, out to 1700 mm, gone by 110 ms
         · THREE SHOCK RINGS instead of two, brighter, the first white-hot
         · a 420 ms EMBER that keeps the kill point alive after the bang, so
           the eye has somewhere to be while the shards fly
       Every one of them is scaled by CN.fx exactly as before, so the
       body-count governor still owns the ceiling: at the 32-body cap
       (fx 0.35) the whole event is a third of what it is at six bodies.
       ═══════════════════════════════════════════════════════════════════ */
    var li = CN.lastImpact;
    if (li) {
      var iu2 = T - li.t;
      if (iu2 >= 0 && iu2 < 0.62) {
        var ix2 = sx(li.y), iy2 = sy(li.x);
        cannonBuildFlash();

        // 1. THE CORE — small, white, 40 ms. This is the hit; everything
        //    after it is the consequence.
        if (iu2 < 0.04 && !reduce) {
          cannonLight(ctx, ix2, iy2, Math.max(6 * d, 460 * mm * (0.6 + 0.8 * CN.fx)),
                      0.95 * (1 - iu2 / 0.04));
        }
        // 2. THE FLASH — out to 1700 mm, and a blit, so it is affordable.
        if (iu2 < 0.11 && !reduce) {
          var fr = (620 + 1080 * CN.fx) * mm;
          cannonLight(ctx, ix2, iy2, Math.max(10 * d, fr),
                      0.80 * Math.pow(1 - iu2 / 0.11, 0.85));
        }
        // 3. THE SHOCK: ellipses flattened to 0.62 vertically, because the
        //    blast rides the floor rather than expanding as a sphere.
        /* A RING MUST DIE AS A RING, NOT THIN INTO A WIRE.
           The first tuning ran them out to 2800 mm over 260 ms on a linear
           width taper, and six frames after the hit the frame carried three
           grey ellipse outlines lassoing the gun: the blast had stopped
           being light and become line art. So they are shorter (200 ms),
           they stay inside the arena, the width never falls below a third of
           its start, and the alpha falls as the cube — by the time they are
           thin they are already gone. */
        var prev3 = ctx.globalCompositeOperation;
        var shocks = reduce ? 1 : CN.fx <= 0.6 ? 2 : 3;
        ctx.globalCompositeOperation = "lighter";
        for (k = 0; k < shocks; k++) {
          var ku = (iu2 - k * 0.038) / 0.20;
          if (ku < 0 || ku > 1) continue;
          if (reduce && iu2 > 0.12) continue;
          /* UNDER REDUCED MOTION THE RING IS THE WHOLE EVENT — no flash, no
             sparks, no smoke, no recoil — so it must not be the one thing
             that reads worst. At the full radius it expands past the panel
             it killed and, with nothing hot inside it, lands as a grey
             lasso. Half the travel keeps it a ring around the hit. */
          var r1 = (reduce ? 500 + 620 * ku
                  : k === 0 ? 600 + 1350 * ku
                  : k === 1 ? 1000 + 1300 * ku
                            : 1420 + 1200 * ku) * mm;
          ctx.strokeStyle = k === 0 ? "rgba(255,246,214,.62)"
                          : k === 1 ? "rgba(255,190,92,.40)"
                                    : "rgba(255,146,38,.26)";
          ctx.lineWidth = (k === 0 ? 96 - 62 * ku : 70 - 46 * ku) * mm;
          ctx.globalAlpha = (k === 0 ? 0.90 : 0.60) * Math.pow(1 - ku, 3);
          ctx.beginPath();
          if (CN.can.ell) ctx.ellipse(ix2, iy2, r1, r1 * 0.62, 0, 0, 6.2832);
          else ctx.arc(ix2, iy2, r1 * 0.8, 0, 6.2832);
          ctx.stroke();
        }
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = prev3;

        // 4. THE EMBER. The bang is over in a tenth of a second; the shards
        //    are in the air for two. This keeps a warm hole in the pile
        //    where the panel was, so the event has a tail instead of a cut.
        if (iu2 < 0.62) {
          var eu = 1 - iu2 / 0.62;
          cannonLight(ctx, ix2, iy2, Math.max(6 * d, (340 + 520 * CN.fx) * mm),
                      (reduce ? 0.12 : 0.34) * eu * eu);
        }
      }
    }

    /* ------------------------------------------------------ 14. sparks - */
    /* SPARKS ARE STREAKS NOW, AND IT IS ONE BATCHED STROKE.
       They were 3 px squares, one fillRect each: at 26 of them the burst
       read as a sprinkle of confetti sitting still in the air. A spark you
       can see the DIRECTION of is what makes a hit read as a hit, and the
       cheapest honest way to draw one is a short line along its own
       velocity — a motion blur that is free because the velocity is already
       in the pool. The two populations keep their colours, so this is TWO
       beginPath/stroke pairs for the whole field where it used to be one
       fillRect per spark, and it reads several times bigger. */
    /* THE FADE SURVIVES BATCHING AS THREE BANDS, NOT AS PER-SPARK ALPHA.
       globalAlpha is context state, so one alpha per stroke is the price of
       batching; three bands per population is six strokes for the whole
       field against twenty-six fillRects, and the banding is invisible
       because the streak LENGTH fades continuously underneath it. Dropping
       the fade entirely was tried first and it is worse than the squares
       were: the burst ends by blinking out instead of dying down. */
    if (CN.sparks.length) {
      ctx.lineCap = "round";
      for (var pass = 0; pass < 6; pass++) {
        var wantHot = pass < 3, band = pass % 3;
        var lo = 1 - (band + 1) / 3, hi = 1 - band / 3;
        var any = false;
        ctx.beginPath();
        for (k = 0; k < CN.sparks.length; k++) {
          var sp = CN.sparks[k];
          if ((sp.hot !== false) !== wantHot) continue;
          var spa = 1 - sp.t / sp.life;
          if (spa <= lo || spa > hi) continue;
          // the streak is 18 ms of the spark's OWN travel, so a fast spark
          // is long and a dying one is a dot — the length IS the speed
          var tl = 0.018 * Math.max(0.12, spa);
          ctx.moveTo(sx(sp.y), sy(sp.x));
          ctx.lineTo(sx(sp.y - sp.vy * tl), sy(sp.x - sp.vx * tl));
          any = true;
        }
        if (!any) continue;
        ctx.strokeStyle = wantHot ? "#ffce6a" : "#7ef7ff";
        ctx.lineWidth = (wantHot ? 2.3 : 1.8) * d;
        ctx.globalAlpha = (wantHot ? 0.95 : 0.72) * (hi - 0.16);
        ctx.stroke();
      }
      ctx.lineCap = "butt";
    }
    ctx.globalAlpha = 1;

    /* ----------------------------------------------- 15. THE PLOTTER SWEEP */
    /* The one moment where spending is unambiguously correct: +0.70 ms for
       750 ms, once per round. A band of light crosses the field and every
       body it passes strokes in lime instead of its own edge colour (see the
       body loop), so the machine appears to RE-CUT everything on its way out.
       Under reduced motion the band appears once at 40% and fades. */
    if (CN.winT >= 0) {
      var bw = 120 * d, bx = sweepX;
      if (reduce) {
        var ru2 = (T - CN.winT - 0.10) / 0.75;
        if (ru2 >= 0 && ru2 <= 1) { bx = matL + (matR - matL) * 0.4; }
        else bx = -1;
      }
      if (bx >= 0) {
        if (!CN.sweepGrad) {
          try {
            if (!CN.can.lin) throw 0;
            var sg = ctx.createLinearGradient(0, 0, bw, 0);
            sg.addColorStop(0, "rgba(190,255,246,0)");
            sg.addColorStop(0.5, "rgba(190,255,246,.55)");
            sg.addColorStop(1, "rgba(190,255,246,0)");
            CN.sweepGrad = sg;
          } catch (e) { CN.sweepGrad = "rgba(190,255,246,.25)"; }
        }
        ctx.save();
        ctx.translate(bx - bw / 2, 0);
        ctx.fillStyle = CN.sweepGrad;
        ctx.fillRect(0, 0, bw, cv.height);
        ctx.restore();
      }
    }
    ctx.globalAlpha = 1;
    ctx.globalCompositeOperation = "source-over";
  }

  /* ----------------------------------------------------------- hud ---- */

  /**
   * THE CANNON'S OWN SCORE, WRITTEN WITH textContent AND classList ONLY.
   *
   * It deliberately does NOT touch getCaught()/setCaught()/gainCatch(): that
   * counter belongs to the medal game, gainCatch clamps to GOAL-3 and is
   * wrapped in if(!isUnlocked()). The cannon counts templates, and the only
   * thing it ever writes to storage is setUnlocked(), through win().
   *
   * Nothing here assigns .className: under theme trap 1 a className write
   * would rebuild the element's class list from one hard-coded word and drop
   * the av-ms prefix that keeps it visible, with nothing in the console.
   */
  function cannonHUD(rebuild) {
    if (!CN) return;
    var left = Math.max(0, CN.templatesLeft);
    if (CN.elLeft) CN.elLeft.textContent = String(left);
    if (CN.elShots) CN.elShots.textContent = String(CN.shots);
    if (CN.elBar) {
      var pct = CN.templatesTotal ? Math.round(CN.templatesDestroyed / CN.templatesTotal * 100) : 0;
      CN.elBar.style.width = pct + "%";
    }
    /* THE PIPS. One small block per target, collapsing as each one dies —
       the one thing on screen that visibly changes when you succeed. They are
       divs, not canvas: DOM text and DOM boxes cost no frame time at all, so
       every part of the HUD that can be DOM is DOM. */
    if (CN.elPips) {
      if (rebuild || CN.elPips.childNodes.length !== CN.templatesTotal) {
        while (CN.elPips.firstChild) CN.elPips.removeChild(CN.elPips.firstChild);
        for (var i = 0; i < CN.templatesTotal; i++) {
          CN.elPips.appendChild(el("i", "av-ms-cannon-pip"));
        }
      }
      var kids = CN.elPips.childNodes;
      for (var j = 0; j < kids.length; j++) {
        kids[j].classList.toggle("is-gone", j < CN.templatesDestroyed);
      }
    }
    /* PAR IS NEVER A FAIL AND SHOTS ARE NEVER CAPPED. A hard magazine is the
       mechanic most likely to feel unfair on a 375 px phone where one mis-tap
       costs the round; par only buys the clean-sheet stamp and the best-run
       record. And LEVEL 1 SHOWS NO PAR DURING A STAKES ROUND: a counter that
       can go red while a shopper is trying to win a discount is hostile. */
    if (CN.elShots && !CN.stakes) {
      var over = CN.shots > CN.level.par;
      CN.elShots.classList.toggle("is-par", CN.shots === CN.level.par);
      CN.elShots.classList.toggle("is-over", over);
    }
    if (CN.modal) CN.modal.classList.toggle("av-ms-cannon-modal--final", left === 1);
  }
  /** ?av_ms_tune=1 only — the owner's frame-time readout. Never a customer's. */
  function cannonDiag() {
    if (!CN || !CN.elDiag) return;
    var sum = 0, mx = 0;
    for (var i = 0; i < CN.rn; i++) { sum += CN.ring[i]; if (CN.ring[i] > mx) mx = CN.ring[i]; }
    var dsum = 0, dmx = 0;
    for (var j = 0; j < CN.dn; j++) { dsum += CN.dring[j]; if (CN.dring[j] > dmx) dmx = CN.dring[j]; }
    /* THE TIER AND THE CATCH-UP CAP ARE PRINTED HERE ON PURPOSE. The 4-8x
       phone multiplier this budget used to rest on has now been measured
       through CDP (scripts/phone-lab.mjs) — but this line is what closes the
       question on a REAL handset in one minute, and "cap 1" is how you can
       see at a glance that the loop decided the device could not afford two
       physics steps in a frame. */
    var fsum = 0, fmx = 0;
    for (var k2 = 0; k2 < CN.fn; k2++) { fsum += CN.fring[k2]; if (CN.fring[k2] > fmx) fmx = CN.fring[k2]; }
    CN.elDiag.textContent =
      "sim " + (CN.rn ? (sum / CN.rn).toFixed(2) : "–") + " · " +
      (CN.rn ? mx.toFixed(2) : "–") + " worst   draw " +
      (CN.dn ? (dsum / CN.dn).toFixed(2) : "–") + " · " +
      (CN.dn ? dmx.toFixed(2) : "–") + " worst   frame " +
      (CN.fn ? (fsum / CN.fn).toFixed(2) : "–") + " · " +
      (CN.fn ? fmx.toFixed(2) : "–") + " worst   ms/frame · cap " +
      (CN.stepMs > 0 ? Math.max(1, Math.min(4, Math.floor(12 / CN.stepMs))) : 4) + " · Q" + CN.q +
      " · L" + CN.L + " · fx " + CN.fx.toFixed(2) + " · " +
      CN.world.bodies.length + " bodies · " + CN.awake + " awake · " +
      "recovered " + CN.templatesRecovered + " · lost " + CN.templatesLost;
  }

  /* ----------------------------------------------------------- end ---- */

  /**
   * TEAR THE ROUND DOWN. Called from closeArena() and nowhere else, so the
   * cannon has exactly one teardown path just like the medal arena — which
   * matters because win()'s finish() closes the arena on its way to
   * reveal(). Safe to call when no round is running.
   */
  function cannonEnd() {
    document.documentElement.classList.remove("av-ms-cannon-on");
    /* 🥚 THE EGG MARK DIES WITH THE ROUND, and it is cleared HERE — above the
       `if (!CN)` guard — because this is the single teardown path for the
       cannon and it must run whether or not a round was ever built.
       This line is what makes the no-stakes state a property of the ROUND
       instead of the page load: the shopper who pressed the badge, played a
       practice level and then opened the real milestone round from the
       celebration bar gets paid, because by the time that round calls
       cannonArena() this has already run. cannonShatter()'s award beat cannot
       be caught by it — the round is still open at 1200 ms, and it reads
       CN.egg as well. */
    CANNON_EGG = false;
    if (!CN) return;
    cannonStop();
    try { window.removeEventListener("resize", CN.onResize); } catch (e) {}
    try { window.removeEventListener("keydown", CN.onKey); } catch (e) {}
    try { document.removeEventListener("visibilitychange", CN.onVis); } catch (e) {}
    try { if (CN.ro) CN.ro.disconnect(); } catch (e) {}
    try { if (CN.obs) CN.obs.disconnect(); } catch (e) {}
    /* ⚠ CLOSE THE BACKDROP BITMAP. It is several megabytes of GPU memory, and
       the game is now replayable from a picker — so without this every round
       of a session leaks another one. */
    try { if (CN.bg && CN.bg.close) CN.bg.close(); } catch (e) {}
    try { if (CN.blob && CN.blob.close) CN.blob.close(); } catch (e) {}
    /* The win beat can be torn down mid-flight (Quit at 0.8 s of a 1.2 s
       sequence): every one of its pieces lives on CN, so dropping CN drops
       the slow motion, the sweep and the crossfade together. The pending
       setTimeouts survive, and both of them re-check CN.round first. */
    CN.bg = null; CN.bgRaw = null; CN.blob = null; CN.sheen = null;
    CN.world = null; CN.meta = null; CN.paths = null;
    CN.ghosts = null; CN.smoke = null; CN.shreds = null; CN.puffs = null;
    CN = null;
  }

  /**
   * SANCTIONED PROGRAMMATIC ENTRY + A READ-ONLY WINDOW ON THE ROUND.
   *
   * Same idea as root.__avMsArcade above: a test, or a future launcher, needs
   * a way in that does not depend on synthesising a trusted click on a canvas.
   *   open()  starts a round — exactly what the welcome card's button does,
   *           through cannonOpen(), so it loads the bundles on demand too and
   *           a diagnostic `root.__avMsCannon.open()` typed into a console on
   *           an already-unlocked page no longer returns false forever.
   *           It returns TRUE only when the arena is open on return; when it
   *           had to start a download first it returns false and the arena
   *           appears a tick later.
   *   peek()  returns a SNAPSHOT, never the live state. It is what the
   *           browser proof aims with (world -> screen is a two-line map once
   *           you have the view) and what the deploy check reads to show that
   *           templatesRecovered and templatesLost stayed 0.
   * There is deliberately no fire(), no win() and no writable handle: the only
   * way to reach the code is still to destroy all six templates.
   */
  root.__avMsCannon = {
    open: function () { return cannonOpen(); },
    /** Open a specific level, clamped to the ladder. */
    openLevel: function (L) { return cannonOpenLevel(L); },
    /** Open the RANGE — the level picker, plus a milestone row when and only
     *  when cannonMayStake() says one could pay. This is what the reward
     *  panel's "↻ Fire the cannon again" and the popover's ☰ link call, so a
     *  test can drive the same door the shopper uses. It grants nothing by
     *  itself: the picker decides, exactly as it does for a click. */
    range: function () { return cannonRange(); },
    /** Open the level picker. The easter-egg badge's own entry point.
     *  It goes through cannonEggLaunch(), so a console caller gets the same
     *  practice-only picker the badge does — no ticket minted, and every round
     *  it dispatches marked as an egg round. There is deliberately no handle
     *  that opens a stakes round. */
    pick: function () { return cannonEggLaunch(); },
    /** The ladder, read-only. It grants nothing — see THE BARRIERS. */
    levels: function () { return { max: cannonMax(), top: CANNON_MAX_LEVEL }; },
    peek: function () {
      if (!CN) return null;
      var t = [], bs = CN.world.bodies;
      for (var i = 0; i < bs.length; i++) {
        var m = CN.meta[bs[i].id];
        if (m && m.kind === "template") t.push({ id: bs[i].id, x: bs[i].cx, y: bs[i].cy });
      }
      return {
        level: CN.L, levelName: CN.level.name, stakes: CN.stakes, quality: CN.q,
        /* what one fixed step costs on this machine, and how many of them
           cannonLoop() will let a late frame catch up. Both are measurements,
           not settings — scripts/phone-lab.mjs asserts on them. */
        stepMs: CN.stepMs,
        stepCap: CN.stepMs > 0 ? Math.max(1, Math.min(4, Math.floor(12 / CN.stepMs))) : 4,
        par: CN.level.par, fx: CN.fx,
        /* the cut-path preview's own verdict: how many ricochets the line is
           showing, and whether it ends on a panel. See cannonDraw(). */
        aimKinks: CN.aimKinks || 0, aimHit: CN.aimHit || 0,
        /* 1 while the aim under the pointer would cut the customer's panel —
           the flag that turns the line red, and the same value cannonFire()
           stamps on the shot. Published so the browser proof and the PNG
           renderer can assert the warning is UP, not merely that it is
           somewhere in the source. */
        aimDanger: CN.aimDanger || 0,
        grazes: CN.grazes || 0,
        left: CN.templatesLeft, total: CN.templatesTotal,
        destroyed: CN.templatesDestroyed,
        recovered: CN.templatesRecovered, lost: CN.templatesLost,
        shots: CN.shots, hits: CN.hits, won: CN.won,
        awake: CN.awake, bodies: CN.world.bodies.length, t: CN.t, frame: CN.frame,
        view: { scale: CN.view.scale, x0: CN.view.x0, y0: CN.view.y0,
                halfY: CN.view.halfY, W: CN.view.W, H: CN.view.H },
        cannon: { x: CN.cfg.cannonX, y: CN.cfg.cannonY,
                  reachMm: (function () {
                    var pr = cannonBarrelProfile(CN.cfg), r = CN.cfg.mountRadiusMm, i;
                    for (i = 0; i < pr.length; i++) r = Math.max(r, Math.hypot(pr[i][0], pr[i][1]));
                    return r;
                  })(),
                  bearing: CN.aimBearing },
        templates: t
      };
    }
  };
  root.__avMsCannonEgg  = cannonEggLaunch;                 // 🎯 the badge's click path
  root.__avMsCannonPick = function () { return cannonEggLaunch(); };   // …and the picker

  /* ==================================================================== */
  /* 🎯 ARM THE EASTER-EGG BADGES — and why the call is HERE.             */
  /* -------------------------------------------------------------------- */
  /* This whole section is spliced into the milestone IIFE immediately
     before its go-block, which reads:

         bindArcade();  then an early return for arcade mode.

     So a statement at the foot of this file runs BEFORE that early return —
     which is exactly what an easter-egg binder needs, because on the
     knowledge-hub page `mode` IS "arcade" and everything after that line is
     never evaluated. bindCannonEgg() therefore needs no edit to
     theme/apply-theme-edits.mjs at all: the game arms its own badge.

     WHAT THE DEPLOY LANE STILL OWES THIS, and it is one comma:
       var arcadeHost = document.querySelector("[data-av-ms-arcade],[data-av-ms-cannon]");
     querySelector with a comma list returns DOM ORDER, and the medal badge
     (the 1000 row) precedes the cannon badge (the 1500 row), so `milestone`
     still resolves to 1000, ARCADE is still true and nothing about the medal
     path changes. It matters on a page that carries ONLY the cannon badge:
     without the comma such a page would not enter arcade mode, ARCADE would
     be false, and the medal game's own ARCADE guards would be absent.
     verify-theme.mjs
     should assert the two badges' byte offsets are in that order — a failure
     that otherwise logs nothing at all. */
  bindCannonEgg();

  /* -------------------------------- go ---------------------------------- */
  bindArcade();                                         // 🕹 the easter egg works in every mode…
  if (mode === "arcade") return;                        // …and in arcade mode it is the ONLY thing on the page
  if (mode === "teaser") { buildTeaser(); return; }     // pre-milestone: only the teaser, no game
  var userHidden = false; try { userHidden = sessionStorage.getItem("av_ms_hidden_" + milestone.n) === "1"; } catch (e) {}
  // NOTHING appears until the cookie banner is handled — it sits at z-index 2,000,000
  // and would cover the HUD and panel, leaving a first-time visitor unable to reach
  // controls they can see. afterConsent resolves immediately when no banner shows.
  /* 🎯 Does this visitor get the cannon instead of the medal game?
     ?av_ms_game=1 forces it on (the only way to see it before the count
     reaches the configured milestone) and ?av_ms_game=0 forces it off, so the
     owner can compare the two on the same URL. Otherwise it is exactly one
     milestone, on the celebration path only: never over the arcade easter egg
     (which must never grant a code) and never for prefers-reduced-motion,
     where a canvas game of falling debris is the wrong answer and the
     accessible token panel is the right one. */
  GAME_ON = qs.get("av_ms_game") === "1" ||
            (mode === "celebration" && !ARCADE && !reduce &&
             GAME_AT > 0 && milestone.n === GAME_AT && qs.get("av_ms_game") !== "0");
  consentWatch(); startEverything();
  function startEverything() {
  buildHUD(); buildPop();
  if (isUnlocked()) { /* code stays available via HUD */ }
  else if (userHidden) { /* HUD stays as a re-entry point, no auto game */ }
  else {
    // The comeback bonus hands out MEDALS, and a cannon round has none — it
    // counts templates and never touches getCaught()/setCaught(). Awarding
    // "+2 bonus medals" for a game with no medals would be a visible lie, so
    // the whole block sits out when the cannon is on.
    if (!GAME_ON) try {                                          // COMEBACK: returned on a later day mid-hunt -> +2 & a guaranteed rare
      var ckey = KEY + "_lastday", tod = new Date().toDateString(), lastDay = localStorage.getItem(ckey);
      localStorage.setItem(ckey, tod);
      var c0 = getCaught();
      if (lastDay && lastDay !== tod && c0 > 0 && c0 < GOAL - 4) {
        setCaught(Math.min(GOAL - 4, c0 + 2)); forceRare = true; updateHUD();
        setTimeout(function () { toast("👋 Welcome back — <b>+2 bonus medals</b> & a rare incoming!", 3400); }, 1800);
      }
    } catch (e) {}
    // buildHUD() and buildPop() above are shared: the bar stays the way back
    // to the code once it is won, whichever game won it.
    GAME_ON ? cannonBoot() : buildGame();
    GAME_ON ? cannonWelcome() : welcome();
  }
  }
})();
